import oauthService from '../../services/oauthService';
import { getAllCountries } from '../../utils/amazonRegions';
import CurrencySelector from '../common/CurrencySelector';
import useConfirmDialog from '../../hooks/useConfirmDialog';
import ConfirmDialog from '../common/ConfirmDialog';
import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Stepper,
  Step,
  StepLabel,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  Chip,
  CircularProgress,
  Paper,
  IconButton,
  Alert,
  Tab,
  Tabs,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Avatar,
  useTheme,
  Snackbar,
  Tooltip,
  FormControlLabel,
  Checkbox,
  Collapse,
  // Mirakl has two connector types (marketplace API key vs Mirakl Connect) and the
  // choice changes what data is available, so it needs an explicit radio selector.
  Radio,
  RadioGroup,
  ToggleButton,
  ToggleButtonGroup
} from '@mui/material';
import {
  Add as AddIcon,
  ArrowForward as ArrowForwardIcon,
  ArrowBack as ArrowBackIcon,
  Refresh as RefreshIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  Check as CheckIcon,
  Cancel as CancelIcon,
  Security as SecurityIcon,
  Email as EmailIcon,
  Sms as SmsIcon,
  IntegrationInstructions as IntegrationInstructionsIcon,
  VpnKey as ReauthIcon,
  Login as LoginIcon,
  Schedule as QueueIcon,
  PlayArrow as SyncIcon,
  Event as ScheduleIcon,
  EventAvailable as ScheduledIcon,
  EventBusy as NoScheduleIcon,
  Info as InfoIcon,
  CloudUpload as UploadIcon,
  FolderOpen as FileFeedIcon,
  TableChart as TableChartIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  ContentCopy as CopyIcon,
  Close as CloseIcon
} from '@mui/icons-material';
import {
  ShopifyIcon as SiShopify,
  FacebookIcon as SiFacebook,
  GoogleIcon as SiGoogle,
  AmazonIcon as SiAmazon,
  AmazonAdsIcon as SiAmazonAds,
  TikTokIcon as SiTiktok,
  SlackIcon as SiSlack,
  PinterestIcon as SiPinterest,
  QuickBooksIcon as SiQuickbooks,
  PayPalIcon as SiPaypal,
  WiseIcon as SiWise,
  RevolutIcon as SiRevolut,
  GoogleSearchConsoleIcon as SiGoogleSearchConsole,
  GoogleAnalyticsIcon as SiGoogleAnalytics,
  GoogleMerchantCenterIcon as SiGoogleMerchantCenter,
  GoogleAdsIcon as SiGoogleAds,
  GoogleWorkspaceIcon as SiGoogleWorkspace,
  KlaviyoIcon as SiKlaviyo,
  SMSBumpIcon as SiSMSBump,
  AttentiveIcon as SiAttentive,
  ShipStationIcon as SiShipStation,
  ShipHeroIcon as SiShipHero,
  Cin7Icon as SiCin7,
  AmericanExpressIcon as SiAmex,
  PayoneerIcon as SiPayoneer,
  MicrosoftIcon as SiMicrosoft,
  TwilioIcon as SiTwilio,
  EdeskIcon as SiEdesk,
  ClarityIcon as SiClarity,
  DHLIcon as SiDHL,
  NetSuiteIcon as SiNetSuite,
  XeroIcon as SiXero,
  UPSIcon as SiUPS,
  USPSIcon as SiUSPS,
  FedExIcon as SiFedEx,
  MiraklIcon as SiMirakl,
  TargetIcon as SiTarget,
  ImpactIcon as SiImpact,
  DorIcon as SiDor,
  CruvaIcon as SiCruva,
  JudgemeIcon as SiJudgeme,
  OkendoIcon as SiOkendo,
  RechargeIcon as SiRecharge,
  HeartlandRetailIcon as SiHeartlandRetail,
  SkioIcon as SiSkio,
  OmnisendIcon as SiOmnisend,
  LoopReturnsIcon as SiLoopReturns,
  AppstleSubscriptionsIcon as SiAppstleSubscriptions,
  SmileIcon as SiSmile,
  StayAiIcon as SiStayAi,
  LoopSubscriptionsIcon as SiLoopSubscriptions,
  GlobaleIcon as SiGlobale,
  BoldSubscriptionsIcon as SiBoldSubscriptions,
  WalmartConnectIcon as SiWalmartConnect,
  AdobeAnalyticsIcon as SiAdobeAnalytics,
  AdobeCampaignIcon as SiAdobeCampaign,
  AdobeExperiencePlatformIcon as SiAdobeExperiencePlatform,
  MarketoIcon as SiMarketo,
  PowerReviewsIcon as SiPowerReviews,
  OrdergrooveIcon as SiOrdergroove,
  SfccIcon as SiSfcc,
  KiboIcon as SiKibo,
  SfmcIcon as SiSfmc,
  SalesforceServiceCloudIcon as SiSalesforceServiceCloud,
  ZendeskIcon as SiZendesk,
  GladlyIcon as SiGladly,
  KustomerIcon as SiKustomer,
  SegmentIcon as SiSegment,
  BrightpearlIcon as SiBrightpearl,
  AdobeCommerceIcon as SiAdobeCommerce,
  WooCommerceIcon as SiWooCommerce,
  ShipbobIcon as SiShipbob,
  StripeIcon as SiStripe,
  PostscriptIcon as SiPostscript,
  FairingIcon as SiFairing,
  WalmartIcon as SiWalmart,
  AppLovinIcon as SiAppLovin,
  ChatGPTAdsIcon as SiChatGPTAds,
  YotpoIcon as SiYotpo,
  GorgiasIcon as SiGorgias,
  WixIcon as SiWix,
  UnifyIcon as SiUnify,
  WShopIcon as SiWShop,
  MicrosoftTeamsIcon as SiMicrosoftTeams,
  Microsoft365Icon as SiMicrosoft365,
  TaboolaIcon as SiTaboola,
  CriteoIcon as SiCriteo,
  AwinIcon as SiAwin,
  PartnerizeIcon as SiPartnerize,
  RakutenAdvertisingIcon as SiRakutenAdvertising,
  BigQueryIcon as SiBigQuery,
  BusinessCentralIcon as SiBusinessCentral,
  CjIcon as SiCj,
  KnoCommerceIcon as SiKnoCommerce,
  BrazeIcon as SiBraze,
  LightspeedIcon as SiLightspeed,
  SquareIcon as SiSquare,
  SnapchatIcon as SiSnapchat,
  RedditIcon as SiReddit,
  Sa360Icon as SiSa360,
  AmazonVendorCentralIcon as SiAmazonVendor,
  Dv360Icon as SiDv360,
  Cm360Icon as SiCm360,
  THGIcon as SiTHG,
  SnowflakeIcon as SiSnowflake,
  DatabricksIcon as SiDatabricks,
  SPSCommerceIcon as SiSPSCommerce,
  ProcurosIcon as SiProcuros
} from '../../assets/icons/BrandIcons';
import { useAuth } from '../../context/AuthContext';
import { brandService } from '../../services/brandService';
import { connectorService } from '../../services/connectorService';
import api from '../../config/api';

// Queue management components
import SyncOptionsDialog from './SyncOptionsDialog';
import QueueStatusPanel from './QueueStatusPanel';
import AmexCSVUpload from './AmexCSVUpload';
import PayoneerCSVUpload from './PayoneerCSVUpload';
import JobDetailsModal from './JobDetailsModal';

// Canonical Shopify Dev Dashboard App scope groups, shared by the read-only/full
// access-level selector. Read-only strips every write_* scope (incl. write_pixels/
// write_custom_pixels); it keeps read_pixels + read_customer_events so pixel/event
// DATA still syncs — we just can't install pixels or edit the theme. Full keeps all.
const SHOPIFY_SCOPE_GROUPS = [
  { label: 'Data & Analytics', scopes: [
    { name: 'read_products', why: 'Product catalog & variants' },
    { name: 'write_products', why: 'Update pricing, SEO titles, descriptions & AEO optimization' },
    { name: 'read_product_listings', why: 'Product listings & availability' },
    { name: 'write_product_listings', why: 'Manage product listings' },
    { name: 'read_orders', why: 'Order history & line items' },
    { name: 'write_orders', why: 'Edit, cancel, fulfil & refund orders' },
    { name: 'read_all_orders', why: 'Access ALL orders (not just app-created)' },
    { name: 'read_customers', why: 'Customer profiles & segments' },
    { name: 'write_customers', why: 'Create & update customer profiles' },
    { name: 'customer_read_orders', why: 'Customer order history (storefront)' },
    { name: 'read_inventory', why: 'Stock levels across locations' },
    { name: 'write_inventory', why: 'Adjust inventory levels' },
    { name: 'read_locations', why: 'Warehouse & store locations' },
    { name: 'write_locations', why: 'Manage store/warehouse locations' },
    { name: 'read_reports', why: 'ShopifyQL analytics, payments & reports' },
    { name: 'write_reports', why: 'Create & manage custom reports' },
    { name: 'read_analytics', why: 'Store analytics & dashboard data' },
    { name: 'read_channels', why: 'Orders & inventory by sales channel' },
    { name: 'write_channels', why: 'Manage sales-channel product publishing' },
    { name: 'read_companies', why: 'B2B company profiles & data' },
    { name: 'write_companies', why: 'Create & update B2B companies' },
    { name: 'read_returns', why: 'Return requests & data' },
    { name: 'write_returns', why: 'Create & process returns' },
    { name: 'read_shipping', why: 'Shipping rates & zones' },
    { name: 'write_shipping', why: 'Manage shipping rates & zones' },
    { name: 'read_fulfillments', why: 'Fulfillment status & tracking' },
    { name: 'write_fulfillments', why: 'Create & update fulfillments & tracking' },
  ]},
  { label: 'Payments & Orders', scopes: [
    { name: 'read_shopify_payments_payouts', why: 'Payment balance, payouts & transactions' },
    { name: 'read_shopify_payments_bank_accounts', why: 'Bank account details on payouts' },
    { name: 'read_draft_orders', why: 'Read draft orders (call centre)' },
    { name: 'write_draft_orders', why: 'Create draft orders & send invoices (call centre)' },
    { name: 'read_discounts', why: 'Discount codes & automatic discounts' },
    { name: 'write_discounts', why: 'Create & update discount codes & automatic discounts' },
    { name: 'read_price_rules', why: 'Price rules for discounts' },
    { name: 'write_price_rules', why: 'Create & update price rules' },
  ]},
  { label: 'Content & Metafields', scopes: [
    { name: 'read_content', why: 'Read blog posts & pages' },
    { name: 'write_content', why: 'Create & update blog posts' },
    { name: 'read_metaobjects', why: 'Read metafields & metaobjects' },
    { name: 'write_metaobjects', why: 'Update metafields, structured data & SEO/AEO metadata' },
    { name: 'read_translations', why: 'Read store translations' },
    { name: 'write_translations', why: 'Update store translations' },
    { name: 'read_locales', why: 'Store locale settings' },
    { name: 'write_locales', why: 'Manage store locales' },
    { name: 'read_themes', why: 'Theme files & templates' },
    { name: 'write_themes', why: 'Install pixels/widgets & edit theme snippets' },
  ]},
  { label: 'Store & Navigation', scopes: [
    { name: 'read_online_store_navigation', why: 'Read URL redirects & navigation menus' },
    { name: 'write_online_store_navigation', why: 'Create 301 redirects when updating URLs/handles' },
    { name: 'read_online_store_pages', why: 'Read store pages' },
    { name: 'write_online_store_pages', why: 'Manage store pages' },
    { name: 'read_markets', why: 'Market & region settings' },
    { name: 'write_markets', why: 'Manage markets & regions' },
  ]},
  { label: 'Tracking & Pixels', scopes: [
    { name: 'read_pixels', why: 'Read installed tracking pixels' },
    { name: 'write_pixels', why: 'Install tracking pixels' },
    { name: 'read_custom_pixels', why: 'Read custom pixel configurations' },
    { name: 'write_custom_pixels', why: 'Manage custom pixel configurations' },
    { name: 'read_customer_events', why: 'Conversion & event data' },
  ]},
];

const shopifyScopeGroupsForMode = (mode) =>
  mode === 'full'
    ? SHOPIFY_SCOPE_GROUPS
    : SHOPIFY_SCOPE_GROUPS
        .map((g) => ({ ...g, scopes: g.scopes.filter((s) => !s.name.startsWith('write_')) }))
        .filter((g) => g.scopes.length > 0);

const shopifyScopesCsvForMode = (mode) =>
  shopifyScopeGroupsForMode(mode).flatMap((g) => g.scopes.map((s) => s.name)).join(', ');

// Communication Apps section on the Active Connectors tab
// Fetches its own data since communication connectors are filtered out of the main API
const CommunicationAppsSection = () => {
  const [commConnectors, setCommConnectors] = useState({ teams: null, slack: null });
  const [loadingComm, setLoadingComm] = useState(true);
  const theme = useTheme();

  // Fetch communication connectors on mount
  useEffect(() => {
    const fetchComm = async () => {
      try {
        const res = await api.get('/api/connectors/communication');
        if (res.data?.success) {
          setCommConnectors({
            teams: res.data.connectors.find(c => c.platform_name === 'microsoft_teams') || null,
            slack: res.data.connectors.find(c => c.platform_name === 'slack') || null
          });
        }
      } catch (err) {
        // Endpoint may not exist yet — try agent-apps as fallback indicator
        try {
          const agentRes = await api.get('/teams/admin/agent-apps');
          if (agentRes.data?.success && agentRes.data.data.length > 0) {
            setCommConnectors(prev => ({ ...prev, teams: { exists: true } }));
          }
        } catch { /* ignore */ }
      } finally {
        setLoadingComm(false);
      }
    };
    fetchComm();
  }, []);

  if (loadingComm) return null;
  if (!commConnectors.teams && !commConnectors.slack) return null;

  return (
    <Box sx={{ mt: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <Box sx={{
          width: 4, height: 24, borderRadius: 2,
          background: 'linear-gradient(180deg, #6264A7 0%, #4A154B 100%)'
        }} />
        <Typography variant="h6" fontWeight={600}>Communication Apps</Typography>
        <Chip label="Messaging" size="small" sx={{ ml: 1, bgcolor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)' }} />
      </Box>

      <Grid container spacing={2}>
        {/* Teams Card */}
        {commConnectors.teams && (
          <Grid item xs={12} md={6}>
            <Card elevation={0} sx={{
              borderRadius: 3, border: '1px solid', borderColor: 'divider',
              background: theme.palette.mode === 'dark'
                ? 'linear-gradient(135deg, rgba(98,100,167,0.08) 0%, rgba(98,100,167,0.02) 100%)'
                : 'linear-gradient(135deg, rgba(98,100,167,0.04) 0%, rgba(255,255,255,1) 100%)'
            }}>
              <CardContent sx={{ p: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                  <Box sx={{
                    width: 48, height: 48, borderRadius: 2, display: 'flex', alignItems: 'center', justifyContent: 'center',
                    bgcolor: '#6264A715', color: '#6264A7'
                  }}>
                    <SiMicrosoft size={28} />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="subtitle1" fontWeight={700}>Microsoft Teams</Typography>
                    <Typography variant="caption" color="text.secondary">Hub Bot Connected</Typography>
                  </Box>
                  <Chip label="Active" size="small" color="success" variant="outlined" />
                </Box>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  AI-powered analytics directly in your Teams workspace. Ask questions, run reports, and get insights from any channel.
                </Typography>

                {/* Agent Apps — link to setup guide */}
                <Box sx={{
                  border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 2,
                  bgcolor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.01)'
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box>
                      <Typography variant="body2" fontWeight={600}>AI Agent Apps</Typography>
                      <Typography variant="caption" color="text.secondary">
                        11 specialist agents — each appears as a separate person in Teams
                      </Typography>
                    </Box>
                    <Chip label="11 agents" size="small" sx={{ fontSize: '0.7rem' }} />
                  </Box>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1.5, mb: 1.5 }}>
                    {[
                      { name: 'Marcus', color: '#DC2626' }, { name: 'Sarah', color: '#10B981' },
                      { name: 'Emma', color: '#D97706' }, { name: 'Turing', color: '#6B7280' },
                      { name: 'Alex', color: 'var(--color-primary)' }, { name: 'Bharat', color: '#059669' },
                      { name: 'Jordan', color: '#2563EB' }, { name: 'Mia', color: '#EC4899' },
                      { name: 'Priyanka', color: 'var(--color-accent)' }, { name: 'Raj', color: '#F59E0B' },
                      { name: 'Sam', color: '#4285F4' }
                    ].map(a => (
                      <Avatar key={a.name} sx={{ width: 26, height: 26, fontSize: '0.6rem', fontWeight: 700, bgcolor: a.color, color: '#fff' }}>
                        {a.name[0]}
                      </Avatar>
                    ))}
                  </Box>
                  <Button
                    variant="outlined"
                    size="small"
                    href="/connectors/teams/setup"
                    sx={{
                      textTransform: 'none', fontWeight: 600, fontSize: '0.8rem',
                      borderColor: '#6264A7', color: '#6264A7',
                      '&:hover': { borderColor: '#515399', bgcolor: '#6264A708' }
                    }}
                  >
                    Setup Guide &amp; Downloads
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        )}

        {/* Slack Card */}
        {commConnectors.slack && (
          <Grid item xs={12} md={6}>
            <Card elevation={0} sx={{
              borderRadius: 3, border: '1px solid', borderColor: 'divider',
              background: theme.palette.mode === 'dark'
                ? 'linear-gradient(135deg, rgba(74,21,75,0.08) 0%, rgba(74,21,75,0.02) 100%)'
                : 'linear-gradient(135deg, rgba(74,21,75,0.04) 0%, rgba(255,255,255,1) 100%)'
            }}>
              <CardContent sx={{ p: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                  <Box sx={{
                    width: 48, height: 48, borderRadius: 2, display: 'flex', alignItems: 'center', justifyContent: 'center',
                    bgcolor: '#4A154B15', color: '#4A154B'
                  }}>
                    <SiSlack size={28} />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="subtitle1" fontWeight={700}>Slack</Typography>
                    <Typography variant="caption" color="text.secondary">Workspace Connected</Typography>
                  </Box>
                  <Chip label="Active" size="small" color="success" variant="outlined" />
                </Box>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  AI-powered analytics in your Slack workspace. Each agent appears as a separate bot — DM or @mention them in any channel.
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
                  {[
                    { name: 'Marcus', role: 'Media', color: '#DC2626' },
                    { name: 'Sarah', role: 'CRO', color: '#10B981' },
                    { name: 'Emma', role: 'Retention', color: '#D97706' },
                    { name: 'Turing', role: 'Data', color: '#6B7280' },
                    { name: 'Alex', role: 'Brand', color: 'var(--color-primary)' },
                    { name: 'Bharat', role: 'Finance', color: '#059669' },
                    { name: 'Jordan', role: 'Ops', color: '#2563EB' },
                    { name: 'Mia', role: 'Social', color: '#EC4899' },
                    { name: 'Priyanka', role: 'Support', color: 'var(--color-accent)' },
                    { name: 'Raj', role: 'Amazon', color: '#F59E0B' },
                    { name: 'Sam', role: 'Google Ads', color: '#4285F4' },
                  ].map(a => (
                    <Chip
                      key={a.name}
                      avatar={<Avatar sx={{ bgcolor: a.color, color: '#fff !important', width: 22, height: 22, fontSize: '0.65rem' }}>{a.name[0]}</Avatar>}
                      label={a.name}
                      size="small"
                      variant="outlined"
                      sx={{ fontSize: '0.7rem', borderColor: 'divider' }}
                    />
                  ))}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

// Teams agent app install section — shows deep links after hub OAuth
const TeamsSetupSection = ({ onOAuthConnect }) => {
  const [agentApps, setAgentApps] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const fetchAgentApps = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get('/teams/admin/agent-apps');
      if (res.data?.success) setAgentApps(res.data.data);
    } catch (err) {
      console.error('Failed to fetch Teams agent apps:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (expanded && agentApps.length === 0) fetchAgentApps();
  }, [expanded, agentApps.length, fetchAgentApps]);

  const agentColors = {
    'brand': 'var(--color-primary)', 'finance': '#059669', 'retention': '#D97706',
    'ops': '#2563EB', 'media': '#DC2626', 'social': '#EC4899',
    'customer': 'var(--color-accent)', 'amazon': '#F59E0B', 'google-ads': '#4285F4',
    'cro': '#10B981', 'data': '#6B7280'
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Alert severity="info">
          Connect to Microsoft Teams using OAuth to enable AI-powered analytics directly in your Teams workspace.
          <Button onClick={onOAuthConnect} sx={{ ml: 1 }} size="small" variant="contained">
            Connect with OAuth
          </Button>
        </Alert>
      </Grid>
      <Grid item xs={12}>
        <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider' }}>
          <CardContent sx={{ pb: '16px !important' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}
              onClick={() => setExpanded(!expanded)}>
              <Box>
                <Typography variant="subtitle1" fontWeight={600}>
                  Add AI Agent Apps to Teams
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Install individual agent personas (Marcus, Sarah, Emma, etc.) as separate bots in your Teams workspace
                </Typography>
              </Box>
              <IconButton size="small">
                {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            </Box>
            <Collapse in={expanded}>
              <Box sx={{ mt: 2 }}>
                {loading ? (
                  <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                    <CircularProgress size={24} />
                  </Box>
                ) : agentApps.length === 0 ? (
                  <Alert severity="warning" sx={{ mt: 1 }}>
                    No agent apps configured yet. Contact support to set up agent bots.
                  </Alert>
                ) : (
                  <>
                    <Alert severity="info" sx={{ mb: 2 }}>
                      Download agent manifests and upload them in the{' '}
                      <a href="https://admin.teams.microsoft.com/policies/manage-apps" target="_blank" rel="noopener noreferrer">Teams Admin Center</a>
                      {' '}&rarr; Manage apps &rarr; Upload new app. This is a one-time admin action per org.
                    </Alert>
                    <Grid container spacing={1.5}>
                      {agentApps.map((agent) => (
                        <Grid item xs={12} sm={6} md={4} key={agent.slug}>
                          <Card
                            elevation={0}
                            sx={{
                              border: '1px solid', borderColor: 'divider',
                              transition: 'all 0.2s',
                              '&:hover': { borderColor: agentColors[agent.slug] || 'var(--color-primary)', transform: 'translateY(-1px)', boxShadow: 1 }
                            }}
                          >
                            <CardContent sx={{ py: 1.5, px: 2, '&:last-child': { pb: 1.5 } }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                <Avatar sx={{
                                  width: 36, height: 36, fontSize: '0.85rem', fontWeight: 700,
                                  bgcolor: agentColors[agent.slug] || 'var(--color-primary)', color: '#fff'
                                }}>
                                  {agent.displayName.charAt(0)}
                                </Avatar>
                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                  <Typography variant="body2" fontWeight={600} noWrap>
                                    {agent.displayName}
                                  </Typography>
                                  <Typography variant="caption" color="text.secondary" noWrap>
                                    {agent.role}
                                  </Typography>
                                </Box>
                                <Button
                                  size="small"
                                  variant="outlined"
                                  href={agent.deepLink}
                                  target="_blank"
                                  sx={{ minWidth: 'auto', px: 1.5, fontSize: '0.75rem', textTransform: 'none' }}
                                >
                                  Add to Teams
                                </Button>
                              </Box>
                            </CardContent>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </>
                )}
              </Box>
            </Collapse>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

const ConnectorSetup = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { confirmDialogProps, confirm } = useConfirmDialog();
  // Any company admin can move THEIR OWN company's Facebook connectors between
  // Meta apps on re-auth. Tenant isolation is enforced server-side: the re-auth
  // ownership check and the app-list are both scoped to the caller's own company,
  // so an admin can only ever switch connectors belonging to their company.
  const canSwitchMetaApp = !!user && !!user.isCompanyAdmin;
  // State for the Facebook "move connector to app" dialog (company admin only).
  const [fbAppMove, setFbAppMove] = useState({
    open: false, connector: null, brandId: null, apps: [], currentAppKey: null,
    selected: '', loading: false, submitting: false, error: ''
  });
  const [activeTab, setActiveTab] = useState(0);
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState('');
  const [selectedType, setSelectedType] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [connectors, setConnectors] = useState([]);
  const [platforms, setPlatforms] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  // True only while an api-key connect request is in flight (used by the Mirakl
  // step to show a spinner + disable the button; other connectors ignore it).
  const [apiKeyConnecting, setApiKeyConnecting] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [connectorType, setConnectorType] = useState('');
  
  // Queue management state
  const [queueStatus, setQueueStatus] = useState({ 
    running: [], 
    queued: [], 
    recent: [],
    completedToday: 0 
  });
  const [queueLoading, setQueueLoading] = useState(false);
  const [syncDialogOpen, setSyncDialogOpen] = useState(false);
  const [selectedConnectorForSync, setSelectedConnectorForSync] = useState(null);
  const [jobDetailsOpen, setJobDetailsOpen] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [csvUploadDialogOpen, setCsvUploadDialogOpen] = useState(false);
  const [selectedConnectorForUpload, setSelectedConnectorForUpload] = useState(null);
  const [activityFilter, setActivityFilter] = useState(''); // Filter for Recent Activity (failed, completed, etc.)
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  const [copyingLink, setCopyingLink] = useState(false); // "Copy client link" (TikTok Shop) in-flight
  // TikTok Shop US app is tenant-scoped (one seller's Partner Center app). Ask the backend whether
  // the selected brand may use it; the "United States" region option only renders when allowed.
  // The backend refuses regardless — this just keeps the option out of the UI for everyone else.
  const [tiktokShopUsAllowed, setTiktokShopUsAllowed] = useState(false);
  // Same for the EU region: a client-owned Global Partner Center app, tenant-scoped the same way.
  const [tiktokShopEuAllowed, setTiktokShopEuAllowed] = useState(false);

  // Confirmation dialog state
  const [confirmDeleteDialog, setConfirmDeleteDialog] = useState({
    open: false,
    connectorId: null,
    connectorName: '',
    connectorPlatform: ''
  });
  const [deleteConfirmationText, setDeleteConfirmationText] = useState('');

  // Re-auth dialog for API-key connectors (eDesk today; extend isApiKeyRotatable for others)
  const [apiKeyDialog, setApiKeyDialog] = useState({
    open: false,
    connector: null,
    newKey: '',
    submitting: false,
    errorText: ''
  });

  // Edit connector state (consolidated name and brand editing)
  const [editingConnector, setEditingConnector] = useState(null); // { id, name, brand_id }

  // Shopify Custom App guide toggle
  const [showCustomAppGuide, setShowCustomAppGuide] = useState(false);
  // Access-level selector for connector setup guides (read-only vs full write).
  const [shopifyAccessMode, setShopifyAccessMode] = useState('read');
  const [klaviyoAccessMode, setKlaviyoAccessMode] = useState('read');
  const [showFacebookGuide, setShowFacebookGuide] = useState(false);
  const [showConnectorGuide, setShowConnectorGuide] = useState(false);

  // Auto-refresh interval (10 seconds for real-time updates)
  const REFRESH_INTERVAL = 10000;
  
  // Stepper state
  const [activeStep, setActiveStep] = useState(0);
  // Tracks whether the user has manually edited the connector name.
  // Drives auto-suggest behavior: brand changes regenerate the name only while it's pristine.
  const [nameDirty, setNameDirty] = useState(false);
  const [connectorForm, setConnectorForm] = useState({
    name: '',
    brandId: '',
    type: '',
    // Shopify specific fields
    shopDomain: '',
    accessToken: '', // For manual Shopify connection (Admin API Access Token / password)
    shopifyApiKey: '', // Shopify API Key for manual connection
    shopifyProductToken: '', // Optional Product Token
    market: '', // Market/Region for Shopify
    shopifyConnectMethod: 'client_credentials', // 'client_credentials', 'manual', or 'oauth'
    apiKey: '',
    apiSecret: '',
    // Gorgias specific fields (manual API-key connector)
    gorgiasSubdomain: '',
    gorgiasEmail: '',
    // Facebook specific fields
    accessToken: '',
    accountId: '',
    // Google specific fields
    clientId: '',
    clientSecret: '',
    refreshToken: '',
    developerToken: '',
    customerId: '',
    // Amazon specific fields
    awsAccessKey: '',
    awsSecretKey: '',
    marketplaceIds: '',
    regionId: '',
    country: '',
    amazonConnectMethod: 'manual', // 'oauth' or 'manual' — manual is default for private SP-API apps
    amazonRefreshToken: '', // Self-authorized refresh token from Seller Central
    amazonSellingPartnerId: '', // Selling Partner ID from Seller Central
    amazonLwaClientId: '', // Seller's own private SP-API app LWA Client ID (optional — falls back to the server app)
    amazonLwaClientSecret: '', // Seller's own private SP-API app LWA Client Secret (optional)
    // Amazon Ads specific fields — OAuth default (shared LWA app), manual = bring-your-own LWA app
    amazonAdsConnectMethod: 'oauth', // 'oauth' or 'manual'
    amazonAdsClientId: '', // User's own LWA Client ID (manual only)
    amazonAdsClientSecret: '', // User's own LWA Client Secret (manual only)
    amazonAdsRefreshToken: '', // Refresh token minted against the user's own LWA app (manual only)
    reauthConnectorId: null, // set on manual RE-auth → backend updates that connector in place
    // TikTok Shop specific fields — US is a separate app/portal; picks authorize host + app creds on the backend
    tiktokShopRegion: 'GLOBAL', // 'GLOBAL' (UK/EU/SEA), 'US', or 'EU' (client-owned app)
    // ShipStation specific fields
    region: '',
    accountName: '',
    // DHL eCommerce specific fields
    sftpUsername: '',
    sftpPassword: '',
    accountNumber: '',
    // Mirakl specific fields — the HOST is required because Mirakl is a platform many
    // operators each run on their own domain; a key is issued by one operator and works
    // only there. marketplaceName is a display label only (it cannot be derived from the
    // host: 'urbanoutfitters' is not mechanically 'Urban Outfitters').
    miraklHost: '',
    miraklMarketplaceName: '',
    // Mirakl has TWO connector types. 'seller_api' is the default because it is the
    // only one that returns commission, invoice and payout data; 'connect' is one
    // OAuth client across marketplaces but orders/shipments/returns ONLY.
    miraklAuthMode: 'seller_api',
    miraklClientId: '',
    miraklClientSecret: '',
    // Target Plus specific fields — SMS ID + API token from Partners Online.
    // appKey is optional: the fetcher falls back to Target's own public gateway key.
    targetSellerId: '',
    targetSellerToken: '',
    targetAppKey: '',
    // Impact.com specific fields — Account SID + Auth Token (sent as HTTP Basic).
    impactAccountSid: '',
    impactAuthToken: '',
    // Dor foot-traffic specific field — Team ID is optional (auto-detected from the
    // API key when the key belongs to exactly one team). The API Key uses the shared
    // connectorForm.apiKey field.
    dorTeamId: '',
    heartlandAccountHost: '',
    // Heartland Retail reports no currency: the brand picks it (no default, never USD by assumption).
    heartlandCurrency: '',
    // Cruva (TikTok Shop affiliate) — Shop ID is optional (auto-detected from the API
    // key when the key can reach exactly one shop). The API Key uses connectorForm.apiKey.
    cruvaShopId: '',
    // Judge.me — shop domain (yourstore.myshopify.com); the private API token uses connectorForm.apiKey.
    judgemeShopDomain: '',
    // WooCommerce — store URL + read REST API key (consumer key ck_... + consumer secret cs_...).
    wooStoreUrl: '',
    wooConsumerKey: '',
    wooConsumerSecret: '',
    // Appstle Subscriptions — shop domain (yourstore.myshopify.com); the API key uses connectorForm.apiKey.
    appstleShopDomain: '',
    // Skio — no extra fields: the API key uses connectorForm.apiKey, the store is read from the key.
    // Yotpo Reviews & Loyalty — Store ID + API secret (required), Loyalty GUID + API key (optional).
    yotpoStoreId: '',
    yotpoApiSecret: '',
    yotpoLoyaltyGuid: '',
    yotpoLoyaltyApiKey: '',
    // Okendo — User ID + Merchant REST API key (both required).
    okendoUserId: '',
    okendoApiKey: '',
    // Walmart Marketplace — personal API key pair (Client ID + Client Secret) from Seller Center.
    walmartClientId: '',
    taboolaClientId: '',
    taboolaClientSecret: '',
    taboolaAccountId: '',
    taboolaAccountChoices: [],   // advertiser accounts a network key reaches (from the 400 TABOOLA_PICK_ACCOUNT reply)
    // PowerReviews Enterprise API credentials (client ID + client secret from the PowerReviews Portal).
    powerreviewsClientId: '',
    powerreviewsClientSecret: '',
    // Salesforce Commerce Cloud: Account Manager API client + instance identifiers (+ optional OCI tenant group id).
    sfccClientId: '',
    sfccClientSecret: '',
    sfccShortCode: '',
    sfccOrganizationId: '',
    sfccOciTenantGroupId: '',
    sfccSites: [],               // sites of the instance (listed with the credentials, before connecting)
    sfccSiteIds: [],             // the sites of THIS brand
    sfccWholeInstance: false,    // also own the instance-wide data (only when no other company uses the instance)
    sfccCustomObjectTypes: '',   // optional: custom object type ids (no API lists them), comma or space separated
    kiboTenantUrl: '',
    kiboApplicationKey: '',
    kiboSharedSecret: '',
    kiboSites: [],               // sites of the tenant (listed with the credentials, before connecting)
    kiboSiteIds: [],             // the sites of THIS brand
    kiboWholeTenant: false,      // also own the tenant-wide data (only when no other company uses the tenant)
    // Zendesk: subdomain + the Identifier / Secret of the brand's own Confidential OAuth client.
    zendeskSubdomain: '',
    zendeskClientId: '',
    zendeskClientSecret: '',
    zendeskBrandChoices: [],     // Zendesk brands of a multi-brand account (from the 400 ZENDESK_BRAND_MAPPING_REQUIRED reply)
    zendeskBrandMapping: {},     // Zendesk brand id -> one of our brand ids
    // Gladly: organization address + a Gladly API user's email and API token.
    gladlyHost: '',
    gladlyEmail: '',
    gladlyApiToken: '',
    gladlyInboxChoices: [],      // inboxes of a multi-inbox organization (from the 400 GLADLY_INBOX_MAPPING_REQUIRED reply)
    gladlyInboxMapping: {},      // Gladly inbox id -> one of our brand ids
    // Kustomer: organization name + an API key.
    kustomerOrgName: '',
    kustomerApiKey: '',
    // Segment: the S3 bucket of the Segment AWS S3 destination + an IAM user's access key; optional Public API token.
    segmentBucket: '',
    segmentRegion: '',
    segmentAccessKeyId: '',
    segmentSecretAccessKey: '',
    segmentPublicApiToken: '',
    segmentPublicApiRegion: 'us',
    // File feed (SFTP): Bazaarvoice export feeds on Bazaarvoice's SFTP, or CSV / JSON-lines files on any SFTP server.
    fileFeedType: 'bazaarvoice',
    fileFeedHost: 'sftp.bazaarvoice.com',
    fileFeedPort: '22',
    fileFeedUsername: '',
    fileFeedAuth: 'password',
    fileFeedPassword: '',
    fileFeedPrivateKey: '',
    fileFeedPassphrase: '',
    fileFeedPath: '/feeds',
    fileFeedPattern: '',
    fileFeedCsvDelimiter: ',',
    fileFeedRecursive: false,
    // BigQuery: the service account's JSON key, the project, then the picked tables (cursor + unique key per table).
    bqKeyText: '',
    bqKeyFileName: '',
    bqProjectId: '',
    bqBillingProjectId: '',
    bqDatasetFilter: '',
    bqDatasets: [],              // datasets + tables the key can see (listed before connecting)
    bqPicked: {},                // 'dataset.table' -> { cursorColumn, primaryKey: [] }
    bqColumns: {},               // 'dataset.table' -> columns / candidates from the backend
    bqMaxGibPerQuery: '100',
    bqMaxGibPerRun: '500',
    bqMaxStoredGibPerRun: '20',
    // Snowflake warehouse reader: key pair generated by us (public key + SQL shown), then account / user / role /
    // warehouse, then the tables / views picked from the role's objects (per table: optional cursor + key columns).
    sfKeyId: null,
    sfPublicKey: '',
    sfFingerprint: '',
    sfSetupSql: '',
    sfAccount: '',
    sfUser: 'SUPERCHARGEME_SVC',
    sfRole: 'SUPERCHARGEME_READER',
    sfWarehouse: '',
    sfObjects: [],
    sfTruncated: false,
    sfFilter: '',
    sfSelected: {},
    sfBusy: false,
    sfMaxGiB: '',
    // Databricks warehouse reader: workspace URL + SQL warehouse + service principal (client ID + OAuth secret) or an
    // access token, then the Unity Catalog tables / views picked from what the principal can see.
    dbHost: '',
    dbWarehouseId: '',
    dbAuthType: 'oauth_m2m',
    dbClientId: '',
    dbClientSecret: '',
    dbToken: '',
    dbCatalogs: '',
    dbObjects: [],
    dbTruncated: false,
    dbFilter: '',
    dbSelected: {},
    dbBusy: false,
    dbMaxGiB: '',
    // Brightpearl: private staff app identifier + staff token (datacentre optional: detected when empty).
    brightpearlAppRef: '',
    brightpearlAccountToken: '',
    brightpearlDatacentre: '',
    // Adobe Commerce / Magento: hosting type, base URL, integration (on-prem/cloud) or IMS (Cloud Service) credentials.
    acHosting: 'paas',
    acBaseUrl: '',
    acConsumerKey: '',
    acConsumerSecret: '',
    acAccessToken: '',
    acAccessTokenSecret: '',
    acClientId: '',
    acClientSecret: '',
    acImsOrgId: '',
    acStores: [],                // store views of the instance (listed with the credentials, before connecting)
    acStoreIds: [],              // the store views of THIS brand
    acWholeInstance: false,      // also own the instance-wide data (only when no other company uses the instance)
    criteoClientId: '',
    criteoClientSecret: '',
    criteoAccountId: '',
    criteoAccountChoices: [],    // demand accounts the keys reach (from the 400 CRITEO_RM_PICK_ACCOUNT reply)
    walmartConnectAdvertiserId: '', // Walmart Connect advertiser id (the brand grants SuperChargeMe partner access first)
    adobeClientId: '',            // Adobe Analytics: OAuth Server-to-Server credential (Adobe Developer Console)
    adobeClientSecret: '',
    adobeOrgId: '',
    adobeScopes: '',
    adobeCompanyId: '',
    adobeCompanyChoices: [],      // Analytics companies the credential reaches (from the 400 ADOBE_ANALYTICS_PICK_COMPANY reply)
    adobeCampaignClientId: '',    // Adobe Campaign: OAuth Server-to-Server credential (Adobe Developer Console)
    adobeCampaignClientSecret: '',
    adobeCampaignScopes: '',
    adobeCampaignProduct: 'v8',   // 'v8' (Campaign v8 SOAP API) or 'standard' (Campaign Standard REST API)
    adobeCampaignInstance: '',    // v8: <name>.campaign.adobe.com; standard: the ORGANIZATION (tenant) id
    aepClientId: '',              // Adobe Experience Platform: OAuth Server-to-Server credential (Adobe Developer Console)
    aepClientSecret: '',
    aepOrgId: '',
    aepScopes: '',
    aepSandboxes: '',             // optional, comma-separated sandbox names (empty = every sandbox the credential can use)
    aepSandboxChoices: [],        // sandboxes the credential can use (from the 400 AEP_PICK_SANDBOXES reply)
    marketoEndpoint: '',      // Marketo REST API endpoint (Admin > Web Services), e.g. https://284-RPR-133.mktorest.com/rest
    marketoClientId: '',      // LaunchPoint custom service Client ID
    marketoClientSecret: '',  // LaunchPoint custom service Client Secret
    awinApiToken: '',
    awinAccountId: '',
    awinAccountChoices: [],      // advertiser accounts the token reaches (from the 400 AWIN_PICK_ACCOUNT reply)
    // Partnerize (brand side) — User application key + User API key (Settings > Account settings).
    partnerizeApplicationKey: '',
    partnerizeUserApiKey: '',
    partnerizeAdvertiserId: '',
    partnerizeBrandChoices: [],  // Partnerize brands the keys reach (from the 400 PARTNERIZE_PICK_BRAND reply)
    // Rakuten Advertising (advertiser side) — the reports' Get API URLs (they carry the account's Reporting API token).
    rakutenReportApiTokenUrls: '',
    // Business Central: environment + company name; the sign-in with Microsoft proves the tenant.
    bcEnvironmentName: 'production',
    bcCompanyName: '',
    // CJ Affiliate — advertiser Company ID (CID); the personal access token uses connectorForm.apiKey.
    cjAdvertiserCid: '',
    walmartClientSecret: '',
    // AppLovin Ads — account ID (account menu → Go to settings); the Report Key uses connectorForm.apiKey.
    applovinAccountId: '',
    // CIN7 Omni specific fields
    cin7Username: '',
    // THG Procure specific fields
    thgUsername: '',
    thgPassword: '',
    thgTenantCode: 'THG',
    // Procuros (EDI middleware) specific fields
    procurosEmail: '',
    procurosPassword: '',
    // NetSuite specific fields
    netsuiteAccountId: '',
    netsuiteConsumerKey: '',
    netsuiteConsumerSecret: '',
    netsuiteTokenId: '',
    netsuiteTokenSecret: '',
    // ShipHero specific fields
    shipheroAccessToken: '',
    shipheroRefreshToken: '',
    shipheroShopName: '',
    // Currency field for user selection
    currency: 'USD'
  });
  
  useEffect(() => {
    if (connectorType !== 'tiktok_shop' || !connectorForm.brandId) {
      setTiktokShopUsAllowed(false);
      return undefined;
    }
    let cancelled = false;
    api.get('/api/connectors/tiktok-shop/us-eligibility', { params: { brandId: connectorForm.brandId } })
      .then((r) => { if (!cancelled) setTiktokShopUsAllowed(Boolean(r.data && r.data.allowed)); })
      .catch(() => { if (!cancelled) setTiktokShopUsAllowed(false); });
    return () => { cancelled = true; };
  }, [connectorType, connectorForm.brandId]);
  useEffect(() => {
    if (connectorType !== 'tiktok_shop' || !connectorForm.brandId) {
      setTiktokShopEuAllowed(false);
      return undefined;
    }
    let cancelled = false;
    api.get('/api/connectors/tiktok-shop/us-eligibility', { params: { brandId: connectorForm.brandId, region: 'EU' } })
      .then((r) => { if (!cancelled) setTiktokShopEuAllowed(Boolean(r.data && r.data.allowed)); })
      .catch(() => { if (!cancelled) setTiktokShopEuAllowed(false); });
    return () => { cancelled = true; };
  }, [connectorType, connectorForm.brandId]);
  useEffect(() => {
    // Brand changed to one that may not use the US app while "US" was selected → fall back to Global.
    if (!tiktokShopUsAllowed && connectorForm.tiktokShopRegion === 'US') {
      setConnectorForm((prev) => ({ ...prev, tiktokShopRegion: 'GLOBAL' }));
      setNotification({
        open: true,
        severity: 'info',
        message: 'This brand cannot use the US TikTok Shop app — region switched to Global. A client link generated now will be a Global (UK / EU / SEA) link.',
      });
    }
  }, [tiktokShopUsAllowed, connectorForm.tiktokShopRegion]);
  useEffect(() => {
    // Brand changed to one that may not use the EU (client-owned) app while "EU" was selected → Global.
    if (!tiktokShopEuAllowed && connectorForm.tiktokShopRegion === 'EU') {
      setConnectorForm((prev) => ({ ...prev, tiktokShopRegion: 'GLOBAL' }));
      setNotification({
        open: true,
        severity: 'info',
        message: 'This brand cannot use the EU TikTok Shop app — region switched to Global. A client link generated now will be a Global (UK / EU / SEA) link.',
      });
    }
  }, [tiktokShopEuAllowed, connectorForm.tiktokShopRegion]);

  useEffect(() => {
    fetchBrands();
    fetchConnectors();
    fetchPlatforms();
    fetchSchedules();
    fetchQueueStatus(); // Initial queue status load
  }, []);
  
  // Auto-refresh queue status every 10 seconds (respecting active filter)
  useEffect(() => {
    const interval = setInterval(() => {
      fetchQueueStatus(activityFilter); // Pass current filter to maintain state
    }, REFRESH_INTERVAL);

    return () => clearInterval(interval);
  }, [activityFilter]); // eslint-disable-line react-hooks/exhaustive-deps
  
  const fetchBrands = async () => {
    try {
      const brandsData = await brandService.getBrands();
      console.log('Brands data:', JSON.stringify(brandsData, null, 2));
      setBrands(brandsData);
    } catch (err) {
      console.error('Error fetching brands:', err);
      setError('Failed to load brands');
    }
  };
  
  const fetchPlatforms = async () => {
    try {
      const platformsData = await connectorService.getPlatforms();
      setPlatforms(platformsData.platforms || platformsData);
    } catch (err) {
      console.error('Error fetching platforms:', err);
      setError('Failed to load available platforms');
    }
  };

  const fetchConnectors = async () => {
    try {
      setLoading(true);
      
      const connectionsData = await connectorService.getConnections();
      setConnectors(connectionsData.connectors || connectionsData);
      
    } catch (err) {
      console.error('Error fetching connectors:', err);
      if (err.response?.status === 401) {
        setError('Authentication failed. Please login again.');
      } else if (err.response?.status === 403) {
        setError('You do not have permission to view connectors.');
      } else if (err.response?.status >= 500) {
        setError('Server error. Please try again later.');
      } else {
        setError(err.response?.data?.message || 'Failed to load connectors');
      }
    } finally {
      setLoading(false);
    }
  };

  // Fetch schedule data
  const fetchSchedules = async () => {
    try {
      const response = await api.get('/api/connectors/schedules');
      setSchedules(response.data.schedules || []);
      console.log('Schedules loaded:', response.data.schedules?.length || 0);
    } catch (err) {
      console.error('Error fetching schedules:', err);
      // Don't set error for schedules as it's not critical for connector display
    }
  };
  
  // Queue management functions
  const fetchQueueStatus = useCallback(async (statusFilter = null) => {
    try {
      setQueueLoading(true);
      console.log('Fetching queue status...', statusFilter ? `with filter: ${statusFilter}` : '');
      
      // Use the proper queue status endpoint with optional filter
      const url = statusFilter 
        ? `/api/connectors/queue/status?statusFilter=${statusFilter}`
        : '/api/connectors/queue/status';
      const response = await api.get(url);
      console.log('Queue status response:', response.data);
      
      if (response.data.success) {
        setQueueStatus(response.data.data);
        console.log('Queue status set:', {
          running: response.data.data.running?.length || 0,
          queued: response.data.data.queued?.length || 0,
          recent: response.data.data.recent?.length || 0
        });
      }
    } catch (err) {
      console.error('Error fetching queue status:', err);
      // Set empty queue status on error
      setQueueStatus({
        running: [],
        queued: [],
        recent: [],
        completedToday: 0,
        failedToday: 0
      });
    } finally {
      setQueueLoading(false);
    }
  }, []);

  // Check if connector is CSV upload type
  const isCSVUploadConnector = (connector) => {
    return connector.platform_name === 'amex' ||
           connector.platform_name === 'american_express' ||
           connector.platform_name === 'payoneer';
  };

  // Handle CSV upload click
  const handleCSVUploadClick = (connector) => {
    setSelectedConnectorForUpload(connector);
    setCsvUploadDialogOpen(true);
  };

  // Enhanced sync functionality
  const handleEnhancedSyncClick = (connector) => {
    setSelectedConnectorForSync(connector);
    // Refresh queue status before showing the dialog to get current info
    fetchQueueStatus();
    setSyncDialogOpen(true);
  };

  const handleSyncQueued = (result) => {
    if (result.jobId) {
      showNotification(`Sync queued successfully! Position: ${result.queuePosition || 'N/A'}`, 'success');
      // Immediately refresh queue status to show the new job
      fetchQueueStatus();
    } else if (result.error) {
      showNotification(`Sync failed: ${result.error}`, 'error');
      // Refresh queue status even on error to ensure consistency
      fetchQueueStatus();
    }
  };

  // Job management
  const handleJobAction = async (action, job) => {
    try {
      let response;
      
      switch (action) {
        case 'view':
          setSelectedJobId(job.id);
          setJobDetailsOpen(true);
          break;
          
        case 'cancel':
          response = await api.post(`/api/connectors/sync-jobs/${job.id}/cancel`);
          if (response.data.success) {
            showNotification('Job cancelled successfully', 'success');
            fetchQueueStatus();
          }
          break;
          
        case 'delete':
          // Confirm deletion first
          if (await confirm({ title: 'Delete Job', message: 'Are you sure you want to delete this job? This action cannot be undone.', confirmText: 'Delete', severity: 'danger' })) {
            response = await api.delete(`/api/connectors/sync-jobs/${job.id}`);
            if (response.data.success) {
              showNotification('Job deleted successfully', 'success');
              fetchQueueStatus();
            }
          }
          break;
          
        case 'retry':
          response = await api.post(`/api/connectors/sync-jobs/${job.id}/retry`);
          if (response.data.success) {
            showNotification(`Job retried successfully! Position: ${response.data.queuePosition || 'N/A'}`, 'success');
            fetchQueueStatus();
          }
          break;
      }
    } catch (err) {
      console.error(`Error ${action}ing job:`, err);
      showNotification(err.response?.data?.message || `Failed to ${action} job`, 'error');
    }
  };

  const handleJobActionComplete = () => {
    fetchQueueStatus();
  };

  const showNotification = (message, severity = 'success') => {
    setNotification({ open: true, message, severity });
  };

  const closeNotification = () => {
    setNotification({ ...notification, open: false });
  };
  
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  
  const handleBrandChange = (event) => {
    setSelectedBrand(event.target.value);
  };

  // Handler for activity filter from queue panel (fetches filtered jobs from backend)
  const handleActivityFilter = (status) => {
    setActivityFilter(status);
    // Fetch queue status with the filter to get all jobs matching the status
    fetchQueueStatus(status);
  };
  
  const handleOpenDialog = (type) => {
    setConnectorType(type);
    setOpenDialog(true);
    // Reset the form and stepper
    setActiveStep(0);
    setNameDirty(false);
    const initialBrand = selectedBrand;
    setConnectorForm({
      ...connectorForm,
      type: type,
      name: initialBrand ? suggestConnectorName(initialBrand, type) : '',
      brandId: initialBrand
    });
  };
  
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setConnectorType('');
    setActiveStep(0);  // Reset stepper to beginning
    setNameDirty(false);
    setError('');  // Clear any errors
    setShowCustomAppGuide(false);  // Reset guide toggle
    setShowFacebookGuide(false);
    setShowConnectorGuide(false);
    // Reset connector form to clear any stored IDs from previous connectors
    setConnectorForm({
      taboolaClientId: '',
      taboolaClientSecret: '',
      taboolaAccountId: '',
      taboolaAccountChoices: [],
      powerreviewsClientId: '',
      powerreviewsClientSecret: '',
      sfccClientId: '',
      sfccClientSecret: '',
      sfccShortCode: '',
      sfccOrganizationId: '',
      sfccOciTenantGroupId: '',
      sfccSites: [],
      sfccSiteIds: [],
      sfccWholeInstance: false,
      sfccCustomObjectTypes: '',
      kiboTenantUrl: '',
      kiboApplicationKey: '',
      kiboSharedSecret: '',
      kiboSites: [],
      kiboSiteIds: [],
      kiboWholeTenant: false,
      zendeskSubdomain: '',
      zendeskClientId: '',
      zendeskClientSecret: '',
      zendeskBrandChoices: [],
      zendeskBrandMapping: {},
      gladlyHost: '',
      gladlyEmail: '',
      gladlyApiToken: '',
      gladlyInboxChoices: [],
      gladlyInboxMapping: {},
      kustomerOrgName: '',
      kustomerApiKey: '',
      segmentBucket: '',
      segmentRegion: '',
      segmentAccessKeyId: '',
      segmentSecretAccessKey: '',
      segmentPublicApiToken: '',
      segmentPublicApiRegion: 'us',
      fileFeedType: 'bazaarvoice',
      fileFeedHost: 'sftp.bazaarvoice.com',
      fileFeedPort: '22',
      fileFeedUsername: '',
      fileFeedAuth: 'password',
      fileFeedPassword: '',
      fileFeedPrivateKey: '',
      fileFeedPassphrase: '',
      fileFeedPath: '/feeds',
      fileFeedPattern: '',
      fileFeedCsvDelimiter: ',',
      fileFeedRecursive: false,
      bqKeyText: '',
      bqKeyFileName: '',
      bqProjectId: '',
      bqBillingProjectId: '',
      bqDatasetFilter: '',
      bqDatasets: [],
      bqPicked: {},
      bqColumns: {},
      bqMaxGibPerQuery: '100',
      bqMaxGibPerRun: '500',
      bqMaxStoredGibPerRun: '20',
      sfKeyId: null,
      sfPublicKey: '',
      sfFingerprint: '',
      sfSetupSql: '',
      sfAccount: '',
      sfUser: 'SUPERCHARGEME_SVC',
      sfRole: 'SUPERCHARGEME_READER',
      sfWarehouse: '',
      sfObjects: [],
      sfTruncated: false,
      sfFilter: '',
      sfSelected: {},
      sfBusy: false,
      sfMaxGiB: '',
      dbHost: '',
      dbWarehouseId: '',
      dbAuthType: 'oauth_m2m',
      dbClientId: '',
      dbClientSecret: '',
      dbToken: '',
      dbCatalogs: '',
      dbObjects: [],
      dbTruncated: false,
      dbFilter: '',
      dbSelected: {},
      dbBusy: false,
      dbMaxGiB: '',
      brightpearlAppRef: '',
      brightpearlAccountToken: '',
      brightpearlDatacentre: '',
      acHosting: 'paas',
      acBaseUrl: '',
      acConsumerKey: '',
      acConsumerSecret: '',
      acAccessToken: '',
      acAccessTokenSecret: '',
      acClientId: '',
      acClientSecret: '',
      acImsOrgId: '',
      acStores: [],
      acStoreIds: [],
      acWholeInstance: false,
      criteoClientId: '',
      criteoClientSecret: '',
      criteoAccountId: '',
      criteoAccountChoices: [],
      walmartConnectAdvertiserId: '',
      adobeClientId: '',
      adobeClientSecret: '',
      adobeOrgId: '',
      adobeScopes: '',
      adobeCompanyId: '',
      adobeCompanyChoices: [],

      adobeCampaignClientId: '',
      adobeCampaignClientSecret: '',
      adobeCampaignScopes: '',
      adobeCampaignProduct: 'v8',
      adobeCampaignInstance: '',
      aepClientId: '',
      aepClientSecret: '',
      aepOrgId: '',
      aepScopes: '',
      aepSandboxes: '',
      aepSandboxChoices: [],
      marketoEndpoint: '',
      marketoClientId: '',
      marketoClientSecret: '',
      awinApiToken: '',
      awinAccountId: '',
      awinAccountChoices: [],
      partnerizeApplicationKey: '',
      partnerizeUserApiKey: '',
      partnerizeAdvertiserId: '',
      partnerizeBrandChoices: [],
      rakutenReportApiTokenUrls: '',
      bcEnvironmentName: 'production',
      bcCompanyName: '',
      cjAdvertiserCid: '',
      name: '',
      brandId: '',
      type: '',
      shopDomain: '',
      accessToken: '',
      shopifyApiKey: '',
      shopifyProductToken: '',
      market: '',
      shopifyConnectMethod: 'client_credentials',
      apiKey: '',
      apiSecret: '',
      gorgiasSubdomain: '',
      gorgiasEmail: '',
      clientId: '',
      clientSecret: '',
      refreshToken: '',
      developerToken: '',
      customerId: '',
      awsAccessKey: '',
      awsSecretKey: '',
      marketplaceIds: '',
      regionId: '',
      country: '',
      amazonConnectMethod: 'manual',
      amazonRefreshToken: '',
      amazonSellingPartnerId: '',
      amazonLwaClientId: '',
      amazonLwaClientSecret: '',
      amazonAdsConnectMethod: 'oauth',
      amazonAdsClientId: '',
      amazonAdsClientSecret: '',
      amazonAdsRefreshToken: '',
      reauthConnectorId: null,
      region: '',
      accountName: ''
    });
  };
  
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setConnectorForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Brand select inside the connector setup dialog. Also regenerates the
  // auto-suggested connector name while the user hasn't manually edited it.
  const handleConnectorBrandChange = (e) => {
    const newBrandId = e.target.value;
    setConnectorForm(prev => ({
      ...prev,
      brandId: newBrandId,
      name: nameDirty ? prev.name : suggestConnectorName(newBrandId, connectorType)
    }));
  };

  // Name field edits flip the dirty flag so subsequent brand changes
  // stop overwriting what the user typed.
  const handleConnectorNameChange = (e) => {
    setNameDirty(true);
    setConnectorForm(prev => ({ ...prev, name: e.target.value }));
  };
  
  // Platforms that have no configuration form on Step 2 (pure OAuth)
  const noConfigPlatforms = [
    'facebook', 'google', 'google_ads', 'tiktok', 'tiktok_shop',
    'tiktok_business_account', 'pinterest',
    'google_search_console', 'google_analytics', 'google_merchant_center', 'google_postmaster',
    'quickbooks', 'microsoft_ads', 'yotpo', 'wise', 'attentive',
    'google_workspace', 'google-workspace',
    'microsoft_workspace', 'microsoft-workspace',
    'sps_commerce', 'sps-commerce', 'square', 'snapchat_ads', 'reddit_ads', 'sa360', 'dv360', 'cm360'
  ];

  const handleNextStep = () => {
    // Skip empty Step 2 for pure-OAuth platforms — go straight to create/connect
    if (activeStep === 0 && noConfigPlatforms.includes(connectorType)) {
      setActiveStep(2);
      return;
    }
    setActiveStep(prevStep => prevStep + 1);
  };
  
  const handleBackStep = () => {
    // Skip empty Step 2 when going back for pure-OAuth platforms
    if (activeStep === 2 && noConfigPlatforms.includes(connectorType)) {
      setActiveStep(0);
      return;
    }
    setActiveStep(prevStep => prevStep - 1);
  };
  
  // Helper to check if platform supports OAuth
  const isOAuthPlatform = (platform) => {
    const oauthPlatforms = [
      'shopify', 'facebook', 'google', 'google_ads', 'tiktok', 'tiktok_shop', 'tiktok_business_account', 'slack',
      // 'amazon' is the actual connectorType for Seller Partner ('amazon_sp'/'amazon-sp' are
      // aliases that never reach here). Without it, OAuth mode fell through to the generic
      // POST /api/connectors below and created a connector with NO credentials at all.
      'amazon', 'amazon_ads', 'amazon-ads', 'amazon_sp', 'amazon-sp', 'pinterest',
      'google_search_console', 'google_analytics', 'google_merchant_center', 'google_postmaster',
      'quickbooks', 'microsoft_ads', 'microsoft-ads', 'yotpo', 'revolut', 'wise', 'shiphero',
      'attentive', 'google_workspace', 'google-workspace',
      'microsoft_workspace', 'microsoft-workspace', 'xero',
      'sps_commerce', 'sps-commerce', 'square', 'snapchat_ads', 'reddit_ads', 'sa360', 'amazon_vendor', 'dv360', 'cm360'
    ];
    return oauthPlatforms.includes(platform);
  };
  
  const validateCurrentStep = () => {
    if (activeStep === 0) {
      // Validate basic information
      return connectorForm.name && connectorForm.brandId;
    } else if (activeStep === 1) {
      // Validate connector-specific information
      switch (connectorType) {
        case 'shopify':
          // For Shopify: validation depends on connection method
          if (connectorForm.shopifyConnectMethod === 'manual') {
            // Custom App method requires shop domain + access token only
            return connectorForm.shopDomain && connectorForm.accessToken;
          } else if (connectorForm.shopifyConnectMethod === 'client_credentials') {
            // Dev Dashboard App requires shop domain + client ID + client secret
            return connectorForm.shopDomain && connectorForm.clientId && connectorForm.clientSecret;
          } else {
            // OAuth method only requires shop domain
            return connectorForm.shopDomain;
          }
        case 'facebook':
          // OAuth-only, no validation needed
          return true;
        case 'google':
        case 'google_ads':
          // OAuth-only, no validation needed
          return true;
        case 'amazon':
          if (connectorForm.amazonConnectMethod === 'manual') {
            return connectorForm.amazonRefreshToken && connectorForm.amazonSellingPartnerId && connectorForm.country;
          }
          return connectorForm.country; // OAuth just needs country
        case 'amazon_vendor':
          return connectorForm.country; // OAuth through Vendor Central needs the store
        case 'amazon_ads':
          if (connectorForm.amazonAdsConnectMethod === 'manual') {
            return connectorForm.amazonAdsClientId && connectorForm.amazonAdsClientSecret
              && connectorForm.amazonAdsRefreshToken && connectorForm.country;
          }
          return connectorForm.country; // OAuth just needs country
        case 'tiktok':
        case 'tiktok_shop':
        case 'slack':
        case 'pinterest':
        case 'square':
        case 'snapchat_ads':
        case 'reddit_ads':
        case 'sa360':
        case 'dv360':
        case 'cm360':
        case 'google_search_console':
        case 'google_analytics':
        case 'google_merchant_center':
        case 'google_postmaster':
        case 'quickbooks':
        case 'microsoft_ads':
        case 'yotpo':
        case 'wise':
        case 'attentive':
        case 'google_workspace':
        case 'google-workspace':
        case 'microsoft_workspace':
        case 'microsoft-workspace':
        case 'sps_commerce':
        case 'sps-commerce':
          return true; // OAuth-only platforms don't need form validation
        case 'ups':
        case 'fedex':
          return connectorForm.carrierClientId && connectorForm.carrierClientSecret && connectorForm.carrierAccountNumber;
        case 'usps':
          return connectorForm.carrierClientId && connectorForm.carrierClientSecret;
        case 'revolut':
          // Revolut requires client ID and private key from user's Revolut Business setup
          return connectorForm.revolutClientId && connectorForm.revolutPrivateKey;
        case 'shiphero':
          // ShipHero requires access token and refresh token from ShipHero dashboard
          return connectorForm.shipheroAccessToken && connectorForm.shipheroRefreshToken;
        default:
          return false;
      }
    }
    return true;
  };
  
  const handleCreateConnector = async () => {
    try {
      setError('');
      
      // Find platform by name
      const selectedPlatform = platforms.find(platform => platform.name === connectorType);
      if (!selectedPlatform) {
        setError(`Platform ${connectorType} not found`);
        return;
      }
      
      // Check if this is Shopify with manual credentials
      if (connectorType === 'shopify' && connectorForm.shopifyConnectMethod === 'manual') {
        console.log('Creating Shopify connector with manual credentials');
        await handleManualShopifyConnect();
        return;
      }

      // Check if this is Shopify with Dev Dashboard App (client credentials)
      if (connectorType === 'shopify' && connectorForm.shopifyConnectMethod === 'client_credentials') {
        console.log('Creating Shopify connector with client credentials (Dev Dashboard App)');
        await handleClientCredentialsShopifyConnect();
        return;
      }

      // Check if this is Amazon SP with manual self-authorization
      if (connectorType === 'amazon' && connectorForm.amazonConnectMethod === 'manual') {
        console.log('Creating Amazon SP connector with manual self-authorization');
        await handleManualAmazonSPConnect();
        return;
      }

      // Check if this is Amazon Ads with manual (bring-your-own LWA app) authorization
      if (connectorType === 'amazon_ads' && connectorForm.amazonAdsConnectMethod === 'manual') {
        console.log('Creating Amazon Ads connector with manual LWA credentials');
        await handleManualAmazonAdsConnect();
        return;
      }
      
      // Shipping carriers (client credentials — not browser OAuth)
      if (['ups', 'usps', 'fedex'].includes(connectorType)) {
        await handleShippingCarrierConnect(connectorType);
        return;
      }

      // Check if this is an OAuth-required platform
      if (isOAuthPlatform(connectorType)) {
        console.log(`${connectorType} requires OAuth - redirecting to OAuth flow`);
        // Close the wizard dialog
        handleCloseDialog();
        // Start OAuth flow with the collected form data
        await handleOAuthConnect(connectorType);
        return;
      }
      
      // For non-OAuth platforms: Create the connector via manual API endpoint
      const connectorData = {
        platformId: selectedPlatform.id,
        brandId: resolveBrandId() ? parseInt(resolveBrandId()) : null,
        connectorName: connectorForm.name,
        platformData: {
          sourceType: connectorType,
          ...connectorForm
        }
      };
      
      const newConnector = await connectorService.createConnector(connectorData);
      setConnectors([...connectors, newConnector]);
      
      handleCloseDialog();
      
    } catch (err) {
      console.error('Error creating connector:', err);
      if (err.response?.status === 400) {
        setError(err.response?.data?.message || 'Invalid connector configuration. Please check your input.');
      } else if (err.response?.status === 403) {
        setError('You do not have permission to create connectors.');
      } else {
        setError(err.response?.data?.message || 'Failed to create connector');
      }
    }
  };
  
  // "Copy client link" is supported where the OAuth callback is public and provisions the
  // connector itself, so the account owner can finish without a SuperChargeMe login:
  // tiktok_shop, plus 'amazon' (Seller Partner) and 'amazon_ads' (Advertising).
  const isAmazonClientLink = connectorType === 'amazon' || connectorType === 'amazon_ads';

  // "Copy client link" — fetch a shareable authorize URL WITHOUT redirecting and copy it, so
  // an internal user can send it to an account owner who is NOT logged into SuperChargeMe.
  // They approve it in their own browser and the connector is auto-provisioned for the
  // selected brand (the platform's public callback does the provisioning).
  const handleCopyClientLink = async () => {
    const brandId = resolveBrandId();
    if (!brandId) {
      setError('Select a brand before generating a client link.');
      return;
    }
    // Amazon builds a region-specific consent URL, so the marketplace must be chosen first.
    if (isAmazonClientLink && !connectorForm.country) {
      setError('Select a country/region before generating a client link.');
      return;
    }
    setCopyingLink(true);
    try {
      const { authUrl, ttlHours } = await oauthService.getShareableLink(connectorType, {
        brandId,
        region: ['US', 'EU'].includes(connectorForm.tiktokShopRegion) ? connectorForm.tiktokShopRegion : 'GLOBAL',
        country: connectorForm.country,
        connectorName: connectorForm.name,
        currency: connectorForm.currency || 'USD',
      });
      // Quote the validity the BACKEND actually applied, not a hardcoded number.
      const validFor = ttlHours ? `${ttlHours} hour${ttlHours === 1 ? '' : 's'}` : '24 hours';
      // "shop owner" only for TikTok Shop; TikTok Ads + Amazon own an advertising/seller ACCOUNT.
      const owner = connectorType === 'tiktok_shop' ? 'shop owner' : 'account owner';
      try {
        await navigator.clipboard.writeText(authUrl);
        setNotification({ open: true, message: `Client link copied. Send it to the ${owner}; it stays valid for ${validFor}.`, severity: 'success' });
      } catch (clipErr) {
        // Clipboard API blocked (insecure context / permission) — surface the URL so the
        // user can copy it manually instead of failing silently.
        window.prompt(`Copy this client link and send it to the ${owner} (valid ${validFor}):`, authUrl);
      }
    } catch (err) {
      setError(err.message || 'Failed to generate client link');
    } finally {
      setCopyingLink(false);
    }
  };

  const handleOAuthConnect = async (platform) => {
    try {
      setError('');
      
      // Validate required fields based on platform
      if (!connectorForm.brandId) {
        setError('Please select a brand first');
        return;
      }
      
      let options = {
        brandId: resolveBrandId(),
        connectorName: connectorForm.name, // Pass the user-entered name
        currency: connectorForm.currency || 'USD' // Include user-selected currency
      };
      
      // Add platform-specific options
      if (platform === 'shopify') {
        if (!connectorForm.shopDomain || !connectorForm.shopDomain.trim()) {
          setError('Shop domain is required for Shopify OAuth');
          return;
        }
        // Clean shop domain (remove https://, http://, and .myshopify.com)
        const cleanDomain = connectorForm.shopDomain
          .replace(/^https?:\/\//, '')
          .replace(/\.myshopify\.com\/?$/, '')
          .trim();
        
        if (!cleanDomain) {
          setError('Invalid shop domain format. Enter just the shop name (e.g., "mystore" for mystore.myshopify.com)');
          return;
        }
        
        options.shopDomain = cleanDomain;
      }
      
      // Amazon platforms require country selection
      if (platform === 'amazon-ads' || platform === 'amazon_ads' || platform === 'amazon-sp' || platform === 'amazon' || platform === 'amazon_vendor') {
        if (!connectorForm.country) {
          setError('Please select a country/region for Amazon integration');
          return;
        }
        options.country = connectorForm.country;
      }

      // Revolut requires user-provided API credentials
      if (platform === 'revolut') {
        if (!connectorForm.revolutClientId || !connectorForm.revolutPrivateKey) {
          setError('Revolut Client ID and Private Key are required');
          return;
        }
        options.clientId = connectorForm.revolutClientId;
        options.privateKey = connectorForm.revolutPrivateKey;
        options.scopes = connectorForm.revolutScopes || 'READ';
        options.useSandbox = connectorForm.revolutUseSandbox || false;
      }

      // Square sandbox option (test sellers only)
      if (platform === 'square') {
        options.useSandbox = connectorForm.squareSandbox || false;
      }

      // PayPal sandbox option
      if (platform === 'paypal') {
        options.useSandbox = connectorForm.paypalSandbox || false;
      }

      // Payoneer sandbox option
      if (platform === 'payoneer') {
        options.useSandbox = connectorForm.payoneerSandbox || false;
      }

      // TikTok Shop — US is a separate app/portal and EU is a client-owned app; pass the chosen
      // region so the backend selects that app's authorize host + credentials. Default GLOBAL.
      if (platform === 'tiktok_shop' || platform === 'tiktok-shop') {
        options.region = ['US', 'EU'].includes(connectorForm.tiktokShopRegion) ? connectorForm.tiktokShopRegion : 'GLOBAL';
      }

      console.log(`Starting ${platform} OAuth with options:`, { ...options, apiKey: undefined, apiSecret: undefined, privateKey: options.privateKey ? '[REDACTED]' : undefined });
      
      // Start OAuth flow
      await oauthService.startOAuth(platform, options);
      
    } catch (err) {
      console.error('OAuth error:', err);
      // Show more specific error messages
      let errorMessage = err.message || `Failed to start ${platform} OAuth process`;

      // Handle common error cases
      if (err.response?.status === 500) {
        errorMessage = err.response?.data?.message || 'Server configuration error. Please contact support.';
      } else if (err.response?.status === 400) {
        errorMessage = err.response?.data?.message || 'Invalid request. Please check your input.';
      } else if (err.response?.status === 403) {
        // Keep the backend's reason when it gives one (e.g. the TikTok Shop US-app tenant
        // refusal) — a generic RBAC message would send the operator to the wrong fix.
        errorMessage = err.response?.data?.message || 'You do not have permission to create connectors.';
      }
      
      setError(errorMessage);
    }
  };

  const handleManualShopifyConnect = async () => {
    try {
      setError('');
      
      if (!connectorForm.brandId) {
        setError('Please select a brand first');
        return;
      }
      
      if (!connectorForm.shopDomain || !connectorForm.accessToken) {
        setError('Shop domain and access token are required');
        return;
      }
      
      // Clean shop domain
      const cleanDomain = connectorForm.shopDomain
        .replace(/^https?:\/\//, '')
        .replace(/\.myshopify\.com\/?$/, '')
        .trim();
      
      if (!cleanDomain) {
        setError('Invalid shop domain format. Enter just the shop name (e.g., "mystore")');
        return;
      }
      
      const payload = {
        shopDomain: cleanDomain,
        password: connectorForm.accessToken, // Admin API Access Token (shpat_...)
        brandId: resolveBrandId() ? parseInt(resolveBrandId()) : null,
        connectorName: connectorForm.name || `${cleanDomain} - Shopify`,
        market: connectorForm.market || '',
        currency: connectorForm.currency || 'USD'
      };
      
      console.log('Creating manual Shopify connector:', { 
        ...payload, 
        apiKey: '[REDACTED]', 
        password: '[REDACTED]',
        productToken: payload.productToken ? '[REDACTED]' : ''
      });
      
      const response = await api.post('/api/connectors/shopify/manual', payload);
      
      if (response.data.success) {
        // Refresh connectors list
        await fetchConnectors();
        
        // Show success message
        setNotification({
          open: true,
          message: `Shopify connector "${response.data.connector.name}" ${response.data.action} successfully!`,
          severity: 'success'
        });
        
        // Close dialog
        handleCloseDialog();
      } else {
        setError(response.data.message || 'Failed to create Shopify connector');
      }
      
    } catch (err) {
      console.error('Manual Shopify connection error:', err);
      let errorMessage = 'Failed to create Shopify connector';
      
      if (err.response?.data?.message) {
        errorMessage = err.response.data.message;
      } else if (err.response?.status === 400) {
        errorMessage = 'Invalid credentials or configuration. Please check your input.';
      } else if (err.response?.status === 403) {
        errorMessage = 'You do not have permission to create connectors.';
      }
      
      setError(errorMessage);
    }
  };

  // Shopify Dev Dashboard App connection (Client Credentials Grant)
  const handleClientCredentialsShopifyConnect = async () => {
    try {
      setError('');

      if (!connectorForm.brandId) {
        setError('Please select a brand first');
        return;
      }

      if (!connectorForm.shopDomain || !connectorForm.clientId || !connectorForm.clientSecret) {
        setError('Shop domain, Client ID, and Client Secret are required');
        return;
      }

      // Clean shop domain
      const cleanDomain = connectorForm.shopDomain
        .replace(/^https?:\/\//, '')
        .replace(/\.myshopify\.com\/?$/, '')
        .trim();

      if (!cleanDomain) {
        setError('Invalid shop domain format. Enter just the shop name (e.g., "mystore")');
        return;
      }

      const payload = {
        shopDomain: cleanDomain,
        clientId: connectorForm.clientId,
        clientSecret: connectorForm.clientSecret,
        brandId: resolveBrandId() ? parseInt(resolveBrandId()) : null,
        connectorName: connectorForm.name || `${cleanDomain} - Shopify`,
        market: connectorForm.market || '',
        currency: connectorForm.currency || 'USD'
      };

      console.log('Creating Shopify connector via client credentials:', {
        ...payload,
        clientId: '[REDACTED]',
        clientSecret: '[REDACTED]'
      });

      const response = await api.post('/api/connectors/shopify/client-credentials', payload);

      if (response.data.success) {
        await fetchConnectors();
        setNotification({
          open: true,
          message: `Shopify connector "${response.data.connector.name}" ${response.data.action} successfully!`,
          severity: 'success'
        });
        handleCloseDialog();
      } else {
        setError(response.data.message || 'Failed to create Shopify connector');
      }

    } catch (err) {
      console.error('Client credentials Shopify connection error:', err);
      let errorMessage = 'Failed to create Shopify connector';

      if (err.response?.data?.message) {
        errorMessage = err.response.data.message;
      } else if (err.response?.status === 400) {
        errorMessage = 'Invalid Client ID or Client Secret. Please check your Dev Dashboard app credentials.';
      } else if (err.response?.status === 403) {
        errorMessage = 'You do not have permission to create connectors.';
      }

      setError(errorMessage);
    }
  };

  // Manual Amazon SP Authorization (self-auth via Seller Central)
  const handleManualAmazonSPConnect = async () => {
    try {
      setError('');

      if (!connectorForm.brandId) {
        setError('Please select a brand first');
        return;
      }
      if (!connectorForm.amazonRefreshToken || !connectorForm.amazonSellingPartnerId || !connectorForm.country) {
        setError('Refresh token, Selling Partner ID, and country are required');
        return;
      }

      const payload = {
        refresh_token: connectorForm.amazonRefreshToken.trim(),
        selling_partner_id: connectorForm.amazonSellingPartnerId.trim(),
        country: connectorForm.country,
        connectorName: connectorForm.name || `Amazon SP - ${connectorForm.amazonSellingPartnerId.trim()}`,
        brandId: resolveBrandId() ? parseInt(resolveBrandId()) : null,
        currency: connectorForm.currency || 'USD',
        // Optional: the seller's OWN private SP-API app. Omitted entirely when blank so the
        // backend falls back to the server-wide app (AMAZON_SP_CLIENT_ID/_SECRET).
        lwaClientId: connectorForm.amazonLwaClientId?.trim() || undefined,
        lwaClientSecret: connectorForm.amazonLwaClientSecret?.trim() || undefined
      };

      console.log('Creating manual Amazon SP connector:', {
        ...payload,
        refresh_token: '[REDACTED]',
        lwaClientSecret: payload.lwaClientSecret ? '[REDACTED]' : undefined
      });

      const response = await api.post('/api/connectors/amazon-sp/manual-auth', payload);

      if (response.data.success) {
        await fetchConnectors();
        setNotification({
          open: true,
          message: `Amazon SP connector "${response.data.connector.name}" ${response.data.connector.was_updated ? 'updated' : 'created'} successfully!`,
          severity: 'success'
        });
        handleCloseDialog();
      } else {
        setError(response.data.message || 'Failed to create Amazon SP connector');
      }
    } catch (err) {
      console.error('Manual Amazon SP connection error:', err);
      let errorMessage = 'Failed to create Amazon SP connector';
      if (err.response?.data?.message) {
        errorMessage = err.response.data.message;
      } else if (err.response?.status === 400) {
        errorMessage = 'Invalid credentials. Please verify your refresh token and Selling Partner ID.';
      }
      setError(errorMessage);
    }
  };

  // Manual Amazon Ads connect — bring-your-own LWA app (Client ID + Client Secret + Refresh Token).
  // Body keys (client_id / client_secret / refresh_token) match the backend handler
  // (handleManualAmazonAdsAuth) and the Login-with-Amazon token-exchange field names.
  const handleManualAmazonAdsConnect = async () => {
    try {
      setError('');

      if (!connectorForm.brandId) {
        setError('Please select a brand first');
        return;
      }
      if (!connectorForm.amazonAdsClientId || !connectorForm.amazonAdsClientSecret
          || !connectorForm.amazonAdsRefreshToken || !connectorForm.country) {
        setError('Client ID, Client Secret, Refresh Token, and country are required');
        return;
      }

      const payload = {
        client_id: connectorForm.amazonAdsClientId.trim(),
        client_secret: connectorForm.amazonAdsClientSecret.trim(),
        refresh_token: connectorForm.amazonAdsRefreshToken.trim(),
        country: connectorForm.country,
        connectorName: connectorForm.name || `Amazon Ads - ${connectorForm.country}`,
        brandId: resolveBrandId() ? parseInt(resolveBrandId()) : null,
        currency: connectorForm.currency || 'USD',
        // On manual RE-auth, connectorId is set → backend updates that connector in place.
        connectorId: connectorForm.reauthConnectorId || undefined
      };

      console.log('Creating manual Amazon Ads connector:', {
        ...payload,
        client_secret: '[REDACTED]',
        refresh_token: '[REDACTED]'
      });

      const response = await api.post('/api/connectors/amazon-ads/manual-auth', payload);

      if (response.data.success) {
        await fetchConnectors();
        setNotification({
          open: true,
          message: `Amazon Ads connector "${response.data.connector.name}" ${response.data.connector.was_updated ? 'updated' : 'created'} successfully!`,
          severity: 'success'
        });
        handleCloseDialog();
      } else {
        setError(response.data.message || 'Failed to create Amazon Ads connector');
      }
    } catch (err) {
      console.error('Manual Amazon Ads connection error:', err);
      let errorMessage = 'Failed to create Amazon Ads connector';
      if (err.response?.data?.message) {
        errorMessage = err.response.data.message;
      } else if (err.response?.status === 400) {
        errorMessage = 'Invalid credentials. Please verify your Client ID, Client Secret, and Refresh Token.';
      }
      setError(errorMessage);
    }
  };

  // Salesforce Commerce Cloud: list the instance's sites with the pasted credentials so the brand picks its own.
  const loadSfccSites = async () => {
    try {
      setError('');
      const response = await api.post('/api/connectors/api-key/sfcc/sites', {
        clientId: connectorForm.sfccClientId,
        clientSecret: connectorForm.sfccClientSecret,
        shortCode: connectorForm.sfccShortCode,
        organizationId: connectorForm.sfccOrganizationId
      });
      const sites = (response.data && response.data.sites) || [];
      setConnectorForm(f => ({ ...f, sfccSites: sites, sfccSiteIds: sites.length === 1 ? [sites[0].id] : [] }));
    } catch (err) {
      setError(err.response?.data?.message || 'Could not list the sites of this instance');
    }
  };

  // Kibo Commerce: list the tenant's sites with the pasted credentials so the brand picks its own.
  const loadKiboSites = async () => {
    try {
      setError('');
      const response = await api.post('/api/connectors/api-key/kibo/sites', {
        tenantUrl: connectorForm.kiboTenantUrl,
        applicationKey: connectorForm.kiboApplicationKey,
        sharedSecret: connectorForm.kiboSharedSecret
      });
      const sites = (response.data && response.data.sites) || [];
      setConnectorForm(f => ({ ...f, kiboSites: sites, kiboSiteIds: sites.length === 1 ? [sites[0].id] : [] }));
    } catch (err) {
      setError(err.response?.data?.message || 'Could not list the sites of this tenant');
    }
  };

  // Adobe Commerce: the credentials as the backend expects them (hosting decides which set is sent).
  const adobeCommerceCredentials = () => (connectorForm.acHosting === 'saas'
    ? { hosting: 'saas', baseUrl: connectorForm.acBaseUrl, clientId: connectorForm.acClientId,
        clientSecret: connectorForm.acClientSecret, imsOrgId: connectorForm.acImsOrgId }
    : { hosting: 'paas', baseUrl: connectorForm.acBaseUrl, consumerKey: connectorForm.acConsumerKey,
        consumerSecret: connectorForm.acConsumerSecret, accessToken: connectorForm.acAccessToken,
        accessTokenSecret: connectorForm.acAccessTokenSecret });
  const adobeCommerceReady = () => Boolean(connectorForm.acBaseUrl) && (connectorForm.acHosting === 'saas'
    ? Boolean(connectorForm.acClientId && connectorForm.acClientSecret && connectorForm.acImsOrgId)
    : Boolean(connectorForm.acConsumerKey && connectorForm.acConsumerSecret && connectorForm.acAccessToken && connectorForm.acAccessTokenSecret));

  // Adobe Commerce: list the instance's store views with the pasted credentials so the brand picks its own.
  const loadAdobeCommerceStores = async () => {
    try {
      setError('');
      const response = await api.post('/api/connectors/api-key/adobe-commerce/stores', adobeCommerceCredentials());
      const stores = (response.data && response.data.stores) || [];
      setConnectorForm(f => ({ ...f, acStores: stores, acStoreIds: stores.length === 1 ? [stores[0].id] : [] }));
    } catch (err) {
      setError(err.response?.data?.message || 'Could not list the store views of this instance');
    }
  };

  // BigQuery: what the key file says (client_email / project_id only; the key itself stays in the form).
  const bigQueryKeyInfo = () => {
    try {
      const k = JSON.parse(connectorForm.bqKeyText || '');
      return k && k.type === 'service_account' ? { email: k.client_email || '', project: k.project_id || '' } : null;
    } catch (e) {
      return null;
    }
  };
  const bigQueryAccess = () => ({
    serviceAccountKey: connectorForm.bqKeyText,
    projectId: connectorForm.bqProjectId || undefined,
    billingProjectId: connectorForm.bqBillingProjectId || undefined
  });
  const loadBigQueryKeyFile = (e) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = '';
    if (!file) return;
    if (file.size > 20000) {
      setError('This file is too large to be a service-account key');
      return;
    }
    const reader = new FileReader();
    reader.onload = () => setConnectorForm(f => ({ ...f, bqKeyText: String(reader.result || ''), bqKeyFileName: file.name,
      bqDatasets: [], bqPicked: {}, bqColumns: {} }));
    reader.readAsText(file);
  };
  // BigQuery: list the datasets and tables the key can see, so the brand picks its own.
  const loadBigQueryTables = async () => {
    try {
      setError('');
      const datasets = (connectorForm.bqDatasetFilter || '').split(',').map(d => d.trim()).filter(Boolean);
      const response = await api.post('/api/connectors/api-key/bigquery/tables', { ...bigQueryAccess(),
        datasets: datasets.length ? datasets : undefined });
      setConnectorForm(f => ({ ...f, bqDatasets: (response.data && response.data.datasets) || [], bqPicked: {}, bqColumns: {} }));
    } catch (err) {
      setError(err.response?.data?.message || 'Could not list the BigQuery tables this key can read');
    }
  };
  // BigQuery: pick / unpick a table; picking loads its columns for the cursor and unique-key choices.
  const toggleBigQueryTable = async (dataset, table, checked) => {
    const id = `${dataset}.${table}`;
    if (!checked) {
      setConnectorForm(f => {
        const picked = { ...f.bqPicked };
        delete picked[id];
        return { ...f, bqPicked: picked };
      });
      return;
    }
    try {
      setError('');
      const response = await api.post('/api/connectors/api-key/bigquery/columns', { ...bigQueryAccess(), dataset, table });
      const info = response.data || {};
      setConnectorForm(f => ({ ...f, bqColumns: { ...f.bqColumns, [id]: info },
        bqPicked: { ...f.bqPicked, [id]: { cursorColumn: '', primaryKey: info.suggestedPrimaryKey || [] } } }));
    } catch (err) {
      setError(err.response?.data?.message || `Could not read the columns of ${id}`);
    }
  };
  const setBigQueryPick = (id, patch) => setConnectorForm(f => ({ ...f,
    bqPicked: { ...f.bqPicked, [id]: { ...f.bqPicked[id], ...patch } } }));
  // BigQuery: a table read by a changed-since column needs its unique-key columns (the backend and fetcher refuse it too).
  const bigQueryMissingKeys = () => Object.entries(connectorForm.bqPicked || {})
    .filter(([, pick]) => pick.cursorColumn && !(pick.primaryKey || []).length).map(([id]) => id);
  const bigQueryLimitTooHigh = () => [connectorForm.bqMaxGibPerQuery, connectorForm.bqMaxGibPerRun].some(v => Number(v) > 1024) ||
    Number(connectorForm.bqMaxStoredGibPerRun) > 50;

  // Snowflake: step 1 - our key pair for this brand (only the public key + SQL come back; the private key stays on the server).
  const sfKey = (t) => JSON.stringify([t.database, t.schema, t.table]);
  const generateSnowflakeKey = async () => {
    try {
      setError('');
      setConnectorForm(f => ({ ...f, sfBusy: true }));
      const response = await api.post('/api/connectors/api-key/snowflake/key-pair', { brandId: resolveBrandId() });
      const d = response.data || {};
      setConnectorForm(f => ({ ...f, sfBusy: false, sfKeyId: d.keyId, sfPublicKey: d.publicKey, sfFingerprint: d.fingerprint, sfSetupSql: d.setupSql,
        sfUser: d.suggestedUser || f.sfUser, sfRole: d.suggestedRole || f.sfRole }));   // per-connection user + role named in the SQL
    } catch (err) {
      setConnectorForm(f => ({ ...f, sfBusy: false }));
      setError(err.response?.data?.message || 'Could not create the Snowflake key pair');
    }
  };
  // Snowflake: step 2 - sign in with the key and list the tables / views the role can see.
  const snowflakeConnection = () => ({ brandId: resolveBrandId(), keyId: connectorForm.sfKeyId, account: connectorForm.sfAccount,
    user: connectorForm.sfUser, role: connectorForm.sfRole, warehouse: connectorForm.sfWarehouse });
  const snowflakeReady = () => Boolean(connectorForm.sfKeyId && connectorForm.sfAccount && connectorForm.sfUser &&
    connectorForm.sfRole && connectorForm.sfWarehouse);
  const loadSnowflakeObjects = async () => {
    try {
      setError('');
      setConnectorForm(f => ({ ...f, sfBusy: true }));
      const response = await api.post('/api/connectors/api-key/snowflake/objects', snowflakeConnection());
      const d = response.data || {};
      setConnectorForm(f => ({ ...f, sfBusy: false, sfObjects: d.objects || [], sfTruncated: d.truncated === true, sfSelected: {} }));
    } catch (err) {
      setConnectorForm(f => ({ ...f, sfBusy: false }));
      setError(err.response?.data?.message || 'Could not list the Snowflake tables');
    }
  };
  const setSnowflakeTable = (obj, patch) => setConnectorForm(f => {
    const next = { ...f.sfSelected };
    if (patch === null) delete next[sfKey(obj)];
    else next[sfKey(obj)] = { ...(next[sfKey(obj)] || { cursorColumn: '', primaryKey: [] }), ...patch };
    return { ...f, sfSelected: next };
  });
  // Databricks: list the Unity Catalog tables / views the principal can see (no warehouse compute), then pick.
  const dbKey = (t) => JSON.stringify([t.catalog, t.schema, t.table]);
  const databricksConnection = () => ({ brandId: resolveBrandId(), host: connectorForm.dbHost.trim(),
    warehouseId: connectorForm.dbWarehouseId.trim().replace(/^.*\/warehouses\//, ''),   // the ID, or the HTTP path that ends in it
    authType: connectorForm.dbAuthType,
    ...(connectorForm.dbAuthType === 'pat'
      ? { personalAccessToken: connectorForm.dbToken }
      : { clientId: connectorForm.dbClientId.trim(), clientSecret: connectorForm.dbClientSecret }) });
  const databricksReady = () => Boolean(connectorForm.dbHost && connectorForm.dbWarehouseId &&
    (connectorForm.dbAuthType === 'pat' ? connectorForm.dbToken : connectorForm.dbClientId && connectorForm.dbClientSecret));
  const loadDatabricksObjects = async () => {
    try {
      setError('');
      setConnectorForm(f => ({ ...f, dbBusy: true }));
      const response = await api.post('/api/connectors/api-key/databricks/objects', {
        ...databricksConnection(), catalogs: connectorForm.dbCatalogs.trim() || undefined });
      const d = response.data || {};
      setConnectorForm(f => ({ ...f, dbBusy: false, dbObjects: d.objects || [], dbTruncated: d.truncated === true, dbSelected: {} }));
    } catch (err) {
      setConnectorForm(f => ({ ...f, dbBusy: false }));
      setError(err.response?.data?.message || 'Could not list the Databricks tables');
    }
  };
  const setDatabricksTable = (obj, patch) => setConnectorForm(f => {
    const next = { ...f.dbSelected };
    if (patch === null) delete next[dbKey(obj)];
    else next[dbKey(obj)] = { ...(next[dbKey(obj)] || { cursorColumn: '', primaryKey: [] }), ...patch };
    return { ...f, dbSelected: next };
  });
  const handleApiKeyConnect = async (platform) => {
    try {
      setError('');

      if (!connectorForm.brandId) {
        setError('Please select a brand first');
        return;
      }

      // Platform-specific validation
      if (platform === 'wise') {
        if (!connectorForm.wiseApiToken) {
          setError('Please enter your Wise API token');
          return;
        }
      } else if (platform === 'paypal') {
        if (!connectorForm.paypalClientId || !connectorForm.paypalClientSecret) {
          setError('Please enter both Client ID and Client Secret');
          return;
        }
      } else if (platform === 'twilio') {
        if (!connectorForm.twilioAccountSid || !connectorForm.twilioAuthToken) {
          setError('Please enter both Account SID and Auth Token');
          return;
        }
      } else if (platform === 'klaviyo') {
        if (!connectorForm.apiKey) {
          setError('Please paste your Klaviyo Private API Key');
          return;
        }
      } else if (platform === 'mirakl') {
        if (connectorForm.miraklAuthMode === 'connect') {
          if (!connectorForm.miraklClientId || !connectorForm.miraklClientSecret) {
            setError('Please enter both your Mirakl Connect Client ID and Client Secret');
            return;
          }
        } else if (!connectorForm.miraklHost || !connectorForm.apiKey) {
          setError('Please enter both the marketplace host and your Mirakl API key');
          return;
        }
      } else if (platform === 'walmart') {
        if (!connectorForm.walmartClientId || !connectorForm.walmartClientSecret) {
          setError('Please enter both your Walmart Client ID and Client Secret');
          return;
        }
      } else if (platform === 'target_plus') {
        if (!connectorForm.targetSellerId || !connectorForm.targetSellerToken) {
          setError('Please enter both your Target Seller ID and API token');
          return;
        }
      } else if (platform === 'impact') {
        if (!connectorForm.impactAccountSid || !connectorForm.impactAuthToken) {
          setError('Please enter both your Impact.com Account SID and Auth Token');
          return;
        }
      } else if (platform === 'taboola') {
        if (!connectorForm.taboolaClientId || !connectorForm.taboolaClientSecret) {
          setError('Please enter both your Taboola Client ID and Client Secret');
          return;
        }
      } else if (platform === 'powerreviews') {
        if (!connectorForm.powerreviewsClientId || !connectorForm.powerreviewsClientSecret) {
          setError('Please enter both your PowerReviews Client ID and Client Secret');
          return;
        }
      } else if (platform === 'adobe_commerce') {
        if (!adobeCommerceReady()) {
          setError('Please enter the store base URL and all the credentials');
          return;
        }
        if (!(connectorForm.acStoreIds || []).length) {
          setError('Load the store views and pick the store view(s) of this brand');
          return;
        }
      } else if (platform === 'sfcc') {
        if (!connectorForm.sfccClientId || !connectorForm.sfccClientSecret || !connectorForm.sfccShortCode || !connectorForm.sfccOrganizationId) {
          setError('Please enter the API client ID and password, the short code and the organization ID');
          return;
        }
        if (!(connectorForm.sfccSiteIds || []).length) {
          setError('Load the sites and pick the site(s) of this brand');
          return;
        }
      } else if (platform === 'kibo') {
        if (!connectorForm.kiboTenantUrl || !connectorForm.kiboApplicationKey || !connectorForm.kiboSharedSecret) {
          setError('Please enter your Kibo tenant URL, the Application Key and the Shared Secret');
          return;
        }
        if (!(connectorForm.kiboSiteIds || []).length) {
          setError('Load the sites and pick the site(s) of this brand');
          return;
        }
      } else if (platform === 'zendesk') {
        if (!connectorForm.zendeskSubdomain || !connectorForm.zendeskClientId || !connectorForm.zendeskClientSecret) {
          setError('Please enter your Zendesk subdomain and the OAuth client Identifier and Secret');
          return;
        }
      } else if (platform === 'gladly') {
        if (!connectorForm.gladlyHost || !connectorForm.gladlyEmail || !connectorForm.gladlyApiToken) {
          setError('Please enter your Gladly address, the API user email and the API token');
          return;
        }
      } else if (platform === 'kustomer') {
        if (!connectorForm.kustomerOrgName || !connectorForm.kustomerApiKey) {
          setError('Please enter your Kustomer organization name and the API key');
          return;
        }
      } else if (platform === 'segment') {
        if (!connectorForm.segmentBucket || !connectorForm.segmentRegion || !connectorForm.segmentAccessKeyId || !connectorForm.segmentSecretAccessKey) {
          setError('Please enter the S3 bucket, its AWS region and the IAM access key ID and secret');
          return;
        }
      } else if (platform === 'file_feed') {
        if (!connectorForm.fileFeedHost || !connectorForm.fileFeedUsername ||
            !(connectorForm.fileFeedAuth === 'key' ? connectorForm.fileFeedPrivateKey : connectorForm.fileFeedPassword)) {
          setError('Please enter the SFTP host, the username and the password or private key');
          return;
        }
      } else if (platform === 'bigquery') {
        if (!bigQueryKeyInfo() || Object.keys(connectorForm.bqPicked || {}).length === 0) {
          setError('Please add the service account key and pick at least one table or view');
          return;
        }
        if (bigQueryMissingKeys().length) {
          setError(`Pick the unique-key columns of ${bigQueryMissingKeys().join(', ')}: a table with a changed-since column needs them`);
          return;
        }
        if (bigQueryLimitTooHigh()) {
          setError('Scan limits above 1024 GiB and storage above 50 GiB per sync are not self-serve: contact support to raise them');
          return;
        }
      } else if (platform === 'snowflake') {
        if (!snowflakeReady()) {
          setError('Generate the key pair, then enter the account identifier, user, role and warehouse');
          return;
        }
        if (!Object.keys(connectorForm.sfSelected || {}).length) {
          setError('Load the tables and pick at least one table or view');
          return;
        }
        if (Object.values(connectorForm.sfSelected).some(sel => sel.cursorColumn && !(sel.primaryKey || []).length)) {
          setError('A table read by an updated-at column needs its key column(s)');
          return;
        }
      } else if (platform === 'databricks') {
        if (!databricksReady()) {
          setError('Enter the workspace URL, the SQL warehouse ID and the service principal client ID and OAuth secret (or an access token)');
          return;
        }
        if (!Object.keys(connectorForm.dbSelected || {}).length) {
          setError('Load the tables and pick at least one table or view');
          return;
        }
        if (Object.values(connectorForm.dbSelected).some(sel => sel.cursorColumn && !(sel.primaryKey || []).length)) {
          setError('A table read by an updated-at column needs its key column(s)');
          return;
        }
      } else if (platform === 'brightpearl') {
        if (!connectorForm.brightpearlAppRef || !connectorForm.brightpearlAccountToken) {
          setError('Please enter the Brightpearl private app identifier and the staff token');
          return;
        }
      } else if (platform === 'adobe_analytics') {
        if (!connectorForm.adobeClientId || !connectorForm.adobeClientSecret || !connectorForm.adobeOrgId) {
          setError('Please enter the Client ID, Client Secret and Organization ID of your Adobe credential');
          return;
        }
      } else if (platform === 'adobe_experience_platform') {
        if (!connectorForm.aepClientId || !connectorForm.aepClientSecret || !connectorForm.aepOrgId) {
          setError('Please enter the Client ID, Client Secret and Organization ID of your Adobe credential');
          return;
        }
      } else if (platform === 'adobe_campaign') {
        if (!connectorForm.adobeCampaignClientId || !connectorForm.adobeCampaignClientSecret || !connectorForm.adobeCampaignInstance) {
          setError('Please enter the Client ID and Client Secret of your Adobe credential and your Campaign instance');
          return;
        }
      } else if (platform === 'walmart_connect') {
        if (!/^[1-9][0-9]{0,18}$/.test(String(connectorForm.walmartConnectAdvertiserId || '').trim())) {
          setError('Please enter your Walmart Connect advertiser ID (digits only)');
          return;
        }
      } else if (platform === 'marketo') {
        if (!connectorForm.marketoEndpoint || !connectorForm.marketoClientId || !connectorForm.marketoClientSecret) {
          setError('Please enter the REST API endpoint, Client ID and Client Secret');
          return;
        }
      } else if (platform === 'criteo_retail_media') {
        if (!connectorForm.criteoClientId || !connectorForm.criteoClientSecret) {
          setError('Please enter both your Criteo Client ID and Client Secret');
          return;
        }
      } else if (platform === 'awin') {
        if (!connectorForm.awinApiToken) {
          setError('Please enter your Awin API token');
          return;
        }
      } else if (platform === 'partnerize') {
        if (!connectorForm.partnerizeApplicationKey || !connectorForm.partnerizeUserApiKey) {
          setError('Please enter both your Partnerize User application key and User API key');
          return;
        }
      } else if (platform === 'rakuten_advertising') {
        if (!connectorForm.rakutenReportApiTokenUrls.trim()) {
          setError('Please paste at least one Rakuten Advertising report API URL');
          return;
        }
      } else if (platform === 'cj') {
        if (!connectorForm.apiKey || !connectorForm.cjAdvertiserCid) {
          setError('Please enter both your CJ personal access token and your advertiser Company ID');
          return;
        }
      } else if (platform === 'braze') {
        if (!connectorForm.apiKey || !connectorForm.brazeRestEndpoint) {
          setError('Please enter both your Braze REST API key and REST endpoint');
          return;
        }
      } else if (platform === 'sfmc') {
        if (!connectorForm.sfmcAuthBaseUri || !connectorForm.sfmcClientId || !connectorForm.sfmcClientSecret || !connectorForm.sfmcAccountId) {
          setError('Please enter the Authentication Base URI, Client ID, Client Secret and business unit MID');
          return;
        }
      } else if (platform === 'salesforce_service_cloud') {
        if (!connectorForm.sfscMyDomainUrl || !connectorForm.sfscClientId || !connectorForm.sfscClientSecret) {
          setError('Please enter your My Domain URL, consumer key and consumer secret');
          return;
        }
      } else if (platform === 'knocommerce') {
        if (!connectorForm.knoClientId || !connectorForm.knoClientSecret) {
          setError('Please enter both your Kno Client ID and Client Secret');
          return;
        }
      } else if (platform === 'okendo') {
        if (!connectorForm.okendoUserId || !connectorForm.okendoApiKey) {
          setError('Please enter both your Okendo User ID and Merchant REST API key');
          return;
        }
      } else if (platform === 'yotpo_reviews') {
        if (!connectorForm.yotpoStoreId || !connectorForm.yotpoApiSecret) {
          setError('Please enter both your Yotpo Store ID and API secret');
          return;
        }
        if (Boolean(connectorForm.yotpoLoyaltyGuid) !== Boolean(connectorForm.yotpoLoyaltyApiKey)) {
          setError('For Loyalty, enter BOTH the GUID and the API key, or leave both empty.');
          return;
        }
      } else {
        if (!connectorForm.apiKey) {
          setError('Please enter your API key');
          return;
        }
      }

      let endpoint;
      let payload = {
        brandId: resolveBrandId(),
        connectorName: `${platform.charAt(0).toUpperCase() + platform.slice(1)} - ${connectorForm.apiKey.substring(0, 8)}...`,
        apiKey: connectorForm.apiKey,
        currency: connectorForm.currency || 'USD'
      };

      switch (platform) {
        case 'klaviyo':
          endpoint = '/api/connectors/api-key/klaviyo';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend will derive from Klaviyo's company_name
            apiKey: connectorForm.apiKey
          };
          break;
        case 'gorgias':
          endpoint = '/api/connectors/api-key/gorgias';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend derives from the Gorgias account domain
            subdomain: connectorForm.gorgiasSubdomain,
            email: connectorForm.gorgiasEmail,
            apiKey: connectorForm.apiKey,
            currency: connectorForm.currency || undefined
          };
          break;
        case 'smsbump':
          endpoint = '/api/connectors/api-key/smsbump';
          break;
        case 'attentive':
          endpoint = '/api/connectors/api-key/attentive';
          break;
        case 'edesk':
          endpoint = '/api/connectors/api-key/edesk';
          break;
        case 'mirakl':
          endpoint = '/api/connectors/api-key/mirakl';
          payload = connectorForm.miraklAuthMode === 'connect'
            ? {
                brandId: resolveBrandId(),
                connectorName: connectorForm.name || undefined,
                authMode: 'connect',
                clientId: connectorForm.miraklClientId,
                clientSecret: connectorForm.miraklClientSecret,
                currency: connectorForm.currency || undefined
              }
            : {
                brandId: resolveBrandId(),
                connectorName: connectorForm.name || undefined,  // backend derives from the shop name
                authMode: 'seller_api',
                host: connectorForm.miraklHost,
                marketplaceName: connectorForm.miraklMarketplaceName || undefined,
                apiKey: connectorForm.apiKey,
                currency: connectorForm.currency || undefined    // backend falls back to the shop's own currency
              };
          break;
        case 'target_plus':
          endpoint = '/api/connectors/api-key/target-plus';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,
            sellerId: connectorForm.targetSellerId,
            sellerToken: connectorForm.targetSellerToken,
            appKey: connectorForm.targetAppKey || undefined,
            currency: connectorForm.currency || 'USD'
          };
          break;
        case 'impact':
          endpoint = '/api/connectors/api-key/impact';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,
            accountSid: connectorForm.impactAccountSid,
            authToken: connectorForm.impactAuthToken,
            currency: connectorForm.currency || 'USD'
          };
          break;
        case 'dor':
          endpoint = '/api/connectors/api-key/dor';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend derives from the Dor team name
            apiKey: connectorForm.apiKey,
            teamId: connectorForm.dorTeamId || undefined,     // optional; backend auto-detects if one team
            currency: connectorForm.currency || undefined
          };
          break;
        case 'heartland_retail':
          endpoint = '/api/connectors/api-key/heartland-retail';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,         // backend derives from the account address
            accountHost: connectorForm.heartlandAccountHost,         // e.g. yourstore.retail.heartland.us
            apiToken: connectorForm.apiKey,
            currency: connectorForm.heartlandCurrency                // required: the API exposes no currency
          };
          break;
        case 'recharge':
          endpoint = '/api/connectors/api-key/recharge';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend derives from the Recharge store name
            apiToken: connectorForm.apiKey                    // currency + timezone come from the Recharge store
          };
          break;
        case 'loop_returns':
          endpoint = '/api/connectors/api-key/loop_returns';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "Loop Returns"
            apiKey: connectorForm.apiKey
          };
          break;
        case 'appstle_subscriptions':
          endpoint = '/api/connectors/api-key/appstle_subscriptions';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend derives from the shop domain
            apiKey: connectorForm.apiKey,
            shopDomain: connectorForm.appstleShopDomain      // yourstore.myshopify.com
          };
          break;
        case 'smile':
          endpoint = '/api/connectors/api-key/smile';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "Smile"
            apiKey: connectorForm.apiKey                      // the Smile account is identified by the key fingerprint
          };
          break;
        case 'stayai':
          endpoint = '/api/connectors/api-key/stayai';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "Stay AI"
            apiKey: connectorForm.apiKey                      // Stay exposes no shop id; identity = key fingerprint
          };
          break;
        case 'loop_subscriptions':
          endpoint = '/api/connectors/api-key/loop_subscriptions';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "Loop Subscriptions"
            apiKey: connectorForm.apiKey                      // Loop exposes no store id; identity = token fingerprint
          };
          break;
        case 'globale':
          endpoint = '/api/connectors/api-key/globale';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "Global-e"
            apiKey: connectorForm.apiKey                      // the Merchant GUID; identity = its fingerprint
          };
          break;
        case 'bold_subscriptions':
          endpoint = '/api/connectors/api-key/bold_subscriptions';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "Bold Subscriptions - <shop domain>"
            apiKey: connectorForm.apiKey                      // the API access token; Bold names the shop it belongs to
          };
          break;
        case 'powerreviews':
          endpoint = '/api/connectors/api-key/powerreviews';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "PowerReviews"
            clientId: connectorForm.powerreviewsClientId,
            clientSecret: connectorForm.powerreviewsClientSecret
          };
          break;
        case 'adobe_commerce':
          endpoint = '/api/connectors/api-key/adobe-commerce';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "Adobe Commerce"
            ...adobeCommerceCredentials(),
            storeIds: connectorForm.acStoreIds,
            wholeInstance: connectorForm.acWholeInstance === true
          };
          break;
        case 'woocommerce':
          endpoint = '/api/connectors/api-key/woocommerce';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "WooCommerce"
            storeUrl: connectorForm.wooStoreUrl,
            consumerKey: connectorForm.wooConsumerKey,
            consumerSecret: connectorForm.wooConsumerSecret
          };
          break;
        case 'sfcc':
          endpoint = '/api/connectors/api-key/sfcc';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "Salesforce Commerce Cloud"
            clientId: connectorForm.sfccClientId,
            clientSecret: connectorForm.sfccClientSecret,
            shortCode: connectorForm.sfccShortCode,
            organizationId: connectorForm.sfccOrganizationId,
            ociTenantGroupId: connectorForm.sfccOciTenantGroupId || undefined,
            siteIds: connectorForm.sfccSiteIds,
            wholeInstance: connectorForm.sfccWholeInstance === true,
            customObjectTypes: (connectorForm.sfccCustomObjectTypes || '').split(/[\s,]+/).filter(Boolean)
          };
          break;
        case 'kibo':
          endpoint = '/api/connectors/api-key/kibo';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "Kibo - <tenant name>"
            tenantUrl: connectorForm.kiboTenantUrl,
            applicationKey: connectorForm.kiboApplicationKey,
            sharedSecret: connectorForm.kiboSharedSecret,
            siteIds: connectorForm.kiboSiteIds,
            wholeTenant: connectorForm.kiboWholeTenant === true
          };
          break;
        case 'zendesk':
          endpoint = '/api/connectors/api-key/zendesk';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "Zendesk - <subdomain>"
            subdomain: connectorForm.zendeskSubdomain,
            clientId: connectorForm.zendeskClientId,
            clientSecret: connectorForm.zendeskClientSecret,
            // multi-brand accounts: each Zendesk brand mapped to one of our brands (asked for after the first try)
            brandMapping: (connectorForm.zendeskBrandChoices || []).length ? connectorForm.zendeskBrandMapping : undefined
          };
          break;
        case 'gladly':
          endpoint = '/api/connectors/api-key/gladly';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "Gladly - <organization name>"
            host: connectorForm.gladlyHost,
            email: connectorForm.gladlyEmail,
            apiToken: connectorForm.gladlyApiToken,
            // multi-inbox organizations: each inbox mapped to one of our brands (asked for after the first try)
            inboxMapping: (connectorForm.gladlyInboxChoices || []).length ? connectorForm.gladlyInboxMapping : undefined
          };
          break;
        case 'kustomer':
          endpoint = '/api/connectors/api-key/kustomer';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "Kustomer - <organization name>"
            orgName: connectorForm.kustomerOrgName,
            apiKey: connectorForm.kustomerApiKey
          };
          break;
        case 'segment':
          endpoint = '/api/connectors/api-key/segment';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "Segment - <bucket>/<prefix>"
            bucket: connectorForm.segmentBucket,              // "bucket" or "bucket/path/prefix", as in the Segment destination
            region: connectorForm.segmentRegion,
            awsAccessKeyId: connectorForm.segmentAccessKeyId,
            awsSecretAccessKey: connectorForm.segmentSecretAccessKey,
            publicApiToken: connectorForm.segmentPublicApiToken || undefined,   // optional: workspace metadata + usage
            publicApiRegion: connectorForm.segmentPublicApiRegion || 'us'
          };
          break;
        case 'file_feed':
          endpoint = '/api/connectors/api-key/file-feed';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "<feed type> - <host><path>"
            feedType: connectorForm.fileFeedType,
            host: connectorForm.fileFeedHost,
            port: Number(connectorForm.fileFeedPort) || 22,
            username: connectorForm.fileFeedUsername,
            password: connectorForm.fileFeedAuth === 'key' ? undefined : connectorForm.fileFeedPassword,
            privateKey: connectorForm.fileFeedAuth === 'key' ? connectorForm.fileFeedPrivateKey : undefined,
            passphrase: connectorForm.fileFeedAuth === 'key' ? (connectorForm.fileFeedPassphrase || undefined) : undefined,
            path: connectorForm.fileFeedPath,
            filePattern: connectorForm.fileFeedPattern || undefined,
            csvDelimiter: connectorForm.fileFeedType === 'csv' ? connectorForm.fileFeedCsvDelimiter : undefined,
            recursive: connectorForm.fileFeedRecursive === true
          };
          break;
        case 'bigquery':
          endpoint = '/api/connectors/api-key/bigquery';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "BigQuery - <project>"
            ...bigQueryAccess(),
            tables: Object.entries(connectorForm.bqPicked || {}).map(([id, pick]) => {
              const dot = id.indexOf('.');
              return { dataset: id.slice(0, dot), table: id.slice(dot + 1), cursorColumn: pick.cursorColumn || '',
                primaryKey: pick.primaryKey || [] };
            }),
            maxGibPerQuery: Number(connectorForm.bqMaxGibPerQuery) || undefined,
            maxGibPerRun: Number(connectorForm.bqMaxGibPerRun) || undefined,
            maxStoredGibPerRun: Number(connectorForm.bqMaxStoredGibPerRun) || undefined
          };
          break;
        case 'snowflake':
          endpoint = '/api/connectors/api-key/snowflake';
          payload = {
            ...snowflakeConnection(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "Snowflake - <org>-<account>"
            maxGiBPerRun: connectorForm.sfMaxGiB ? Number(connectorForm.sfMaxGiB) : undefined,   // default 20 GiB
            tables: (connectorForm.sfObjects || []).filter(o => connectorForm.sfSelected[sfKey(o)]).map(o => ({
              database: o.database, schema: o.schema, table: o.table,
              cursorColumn: connectorForm.sfSelected[sfKey(o)].cursorColumn || undefined,
              primaryKey: connectorForm.sfSelected[sfKey(o)].primaryKey || []
            }))
          };
          break;
        case 'databricks':
          endpoint = '/api/connectors/api-key/databricks';
          payload = {
            ...databricksConnection(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "Databricks - <workspace>"
            maxGiBPerRun: connectorForm.dbMaxGiB ? Number(connectorForm.dbMaxGiB) : undefined,   // default 20 GiB
            tables: (connectorForm.dbObjects || []).filter(o => connectorForm.dbSelected[dbKey(o)]).map(o => ({
              catalog: o.catalog, schema: o.schema, table: o.table,
              cursorColumn: connectorForm.dbSelected[dbKey(o)].cursorColumn || undefined,
              primaryKey: connectorForm.dbSelected[dbKey(o)].primaryKey || []
            }))
          };
          break;
        case 'brightpearl':
          endpoint = '/api/connectors/api-key/brightpearl';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "Brightpearl - <account code>"
            appRef: connectorForm.brightpearlAppRef,          // "<account code>_<app name>": the account code comes from it
            accountToken: connectorForm.brightpearlAccountToken,
            datacentre: connectorForm.brightpearlDatacentre || undefined   // empty: the backend finds the datacentre
          };
          break;
        case 'ordergroove':
          endpoint = '/api/connectors/api-key/ordergroove';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "Ordergroove"
            apiKey: connectorForm.apiKey                      // store + currency come from Ordergroove
          };
          break;
        case 'stripe':
          endpoint = '/api/connectors/api-key/stripe';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "Stripe"
            apiKey: connectorForm.apiKey
          };
          break;
        case 'yotpo_reviews':
          endpoint = '/api/connectors/api-key/yotpo';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend falls back to "Yotpo - <store id>"
            storeId: connectorForm.yotpoStoreId,
            apiSecret: connectorForm.yotpoApiSecret,
            loyaltyGuid: connectorForm.yotpoLoyaltyGuid || undefined,
            loyaltyApiKey: connectorForm.yotpoLoyaltyApiKey || undefined
          };
          break;
        case 'postscript':
          endpoint = '/api/connectors/api-key/postscript';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend derives from the Postscript shop name
            apiKey: connectorForm.apiKey
          };
          break;
        case 'okendo':
          endpoint = '/api/connectors/api-key/okendo';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend falls back to "Okendo - <user id prefix>"
            userId: connectorForm.okendoUserId,
            apiKey: connectorForm.okendoApiKey
          };
          break;
        case 'fairing':
          endpoint = '/api/connectors/api-key/fairing';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "Fairing"
            apiKey: connectorForm.apiKey
          };
          break;
        case 'braze':
          endpoint = '/api/connectors/api-key/braze';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "Braze (<instance>)"
            apiKey: connectorForm.apiKey,
            restEndpoint: connectorForm.brazeRestEndpoint
          };
          break;
        case 'sfmc':
          endpoint = '/api/connectors/api-key/sfmc';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "Salesforce Marketing Cloud (<enterprise> / MID n)"
            authBaseUri: connectorForm.sfmcAuthBaseUri,
            clientId: connectorForm.sfmcClientId,
            clientSecret: connectorForm.sfmcClientSecret,
            accountId: connectorForm.sfmcAccountId,
            dataExtensionKeys: connectorForm.sfmcDataExtensionKeys || '',
            dataViewsOptIn: connectorForm.sfmcDataViewsOptIn === true
          };
          break;
        case 'salesforce_service_cloud':
          endpoint = '/api/connectors/api-key/salesforce-service-cloud';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "Salesforce Service Cloud (<my domain>)"
            myDomainUrl: connectorForm.sfscMyDomainUrl,
            clientId: connectorForm.sfscClientId,
            clientSecret: connectorForm.sfscClientSecret,
            customObjects: connectorForm.sfscCustomObjects || ''
          };
          break;
        case 'knocommerce':
          endpoint = '/api/connectors/api-key/knocommerce';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to "KnoCommerce"
            clientId: connectorForm.knoClientId,
            clientSecret: connectorForm.knoClientSecret
          };
          break;
        case 'cruva':
          endpoint = '/api/connectors/api-key/cruva';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend derives from the Cruva shop name
            apiKey: connectorForm.apiKey,
            shopId: connectorForm.cruvaShopId || undefined,  // optional; backend auto-detects if one shop
            currency: connectorForm.currency || undefined
          };
          break;
        case 'judgeme':
          endpoint = '/api/connectors/api-key/judgeme';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend derives from the Judge.me shop name
            apiToken: connectorForm.apiKey,
            shopDomain: connectorForm.judgemeShopDomain
          };
          break;
        case 'skio':
          endpoint = '/api/connectors/api-key/skio';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend defaults to 'Skio'
            apiKey: connectorForm.apiKey
          };
          break;
        case 'omnisend':
          endpoint = '/api/connectors/api-key/omnisend';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend derives from the Omnisend brand name
            apiKey: connectorForm.apiKey                      // currency + timezone come from GET /api/brands/current
          };
          break;
        case 'shipbob':
          endpoint = '/api/connectors/api-key/shipbob';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend derives from the ShipBob channel
            apiToken: connectorForm.apiKey
          };
          break;
        case 'walmart':
          endpoint = '/api/connectors/api-key/walmart';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend derives from the Walmart partner id
            clientId: connectorForm.walmartClientId,
            clientSecret: connectorForm.walmartClientSecret
          };
          break;
        case 'applovin':
          endpoint = '/api/connectors/api-key/applovin';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend default: "AppLovin Ads - <account id>"
            reportKey: connectorForm.apiKey,
            accountId: connectorForm.applovinAccountId
          };
          break;
        case 'taboola':
          endpoint = '/api/connectors/api-key/taboola';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend default: "Taboola - <account name>"
            clientId: connectorForm.taboolaClientId,
            clientSecret: connectorForm.taboolaClientSecret,
            accountId: connectorForm.taboolaAccountId || undefined
          };
          break;
        case 'cj':
          endpoint = '/api/connectors/api-key/cj';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend default: "CJ Affiliate - CID <cid>"
            apiKey: connectorForm.apiKey,
            advertiserCid: connectorForm.cjAdvertiserCid
          };
          break;
        case 'adobe_analytics':
          endpoint = '/api/connectors/api-key/adobe_analytics';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend default: "Adobe Analytics - <company name>"
            clientId: connectorForm.adobeClientId,
            clientSecret: connectorForm.adobeClientSecret,
            orgId: connectorForm.adobeOrgId,
            scopes: connectorForm.adobeScopes || undefined,  // backend default when empty
            globalCompanyId: connectorForm.adobeCompanyId || undefined
          };
          break;
        case 'adobe_experience_platform':
          endpoint = '/api/connectors/api-key/adobe_experience_platform';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend default: "Adobe Experience Platform - <tenant>"
            clientId: connectorForm.aepClientId,
            clientSecret: connectorForm.aepClientSecret,
            orgId: connectorForm.aepOrgId,
            scopes: connectorForm.aepScopes || undefined,     // backend default when empty
            sandboxes: connectorForm.aepSandboxes || undefined // empty = every sandbox the credential can use
          };
          break;
        case 'adobe_campaign':
          endpoint = '/api/connectors/api-key/adobe_campaign';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend default: "Adobe Campaign - <instance>"
            clientId: connectorForm.adobeCampaignClientId,
            clientSecret: connectorForm.adobeCampaignClientSecret,
            scopes: connectorForm.adobeCampaignScopes || undefined,  // backend default when empty
            product: connectorForm.adobeCampaignProduct,
            instance: connectorForm.adobeCampaignInstance
          };
          break;
        case 'walmart_connect':
          endpoint = '/api/connectors/api-key/walmart_connect';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend default: "Walmart Connect - <advertiser id>"
            advertiserId: String(connectorForm.walmartConnectAdvertiserId || '').trim()
          };
          break;
        case 'marketo':
          endpoint = '/api/connectors/api-key/marketo';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend default: "Marketo Engage (<Munchkin ID>)"
            restEndpoint: String(connectorForm.marketoEndpoint || '').trim(),
            clientId: String(connectorForm.marketoClientId || '').trim(),
            clientSecret: connectorForm.marketoClientSecret
          };
          break;
        case 'criteo_retail_media':
          endpoint = '/api/connectors/api-key/criteo_retail_media';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend default: "Criteo Retail Media - <account name>"
            clientId: connectorForm.criteoClientId,
            clientSecret: connectorForm.criteoClientSecret,
            accountId: connectorForm.criteoAccountId || undefined
          };
          break;
        case 'awin':
          endpoint = '/api/connectors/api-key/awin';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend default: "Awin - <programme name>"
            apiToken: connectorForm.awinApiToken,
            accountId: connectorForm.awinAccountId || undefined
          };
          break;
        case 'partnerize':
          endpoint = '/api/connectors/api-key/partnerize';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend default: "Partnerize - <brand name>"
            applicationKey: connectorForm.partnerizeApplicationKey,
            userApiKey: connectorForm.partnerizeUserApiKey,
            advertiserId: connectorForm.partnerizeAdvertiserId || undefined
          };
          break;
        case 'rakuten_advertising':
          endpoint = '/api/connectors/api-key/rakuten-advertising';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend default: "Rakuten Advertising - <advertiser name>"
            reportApiTokenUrls: connectorForm.rakutenReportApiTokenUrls.split(/\s+/).filter(Boolean),
          };
          break;
        case 'chatgpt_ads':
          endpoint = '/api/connectors/api-key/chatgpt_ads';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || undefined,  // backend default: "ChatGPT Ads - <account name>"
            apiKey: connectorForm.apiKey
          };
          break;
        case 'clarity':
          endpoint = '/api/connectors/api-key/clarity';
          break;
        case 'wise':
          endpoint = '/api/connectors/api-key/wise';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || `Wise - ${connectorForm.wiseApiToken.substring(0, 8)}...`,
            apiToken: connectorForm.wiseApiToken,
            useSandbox: connectorForm.wiseSandbox || false,
            currency: connectorForm.currency || 'USD'
          };
          break;
        case 'paypal':
          endpoint = '/api/connectors/api-key/paypal';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || `PayPal - ${connectorForm.paypalClientId.substring(0, 8)}...`,
            clientId: connectorForm.paypalClientId,
            clientSecret: connectorForm.paypalClientSecret,
            useSandbox: connectorForm.paypalSandbox || false
          };
          break;
        case 'twilio':
          endpoint = '/api/connectors/api-key/twilio';
          payload = {
            brandId: resolveBrandId(),
            connectorName: connectorForm.name || `Twilio - ${connectorForm.twilioAccountSid.substring(0, 10)}...`,
            accountSid: connectorForm.twilioAccountSid,
            authToken: connectorForm.twilioAuthToken
          };
          break;
        default:
          throw new Error(`API key authentication not supported for platform: ${platform}`);
      }

      setApiKeyConnecting(true);
      const response = await api.post(endpoint, payload);

      if (response.data.success) {
        setError('');
        alert(response.data.warning || `${platform.charAt(0).toUpperCase() + platform.slice(1)} connected successfully!`);

        // Refresh connectors list
        await fetchConnectors();

        // Close dialog
        handleCloseDialog();
      } else {
        throw new Error(response.data.message || 'Failed to connect');
      }
      
    } catch (err) {
      console.error('API Key connection error:', err);
      const data = err.response?.data;
      if (platform === 'taboola' && Array.isArray(data?.accounts) && data.accounts.length) {
        // Network key: show the advertiser accounts it reaches; the user picks one and connects again.
        setConnectorForm(f => ({ ...f, taboolaAccountChoices: data.accounts, taboolaAccountId: '' }));
      }
      if (platform === 'adobe_analytics' && Array.isArray(data?.companies) && data.companies.length) {
        // The credential reaches several Analytics companies: show them; the user picks one and connects again.
        setConnectorForm(f => ({ ...f, adobeCompanyChoices: data.companies, adobeCompanyId: '' }));
      }
      if (platform === 'adobe_experience_platform' && Array.isArray(data?.sandboxes) && data.sandboxes.length) {
        // Some picked sandboxes are not available to the credential: show the ones it can use.
        setConnectorForm(f => ({ ...f, aepSandboxChoices: data.sandboxes }));
      }
      if (platform === 'criteo_retail_media' && Array.isArray(data?.accounts) && data.accounts.length) {
        // The keys reach several Criteo accounts: show them; the user picks one and connects again.
        setConnectorForm(f => ({ ...f, criteoAccountChoices: data.accounts, criteoAccountId: '' }));
      }
      if (platform === 'zendesk' && data?.code === 'ZENDESK_BRAND_MAPPING_REQUIRED' && Array.isArray(data?.zendesk_brands)) {
        // Several Zendesk brands: show them; the user maps each to one of our brands and connects again.
        setConnectorForm(f => ({ ...f, zendeskBrandChoices: data.zendesk_brands }));
      }
      if (platform === 'gladly' && data?.code === 'GLADLY_INBOX_MAPPING_REQUIRED' && Array.isArray(data?.gladly_inboxes)) {
        // Several inboxes: show them; the user maps each to one of our brands and connects again.
        setConnectorForm(f => ({ ...f, gladlyInboxChoices: data.gladly_inboxes }));
      }
      if (platform === 'awin' && Array.isArray(data?.accounts) && data.accounts.length) {
        // The token reaches several Awin advertiser accounts: show them; the user picks one and connects again.
        setConnectorForm(f => ({ ...f, awinAccountChoices: data.accounts, awinAccountId: '' }));
      }
      if (platform === 'partnerize' && Array.isArray(data?.brands) && data.brands.length) {
        // The keys reach several Partnerize brands: show them; the user picks one and connects again.
        setConnectorForm(f => ({ ...f, partnerizeBrandChoices: data.brands, partnerizeAdvertiserId: '' }));
      }
      setError(data?.message || err.message || `Failed to connect ${platform}`);
    } finally {
      setApiKeyConnecting(false);
    }
  };

  const handleMicrosoftAdsTokenConnect = async () => {
    try {
      setError('');
      
      if (!connectorForm.brandId) {
        setError('Please select a brand first');
        return;
      }
      
      if (!connectorForm.developerToken) {
        setError('Please enter your Microsoft Ads Developer Token');
        return;
      }

      const payload = {
        brandId: resolveBrandId(),
        connectorName: connectorForm.name || `Microsoft Ads - ${connectorForm.developerToken.substring(0, 6)}...`,
        developerToken: connectorForm.developerToken,
        customerId: connectorForm.customerId
      };

      const response = await api.post('/api/connectors/microsoft-ads/setup-token', payload);
      
      if (response.data.success) {
        setError('');
        alert('Microsoft Ads connected successfully with Developer Token!');
        
        // Refresh connectors list
        await fetchConnectors();
        
        // Close dialog
        handleCloseDialog();
      } else {
        throw new Error(response.data.message || 'Failed to connect');
      }
      
    } catch (err) {
      console.error('Microsoft Ads token connection error:', err);
      setError(err.response?.data?.message || err.message || 'Failed to connect Microsoft Ads');
    }
  };

  const handleShipStationConnect = async () => {
    console.log('handleShipStationConnect called');
    try {
      setLoading(true);
      setError('');

      console.log('Sending ShipStation connection request with data:', {
        name: connectorForm.name || `ShipStation ${connectorForm.region}`,
        region: connectorForm.region,
        accountName: connectorForm.accountName || '',
        hasApiKey: !!connectorForm.apiKey,
        hasApiSecret: !!connectorForm.apiSecret
      });

      const response = await api.post('/api/connectors/shipstation', {
        apiKey: connectorForm.apiKey,
        apiSecret: connectorForm.apiSecret,
        name: connectorForm.name || `ShipStation ${connectorForm.region}`,
        region: connectorForm.region,
        accountName: connectorForm.accountName || ''
      });

      console.log('ShipStation connection response:', response.data);

      if (response.data.success) {
        setNotification({
          open: true,
          message: 'ShipStation connector created successfully!',
          severity: 'success'
        });
        
        // Reset form
        setConnectorForm({
          ...connectorForm,
          apiKey: '',
          apiSecret: '',
          name: '',
          region: '',
          accountName: ''
        });
        
        // Refresh connectors list
        await fetchConnectors();
        
        // Close dialog
        setOpenDialog(false);
      }
    } catch (err) {
      console.error('ShipStation connection error:', err);
      console.error('Error response:', err.response?.data);
      console.error('Error status:', err.response?.status);
      setError(err.response?.data?.message || err.message || 'Failed to connect ShipStation account');
    } finally {
      setLoading(false);
    }
  };

  const handleShippingCarrierConnect = async (carrier) => {
    try {
      setLoading(true);
      setError('');

      if (!connectorForm.carrierClientId || !connectorForm.carrierClientSecret) {
        setError('Please enter your Client ID and Client Secret');
        return;
      }

      if ((carrier === 'ups' || carrier === 'fedex') && !connectorForm.carrierAccountNumber) {
        setError('Please enter your account number');
        return;
      }

      const carrierLabel = carrier.toUpperCase() === 'FEDEX' ? 'FedEx' : carrier.toUpperCase();

      const response = await api.post(`/api/connectors/${carrier}/connect`, {
        clientId: connectorForm.carrierClientId,
        clientSecret: connectorForm.carrierClientSecret,
        accountNumber: connectorForm.carrierAccountNumber || '',
        connectorName: connectorForm.name || carrierLabel,
        brandId: resolveBrandId() || null
      });

      if (response.data.success) {
        setNotification({
          open: true,
          message: `${carrierLabel} connector created successfully!`,
          severity: 'success'
        });

        setConnectorForm({
          ...connectorForm,
          carrierClientId: '',
          carrierClientSecret: '',
          carrierAccountNumber: '',
          name: ''
        });

        await fetchConnectors();
        setOpenDialog(false);
      }
    } catch (err) {
      console.error(`${carrier} connection error:`, err);
      setError(err.response?.data?.message || err.message || `Failed to connect ${carrier}`);
    } finally {
      setLoading(false);
    }
  };

  const handleDHLConnect = async () => {
    try {
      setLoading(true);
      setError('');

      const response = await api.post('/api/connectors/dhl', {
        sftpUsername: connectorForm.sftpUsername,
        sftpPassword: connectorForm.sftpPassword,
        accountNumber: connectorForm.accountNumber,
        accountName: connectorForm.accountName || '',
        name: connectorForm.name || `DHL eCommerce - ${connectorForm.accountName || connectorForm.accountNumber}`
      });

      if (response.data.success) {
        setNotification({
          open: true,
          message: 'DHL eCommerce connector created successfully!',
          severity: 'success'
        });

        setConnectorForm({
          ...connectorForm,
          sftpUsername: '',
          sftpPassword: '',
          accountNumber: '',
          accountName: '',
          name: ''
        });

        await fetchConnectors();
        setOpenDialog(false);
      }
    } catch (err) {
      console.error('DHL connection error:', err);
      setError(err.response?.data?.message || err.message || 'Failed to create DHL eCommerce connector');
    } finally {
      setLoading(false);
    }
  };

  const handleAttentiveSftpConnect = async () => {
    try {
      if (!connectorForm.brandId || connectorForm.brandId === 'company') {
        setError('Please select a brand for this Attentive SFTP connector');
        return;
      }
      setLoading(true);
      setError('');

      const response = await api.post('/api/connectors/attentive-sftp', {
        brandId: resolveBrandId(),
        sftpHost: connectorForm.sftpHost || 'sftp.client.attentivemobile.com',
        sftpPort: connectorForm.sftpPort || 22,
        sftpUsername: connectorForm.sftpUsername,
        sftpPassword: connectorForm.sftpPassword,
        sftpPath: connectorForm.sftpPath || 'downloads',
        market: connectorForm.market || '',
        currency: connectorForm.currency || 'USD',
        connectorName: connectorForm.name || `Attentive SFTP - ${connectorForm.sftpUsername}`
      });

      if (response.data.success) {
        setNotification({
          open: true,
          message: 'Attentive SFTP connector created successfully!',
          severity: 'success'
        });

        setConnectorForm({
          ...connectorForm,
          sftpHost: '',
          sftpPort: '',
          sftpUsername: '',
          sftpPassword: '',
          sftpPath: '',
          market: '',
          name: ''
        });

        await fetchConnectors();
        setOpenDialog(false);
      }
    } catch (err) {
      console.error('Attentive SFTP connection error:', err);
      setError(err.response?.data?.message || err.message || 'Failed to create Attentive SFTP connector');
    } finally {
      setLoading(false);
    }
  };

  const handleCin7OmniConnect = async () => {
    console.log('handleCin7OmniConnect called');
    try {
      setLoading(true);
      setError('');

      if (!connectorForm.brandId) {
        setError('Please select a brand first');
        return;
      }

      if (!connectorForm.cin7Username || !connectorForm.apiKey) {
        setError('Please enter both username and API key');
        return;
      }

      console.log('Sending CIN7 Omni connection request');

      const response = await api.post('/api/connectors/api-key/cin7-omni', {
        brandId: resolveBrandId(),
        connectorName: connectorForm.name || `CIN7 Omni - ${connectorForm.cin7Username}`,
        username: connectorForm.cin7Username,
        apiKey: connectorForm.apiKey,
        currency: connectorForm.currency || 'USD'
      });

      console.log('CIN7 Omni connection response:', response.data);

      if (response.data.success) {
        setNotification({
          open: true,
          message: 'CIN7 Omni connector created successfully!',
          severity: 'success'
        });

        // Refresh connectors list
        await fetchConnectors();

        // Reset form
        setConnectorForm({
          ...connectorForm,
          name: '',
          cin7Username: '',
          apiKey: '',
          currency: 'USD'
        });

        // Close dialog
        setOpenDialog(false);
      }
    } catch (err) {
      console.error('CIN7 Omni connection error:', err);
      console.error('Error response:', err.response?.data);
      setError(err.response?.data?.message || err.message || 'Failed to connect CIN7 Omni account');
    } finally {
      setLoading(false);
    }
  };

  const handleThgProcureConnect = async () => {
    try {
      setLoading(true);
      setError('');

      if (!connectorForm.brandId) {
        setError('Please select a brand first');
        return;
      }
      if (!connectorForm.thgUsername || !connectorForm.thgPassword) {
        setError('Please enter both username and password');
        return;
      }

      const response = await api.post('/api/connectors/api-key/thg-procure', {
        brandId: resolveBrandId(),
        connectorName: connectorForm.name || `THG Procure - ${connectorForm.thgUsername}`,
        username: connectorForm.thgUsername,
        password: connectorForm.thgPassword,
        tenantCode: (connectorForm.thgTenantCode || 'THG').toUpperCase(),
        currency: connectorForm.currency || 'GBP'
      });

      if (response.data.success) {
        setNotification({
          open: true,
          message: 'THG Procure connector created successfully!',
          severity: 'success'
        });
        await fetchConnectors();
        setConnectorForm({
          ...connectorForm,
          name: '',
          thgUsername: '',
          thgPassword: '',
          thgTenantCode: 'THG'
        });
        setOpenDialog(false);
      }
    } catch (err) {
      console.error('THG Procure connection error:', err);
      setError(err.response?.data?.message || err.message || 'Failed to connect THG Procure account');
    } finally {
      setLoading(false);
    }
  };

  const handleProcurosConnect = async () => {
    try {
      setLoading(true);
      setError('');

      if (!connectorForm.brandId) {
        setError('Please select a brand first');
        return;
      }
      if (!connectorForm.procurosEmail || !connectorForm.procurosPassword) {
        setError('Please enter both email and password');
        return;
      }

      const response = await api.post('/api/connectors/api-key/procuros', {
        brandId: resolveBrandId(),
        connectorName: connectorForm.name || `Procuros - ${connectorForm.procurosEmail}`,
        email: connectorForm.procurosEmail,
        password: connectorForm.procurosPassword,
        currency: connectorForm.currency || 'EUR'
      });

      if (response.data.success) {
        setNotification({
          open: true,
          message: 'Procuros connector created successfully!',
          severity: 'success'
        });
        await fetchConnectors();
        setConnectorForm({
          ...connectorForm,
          name: '',
          procurosEmail: '',
          procurosPassword: ''
        });
        setOpenDialog(false);
      }
    } catch (err) {
      console.error('Procuros connection error:', err);
      setError(err.response?.data?.message || err.message || 'Failed to connect Procuros account');
    } finally {
      setLoading(false);
    }
  };

  const handleNetSuiteConnect = async () => {
    try {
      setLoading(true);
      setError('');

      if (!connectorForm.brandId) {
        setError('Please select a brand first');
        return;
      }

      if (!connectorForm.netsuiteAccountId || !connectorForm.netsuiteConsumerKey ||
          !connectorForm.netsuiteConsumerSecret || !connectorForm.netsuiteTokenId ||
          !connectorForm.netsuiteTokenSecret) {
        setError('Please fill in all NetSuite credential fields');
        return;
      }

      const response = await api.post('/api/connectors/api-key/netsuite', {
        brandId: resolveBrandId(),
        connectorName: connectorForm.name || `NetSuite - ${connectorForm.netsuiteAccountId}`,
        accountId: connectorForm.netsuiteAccountId,
        consumerKey: connectorForm.netsuiteConsumerKey,
        consumerSecret: connectorForm.netsuiteConsumerSecret,
        tokenId: connectorForm.netsuiteTokenId,
        tokenSecret: connectorForm.netsuiteTokenSecret,
        currency: connectorForm.currency || 'USD'
      });

      if (response.data.success) {
        setNotification({
          open: true,
          message: 'NetSuite connector created successfully!',
          severity: 'success'
        });

        await fetchConnectors();

        setConnectorForm({
          ...connectorForm,
          name: '',
          netsuiteAccountId: '',
          netsuiteConsumerKey: '',
          netsuiteConsumerSecret: '',
          netsuiteTokenId: '',
          netsuiteTokenSecret: '',
          currency: 'USD'
        });

        setOpenDialog(false);
      }
    } catch (err) {
      console.error('NetSuite connection error:', err);
      setError(err.response?.data?.message || err.message || 'Failed to connect NetSuite account');
    } finally {
      setLoading(false);
    }
  };

  // Business Central: optional admin consent link, then a Microsoft sign-in that proves the tenant and company
  // (backend/connector-management/business-central-oauth.js). Both redirect the browser to Microsoft.
  const handleBusinessCentralConsent = async () => {
    try {
      setLoading(true);
      setError('');
      const response = await api.post('/api/connectors/oauth/business-central/consent', {});
      if (response.data.success && response.data.consentUrl) {
        window.location.href = response.data.consentUrl;
      } else {
        setError(response.data.message || 'Could not start the Business Central consent');
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Could not start the Business Central consent');
    } finally {
      setLoading(false);
    }
  };

  const handleBusinessCentralConnect = async () => {
    try {
      setLoading(true);
      setError('');
      if (!resolveBrandId()) {
        setError('Please select a brand first');
        return;
      }
      if (!connectorForm.bcEnvironmentName || !connectorForm.bcCompanyName) {
        setError('Please enter the Business Central environment and company name');
        return;
      }
      const response = await api.post('/api/connectors/oauth/business-central/start', {
        brandId: resolveBrandId(),
        connectorName: connectorForm.name || undefined,   // backend default: "Business Central - <company>"
        environmentName: connectorForm.bcEnvironmentName.trim(),
        companyName: connectorForm.bcCompanyName.trim()
      });
      if (response.data.success && response.data.authUrl) {
        window.location.href = response.data.authUrl;
      } else {
        setError(response.data.message || 'Could not start the Business Central sign-in');
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Could not start the Business Central sign-in');
    } finally {
      setLoading(false);
    }
  };

  const handleShipHeroConnect = async () => {
    console.log('handleShipHeroConnect called');
    try {
      setLoading(true);
      setError('');

      if (!connectorForm.brandId) {
        setError('Please select a brand first');
        return;
      }

      if (!connectorForm.shipheroAccessToken || !connectorForm.shipheroRefreshToken) {
        setError('Please enter both Access Token and Refresh Token');
        return;
      }

      console.log('Sending ShipHero connection request');

      const response = await api.post('/api/connectors/shiphero/connect', {
        brandId: resolveBrandId(),
        accessToken: connectorForm.shipheroAccessToken,
        refreshToken: connectorForm.shipheroRefreshToken,
        shopName: connectorForm.shipheroShopName || null,
        connectorName: connectorForm.name || `ShipHero - ${connectorForm.shipheroShopName || 'Account'}`
      });

      console.log('ShipHero connection response:', response.data);

      if (response.data.success) {
        setNotification({
          open: true,
          message: 'ShipHero connector created successfully!',
          severity: 'success'
        });

        // Refresh connectors list
        await fetchConnectors();

        // Reset form
        setConnectorForm({
          ...connectorForm,
          name: '',
          shipheroAccessToken: '',
          shipheroRefreshToken: '',
          shipheroShopName: ''
        });

        // Close dialog
        setOpenDialog(false);
      }
    } catch (err) {
      console.error('ShipHero connection error:', err);
      console.error('Error response:', err.response?.data);
      setError(err.response?.data?.message || err.message || 'Failed to connect ShipHero account');
    } finally {
      setLoading(false);
    }
  };

  const handleSyncConnector = async (connectorId) => {
    try {
      setError('');
      
      // Trigger sync via our backend API
      await connectorService.triggerSync(connectorId);
      
      // Update the connector status in the local state
      setConnectors(connectors.map(connector => {
        if (connector.id === connectorId) {
          return {
            ...connector,
            status: 'syncing',
            lastSync: new Date().toISOString(),
          };
        }
        return connector;
      }));
      
    } catch (err) {
      console.error('Error syncing connector:', err);
      if (err.response?.status === 404) {
        setError('Connector not found.');
      } else if (err.response?.status === 403) {
        setError('You do not have permission to sync this connector.');
      } else {
        setError(err.response?.data?.message || 'Failed to sync connector');
      }
    }
  };
  
  const handleDeleteConnector = (connector) => {
    // Show confirmation dialog instead of directly deleting
    setConfirmDeleteDialog({
      open: true,
      connectorId: connector.id,
      connectorName: connector.name,
      connectorPlatform: connector.platform_display_name || connector.platform_name || 'Unknown Platform'
    });
    setDeleteConfirmationText(''); // Reset confirmation text
  };
  
  const confirmDeleteConnector = async () => {
    const { connectorId, connectorName } = confirmDeleteDialog;
    
    try {
      setError('');
      
      console.log('Deleting connector:', connectorId);
      
      // Delete connector via our backend API
      const response = await connectorService.deleteConnection(connectorId);
      
      console.log('Delete response:', response);
      
      // Remove from local state
      setConnectors(connectors.filter(connector => connector.id !== connectorId));
      
      // Close confirmation dialog
      setConfirmDeleteDialog({
        open: false,
        connectorId: null,
        connectorName: '',
        connectorPlatform: ''
      });
      setDeleteConfirmationText(''); // Reset confirmation text
      
      // Show success notification
      showNotification(
        response.message || `Connector "${connectorName}" deleted successfully`, 
        'success'
      );
      
    } catch (err) {
      console.error('Error deleting connector:', err);
      console.error('Error response:', err.response?.data);
      
      let errorMessage = 'Failed to delete connector';
      
      if (err.response?.status === 404) {
        errorMessage = 'Connector not found or already deleted';
      } else if (err.response?.status === 403) {
        errorMessage = 'You do not have permission to delete this connector';
      } else if (err.response?.status === 400) {
        errorMessage = err.response?.data?.message || 'Invalid request';
      } else if (err.response?.data?.message) {
        errorMessage = err.response.data.message;
      } else if (err.message) {
        errorMessage = err.message;
      }
      
      setError(errorMessage);
      showNotification(errorMessage, 'error');
      
      // Close confirmation dialog even on error
      setConfirmDeleteDialog({
        open: false,
        connectorId: null,
        connectorName: '',
        connectorPlatform: ''
      });
      setDeleteConfirmationText(''); // Reset confirmation text
    }
  };
  
  const cancelDeleteConnector = () => {
    setConfirmDeleteDialog({
      open: false,
      connectorId: null,
      connectorName: '',
      connectorPlatform: ''
    });
    setDeleteConfirmationText(''); // Reset confirmation text
  };

  // Consolidated edit connector handlers (name and brand together)
  const handleStartEditConnector = (connector) => {
    setEditingConnector({
      id: connector.id,
      name: connector.name,
      brand_id: connector.brand_id || connector.brandId
    });
  };

  const handleCancelEditConnector = () => {
    setEditingConnector(null);
  };

  const handleUpdateEditingConnector = (field, value) => {
    setEditingConnector(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSaveConnector = async () => {
    if (!editingConnector) return;

    if (!editingConnector.name || editingConnector.name.trim().length === 0) {
      showNotification('Connector name cannot be empty', 'error');
      return;
    }

    if (!editingConnector.brand_id) {
      showNotification('Please select a brand', 'error');
      return;
    }

    try {
      setError('');

      const response = await connectorService.updateConnector(editingConnector.id, {
        name: editingConnector.name.trim(),
        brand_id: parseInt(editingConnector.brand_id)
      });

      // Update local state
      setConnectors(connectors.map(connector =>
        connector.id === editingConnector.id
          ? {
              ...connector,
              name: editingConnector.name.trim(),
              brand_id: parseInt(editingConnector.brand_id),
              brandId: parseInt(editingConnector.brand_id)
            }
          : connector
      ));

      // Clear editing state
      setEditingConnector(null);

      showNotification(
        response.message || 'Connector updated successfully',
        'success'
      );

      // Refresh connectors to get updated data
      setTimeout(() => {
        fetchConnectors();
      }, 500);

    } catch (err) {
      console.error('Error updating connector:', err);
      const errorMessage = err.response?.data?.message || 'Failed to update connector';
      setError(errorMessage);
      showNotification(errorMessage, 'error');
    }
  };

  // Helper to format dates
  const formatDate = (dateString) => {
    if (!dateString) return 'Never';
    
    // Handle epoch date (1970-01-01) - means never synced
    if (dateString === '1970-01-01T00:00:00' || 
        dateString === '1970-01-01 00:00:00' ||
        dateString.startsWith('1970-01-01')) {
      return 'Never';
    }
    
    try {
      const date = new Date(dateString);
      // Check if date is invalid
      if (isNaN(date.getTime())) {
        return 'Invalid Date';
      }
      
      // Check if date is in the far future (disabled schedule)
      if (date.getFullYear() > 2050) {
        return 'Disabled';
      }
      
      return date.toLocaleString();
    } catch (error) {
      return 'Invalid Date';
    }
  };
  
  // Helper to get the appropriate icon for a platform
  const getPlatformIcon = (platformName) => {
    const iconSize = 40; // Large size for platform icons

    switch (platformName) {
      case 'shopify':
        return <SiShopify size={iconSize} />;
      case 'facebook':
        return <SiFacebook size={iconSize} />;
      case 'google_ads':
        return <SiGoogleAds size={iconSize} />;
      case 'google_search_console':
        return <SiGoogleSearchConsole size={iconSize} />;
      case 'google_analytics':
        return <SiGoogleAnalytics size={iconSize} />;
      case 'google_merchant_center':
        return <SiGoogleMerchantCenter size={iconSize} />;
      case 'amazon':
      case 'amazon_sp':
        return <SiAmazon size={iconSize} />;
      case 'amazon_ads':
        return <SiAmazonAds size={iconSize} />;
      case 'amazon_vendor':
        return <SiAmazonVendor size={iconSize} />;
      case 'tiktok':
      case 'tiktok_shop':
      case 'tiktok_business_account':
      case 'tiktok_creator':
        return <SiTiktok size={iconSize} />;
      case 'amazon_stream':
        return <SiAmazon size={iconSize} />;
      case 'slack':
        return <SiSlack size={iconSize} />;
      case 'microsoft_teams':
        return <SiMicrosoftTeams size={iconSize} />;
      case 'twilio':
        return <SiTwilio size={iconSize} />;
      case 'klaviyo':
        return <SiKlaviyo size={iconSize} />;
      case 'smsbump':
        return <SiSMSBump size={iconSize} />;
      case 'attentive':
        return <SiAttentive size={iconSize} />;
      case 'attentive_sftp':
        return <SiAttentive size={iconSize} />;
      case 'edesk':
        return <SiEdesk size={iconSize} />;
      case 'mirakl':
        return <SiMirakl size={iconSize} />;
      case 'target_plus':
        return <SiTarget size={iconSize} />;
      case 'impact':
        return <SiImpact size={iconSize} />;
      case 'clarity':
        return <SiClarity size={iconSize} />;
      case 'dor':
        return <SiDor size={iconSize} />;
      case 'knocommerce':
        return <SiKnoCommerce size={iconSize} />;
      case 'braze':
        return <SiBraze size={iconSize} />;
      case 'sfmc':
        return <SiSfmc size={iconSize} />;
      case 'salesforce_service_cloud':
        return <SiSalesforceServiceCloud size={iconSize} />;
      case 'cruva':
        return <SiCruva size={iconSize} />;
      case 'judgeme':
        return <SiJudgeme size={iconSize} />;
      case 'okendo':
        return <SiOkendo size={iconSize} />;
      case 'recharge':
        return <SiRecharge size={iconSize} />;
      case 'heartland_retail':
        return <SiHeartlandRetail size={iconSize} />;
      case 'skio':
        return <SiSkio size={iconSize} />;
      case 'omnisend':
        return <SiOmnisend size={iconSize} />;
      case 'loop_returns':
        return <SiLoopReturns size={iconSize} />;
      case 'appstle_subscriptions':
        return <SiAppstleSubscriptions size={iconSize} />;
      case 'smile':
        return <SiSmile size={iconSize} />;
      case 'stayai':
        return <SiStayAi size={iconSize} />;
      case 'loop_subscriptions':
        return <SiLoopSubscriptions size={iconSize} />;
      case 'globale':
        return <SiGlobale size={iconSize} />;
      case 'bold_subscriptions':
        return <SiBoldSubscriptions size={iconSize} />;
      case 'powerreviews':
        return <SiPowerReviews size={iconSize} />;
      case 'ordergroove':
        return <SiOrdergroove size={iconSize} />;
      case 'sfcc':
        return <SiSfcc size={iconSize} />;
      case 'kibo':
        return <SiKibo size={iconSize} />;
      case 'zendesk':
        return <SiZendesk size={iconSize} />;
      case 'gladly':
        return <SiGladly size={iconSize} />;
      case 'kustomer':
        return <SiKustomer size={iconSize} />;
      case 'segment':
        return <SiSegment size={iconSize} />;
      case 'snowflake':
        return <SiSnowflake size={iconSize} />;
      case 'databricks':
        return <SiDatabricks size={iconSize} />;
      case 'file_feed':
        return <FileFeedIcon sx={{ fontSize: iconSize }} />;   // generic SFTP loader (no single vendor mark)
      case 'bigquery':
        return <SiBigQuery size={iconSize} />;
      case 'brightpearl':
        return <SiBrightpearl size={iconSize} />;
      case 'adobe_commerce':
        return <SiAdobeCommerce size={iconSize} />;
      case 'woocommerce':
        return <SiWooCommerce size={iconSize} />;
      case 'shipbob':
        return <SiShipbob size={iconSize} />;
      case 'stripe':
        return <SiStripe size={iconSize} />;
      case 'yotpo_reviews':
        return <SiYotpo size={iconSize} />;  // the official Yotpo app icon
      case 'postscript':
        return <SiPostscript size={iconSize} />;
      case 'fairing':
        return <SiFairing size={iconSize} />;
      case 'walmart':
        return <SiWalmart size={iconSize} />;
      case 'applovin':
        return <SiAppLovin size={iconSize} />;
      case 'chatgpt_ads':
        return <SiChatGPTAds size={iconSize} />;
      case 'taboola':
        return <SiTaboola size={iconSize} />;
      case 'walmart_connect':
        return <SiWalmartConnect size={iconSize} />;
      case 'adobe_analytics':
        return <SiAdobeAnalytics size={iconSize} />;
      case 'adobe_campaign':
        return <SiAdobeCampaign size={iconSize} />;
      case 'adobe_experience_platform':
        return <SiAdobeExperiencePlatform size={iconSize} />;
      case 'marketo':
        return <SiMarketo size={iconSize} />;
      case 'criteo_retail_media':
        return <SiCriteo size={iconSize} />;
      case 'awin':
        return <SiAwin size={iconSize} />;
      case 'partnerize':
        return <SiPartnerize size={iconSize} />;
      case 'rakuten_advertising':
        return <SiRakutenAdvertising size={iconSize} />;
      case 'business_central':
        return <SiBusinessCentral size={iconSize} />;
      case 'cj':
        return <SiCj size={iconSize} />;
      case 'lightspeed':
      case 'lightspeed_r':
        return <SiLightspeed size={iconSize} />;
      case 'square':
        return <SiSquare size={iconSize} />;
      case 'snapchat_ads':
        return <SiSnapchat size={iconSize} />;
      case 'reddit_ads':
        return <SiReddit size={iconSize} />;
      case 'sa360':
        return <SiSa360 size={iconSize} />;
      case 'dv360':
        return <SiDv360 size={iconSize} />;
      case 'cm360':
        return <SiCm360 size={iconSize} />;
      case 'teams-agent-app':
        return <SiMicrosoftTeams size={iconSize} />;
      case 'pinterest':
        return <SiPinterest size={iconSize} />;
      case 'quickbooks':
        return <SiQuickbooks size={iconSize} />;
      case 'microsoft_ads':
        return <SiMicrosoft size={iconSize} />;
      case 'paypal':
        return <SiPaypal size={iconSize} />;
      case 'wise':
        return <SiWise size={iconSize} />;
      case 'revolut':
        return <SiRevolut size={iconSize} />;
      case 'shipstation':
        return <SiShipStation size={iconSize} />;
      case 'dhl_ecommerce':
        return <SiDHL size={iconSize} />;
      case 'cin7_omni':
        return <SiCin7 size={iconSize} />;
      case 'netsuite':
        return <SiNetSuite size={iconSize} />;
      case 'xero':
        return <SiXero size={iconSize} />;
      case 'shiphero':
        return <SiShipHero size={iconSize} />;
      case 'amex':
        return <SiAmex size={iconSize} />;
      case 'payoneer':
        return <SiPayoneer size={iconSize} />;
      case 'google_workspace':
      case 'google-workspace':
        return <SiGoogleWorkspace size={iconSize} />;
      case 'microsoft_workspace':
      case 'microsoft-workspace':
        return <SiMicrosoft365 size={iconSize} />;
      case 'sps_commerce':
      case 'sps-commerce':
        return <SiSPSCommerce size={iconSize} />;
      case 'thg_procure':
      case 'thg-procure':
        return <SiTHG size={iconSize} />;
      case 'procuros':
        return <SiProcuros size={iconSize} />;
      case 'ups':
        return <SiUPS size={iconSize} />;
      case 'usps':
        return <SiUSPS size={iconSize} />;
      case 'fedex':
        return <SiFedEx size={iconSize} />;
      case 'google_postmaster':
        return <SiGoogle size={iconSize} />;
      case 'gorgias':
        return <SiGorgias size={iconSize} />;
      case 'wix':
        return <SiWix size={iconSize} />;
      case 'unify':
        return <SiUnify size={iconSize} />;
      case 'wshop':
        return <SiWShop size={iconSize} />;
      default:
        // Internal Amazon report pseudo-platforms (amazon_ba_*, amazon_listings*,
        // amazon_sales_traffic*, ...) all carry the Amazon mark.
        if (platformName && platformName.startsWith('amazon')) {
          return <SiAmazon size={iconSize} />;
        }
        return <IntegrationInstructionsIcon fontSize="large" />;
    }
  };

  // Helper to get platform color
  const getPlatformColor = (platformName) => {
    switch (platformName) {
      case 'shopify':
        return '#7AB55C'; // Shopify green
      case 'facebook':
        return '#1877F2'; // Facebook blue
      case 'google_ads':
        return '#EA4335'; // Google red
      case 'amazon':
        return '#FF9900'; // Amazon orange (Seller Central)
      case 'amazon_ads':
        return '#232F3E'; // Amazon Advertising dark blue
      case 'amazon_vendor':
        return '#FF9900'; // Amazon orange (Vendor Central mark)
      case 'tiktok':
      case 'tiktok_shop':
      case 'tiktok_business_account':
      case 'tiktok_creator':
        return '#FE2C55'; // TikTok pink
      case 'amazon_stream':
        return '#00A8E1'; // Amazon Marketing Stream teal
      case 'slack':
        return '#4A154B'; // Slack purple
      case 'microsoft_teams':
        return '#6264A7'; // Microsoft Teams purple
      case 'twilio':
        return '#F22F46'; // Twilio red
      case 'pinterest':
        return '#E60023'; // Pinterest red
      case 'square':
        return '#000000'; // Square black
      case 'snapchat_ads':
        return '#FFFC00'; // Snapchat yellow
      case 'reddit_ads':
        return '#FF4500'; // Reddit orange
      case 'sa360':
        return '#4285F4'; // Google blue (SA360 mark)
      case 'dv360':
      case 'cm360':
        return '#34A853'; // Google green (DV360 / CM360 marks)
      case 'google_postmaster':
      case 'google_search_console':
        return '#4285F4'; // Google blue
      case 'google_analytics':
        return '#FF6F00'; // Google Analytics orange
      case 'google_merchant_center':
        return '#34A853'; // Google green
      case 'quickbooks':
        return '#0077C5'; // QuickBooks blue
      case 'microsoft_ads':
        return '#00BCF2'; // Microsoft blue
      case 'shipstation':
        return '#3B5998'; // ShipStation blue
      case 'dor':
        return '#DF1E25'; // Dor red (official logo badge)
      case 'fairing':
        return '#1F2D06'; // Fairing dark olive (fairing.co site CSS)
      case 'knocommerce':
        return '#030300'; // Kno black (official logo SVG)
      case 'braze':
        return '#801ED7'; // Braze purple (fill of the official monogram SVG)
      case 'sfmc':
        return '#FE9339'; // Salesforce Marketing orange (fill of the official product icon SVG)
      case 'salesforce_service_cloud':
        return '#E3066A'; // Salesforce Service pink (darker fill of the official product icon SVG)
      case 'cruva':
        return '#4C3DF5'; // Cruva indigo (brand mark)
      case 'judgeme':
        return '#339999'; // Judge.me teal (theme-color on judge.me)
      case 'recharge':
        return '#3901F1'; // Recharge purple (brand mark)
      case 'heartland_retail':
        return '#313131'; // placeholder (heartland.us); swap for the official brand colour
      case 'skio':
        return '#5D38A0'; // Skio purple (main colour on skio.com)
      case 'omnisend':
        return '#1a1c1b'; // Omnisend brand ink (theme-color on omnisend.com); the tile icon is the official monogram
      case 'loop_returns':
        return '#201F0F'; // Loop Returns (most-used colour on loopreturns.com)
      case 'appstle_subscriptions':
        return '#1CA7E5'; // Appstle blue (background of the official Appstle favicon)
      case 'smile':
        return '#FFC419'; // Smile.io brand yellow (dominant colour of the official apple-touch-icon.png, sampled)
      case 'stayai':
        return '#CF088B'; // Stay AI magenta (sampled from the official stay.ai favicon logomark)
      case 'loop_subscriptions':
        return '#8B43FD'; // Loop Subscriptions purple (sampled from the official loopwork.co apple-touch-icon)
      case 'globale':
        return '#F05A2C'; // Global-e orange (dominant colour of the official global-e.com favicon "e", sampled)
      case 'bold_subscriptions':
        return '#E60046'; // Bold red (background of the official boldcommerce.com favicon, sampled)
      case 'powerreviews':
        return '#595A5B'; // PowerReviews (the grey "R" of its site icon, sampled from apple-touch-icon.png)
      case 'ordergroove':
        return '#17132F'; // Ordergroove navy (logomark background)
      case 'adobe_commerce':
        return '#FF0000'; // Adobe red (.st0 fill of the official Commerce mark, adobe-commerce-logo.svg)
      case 'woocommerce':
        return '#7F54B3'; // WooCommerce purple (official brand colour, woocommerce-logo.svg)
      case 'sfcc':
        return '#2E844A'; // Salesforce Commerce green (the darker cart green, .cls-2 of the official icon-commerce.svg)
      case 'kibo':
        return '#FECE00'; // Kibo yellow (the dominant yellow of the official "K" site icon, kibo-logo.png palette)
      case 'zendesk':
        return '#16140C'; // Zendesk (mask-icon color on zendesk.com, the icon background)
      case 'gladly':
        return '#009B00'; // Gladly green (the circle of the official site icon, palette entry of icon.svg)
      case 'kustomer':
        return '#FBEC2A'; // Kustomer yellow (the fill of the official mark, Kusty.svg on kustomer.com)
      case 'segment':
        return '#F22F46'; // Twilio Segment red (the fill of the mark on the official Segment docs navbar)
      case 'snowflake':
        return '#29B5E8'; // Snowflake blue (brand colour of the official mark, simple-icons snowflake / snowflake.com brand guidelines)
      case 'databricks':
        return '#FF3621'; // Databricks red (brand colour of the official mark, simple-icons databricks / brand.databricks.com)
      case 'file_feed':
        return '#5F6368'; // neutral grey: a generic file loader, not one vendor's brand
      case 'bigquery':
        return '#4285F4'; // Google blue (the handle fill of the official BigQuery product icon)
      case 'brightpearl':
        return '#60D352'; // Brightpearl green (the dot of the official site icon, cropped-brightpearl-favicon-192x192.png)
      case 'shipbob':
        return '#175CFF'; // ShipBob blue (--primary on shipbob.com)
      case 'stripe':
        return '#635BFF'; // Stripe blurple
      case 'yotpo_reviews':
        return '#0042E4'; // Yotpo blue (same as the existing Yotpo wordmark icon)
      case 'postscript':
        return '#AB92F4'; // Postscript lavender (postscript.io site accent)
      case 'walmart':
        return '#0071DC'; // Walmart blue
      case 'applovin':
        return '#2A64F6'; // AppLovin blue (as used on applovin.com)
      case 'chatgpt_ads':
        return '#000000'; // ChatGPT black
      case 'taboola':
        return '#0056F0'; // Taboola blue (--tbla-blue on taboola.com)
      case 'walmart_connect':
        return '#4DBDF5'; // Walmart Connect light blue ("Connect" fill of the official walmartconnect.com logo SVG)
      case 'adobe_analytics':
        return '#130732'; // Adobe Analytics icon background (outer gradient stop of the official adobe.com icon SVG)
      case 'adobe_campaign':
        return '#1a1d05'; // Adobe Campaign icon background (outer gradient stop of the official adobe.com icon SVG)
      case 'adobe_experience_platform':
        return '#C20020'; // Adobe Experience Platform red (middle fill of the official adobe.com icon SVG)
      case 'marketo':
        return '#5C4C9F'; // Marketo purple (Simple Icons 13.0.0 brand colour of the legacy Marketo mark)
      case 'criteo_retail_media':
        return '#FE5000'; // Criteo orange (fill of the criteo.com site icon)
      case 'awin':
        return '#FF6600'; // Awin orange (main fill of the awin.com favicon.svg)
      case 'partnerize':
        return '#3B82E8'; // Partnerize blue (the dot of the official partnerize.com site icon)
      case 'rakuten_advertising':
        return '#8529CD'; // Rakuten Advertising purple (fill of the official RAD_Logo_Hor_RADPurple-9.svg on rakutenadvertising.com)
      case 'business_central':
        return '#0F7C8C'; // Business Central teal (the centre circle of the official product icon)
      case 'cj':
        return '#025450'; // CJ green (fill of the official cj_logo_green_rgb.svg)
      case 'lightspeed':
      case 'lightspeed_r':
        return '#ED5153'; // Lightspeed coral (flame mark)
      case 'mirakl':
        return '#03182F'; // Mirakl navy
      case 'target_plus':
        return '#CC0000'; // Target red
      case 'impact':
        return '#1B1B1B'; // impact.com black
      case 'dhl_ecommerce':
        return '#D40511'; // DHL red
      case 'attentive_sftp':
        return '#7C4DFF'; // Attentive SFTP (purple, distinct from Attentive API)
      case 'cin7_omni':
        return '#1E88E5'; // CIN7 blue
      case 'netsuite':
        return '#3E3E3E'; // Oracle NetSuite
      case 'xero':
        return '#13B5EA'; // Xero blue
      case 'revolut':
        return '#0666EB'; // Revolut blue
      case 'wise':
        return '#9FE870'; // Wise green
      case 'shiphero':
        return 'var(--color-primary)'; // ShipHero purple
      case 'amex':
        return '#006FCF'; // American Express blue
      case 'google_workspace':
      case 'google-workspace':
        return '#4285F4'; // Google blue
      case 'microsoft_workspace':
      case 'microsoft-workspace':
        return '#0078D4'; // Microsoft 365 blue
      case 'sps_commerce':
      case 'sps-commerce':
        return '#0088CC'; // SPS Commerce blue
      case 'thg_procure':
      case 'thg-procure':
        return '#000000'; // THG black
      case 'procuros':
        return '#0FB87E'; // Procuros green
      case 'ups':
        return '#351C15'; // UPS brown
      case 'usps':
        return '#004B87'; // USPS blue
      case 'fedex':
        return '#4D148C'; // FedEx purple
      default:
        return 'primary.main';
    }
  };

  // Helper to get platform description
  const getPlatformDescription = (platform) => {
    const descriptions = {
      'shopify': 'Connect your Shopify store to import product, order, and customer data',
      'amazon': 'Connect to Amazon Seller Central to import product, order, and inventory data',
      'klaviyo': 'Connect to Klaviyo for email marketing analytics and customer engagement data',
      'smsbump': 'Connect to SMSBump for SMS marketing analytics and customer communication data',
      'attentive': 'Connect to Attentive for SMS marketing analytics and customer engagement data',
      'attentive_sftp': 'Connect Attentive via SFTP for daily event & conversion CSV data feeds (per-brand)',
      'edesk': 'Connect to eDesk for customer support helpdesk data, tickets, and sales orders',
      'gorgias': 'Connect to Gorgias to sync helpdesk tickets, messages, customers and CSAT surveys',
      'heartland_retail': 'Connect Heartland Retail to sync your stores — POS sales, returns, customers, items, inventory, transfers, purchasing, promotions, gift cards and sales reports',
      'recharge': 'Connect Recharge to sync your subscriptions — subscribers, cancellations and cancellation reasons, charges, orders, discounts and plans',
      'skio': 'Connect Skio to sync your Shopify subscriptions — subscriptions and their products, subscription orders, customers, cancellation reasons, selling-plan discounts and daily subscription revenue',
      'omnisend': 'Connect Omnisend to sync your email and SMS marketing — contacts and their consents, segments, campaigns and automations with UTMs and content, forms and their reports, products, orders, carts, and campaign and automation performance',
      'gladly': 'Connect Gladly to sync your customer service — customers, conversations with every message, call, note and voice transcript, tasks, topics, inboxes, agents and teams, answers, events and every Gladly report',
      'kustomer': 'Connect Kustomer to sync your customer service — customers, conversations with messages, notes, events and attachments, custom objects, companies, satisfaction, SLAs, routing and work sessions, audit logs, knowledge base and settings',
      'segment': 'Connect Segment to sync every tracked event from your Segment S3 storage destination — track, identify, page, screen, group and alias calls of every source — plus, with a Public API token, your workspace sources, destinations, tracking plans, audiences, audit trail and usage',
      'file_feed': 'Connect an SFTP folder to load files on a schedule — Bazaarvoice export feeds (products, reviews, questions, answers, comments, ratings) or any CSV / JSON-lines files your systems or vendors deliver',
      'bigquery': 'Connect Google BigQuery to copy the tables and views you choose from your own BigQuery project into SuperChargeMe on a schedule — every row and column, refreshed with only what changed when a table has an updated-at column',
      'snowflake': 'Connect Snowflake to copy the tables and views you choose from your Snowflake account — read-only with a key pair, incremental on an updated-at column or a full refresh each run, with table and column definitions',
      'databricks': 'Connect Databricks to copy the Unity Catalog tables and views you choose from your workspace — read-only with a service principal, on your SQL warehouse, incremental on an updated-at column or a full refresh each run, with table and column definitions',
      'brightpearl': 'Connect Brightpearl to sync your retail operations — sales and purchase orders with rows, shipments and receipts, stock per warehouse and stock movements, products, price lists and prices, customers and suppliers, journals, payments and every reference list',
      'zendesk': 'Connect Zendesk to sync your customer service — tickets with comments, events and SLA metrics, users and organizations, CSAT, macros and business rules, Help Center articles, Talk calls and Chat',
      'ordergroove': 'Connect Ordergroove to sync your subscriptions — subscribers, subscriptions and cancellation reasons, subscription orders and items, addresses, products, offer profiles and one-time incentives',
      'adobe_commerce': 'Connect Adobe Commerce (Magento) to sync your store views — orders with items, invoices, credit memos, shipments and returns, customers, products and prices, categories, inventory, promotions and coupons, and B2B companies',
      'woocommerce': 'Connect WooCommerce to sync your store — orders with line items and notes, refunds, products with variations and reviews, customers, coupons, taxes, shipping zones, payment gateways, settings, webhooks and reports, plus Subscriptions and Bookings when installed',
      'sfcc': 'Connect Salesforce Commerce Cloud to sync every site of your B2C Commerce instance — orders with items, shipments and payments, customers, products, catalogs, price books, inventory, promotions, coupons, gift certificates and sales metrics',
      'kibo': 'Connect Kibo Commerce to sync the sites of your tenant: orders with items, payments, refunds and shipments, returns, fulfillment, subscriptions, customers, catalog, prices, discounts, inventory and settings',
      'loop_returns': 'Connect Loop Returns to sync your returns and exchanges — return reasons, outcomes, refunds, store credit, exchange items and return shipping status',
      'powerreviews': 'Connect PowerReviews to sync your ratings and reviews (every moderation status), questions and answers, and the product catalog PowerReviews holds',
      'shipbob': 'Connect ShipBob to sync your fulfilment: orders and shipments with tracking and costs, inventory by fulfillment center, receiving orders, returns and ShipBob billing',
      'stripe': 'Connect Stripe to sync your payments — balance transactions with fees and payouts, charges, refunds, disputes, customers, invoices and subscriptions',
      'yotpo_reviews': 'Connect Yotpo to sync your product and site reviews, star ratings, Q&A and (optionally) Loyalty & Referrals customers, points, tiers and campaigns',
      'postscript': 'Connect Postscript to sync your SMS subscribers (promotional and transactional consent) and keywords',
      'okendo': 'Connect Okendo to sync your product reviews (every moderation status), review photos and videos, star-rating summaries, product Q&A and loyalty program settings',
      'fairing': 'Connect Fairing to sync your post-purchase survey answers ("How did you hear about us?") linked to each Shopify order',
      'taboola': 'Connect Taboola to sync your campaigns, ads, spend, clicks, conversions and revenue by day, campaign, site, country and device',
      'awin': 'Connect Awin to sync your affiliate programme: every transaction and its status, commissions, publishers, and publisher, creative and campaign performance by day (ShareASale programmes upgraded to Awin included)',
      'partnerize': 'Connect Partnerize to sync your partner programme: every conversion with its items and status changes, clicks, impressions, commissions, partners, vouchers, creatives, invoices and daily performance by partner, device, country and more',
      'rakuten_advertising': 'Connect Rakuten Advertising to sync your affiliate programme reports: every order and transaction with its publisher, sales and commission, and every standard or custom report you choose, by network and month',
      'business_central': 'Connect Microsoft Dynamics 365 Business Central to sync your ERP: customers, vendors and items with inventory, sales and purchase orders, invoices, credit memos, shipments and receipts with their lines and dimensions, the general ledger and item ledger, unposted journals and payments, and daily aged receivables, payables, trial balance and financial statements',
      'cj': 'Connect CJ Affiliate to sync your affiliate commissions with item detail, your joined publishers and their promotional properties, and your product feeds',
      'marketo': 'Connect Marketo Engage to sync your marketing automation data — people and every activity, program membership, static lists, custom objects, deleted people, programs, emails and their content, landing pages, forms, snippets, smart campaigns and smart lists with their rules, tokens, channels, tags and folders',
      'walmart_connect': 'Connect Walmart Connect to sync your Walmart Sponsored Products, Sponsored Brands and Sponsored Videos advertising — campaigns, ad groups, keywords, items, bids, budgets and placements, every daily performance report (keyword, item, placement, platform, page type, attributed purchases, search impression share, video), recommendations and change history',
      'adobe_campaign': 'Connect Adobe Campaign to sync your profiles, lists, services and subscriptions, campaigns, deliveries with their results, every delivery and tracking log (sends, opens, clicks), quarantines and workflows',
      'adobe_analytics': 'Connect Adobe Analytics to sync your report suites, dimensions, metrics, segments and calculated metrics, daily totals of every metric, and daily traffic and conversion by marketing channel, tracking code, page, product, device and location',
      'adobe_experience_platform': 'Connect Adobe Experience Platform (Real-Time CDP) to sync your sandboxes, schemas, datasets and ingestion batches, audiences and segment runs with audience sizes, sources and destinations with their runs, merge policies, identity namespaces, queries, data usage policies and platform usage metrics',
      'criteo_retail_media': 'Connect Criteo Retail Media to sync your retailer ad spend, impressions, clicks and attributed sales by day, line item, product and keyword',
      'chatgpt_ads': 'Connect ChatGPT Ads to sync your campaign, ad group and ad spend, impressions, clicks, conversions and attributed sales',
      'applovin': 'Connect AppLovin Ads to sync your web campaign spend, impressions, clicks, attributed sales and checkout revenue by campaign, creative set and ad',
      'braze': 'Connect Braze to sync your campaign, Canvas and segment analytics by day — sends, opens, clicks, conversions and revenue by channel — plus campaign and Canvas content, user profiles, subscriptions, custom events, active users, sessions, purchases, templates and catalogs',
      'sfmc': 'Connect Salesforce Marketing Cloud to sync one business unit — every email send and its sends, opens, clicks, bounces and unsubscribes, lists and subscribers, data extensions, journeys and journey history, Content Builder assets, automations, triggered and transactional sends, SMS and push',
      'salesforce_service_cloud': 'Connect Salesforce Service Cloud to sync your cases with their comments, emails, history and activities, contacts and accounts, entitlements and milestones, knowledge articles, Omni-Channel work, messaging, chat and voice sessions, and surveys',
      'knocommerce': 'Connect KnoCommerce to sync your post-purchase survey answers ("How did you hear about us?") linked to each order',
      'cruva': 'Connect Cruva to sync your TikTok Shop affiliate program — creators/CRM, video/live/slideshow performance, sample requests, spark codes, ads and outreach',
      'judgeme': 'Connect Judge.me to sync your product and store reviews, star ratings, reviewers and review counts',
      'appstle_subscriptions': 'Connect Appstle Subscriptions to sync your subscription contracts with their Shopify contract lines and discounts, billing attempts and upcoming orders, cancellation and pause reasons, customer retention and churn activities, selling plans and subscription groups, customers and payment methods (no card data), product swaps, build-a-box bundles, quick checkout links and portal settings',
      'smile': 'Connect Smile.io to sync your loyalty & rewards program — members and their points balances and VIP status, the full points transaction ledger, reward fulfillments and their discount codes, earning rules, points products (redemption options), VIP tiers, and your points and referral program settings',
      'stayai': 'Connect Stay AI (formerly Retextion) to sync your subscriptions with their line items and rich detail (lifetime value, billing and delivery policy, churn risk, cancellation reasons), recurring orders with line items, customers, product catalog, selling plan groups and plans, and your account and webhook settings',
      'loop_subscriptions': 'Connect Loop Subscriptions to sync your subscriptions with their lines, recurring and upcoming orders, gift subscriptions, customers with their loyalty points and referral details, billing attempts, cancellation flows and reasons, activity logs, inventory events, products and selling plans',
      'globale': 'Connect Global-e to sync your cross-border setup: the countries you sell to and which Global-e operates, currencies and Global-e\'s daily currency rates, country price coefficients, rounding rules, VAT rates per category and country, product restrictions per country, and your hub. Order lists, duties and settlements are not available from Global-e\'s API (they come as Global-e reports)',
      'bold_subscriptions': 'Connect Bold Subscriptions to sync your subscriptions with their line items, upcoming orders, every subscription\'s order history with totals and taxes, intervals, adjustments and payment methods (card brand and last four only), subscription groups with their billing rules and products, swap options, customers with their addresses, and your Bold product catalog and webhook delivery log',
      'clarity': 'Connect to Microsoft Clarity for session-behaviour analytics — traffic, engagement, scroll depth, and frustration signals (rage/dead clicks)',
      'mirakl': 'Connect a Mirakl marketplace (Urban Outfitters, Kingfisher, Decathlon and others) for orders, offers, shipments, and the full commission and payout ledger',
      'walmart': 'Connect Walmart Marketplace for orders, returns, catalogue, inventory, and the reconciliation and settlement reports with fees and payouts',
      'target_plus': 'Connect Target Plus for orders, catalogue, inventory, prices, returns, and the settlement report with referral fees and payouts',
      'impact': 'Connect Impact.com for affiliate/influencer programs, media partners, conversions (actions), payouts and invoices, promo codes, deals, and product catalogs',
      'facebook': 'Connect to Meta Ads to import campaign and ad performance data',
      'google_ads': 'Connect to Google Ads to import campaign and ad performance metrics',
      'google_search_console': 'Connect to Google Search Console to import website search performance and SEO data',
      'google_analytics': 'Connect to Google Analytics to import website traffic and user behavior analytics',
      'google_merchant_center': 'Connect to Google Merchant Center to import product listings, inventory data, and e-commerce performance',
      'google_postmaster': 'Connect to Google Postmaster Tools to monitor sending-domain deliverability, spam rate, authentication and compliance status',
      'amazon_ads': 'Connect to Amazon Advertising to import ad campaign and performance data',
      'amazon_vendor': 'Connect Amazon Vendor Central (1P) to import purchase orders, shipments, direct fulfillment orders, remittances, catalog and every vendor analytics report: sales, traffic, inventory, margin, forecasts, real-time sales, promotions and coupons',
      'tiktok': 'Connect to TikTok Ads to import ad campaign and social media analytics',
      'tiktok_shop': 'Connect to TikTok Shop to import orders, products, returns, and settlement data',
      'slack': 'Connect to Slack for team communication analytics and workspace data',
      'microsoft_teams': 'Connect to Microsoft Teams for AI-powered analytics directly in your Teams workspace',
      'twilio': 'Connect to Twilio for VoIP calls, SMS messaging, and call center functionality',
      'pinterest': 'Connect to Pinterest Business to import advertising and pin performance data',
      'snapchat_ads': 'Connect Snapchat Ads to import your ad accounts, campaigns, ad squads, ads and creatives with daily spend, impressions, swipes, video views and purchase conversions',
      'reddit_ads': 'Connect to Reddit Ads to import your ad accounts, campaigns, ad groups, ads and daily spend, impressions, clicks, purchases and video views',
      'dv360': 'Connect Display & Video 360 to import every campaign, insertion order, line item, ad group, ad, creative, targeting setting, audience, inventory source and invoice of your advertisers, with daily delivery, cost, conversion, YouTube, Floodlight and reach reports and their breakdowns',
      'cm360': 'Connect Campaign Manager 360 to import every advertiser, campaign, placement, site, ad, creative, Floodlight activity and remarketing list of your account, with daily delivery, cost and conversion reports and their breakdowns, Floodlight, reach and path to conversion reports',
      'sa360': 'Connect Search Ads 360 to import every campaign, ad group, ad, keyword, asset, audience, bidding strategy and conversion action with daily performance by device, hour, location, product and more, plus custom columns, Floodlight variables and conversion and visit events',
      'square': 'Connect to Square to import orders, payments, refunds, payouts, catalog, inventory, customers, bookings, loyalty, gift cards, subscriptions and staff data',
      'quickbooks': 'Connect to QuickBooks Online to import accounting data, invoices, and financial reports',
      'microsoft_ads': 'Connect to Microsoft Advertising (Bing Ads) to import search campaign and performance data',
      'shipstation': 'Connect to ShipStation for order fulfillment, shipping, and logistics data',
      'dhl_ecommerce': 'Connect to DHL eCommerce for shipping invoices, tracking, and actual shipping costs',
      'cin7_omni': 'Connect to CIN7 Omni for inventory management, orders, and product data',
      'netsuite': 'Connect to Oracle NetSuite to import general ledger, transactions, chart of accounts, and financial data',
      'xero': 'Connect to Xero to import chart of accounts, invoices, bank transactions, contacts, and financial reports',
      'revolut': 'Connect to Revolut Business to import accounts, transactions, and financial data',
      'wise': 'Connect to Wise (TransferWise) to import multi-currency accounts, balances, and international transfers',
      'shiphero': 'Connect to ShipHero for warehouse inventory, orders, shipments, and fulfillment data',
      'amex': 'Upload American Express CSV statements manually - automated connection not supported',
      'google_workspace': 'Connect Google Workspace to import Google Sheets data and export reports to Sheets, Docs, and Drive',
      'google-workspace': 'Connect Google Workspace to import Google Sheets data and export reports to Sheets, Docs, and Drive',
      'microsoft_workspace': 'Connect Microsoft 365 to read and write Excel workbooks and Word docs in OneDrive and SharePoint',
      'microsoft-workspace': 'Connect Microsoft 365 to read and write Excel workbooks and Word docs in OneDrive and SharePoint',
      'sps_commerce': 'Connect SPS Commerce EDI to pull purchase orders (850), POS activity (852) and post acknowledgments, ASNs and invoices to retailers',
      'sps-commerce': 'Connect SPS Commerce EDI to pull purchase orders (850), POS activity (852) and post acknowledgments, ASNs and invoices to retailers',
      'thg_procure': 'Connect to THG Procure supplier portal to automatically pull purchase orders, line items, deliveries, receipts, ASNs and invoices from The Hut Group',
      'thg-procure': 'Connect to THG Procure supplier portal to automatically pull purchase orders, line items, deliveries, receipts, ASNs and invoices from The Hut Group',
      'procuros': 'Connect to Procuros to pull EDI orders, order responses, shipping notices and invoices for every retailer relationship on the network (Flaconi, Douglas, Sephora, etc.)',
      'ups': 'Connect to UPS for shipment tracking, rates, address validation, and delivery data',
      'usps': 'Connect to USPS for package tracking, domestic and international rates, and address validation',
      'fedex': 'Connect to FedEx for shipment tracking, rate quotes, address validation, and pickup scheduling'
    };
    // Active Connectors cards pass only { name } — resolve display_name from the platforms list
    const displayName = platform.display_name || (platform.name ? getPlatformDisplayName(platform.name) : 'this platform');
    return descriptions[platform.name] || `Connect to ${displayName} for data integration`;
  };

  // Helper to get proper display name for a connector type (from platforms API data)
  const getPlatformDisplayName = (type) => {
    const match = platforms.find(p => p.name === type);
    if (match?.display_name) return match.display_name;
    // Fallback: capitalize each word
    return type.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  };

  // Builds an auto-suggested connector name as "{Brand} - {Platform}".
  // If a connector with that name already exists for the same brand+platform,
  // appends "(2)", "(3)", etc. until a free name is found.
  // Normalize the form's brandId for backend submission.
  // Frontend uses 'company' as a sentinel for company-level connectors; backend expects null.
  const resolveBrandId = () => connectorForm.brandId === 'company' ? null : connectorForm.brandId;

  const suggestConnectorName = (brandId, type) => {
    if (!brandId || !type) return '';
    // Company-level connectors: use platform display name only
    if (brandId === 'company') {
      return `Company - ${getPlatformDisplayName(type)}`;
    }
    const brand = brands.find(b => String(b.id) === String(brandId));
    if (!brand) return '';
    const base = `${brand.name} - ${getPlatformDisplayName(type)}`;
    const existing = new Set(
      (connectors || [])
        .filter(c => {
          const cType = c.platform_name || c.type;
          const cBrand = c.brand_id ?? c.brandId;
          return cType === type && String(cBrand) === String(brandId);
        })
        .map(c => c.name)
    );
    if (!existing.has(base)) return base;
    for (let i = 2; i < 100; i++) {
      const candidate = `${base} (${i})`;
      if (!existing.has(candidate)) return candidate;
    }
    return base;
  };

  // Helper to get the appropriate icon for a connector type (legacy)
  const getConnectorIcon = (type) => {
    const iconSize = 24;

    switch (type) {
      case 'shopify':
        return <SiShopify size={iconSize} />;
      case 'facebook':
        return <SiFacebook size={iconSize} />;
      case 'google':
      case 'google_ads':
      case 'google_search_console':
      case 'google_analytics':
      case 'google_postmaster':
        return <SiGoogle size={iconSize} />;
      case 'google_workspace':
        return <SiGoogleWorkspace size={iconSize} />;
      case 'microsoft_workspace':
      case 'microsoft-workspace':
        return <SiMicrosoft365 size={iconSize} />;
      case 'sps_commerce':
      case 'sps-commerce':
        return <SiSPSCommerce size={iconSize} />;
      case 'thg_procure':
      case 'thg-procure':
        return <SiTHG size={iconSize} />;
      case 'procuros':
        return <SiProcuros size={iconSize} />;
      case 'amazon':
      case 'amazon_sp':
        return <SiAmazon size={iconSize} />;
      case 'amazon_ads':
        return <SiAmazonAds size={iconSize} />;
      case 'amazon_vendor':
        return <SiAmazonVendor size={iconSize} />;
      case 'slack':
        return <SiSlack size={iconSize} />;
      case 'microsoft_teams':
        return <SiMicrosoftTeams size={iconSize} />;
      case 'twilio':
        return <SiTwilio size={iconSize} />;
      case 'tiktok':
      case 'tiktok_shop':
      case 'tiktok_business_account':
      case 'tiktok_creator':
        return <SiTiktok size={iconSize} />;
      case 'amazon_stream':
        return <SiAmazon size={iconSize} />;
      case 'klaviyo':
        return <EmailIcon />;
      case 'smsbump':
        return <SmsIcon />;
      case 'attentive':
        return <SmsIcon />;
      case 'edesk':
        return <SiEdesk size={iconSize} />;
      case 'mirakl':
        return <SiMirakl size={iconSize} />;
      case 'target_plus':
        return <SiTarget size={iconSize} />;
      case 'impact':
        return <SiImpact size={iconSize} />;
      case 'clarity':
        return <SiClarity size={iconSize} />;
      case 'dor':
        return <SiDor size={iconSize} />;
      case 'knocommerce':
        return <SiKnoCommerce size={iconSize} />;
      case 'braze':
        return <SiBraze size={iconSize} />;
      case 'sfmc':
        return <SiSfmc size={iconSize} />;
      case 'salesforce_service_cloud':
        return <SiSalesforceServiceCloud size={iconSize} />;
      case 'cruva':
        return <SiCruva size={iconSize} />;
      case 'judgeme':
        return <SiJudgeme size={iconSize} />;
      case 'okendo':
        return <SiOkendo size={iconSize} />;
      case 'recharge':
        return <SiRecharge size={iconSize} />;
      case 'heartland_retail':
        return <SiHeartlandRetail size={iconSize} />;
      case 'skio':
        return <SiSkio size={iconSize} />;
      case 'omnisend':
        return <SiOmnisend size={iconSize} />;
      case 'loop_returns':
        return <SiLoopReturns size={iconSize} />;
      case 'appstle_subscriptions':
        return <SiAppstleSubscriptions size={iconSize} />;
      case 'smile':
        return <SiSmile size={iconSize} />;
      case 'stayai':
        return <SiStayAi size={iconSize} />;
      case 'loop_subscriptions':
        return <SiLoopSubscriptions size={iconSize} />;
      case 'globale':
        return <SiGlobale size={iconSize} />;
      case 'bold_subscriptions':
        return <SiBoldSubscriptions size={iconSize} />;
      case 'powerreviews':
        return <SiPowerReviews size={iconSize} />;
      case 'ordergroove':
        return <SiOrdergroove size={iconSize} />;
      case 'sfcc':
        return <SiSfcc size={iconSize} />;
      case 'kibo':
        return <SiKibo size={iconSize} />;
      case 'zendesk':
        return <SiZendesk size={iconSize} />;
      case 'gladly':
        return <SiGladly size={iconSize} />;
      case 'kustomer':
        return <SiKustomer size={iconSize} />;
      case 'segment':
        return <SiSegment size={iconSize} />;
      case 'snowflake':
        return <SiSnowflake size={iconSize} />;
      case 'databricks':
        return <SiDatabricks size={iconSize} />;
      case 'file_feed':
        return <FileFeedIcon sx={{ fontSize: iconSize }} />;   // generic SFTP loader (no single vendor mark)
      case 'bigquery':
        return <SiBigQuery size={iconSize} />;
      case 'brightpearl':
        return <SiBrightpearl size={iconSize} />;
      case 'adobe_commerce':
        return <SiAdobeCommerce size={iconSize} />;
      case 'woocommerce':
        return <SiWooCommerce size={iconSize} />;
      case 'shipbob':
        return <SiShipbob size={iconSize} />;
      case 'stripe':
        return <SiStripe size={iconSize} />;
      case 'yotpo_reviews':
        return <SiYotpo size={iconSize} />;  // the official Yotpo app icon
      case 'postscript':
        return <SiPostscript size={iconSize} />;
      case 'fairing':
        return <SiFairing size={iconSize} />;
      case 'walmart':
        return <SiWalmart size={iconSize} />;
      case 'applovin':
        return <SiAppLovin size={iconSize} />;
      case 'chatgpt_ads':
        return <SiChatGPTAds size={iconSize} />;
      case 'taboola':
        return <SiTaboola size={iconSize} />;
      case 'walmart_connect':
        return <SiWalmartConnect size={iconSize} />;
      case 'adobe_analytics':
        return <SiAdobeAnalytics size={iconSize} />;
      case 'adobe_campaign':
        return <SiAdobeCampaign size={iconSize} />;
      case 'adobe_experience_platform':
        return <SiAdobeExperiencePlatform size={iconSize} />;
      case 'marketo':
        return <SiMarketo size={iconSize} />;
      case 'criteo_retail_media':
        return <SiCriteo size={iconSize} />;
      case 'awin':
        return <SiAwin size={iconSize} />;
      case 'partnerize':
        return <SiPartnerize size={iconSize} />;
      case 'rakuten_advertising':
        return <SiRakutenAdvertising size={iconSize} />;
      case 'business_central':
        return <SiBusinessCentral size={iconSize} />;
      case 'cj':
        return <SiCj size={iconSize} />;
      case 'lightspeed':
      case 'lightspeed_r':
        return <SiLightspeed size={iconSize} />;
      case 'square':
        return <SiSquare size={iconSize} />;
      case 'snapchat_ads':
        return <SiSnapchat size={iconSize} />;
      case 'reddit_ads':
        return <SiReddit size={iconSize} />;
      case 'sa360':
        return <SiSa360 size={iconSize} />;
      case 'dv360':
        return <SiDv360 size={iconSize} />;
      case 'cm360':
        return <SiCm360 size={iconSize} />;
      case 'teams-agent-app':
        return <SiMicrosoftTeams size={iconSize} />;
      case 'pinterest':
        return <SiPinterest size={iconSize} />;
      case 'quickbooks':
        return <SiQuickbooks size={iconSize} />;
      case 'microsoft_ads':
        return <SiMicrosoft size={iconSize} />;
      case 'paypal':
        return <SiPaypal size={iconSize} />;
      case 'wise':
        return <SiWise size={iconSize} />;
      case 'revolut':
        return <SiRevolut size={iconSize} />;
      case 'netsuite':
        return <SiNetSuite size={iconSize} />;
      case 'xero':
        return <SiXero size={iconSize} />;
      case 'gorgias':
        return <SiGorgias size={iconSize} />;
      case 'wix':
        return <SiWix size={iconSize} />;
      case 'unify':
        return <SiUnify size={iconSize} />;
      case 'wshop':
        return <SiWShop size={iconSize} />;
      default:
        if (type && type.startsWith('amazon')) {
          return <SiAmazon size={iconSize} />;
        }
        return <IntegrationInstructionsIcon />;
    }
  };

  // Helper to get the appropriate color for a connector status
  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return theme.palette.success.main;
      case 'warning':
        return theme.palette.warning.main;
      case 'error':
        return theme.palette.error.main;
      default:
        return theme.palette.grey[500];
    }
  };
  
  // Helper to check if a connector uses OAuth
  const isOAuthConnector = (platformName) => {
    const oauthPlatforms = [
      'facebook', 'pinterest', 'google_ads', 'google_analytics',
      'google_search_console', 'google_merchant_center', 'google_postmaster', 'tiktok', 'tiktok_shop', 'tiktok_business_account',
      'slack', 'microsoft_teams', 'amazon_ads', 'amazon', 'shopify', 'klaviyo', 'quickbooks', 'microsoft_ads',
      'google_workspace', 'google-workspace',
      'microsoft_workspace', 'microsoft-workspace', 'xero',
      'sps_commerce', 'sps-commerce', 'square', 'snapchat_ads', 'reddit_ads', 'sa360', 'amazon_vendor', 'dv360', 'cm360'
    ];
    return oauthPlatforms.includes(platformName);
  };

  // Parse a connector's metadata, which arrives from the API as a raw JSON
  // string (ClickHouse String column). Returns {} on missing/invalid input.
  const parseConnectorMetadata = (metadata) => {
    if (!metadata) return {};
    if (typeof metadata === 'object') return metadata;
    try { return JSON.parse(metadata); } catch { return {}; }
  };

  // Open the connector wizard pre-filled to re-enter a Shopify Admin API access
  // token for an EXISTING connector. The manual flow (POST /shopify/manual)
  // matches the existing connector by shop domain + brand (Shopify uniqueness =
  // external_id) and UPDATEs it in place — so this re-authenticates rather than
  // creating a duplicate. The user just pastes a fresh access token.
  const openShopifyTokenReauth = (connector, shopDomain, reauthBrandId) => {
    setError('');
    setConnectorType('shopify');
    setNameDirty(true); // preserve the existing connector name; don't auto-rename
    setConnectorForm({
      name: connector.name || '',
      brandId: reauthBrandId != null ? String(reauthBrandId) : '',
      type: 'shopify',
      shopDomain: shopDomain || '',
      accessToken: '',            // user pastes a fresh Admin API access token
      shopifyApiKey: '',
      shopifyProductToken: '',
      market: connector.market || '',
      shopifyConnectMethod: 'manual',
      apiKey: '',
      apiSecret: '',
      gorgiasSubdomain: '',
      gorgiasEmail: '',
      clientId: '',
      clientSecret: '',
      refreshToken: '',
      developerToken: '',
      customerId: '',
      awsAccessKey: '',
      awsSecretKey: '',
      marketplaceIds: '',
      regionId: '',
      country: '',
      amazonConnectMethod: 'manual',
      amazonRefreshToken: '',
      amazonSellingPartnerId: '',
      amazonLwaClientId: '',
      amazonLwaClientSecret: '',
      amazonAdsConnectMethod: 'oauth',
      amazonAdsClientId: '',
      amazonAdsClientSecret: '',
      amazonAdsRefreshToken: '',
      reauthConnectorId: null,
      region: '',
      accountName: '',
      currency: connector.currency || 'USD'
    });
    setActiveStep(1); // jump straight to the credentials step
    setOpenDialog(true);
  };

  // Manual RE-auth for an Amazon Ads connector created with the customer's own LWA app
  // (metadata.created_via === 'manual_self_auth'). OAuth re-auth would swap in the SHARED app's
  // credentials, so these must re-enter their own client_id/secret/refresh_token. reauthConnectorId
  // is threaded to the backend so it updates THAT connector in place (deterministic, no duplicate).
  const openAmazonAdsManualReauth = (connector, reauthBrandId) => {
    setError('');
    setConnectorType('amazon_ads');
    setNameDirty(true); // preserve the existing connector name
    setConnectorForm(prev => ({
      ...prev,
      name: connector.name || '',
      brandId: reauthBrandId != null ? String(reauthBrandId) : '',
      type: 'amazon_ads',
      amazonAdsConnectMethod: 'manual',
      amazonAdsClientId: '',
      amazonAdsClientSecret: '',
      amazonAdsRefreshToken: '',
      // country is required by the manual endpoint's validation; prefill from the connector
      // (new manual connectors store countryCode in region; legacy rows use market).
      country: connector.market || connector.region || '',
      currency: connector.currency || 'USD',
      reauthConnectorId: connector.id
    }));
    setActiveStep(1); // jump straight to the credentials step
    setOpenDialog(true);
  };

  // Handle re-authentication for a connector. Most platforms use OAuth, but
  // Shopify connectors here authenticate with a stored Admin API access token
  // (credential_type 'shopify_credentials') — there are no live Shopify OAuth
  // connectors. So Shopify re-auth re-enters the access token via the manual
  // flow instead of firing the OAuth authorize redirect (which 400s, because
  // these connectors carry no shopDomain in metadata and aren't OAuth).
  // Open the Facebook "move connector to Meta app" dialog and load the app list
  // (super-admin only; the backend enforces the same gate).
  const openFbAppMove = async (connector, brandId) => {
    setFbAppMove({
      open: true, connector, brandId, apps: [], currentAppKey: null,
      selected: '', loading: true, submitting: false, error: ''
    });
    try {
      const resp = await api.get('/api/connectors/facebook/apps', {
        params: { connectorId: connector.id }
      });
      const apps = (resp.data && resp.data.apps) || [];
      const currentAppKey = (resp.data && resp.data.currentAppKey) || null;
      setFbAppMove(prev => ({
        ...prev,
        apps,
        currentAppKey,
        // Preselect the connector's current app when known, else the first usable app.
        selected: currentAppKey || (apps.find(a => a.usable) || {}).app_key || '',
        loading: false
      }));
    } catch (err) {
      setFbAppMove(prev => ({
        ...prev,
        loading: false,
        error: err.response?.data?.message || err.message || 'Failed to load Meta apps'
      }));
    }
  };

  // Start the Facebook re-auth against the selected app (passes targetAppKey when
  // it differs from the current app; identical selection = a plain re-auth).
  const submitFbAppMove = async () => {
    const { connector, brandId, selected, currentAppKey } = fbAppMove;
    if (!connector || !selected) return;
    setFbAppMove(prev => ({ ...prev, submitting: true, error: '' }));
    try {
      await oauthService.startOAuth('facebook', {
        brandId: brandId || 0,
        reauth: true,
        connectorId: connector.id,
        // Only send the override when actually switching apps.
        targetAppKey: selected !== currentAppKey ? selected : undefined
      });
      // startOAuth redirects the browser to Facebook on success; nothing else to do.
    } catch (err) {
      setFbAppMove(prev => ({
        ...prev,
        submitting: false,
        error: err.message || 'Failed to start re-authentication'
      }));
    }
  };

  const closeFbAppMove = () => {
    setFbAppMove(prev => ({ ...prev, open: false, submitting: false }));
  };

  const handleReauthenticate = async (connector) => {
    try {
      setError('');

      const platformName = connector.platform_name || connector.type;
      const brandId = connector.brandId || connector.brand_id;

      if (!platformName) {
        setError('Unable to determine connector platform');
        return;
      }

      const isGoogleWorkspace = platformName === 'google_workspace' || platformName === 'google-workspace';
      const isMicrosoftWorkspace = platformName === 'microsoft_workspace' || platformName === 'microsoft-workspace';
      const isSpsCommerce = platformName === 'sps_commerce' || platformName === 'sps-commerce';

      if (!brandId && !isGoogleWorkspace && !isMicrosoftWorkspace && !isSpsCommerce) {
        setError('Unable to determine brand for re-authentication');
        return;
      }

      // Route by connector type: token-based Shopify connectors (every live one)
      // re-enter their access token; only genuine OAuth-created connectors
      // (metadata.created_via === 'oauth') keep the OAuth re-auth path.
      const connectorMeta = parseConnectorMetadata(connector.metadata);
      const isShopifyTokenReauth =
        platformName === 'shopify' && connectorMeta.created_via !== 'oauth';
      // Amazon Ads connectors created with the customer's OWN LWA app must re-enter their own
      // credentials (OAuth re-auth would swap in the shared app). Detected via created_via.
      const isAmazonAdsManualReauth =
        platformName === 'amazon_ads' && connectorMeta.created_via === 'manual_self_auth';

      // Facebook + platform super-admin: open the "move to Meta app" dialog, which
      // lets an operator re-mint the connector under a chosen app (e.g. shift a
      // brand off a rate-limited app). Everyone else keeps the normal re-auth,
      // which always re-mints under the connector's existing app.
      if (platformName === 'facebook' && canSwitchMetaApp) {
        openFbAppMove(connector, brandId);
        return;
      }

      // Show confirmation dialog — wording depends on the re-auth method.
      const confirmed = await confirm({
        title: 'Re-authenticate Connector',
        message: isShopifyTokenReauth
          ? `Re-authenticate this Shopify connector?\n\nShopify connections use an Admin API access token. You'll be asked to paste a fresh access token — the existing connector will be updated in place.`
          : isAmazonAdsManualReauth
          ? `Re-authenticate this Amazon Ads connector?\n\nThis connector uses your own Login-with-Amazon app. You'll re-enter your Client ID, Client Secret, and Refresh Token — the existing connector will be updated in place.`
          : `Re-authenticate ${platformName.toUpperCase()} connector?\n\nThis will refresh your ${platformName} permissions and may grant access to new features like analytics data.\n\nYou'll be redirected to ${platformName} to re-authorize the connection.`,
        confirmText: 'Re-authenticate',
        severity: 'danger'
      });

      if (!confirmed) {
        return;
      }

      if (isShopifyTokenReauth) {
        // Derive the shop domain from the connector itself: external_id reliably
        // holds '<shop>.myshopify.com' for every Shopify connector; metadata may
        // also carry shop_domain. The backend cleans the domain before matching.
        const shopDomain =
          connectorMeta.shop_domain || connectorMeta.shopDomain || connector.external_id || '';
        openShopifyTokenReauth(connector, shopDomain, brandId);
        return;
      }

      if (isAmazonAdsManualReauth) {
        openAmazonAdsManualReauth(connector, brandId);
        return;
      }

      // OAuth re-authentication flow (all other platforms + any OAuth-created
      // Shopify connector).
      let options = {
        brandId: brandId || 0,
        reauth: true,
        connectorId: connector.id
      };

      if (isGoogleWorkspace || isMicrosoftWorkspace) {
        options.type = 'company';
      } else if (platformName === 'shopify') {
        // OAuth-created Shopify connector: pass its shop domain so the backend
        // can build the authorize URL.
        const shopDomain =
          connectorMeta.shop_domain || connectorMeta.shopDomain || connector.external_id;
        if (shopDomain) {
          options.shopDomain = shopDomain;
        }
      }

      await oauthService.startOAuth(platformName, options);

      // Show success message
      alert(`Re-authentication started for ${platformName.toUpperCase()}. You'll be redirected to complete the process.`);

    } catch (err) {
      console.error('Re-authentication error:', err);
      setError(err.message || `Failed to start re-authentication for ${connector.platform_name || connector.type}`);
    }
  };

  // Platforms whose credentials can be rotated via the "Update API Token" dialog.
  // Currently scoped to eDesk only — extend this list (and add a matching backend
  // PUT /api-key/<platform>/:id endpoint) for any other API-key connector that
  // needs in-UI rotation.
  const isApiKeyRotatable = (platformName) =>
    platformName === 'edesk' ||
    platformName === 'clarity' ||
    platformName === 'mirakl' ||
    platformName === 'target_plus' ||
    platformName === 'impact';

  // Open the API-key rotation dialog for an existing connector
  const handleOpenApiKeyDialog = (connector) => {
    setApiKeyDialog({
      open: true,
      connector,
      newKey: '',
      submitting: false,
      errorText: ''
    });
  };

  // Close the API-key rotation dialog (clears state)
  const handleCloseApiKeyDialog = () => {
    setApiKeyDialog({ open: false, connector: null, newKey: '', submitting: false, errorText: '' });
  };

  // Submit the rotated API key to the backend. On success: refresh the connector
  // list so the new account info renders, and close the dialog.
  const handleSubmitApiKeyUpdate = async () => {
    const { connector, newKey } = apiKeyDialog;
    if (!connector || !newKey || !newKey.trim()) {
      setApiKeyDialog(prev => ({ ...prev, errorText: 'Please enter the new API token' }));
      return;
    }
    const platform = connector.platform_name || connector.type;
    if (!isApiKeyRotatable(platform)) {
      setApiKeyDialog(prev => ({ ...prev, errorText: `Token rotation is not supported for ${platform}` }));
      return;
    }
    setApiKeyDialog(prev => ({ ...prev, submitting: true, errorText: '' }));
    try {
      // platforms_v2.name uses underscores (target_plus) but the api-key ROUTES are
      // hyphenated (/api-key/target-plus), matching cin7-omni and thg-procure. Without
      // this map the rotation PUT 404s for any underscored platform — add an entry when
      // you make one rotatable.
      const ROTATE_SLUG = { target_plus: 'target-plus', cin7_omni: 'cin7-omni', thg_procure: 'thg-procure' };
      const routeSlug = ROTATE_SLUG[platform] || platform;
      const response = await api.put(`/api/connectors/api-key/${routeSlug}/${connector.id}`, {
        apiKey: newKey.trim()
      });
      if (response.data?.success) {
        await fetchConnectors();
        handleCloseApiKeyDialog();
        alert(response.data.message || 'API token updated successfully.');
      } else {
        setApiKeyDialog(prev => ({
          ...prev,
          submitting: false,
          errorText: response.data?.message || 'Failed to update API token'
        }));
      }
    } catch (err) {
      console.error('Update API key error:', err);
      const msg = err.response?.data?.message || err.message || 'Failed to update API token';
      setApiKeyDialog(prev => ({ ...prev, submitting: false, errorText: msg }));
    }
  };

  // Helper to get brand name from brand ID
  const getBrandName = (brandIdParam) => {
    if (!brandIdParam) return 'Company Level';
    const brandId = parseInt(brandIdParam);
    console.log('Looking for brandId:', brandId, 'in brands:', brands.length);
    const brand = brands.find(b => parseInt(b.id) === brandId);
    console.log('Found brand:', brand);
    return brand ? brand.name : `Unknown Brand (ID: ${brandId})`;
  };

  // Helper to get connector account information for enhanced display
  const getConnectorAccountInfo = (connector) => {
    const accountId = connector.external_id || connector.account_id;
    const metadata = parseConnectorMetadata(connector.metadata);
    
    // Extract account-specific information based on platform
    let accountInfo = {};
    
    if (accountId) {
      // Show full account ID for all platforms
      accountInfo.displayId = accountId;
      accountInfo.fullId = accountId;
    }
    
    // Platform-specific account name extraction
    switch (connector.platform_name || connector.type) {
      case 'facebook':
        accountInfo.accountName = metadata.account_name || connector.account_name || 'Meta Account';
        break;
      case 'google_ads':
        accountInfo.accountName = metadata.customer_name || connector.customer_name || 'Google Ads Account';
        break;
      case 'shopify':
        accountInfo.accountName = metadata.shop_domain || connector.shop_domain || accountId;
        break;
      case 'amazon':
      case 'amazon_ads':
        accountInfo.accountName = metadata.marketplace_name || connector.marketplace_name || 'Amazon Account';
        break;
      case 'tiktok':
        // TikTok advertiser info is stored in selected_advertiser object
        const advertiserInfo = metadata.selected_advertiser || {};
        accountInfo.accountName = advertiserInfo.name || metadata.advertiser_name || connector.advertiser_name || 'TikTok Account';
        // Also extract the advertiser ID for display
        if (advertiserInfo.advertiser_id) {
          accountInfo.displayId = advertiserInfo.advertiser_id;
          accountInfo.fullId = advertiserInfo.advertiser_id;
        }
        break;
      case 'klaviyo':
        accountInfo.accountName = metadata.company_name || connector.company_name || 'Klaviyo Account';
        break;
      case 'smsbump':
        accountInfo.accountName = 'SMSBump Account';
        break;
      case 'attentive':
        accountInfo.accountName = metadata.company_name || connector.company_name || 'Attentive Account';
        break;
      case 'edesk':
        accountInfo.accountName = metadata.user_name || metadata.user_email || connector.user_name || 'eDesk Account';
        break;
      case 'mirakl':
        accountInfo.accountName = metadata.marketplace_name
          ? `${metadata.marketplace_name}${metadata.shop_name ? ` — ${metadata.shop_name}` : ''}`
          : 'Mirakl Marketplace';
        break;
      case 'target_plus':
        accountInfo.accountName = metadata.seller_id ? `Target Plus seller ${metadata.seller_id}` : 'Target Plus';
        break;
      case 'impact':
        accountInfo.accountName = metadata.account_sid ? `Impact.com ${metadata.account_sid}` : 'Impact.com';
        break;
      case 'clarity':
        accountInfo.accountName = metadata.clarity_project_id ? `Clarity project ${metadata.clarity_project_id}` : 'Microsoft Clarity';
        break;
      case 'pinterest':
        accountInfo.accountName = metadata.business_name || connector.business_name || 'Pinterest Business';
        break;
      case 'google_merchant_center':
        accountInfo.accountName = metadata.account_name || connector.account_name || 'Merchant Center Account';
        break;
      default:
        accountInfo.accountName = metadata.account_name || connector.account_name || 
                                 `${(connector.platform_name || connector.type || 'Unknown').replace(/_/g, ' ')} Account`;
        break;
    }
    
    return accountInfo;
  };

  // Helper to check if a connector has a schedule
  const connectorHasSchedule = (connectorId) => {
    return schedules.some(schedule => 
      schedule.connector_id === connectorId || schedule.connector_id === parseInt(connectorId)
    );
  };

  // Handle creating a new schedule for a connector
  const handleCreateSchedule = (connectorId) => {
    // Navigate to scheduled jobs page with modal open and connector pre-selected
    navigate(`/scheduled-jobs?create=true&connector_id=${connectorId}`);
  };

  // Get connectors for the selected brand and type
  const filteredConnectors = connectors.filter(connector => {
    // Handle both brandId and brand_id properties for consistency
    const connectorBrandId = connector.brandId || connector.brand_id;
    const brandMatch = selectedBrand ?
      (connectorBrandId && parseInt(connectorBrandId) === parseInt(selectedBrand)) : true;

    // Platform filter: if no platform selected, show all (typeMatch = true)
    let typeMatch = true;
    if (selectedType && selectedType.trim() !== '') {
      const normalizedSelectedType = selectedType.toLowerCase().trim();

      // Try platform_key first (most reliable - it's the 'name' field from platforms_v2)
      // This is what the dropdown uses, so it should match exactly
      if (connector.platform_key) {
        const normalizedPlatformKey = connector.platform_key.toLowerCase().trim();
        typeMatch = normalizedPlatformKey === normalizedSelectedType;
      }
      // Fallback: if no platform_key, try to extract platform from platform_name or type
      // This handles old data or connectors without platform_key
      else if (connector.platform_name || connector.type) {
        const fallbackPlatform = connector.platform_name || connector.type;
        const normalizedFallback = fallbackPlatform.toLowerCase().trim();

        // Smart matching: check if the selected platform is the start of the fallback
        // e.g., "facebook" matches "Facebook Ads" but not "Wise (TransferWise)"
        // Also check for exact match with underscores replaced (e.g., "google_ads" -> "google ads")
        const selectedWithSpaces = normalizedSelectedType.replace(/_/g, ' ');
        typeMatch = normalizedFallback.startsWith(normalizedSelectedType) ||
                    normalizedFallback.startsWith(selectedWithSpaces) ||
                    normalizedFallback === normalizedSelectedType;
      } else {
        // No platform info at all, filter it out when a platform is selected
        typeMatch = false;
      }

    }

    // Category filter: connector.platform_category vs selectedCategory
    let categoryMatch = true;
    if (selectedCategory && selectedCategory.trim() !== '') {
      const cat = (connector.platform_category || '').toLowerCase().trim();
      categoryMatch = cat === selectedCategory.toLowerCase().trim();
    }

    return brandMatch && typeMatch && categoryMatch;
  });

  // Get all supported platforms for the filter dropdown (not just ones with connectors)
  // Sort the "Filter by Platform" dropdown by the VISIBLE display label, not the
  // internal platform name — otherwise e.g. "Microsoft Clarity" (name 'clarity') and
  // "Google Workspace" (name 'google-workspace') land in the wrong alphabetical spot.
  const supportedPlatforms = platforms
    .map(platform => platform.name)
    .sort((a, b) => getPlatformDisplayName(a).localeCompare(getPlatformDisplayName(b)));

  // Distinct, capitalised categories sourced from the platforms list. Empty/undefined skipped.
  const supportedCategories = Array.from(
    new Set(platforms.map(p => (p.category || '').trim()).filter(Boolean))
  ).sort();

  return (
    <Box>
      {/* Queue Status Panel */}
      <QueueStatusPanel
        queueStatus={queueStatus}
        onJobAction={handleJobAction}
        onRefresh={() => fetchQueueStatus(activityFilter)}
        loading={queueLoading}
        onActivityFilter={handleActivityFilter}
        activityFilter={activityFilter}
      />
      
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Box>
              <Typography variant="h4" sx={{ mb: 1, fontWeight: 600 }}>
                Data Connectors
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Connect your data sources to the platform
              </Typography>
            </Box>
          </Box>
        </Grid>
        
        {error && (
          <Grid item xs={12}>
            <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
          </Grid>
        )}
        
        <Grid item xs={12}>
          <Card 
            sx={{ 
              borderRadius: 3,
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
              mb: 3
            }}
          >
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                <FormControl sx={{ minWidth: 240 }}>
                  <InputLabel id="brand-select-label">Filter by Brand</InputLabel>
                  <Select
                    labelId="brand-select-label"
                    value={selectedBrand}
                    label="Filter by Brand"
                    onChange={handleBrandChange}
                    sx={{ borderRadius: 2 }}
                  >
                    <MenuItem value="">All Brands</MenuItem>
                    {brands.map(brand => (
                      <MenuItem key={brand.id} value={brand.id}>{brand.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                
                <FormControl sx={{ minWidth: 200 }}>
                  <InputLabel id="type-select-label">Filter by Platform</InputLabel>
                  <Select
                    labelId="type-select-label"
                    value={selectedType}
                    label="Filter by Platform"
                    onChange={(e) => setSelectedType(e.target.value)}
                    sx={{ borderRadius: 2 }}
                  >
                    <MenuItem value="">All Platforms</MenuItem>
                    {supportedPlatforms.map(platform => (
                      <MenuItem key={platform} value={platform}>
                        {getPlatformDisplayName(platform)}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl sx={{ minWidth: 200 }}>
                  <InputLabel id="category-select-label">Filter by Category</InputLabel>
                  <Select
                    labelId="category-select-label"
                    value={selectedCategory}
                    label="Filter by Category"
                    onChange={(e) => setSelectedCategory(e.target.value)}
                    sx={{ borderRadius: 2 }}
                  >
                    <MenuItem value="">All Categories</MenuItem>
                    {supportedCategories.map(category => (
                      <MenuItem key={category} value={category} sx={{ textTransform: 'capitalize' }}>
                        {category.charAt(0).toUpperCase() + category.slice(1)}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                
                <Box sx={{ flexGrow: 1 }} />
                
                <Button
                  variant="outlined" 
                  startIcon={<RefreshIcon />}
                  onClick={fetchConnectors}
                  sx={{ borderRadius: 2 }}
                >
                  Refresh
                </Button>
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() => setActiveTab(1)}
                  sx={{ 
                    borderRadius: 2,
                    background: 'linear-gradient(45deg, var(--color-primary) 30%, var(--color-accent) 90%)',
                  }}
                >
                  Add Connector
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12}>
          <Card 
            sx={{ 
              borderRadius: 3,
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
            }}
          >
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                sx={{
                  '& .MuiTab-root': {
                    minWidth: 120,
                    px: 3,
                    py: 2
                  }
                }}
              >
                <Tab label="Active Connectors" />
                <Tab label="Add New Connector" />
              </Tabs>
            </Box>
            
            {/* Active Connectors Tab */}
            {activeTab === 0 && (
              <Box sx={{ p: 3 }}>
                {loading ? (
                  <Box sx={{ display: 'flex', justifyContent: 'center', py: 5 }}>
                    <CircularProgress />
                  </Box>
                ) : filteredConnectors.length === 0 ? (
                  <Box sx={{ textAlign: 'center', py: 5 }}>
                    <Typography variant="h6" gutterBottom>
                      No connectors found
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                      {selectedBrand 
                        ? "This brand doesn't have any connectors yet." 
                        : "You don't have any connectors set up yet."}
                    </Typography>
                    <Button
                      variant="contained"
                      startIcon={<AddIcon />}
                      onClick={() => setActiveTab(1)}
                      sx={{ 
                        borderRadius: 2,
                        background: 'linear-gradient(45deg, var(--color-primary) 30%, var(--color-accent) 90%)',
                      }}
                    >
                      Add Connector
                    </Button>
                  </Box>
                ) : (
                  <div className="connector-grid">
                    {filteredConnectors.map(connector => (
                      <Card
                        key={connector.uniqueKey || connector.id}
                        className="connector-card"
                        sx={{
                          borderRadius: 3,
                          border: '1px solid',
                          borderColor: 'divider',
                          overflow: 'visible'
                        }}
                      >
                        <CardContent className="connector-card-content">
                          <div className="connector-card-header">
                            <div className="connector-card-icon" style={{ backgroundColor: getPlatformColor(connector.platform_name || connector.type) + '15' }}>
                              <Box sx={{ color: getPlatformColor(connector.platform_name || connector.type) }}>
                                {getPlatformIcon(connector.platform_name || connector.type)}
                              </Box>
                            </div>
                            <div className="connector-card-info">
                              {editingConnector?.id === connector.id ? (
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 0.5 }}>
                                  {/* Name field */}
                                  <TextField
                                    size="small"
                                    label="Connector Name"
                                    value={editingConnector.name}
                                    onChange={(e) => handleUpdateEditingConnector('name', e.target.value)}
                                    onKeyPress={(e) => {
                                      if (e.key === 'Enter') {
                                        handleSaveConnector();
                                      } else if (e.key === 'Escape') {
                                        handleCancelEditConnector();
                                      }
                                    }}
                                    autoFocus
                                    fullWidth
                                  />
                                  {/* Brand selector */}
                                  <Select
                                    size="small"
                                    value={editingConnector.brand_id || ''}
                                    onChange={(e) => handleUpdateEditingConnector('brand_id', e.target.value)}
                                    fullWidth
                                  >
                                    {brands.map(brand => (
                                      <MenuItem key={brand.id} value={brand.id}>
                                        {brand.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                  {/* Action buttons */}
                                  <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'flex-end' }}>
                                    <IconButton
                                      size="small"
                                      color="primary"
                                      onClick={handleSaveConnector}
                                      title="Save changes"
                                    >
                                      <CheckIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton
                                      size="small"
                                      onClick={handleCancelEditConnector}
                                      title="Cancel"
                                    >
                                      <CancelIcon fontSize="small" />
                                    </IconButton>
                                  </Box>
                                </Box>
                              ) : (
                                <>
                                  {/* Name display */}
                                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5, width: '100%' }}>
                                    <Typography
                                      variant="h6"
                                      title={connector.name}
                                      style={{
                                        flex: '1 1 auto',
                                        display: '-webkit-box',
                                        WebkitLineClamp: 3,
                                        WebkitBoxOrient: 'vertical',
                                        overflow: 'hidden',
                                        lineHeight: 1.25,
                                        wordBreak: 'break-word',
                                        fontSize: '1.0rem',
                                        fontWeight: 600,
                                        whiteSpace: 'normal',
                                        textOverflow: 'clip'
                                      }}
                                    >
                                      {connector.name}
                                    </Typography>
                                    <Tooltip title="Edit connector">
                                      <IconButton
                                        size="small"
                                        onClick={() => handleStartEditConnector(connector)}
                                        sx={{
                                          opacity: 0,
                                          transition: 'opacity 0.2s',
                                          '.connector-card:hover &': { opacity: 0.7 },
                                          '&:hover': { opacity: 1 }
                                        }}
                                      >
                                        <EditIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                  {/* Profile/Subsidiary display (shows unique identifier) */}
                                  {(connector.profileName || connector.subsidiaryName) ? (
                                    <Typography
                                      variant="body2"
                                      title={`Profile: ${connector.profileName || connector.subsidiaryName}`}
                                      style={{
                                        color: '#0f766e',
                                        fontWeight: 600,
                                        display: '-webkit-box',
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: 'vertical',
                                        overflow: 'hidden',
                                        lineHeight: 1.3,
                                        wordBreak: 'break-word',
                                        whiteSpace: 'normal',
                                        textOverflow: 'clip',
                                        fontSize: '0.9rem',
                                        marginTop: '4px'
                                      }}
                                    >
                                      📍 {connector.profileName || connector.subsidiaryName}
                                    </Typography>
                                  ) : null}
                                  {/* Brand display (only if no profile) */}
                                  {!(connector.profileName || connector.subsidiaryName) && (
                                    <Typography
                                      variant="body2"
                                      title={getBrandName(connector.brandId || connector.brand_id)}
                                      style={{
                                        color: '#64748b',
                                        fontWeight: 500,
                                        display: '-webkit-box',
                                        WebkitLineClamp: 1,
                                        WebkitBoxOrient: 'vertical',
                                        overflow: 'hidden',
                                        lineHeight: 1.3,
                                        wordBreak: 'break-word',
                                        whiteSpace: 'normal',
                                        textOverflow: 'clip',
                                        fontSize: '0.875rem'
                                      }}
                                    >
                                      {getBrandName(connector.brandId || connector.brand_id)}
                                    </Typography>
                                  )}
                                </>
                              )}
                              {(() => {
                                const accountInfo = getConnectorAccountInfo(connector);
                                return (
                                  <Box className="connector-account-details" sx={{ mt: 1, minHeight: '48px' }}>
                                    {accountInfo.accountName && accountInfo.accountName !== `${(connector.platform_name || connector.type || 'Unknown').replace(/_/g, ' ')} Account` && (
                                      <Typography
                                        variant="caption"
                                        sx={{
                                          display: 'block',
                                          color: 'text.primary',
                                          fontSize: '0.8125rem',
                                          fontWeight: 500,
                                          lineHeight: 1.4,
                                          mb: 0.25
                                        }}
                                        title={`Account: ${accountInfo.accountName}`}
                                      >
                                        <strong>Account:</strong> {accountInfo.accountName}
                                      </Typography>
                                    )}
                                    {accountInfo.displayId && (
                                      <Typography
                                        variant="caption"
                                        sx={{
                                          display: 'block',
                                          color: 'text.primary',
                                          fontSize: '0.8125rem',
                                          fontFamily: 'monospace',
                                          fontWeight: 500,
                                          lineHeight: 1.4
                                        }}
                                        title={`Full ID: ${accountInfo.fullId || accountInfo.displayId}`}
                                      >
                                        <strong>ID:</strong> {accountInfo.displayId}
                                      </Typography>
                                    )}
                                  </Box>
                                );
                              })()}
                            </div>
                            {/* Status chip - only show if error or important status */}
                            {connector.status && connector.status !== 'active' && connector.status !== 'syncing' && (
                              <Chip
                                label={connector.status}
                                size="small"
                                className={`connector-card-status connector-status-${connector.status}`}
                              />
                            )}
                            {/* Schedule Status Icon - Only show if no schedule is enabled */}
                            {!connector.schedule_enabled && (
                              <Tooltip title={connectorHasSchedule(connector.id) ? "Has scheduled sync" : "Click to create schedule"}>
                                <IconButton
                                  size="small"
                                  onClick={() => !connectorHasSchedule(connector.id) && handleCreateSchedule(connector.id)}
                                  sx={{ 
                                    ml: 1,
                                    cursor: connectorHasSchedule(connector.id) ? 'default' : 'pointer',
                                    '&:hover': {
                                      backgroundColor: !connectorHasSchedule(connector.id) ? 'success.light' : 'transparent'
                                    }
                                  }}
                                  disabled={connectorHasSchedule(connector.id)}
                                >
                                  {connectorHasSchedule(connector.id) ? (
                                    <ScheduledIcon 
                                      fontSize="small" 
                                      sx={{ color: 'success.main' }}
                                    />
                                  ) : (
                                    <NoScheduleIcon 
                                      fontSize="small" 
                                      sx={{ 
                                        color: 'text.secondary',
                                        '&:hover': {
                                          color: 'success.main'
                                        }
                                      }}
                                    />
                                  )}
                                </IconButton>
                              </Tooltip>
                            )}
                            {connector.schedule_enabled && (
                              <Chip
                                label={`Auto (${connector.schedule_type || 'daily'})`}
                                size="small"
                                variant="outlined"
                                sx={{ 
                                  ml: 1,
                                  fontSize: '0.7rem',
                                  height: '20px',
                                  borderColor: 'primary.main',
                                  color: 'primary.main',
                                  '& .MuiChip-label': {
                                    px: 0.5
                                  }
                                }}
                              />
                            )}
                          </div>
                          
                          <Typography 
                            variant="body2" 
                            className="connector-card-description"
                            sx={{ color: 'text.secondary' }}
                          >
                            {getPlatformDescription({ name: connector.platform_name || connector.type })}
                          </Typography>
                          
                          <Box sx={{ mb: 2, fontSize: '0.875rem', color: 'text.secondary' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5, gap: 1 }}>
                              <span style={{ flexShrink: 0 }}><strong>Type:</strong></span>
                              <span style={{ textAlign: 'right', wordBreak: 'break-word' }}>
                                {(connector.platform_category || connector.platform_name || 'unknown').charAt(0).toUpperCase() +
                                 (connector.platform_category || connector.platform_name || 'unknown').slice(1)}
                              </span>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mb: 0.5, gap: 1 }}>
                              <span style={{ flexShrink: 0 }}><strong>Last Successful Auth:</strong></span>
                              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flexWrap: 'wrap', gap: 6, textAlign: 'right', wordBreak: 'break-word' }}>
                                <span style={{ color: connector.lifecycleState === 'needs_reauth' ? '#b45309' : 'inherit', fontWeight: connector.lifecycleState === 'needs_reauth' ? 600 : 'inherit' }}>
                                  {formatDate(connector.lastSuccessfulAuth)}
                                </span>
                                {connector.lifecycleState === 'needs_reauth' && (
                                  <span style={{ fontSize: '0.68rem', fontWeight: 700, letterSpacing: '0.02em', textTransform: 'uppercase', color: '#b45309', background: '#fdf1e0', border: '1px solid #f4d199', borderRadius: 999, padding: '1px 8px', whiteSpace: 'nowrap', lineHeight: 1.6 }}>
                                    Reconnect needed
                                  </span>
                                )}
                              </span>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5, gap: 1 }}>
                              <span style={{ flexShrink: 0 }}><strong>Last Successful Sync:</strong></span>
                              <span style={{ textAlign: 'right', wordBreak: 'break-word' }}>
                                {formatDate(connector.lastSync || connector.updated_at)}
                              </span>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}>
                              <span style={{ flexShrink: 0 }}><strong>Next Sync:</strong></span>
                              <span style={{ textAlign: 'right', wordBreak: 'break-word' }}>
                                {(() => {
                                  if (!connector.nextSync) {
                                    return connector.schedule_enabled === false ? 'Disabled' : 'Manual';
                                  }
                                  const formattedDate = formatDate(connector.nextSync);
                                  return formattedDate === 'Never' ? 'Manual' : formattedDate;
                                })()}
                              </span>
                            </Box>
                          </Box>
                          
                          <div className="connector-card-actions">
                            {(connector.platform_name === 'google-workspace' || connector.platform_name === 'google_workspace') ? (
                              <Button
                                variant="contained"
                                size="small"
                                startIcon={<TableChartIcon />}
                                onClick={() => navigate('/google-sheets')}
                                sx={{
                                  borderRadius: 2,
                                  flex: 1,
                                  minWidth: 'fit-content',
                                  background: 'linear-gradient(45deg, #4285F4 30%, #34A853 90%)',
                                  '&:hover': {
                                    background: 'linear-gradient(45deg, #3367D6 30%, #2E7D32 90%)',
                                  }
                                }}
                              >
                                Manage Sheets
                              </Button>
                            ) : isCSVUploadConnector(connector) ? (
                              <Button
                                variant="contained"
                                size="small"
                                startIcon={<UploadIcon />}
                                onClick={() => handleCSVUploadClick(connector)}
                                sx={{
                                  borderRadius: 2,
                                  flex: 1,
                                  minWidth: 'fit-content',
                                  background: 'linear-gradient(45deg, #FF6B6B 30%, #FF8E53 90%)',
                                  '&:hover': {
                                    background: 'linear-gradient(45deg, #EE5A6F 30%, #F77737 90%)',
                                  }
                                }}
                              >
                                Upload Transactions
                              </Button>
                            ) : (
                              <Button
                                variant="contained"
                                size="small"
                                startIcon={<QueueIcon />}
                                onClick={() => handleEnhancedSyncClick(connector)}
                                sx={{
                                  borderRadius: 2,
                                  flex: 1,
                                  minWidth: 'fit-content',
                                  background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
                                  '&:hover': {
                                    background: 'linear-gradient(45deg, #1976D2 30%, #1BB5D3 90%)',
                                  }
                                }}
                              >
                                Queue Sync
                              </Button>
                            )}
                            {isOAuthConnector(connector.platform_name || connector.type) && (
                              <Button
                                variant="outlined"
                                size="small"
                                startIcon={<ReauthIcon />}
                                onClick={() => handleReauthenticate(connector)}
                                sx={{ borderRadius: 2, color: 'warning.main', borderColor: 'warning.main' }}
                                title="Re-authenticate to refresh permissions"
                              >
                                Reauth
                              </Button>
                            )}
                            {isApiKeyRotatable(connector.platform_name || connector.type) && (
                              <Button
                                variant="outlined"
                                size="small"
                                startIcon={<ReauthIcon />}
                                onClick={() => handleOpenApiKeyDialog(connector)}
                                sx={{ borderRadius: 2, color: 'warning.main', borderColor: 'warning.main' }}
                                title="Update API token (rotate credentials)"
                              >
                                Update Token
                              </Button>
                            )}
                            <IconButton
                              color="error"
                              onClick={() => handleDeleteConnector(connector)}
                              size="small"
                              sx={{ border: 1, borderColor: 'divider', borderRadius: 2 }}
                              title="Delete connector"
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </div>
                        </CardContent>
                      </Card>
                    ))}
                  </div>
                )}

                {/* Communication Apps Section */}
                <CommunicationAppsSection />
              </Box>
            )}

            {/* Add New Connector Tab */}
            {activeTab === 1 && (
              <Box sx={{ p: 3 }}>
                <Typography variant="h6" gutterBottom>
                  Choose a connector type
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                  Select a data source to connect to your platform
                </Typography>

                {(selectedType || selectedCategory) && (
                  <Alert severity="info" sx={{ mb: 2, borderRadius: 2 }}>
                    Showing only {selectedType && <><strong>{getPlatformDisplayName(selectedType)}</strong></>}
                    {selectedType && selectedCategory && ' in '}
                    {selectedCategory && <><strong>{selectedCategory.charAt(0).toUpperCase() + selectedCategory.slice(1)}</strong> category</>}
                    {' '}
                    <Button size="small" onClick={() => { setSelectedType(''); setSelectedCategory(''); }} sx={{ ml: 1 }}>Show all</Button>
                  </Alert>
                )}

                <div className="platform-grid">
                  {platforms
                    /* Hide system auth_type platforms (amazon_stream, amazon_ba_*) from the
                       picker: they are auto-derived off a parent Amazon connector and not
                       user-connectable, so their cards dead-end. Filtered client-side (not in
                       getPlatforms) so the Scheduled Jobs "Platform" filter can still list them. */
                    .filter(platform => platform.auth_type !== 'system')
                    .filter(platform => !selectedType || platform.name === selectedType)
                    .filter(platform => !selectedCategory || (platform.category || '').toLowerCase().trim() === selectedCategory.toLowerCase().trim())
                    .map(platform => (
                    <Card 
                      key={platform.id}
                      onClick={() => handleOpenDialog(platform.name)}
                      className="platform-setup-card"
                      sx={{ 
                        borderRadius: 3,
                        border: '1px solid',
                        borderColor: 'divider',
                      }}
                    >
                      <CardContent className="platform-setup-content">
                        <div 
                          className="platform-icon" 
                          style={{ 
                            backgroundColor: getPlatformColor(platform.name) + '15',
                            color: getPlatformColor(platform.name)
                          }}
                        >
                          {getPlatformIcon(platform.name)}
                        </div>
                        <Typography
                          variant="h6"
                          className="platform-title"
                          title={platform.display_name}
                          sx={{
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            lineHeight: 1.3,
                            minHeight: '2.6em',
                            wordBreak: 'break-word'
                          }}
                        >
                          {platform.display_name}
                        </Typography>
                        <Typography 
                          variant="body2" 
                          className="platform-description"
                          title={getPlatformDescription(platform)}
                        >
                          {getPlatformDescription(platform)}
                        </Typography>
                        <Chip 
                          label={platform.category} 
                          size="small"
                          sx={{
                            textTransform: 'capitalize',
                            bgcolor: getPlatformColor(platform.name) + '15',
                            color: getPlatformColor(platform.name),
                            fontWeight: 500
                          }}
                        />
                      </CardContent>
                      </Card>
                    ))}
                </div>
              </Box>
            )}
          </Card>
        </Grid>
      </Grid>
      
      {/* Connector Setup Dialog */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: 'hidden',
          }
        }}
      >
        <DialogTitle sx={{ px: 3, py: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 32,
                height: 32,
                borderRadius: 1.5,
                backgroundColor: getPlatformColor(connectorType) + '15',
                color: getPlatformColor(connectorType),
                flexShrink: 0,
                '& > svg': { fontSize: 18 }
              }}
            >
              {getPlatformIcon(connectorType)}
            </Box>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, letterSpacing: 0.1, flex: 1, minWidth: 0 }}
            >
              {getPlatformDisplayName(connectorType || 'unknown')}
              <Box component="span" sx={{ color: 'text.secondary', fontWeight: 400, mx: 1 }}>·</Box>
              <Box component="span" sx={{ color: 'text.secondary', fontWeight: 400 }}>
                {(connectorType === 'amex' || connectorType === 'payoneer') ? 'CSV upload' : 'Connector setup'}
              </Box>
            </Typography>
            <IconButton
              size="small"
              onClick={handleCloseDialog}
              sx={{ color: 'text.secondary' }}
              aria-label="Close"
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          {/* Special case for American Express & Payoneer - CSV Upload Only */}
          {(connectorType === 'amex' || connectorType === 'payoneer') ? (
            <Box sx={{ mt: 2 }}>
              {!(connectorForm.amexConnectorId || connectorForm.payoneerConnectorId) ? (
                // Step 1: Create CSV Upload Connector
                <Box>
                  <Typography variant="h6" gutterBottom>
                    Create {connectorType === 'amex' ? 'American Express' : 'Payoneer'} Connector
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                    First, let's create a connector for your {connectorType === 'amex' ? 'American Express' : 'Payoneer'} account.
                  </Typography>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <FormControl fullWidth required>
                        <InputLabel id="brand-select-label">Brand</InputLabel>
                        <Select
                          labelId="brand-select-label"
                          name="brandId"
                          value={connectorForm.brandId}
                          label="Brand"
                          onChange={handleConnectorBrandChange}
                          sx={{ borderRadius: 2 }}
                        >
                          {brands.map(brand => (
                            <MenuItem key={brand.id} value={brand.id}>{brand.name}</MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>Select the brand this connector belongs to</FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Connector Name"
                        name="name"
                        value={connectorForm.name}
                        onChange={handleConnectorNameChange}
                        placeholder={connectorType === 'amex' ? 'e.g., Amex Business Card' : 'e.g., Payoneer Business Account'}
                        required
                        helperText={!nameDirty && connectorForm.name ? 'Auto-suggested from brand & platform. Edit if needed.' : ' '}
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        variant="contained"
                        fullWidth
                        onClick={async () => {
                          // Create the connector
                          try {
                            const platformId = connectorType === 'amex' ? 23 : 22; // Amex: 23, Payoneer: 22
                            const response = await api.post('/api/connectors/create', {
                              connectorName: connectorForm.name,
                              brandId: resolveBrandId(),
                              platformId: platformId,
                              platformData: {
                                type: 'csv_upload',
                                account_type: 'business'
                              }
                            });

                            const connectorId = response.data.connector?.id || response.data.id;
                            const connectorIdField = connectorType === 'amex' ? 'amexConnectorId' : 'payoneerConnectorId';

                            setConnectorForm({
                              ...connectorForm,
                              [connectorIdField]: connectorId
                            });
                            showNotification('Connector created successfully! Now you can upload CSV files.', 'success');
                          } catch (error) {
                            console.error(`${connectorType} connector creation error:`, error);
                            showNotification(error.response?.data?.message || error.response?.data?.errors?.[0]?.msg || 'Failed to create connector', 'error');
                          }
                        }}
                        disabled={!connectorForm.name || !connectorForm.brandId}
                        sx={{
                          borderRadius: 2,
                          background: 'linear-gradient(45deg, #006FCF 30%, #0088FF 90%)',
                        }}
                      >
                        Create Connector
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              ) : (
                // Step 2: Upload CSV Files
                <>
                  {connectorType === 'amex' ? (
                    <AmexCSVUpload
                      connectorId={connectorForm.amexConnectorId}
                      onUploadComplete={(results) => {
                        showNotification(`Successfully uploaded ${results.totalTransactions} transactions`, 'success');
                        handleCloseDialog();
                        fetchConnectors();
                      }}
                    />
                  ) : (
                    <PayoneerCSVUpload
                      connectorId={connectorForm.payoneerConnectorId}
                      onUploadComplete={(results) => {
                        showNotification(`Successfully uploaded ${results.totalTransactions} transactions`, 'success');
                        handleCloseDialog();
                        fetchConnectors();
                      }}
                    />
                  )}
                </>
              )}
            </Box>
          ) : (
            <>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                  mx: -3,
                  px: 3,
                  py: 1.5,
                  mb: 1,
                  borderTop: '1px solid',
                  borderBottom: '1px solid',
                  borderColor: 'divider',
                  bgcolor: theme => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.015)',
                }}
              >
                {[
                  { num: '01', label: 'Basics' },
                  { num: '02', label: 'Connect' },
                  { num: '03', label: 'Done' }
                ].map((step, idx) => {
                  const isActive = idx === activeStep;
                  const isCompleted = idx < activeStep;
                  const platformColor = getPlatformColor(connectorType);
                  return (
                    <React.Fragment key={step.num}>
                      {idx > 0 && (
                        <Box
                          sx={{
                            flex: 1,
                            height: '1px',
                            bgcolor: isCompleted || isActive ? platformColor : 'divider',
                            opacity: isCompleted || isActive ? 0.4 : 1,
                            transition: 'background-color 0.2s, opacity 0.2s'
                          }}
                        />
                      )}
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                        <Typography
                          variant="caption"
                          sx={{
                            fontWeight: 700,
                            color: isActive || isCompleted ? platformColor : 'text.disabled',
                            fontFeatureSettings: '"tnum"',
                            letterSpacing: 0.5,
                            fontSize: '0.75rem'
                          }}
                        >
                          {step.num}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: isActive ? 600 : 500,
                            color: isActive ? 'text.primary' : 'text.secondary',
                            fontSize: '0.85rem'
                          }}
                        >
                          {step.label}
                        </Typography>
                      </Box>
                    </React.Fragment>
                  );
                })}
              </Box>

              <Box sx={{ mt: 3 }}>
                {/* Step 1: Basic Information */}
                {activeStep === 0 && (
              <Box>
                <Typography variant="h6" gutterBottom>
                  Basic Information
                </Typography>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <FormControl fullWidth required>
                      <InputLabel id="brand-select-label">Brand</InputLabel>
                      <Select
                        labelId="brand-select-label"
                        name="brandId"
                        value={connectorForm.brandId}
                        label="Brand"
                        onChange={handleConnectorBrandChange}
                        sx={{ borderRadius: 2 }}
                      >
                        {(() => {
                          const platform = platforms.find(p => p.name === connectorType);
                          const supportsCompany = platform && (platform.supports_company_level === true || platform.supports_company_level === 1);
                          return supportsCompany ? (
                            <MenuItem value="company" sx={{ fontStyle: 'italic', borderBottom: '1px solid', borderColor: 'divider' }}>
                              Company Level (shared across all brands)
                            </MenuItem>
                          ) : null;
                        })()}
                        {brands.map(brand => (
                          <MenuItem key={brand.id} value={brand.id}>{brand.name}</MenuItem>
                        ))}
                      </Select>
                      <FormHelperText>
                        {(() => {
                          const platform = platforms.find(p => p.name === connectorType);
                          const supportsCompany = platform && (platform.supports_company_level === true || platform.supports_company_level === 1);
                          return supportsCompany
                            ? 'Pick a brand — or "Company Level" for shared connectors (banks, accounting, marketplace OAuth, etc.).'
                            : 'Select the brand this connector belongs to';
                        })()}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Connector Name"
                      name="name"
                      value={connectorForm.name}
                      onChange={handleConnectorNameChange}
                      placeholder="e.g., My Brand - Pinterest Ads"
                      required
                      helperText={!nameDirty && connectorForm.name ? 'Auto-suggested from brand & platform. Edit if needed.' : ' '}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>
            )}
            
            {/* Step 2: Connector Configuration */}
            {activeStep === 1 && (
              <Box>
                <Typography variant="h6" gutterBottom>
                  Connector Configuration
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                  Enter the details needed to connect to your {connectorType} account
                </Typography>
                
                {/* Shopify Configuration */}
                {connectorType === 'shopify' && (
                  <Grid container spacing={3}>
                    {/* Connection Method Selector */}
                    <Grid item xs={12}>
                      <FormControl fullWidth>
                        <InputLabel>Connection Method</InputLabel>
                        <Select
                          name="shopifyConnectMethod"
                          value={connectorForm.shopifyConnectMethod}
                          onChange={(e) => {
                            handleFormChange(e);
                            setShowCustomAppGuide(false);
                          }}
                          label="Connection Method"
                          sx={{ borderRadius: 2 }}
                        >
                          <MenuItem value="client_credentials">Dev Dashboard App (Recommended)</MenuItem>
                          <MenuItem value="manual">Legacy Custom App (Pre-2026 stores)</MenuItem>
                          <MenuItem value="oauth" disabled>OAuth (Coming Soon)</MenuItem>
                        </Select>
                        <FormHelperText>
                          {connectorForm.shopifyConnectMethod === 'client_credentials'
                            ? 'Create an app in the Shopify Dev Dashboard and enter the Client ID and Client Secret'
                            : connectorForm.shopifyConnectMethod === 'manual'
                            ? 'For stores with existing legacy custom apps created before January 2026'
                            : 'OAuth integration coming soon'}
                        </FormHelperText>
                      </FormControl>
                    </Grid>

                    {/* Shop Domain - Required for both methods */}
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Shop Domain"
                        name="shopDomain"
                        value={connectorForm.shopDomain}
                        onChange={handleFormChange}
                        placeholder="e.g., your-store or your-store.myshopify.com"
                        required
                        helperText="Enter your shop name or full domain"
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                      />
                    </Grid>

                    {/* Market/Region Field */}
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Market/Region"
                        name="market"
                        value={connectorForm.market}
                        onChange={handleFormChange}
                        placeholder="e.g., US, UK, AU"
                        helperText="Optional: Specify the market or region for this store"
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                      />
                    </Grid>

                    {/* Currency Field */}
                    <Grid item xs={12} md={6}>
                      <CurrencySelector
                        value={connectorForm.currency}
                        onChange={(value) => setConnectorForm({...connectorForm, currency: value})}
                        fullWidth
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                      />
                    </Grid>

                    {/* Dev Dashboard App Method: Client ID + Client Secret */}
                    {connectorForm.shopifyConnectMethod === 'client_credentials' && (
                      <>
                        {/* Access-level selector: controls which scopes the guide lists */}
                        <Grid item xs={12}>
                          <Typography variant="caption" color="text.secondary" fontWeight={600} sx={{ display: 'block', mb: 0.5 }}>
                            Access level
                          </Typography>
                          <ToggleButtonGroup
                            exclusive
                            value={shopifyAccessMode}
                            onChange={(e, v) => { if (v) setShopifyAccessMode(v); }}
                            size="small"
                            fullWidth
                            sx={{ '& .MuiToggleButton-root': { textTransform: 'none', borderRadius: 2, py: 1, flexDirection: 'column', alignItems: 'flex-start', gap: 0.25 } }}
                          >
                            <ToggleButton value="read">
                              <Typography variant="body2" fontWeight={600}>Read-only</Typography>
                              <Typography variant="caption" color="text.secondary">Analytics &amp; sync only</Typography>
                            </ToggleButton>
                            <ToggleButton value="full">
                              <Typography variant="body2" fontWeight={600}>Full access</Typography>
                              <Typography variant="caption" color="text.secondary">Also install pixels, edit theme &amp; content</Typography>
                            </ToggleButton>
                          </ToggleButtonGroup>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                            {shopifyAccessMode === 'read'
                              ? 'Read-only requests no write scopes (no pixel install / theme edits). Pixel & event data still sync via read_customer_events.'
                              : 'Full access adds write scopes for pixel/widget install, theme edits, SEO/AEO content, and call-centre draft orders.'}
                          </Typography>
                        </Grid>

                        {/* Step-by-step guide */}
                        <Grid item xs={12}>
                          <Paper
                            elevation={0}
                            sx={{
                              border: '1px solid',
                              borderColor: 'divider',
                              borderRadius: 2,
                              overflow: 'hidden',
                            }}
                          >
                            <Box
                              onClick={() => setShowCustomAppGuide(!showCustomAppGuide)}
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                px: 2.5,
                                py: 1.5,
                                cursor: 'pointer',
                                bgcolor: 'action.hover',
                                '&:hover': { bgcolor: 'action.selected' },
                              }}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <IntegrationInstructionsIcon fontSize="small" color="primary" />
                                <Typography variant="subtitle2" fontWeight={600}>
                                  How to create a Dev Dashboard App
                                </Typography>
                              </Box>
                              {showCustomAppGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </Box>
                            <Collapse in={showCustomAppGuide}>
                              <Box sx={{ px: 2.5, py: 2 }}>
                                {[
                                  { step: 1, title: 'Go to Shopify Dev Dashboard', desc: 'Visit dev.shopify.com and sign in with your Shopify Partners account (or the store owner\'s account). Click "Create app".' },
                                  { step: 2, title: 'Name the app & set fields', desc: 'Enter a name like "SuperChargeMe" and click Create. Then on the config page set App URL to https://app.superchargeme.com and tick "Embed app in Shopify admin". Leave everything else at its default: Optional scopes, Preferences URL and Redirect URLs blank, "Use legacy install flow" unchecked, and the Webhooks API version at its default.' },
                                  { step: 3, title: 'Configure Access Scopes', desc: `In the app settings, add the ${shopifyAccessMode === 'read' ? 'read-only' : 'full-access'} scopes below. You can copy-paste this comma-separated list: ${shopifyScopesCsvForMode(shopifyAccessMode)}`,
                                    scopeGroups: shopifyScopeGroupsForMode(shopifyAccessMode)
                                  },
                                  { step: 4, title: 'Create & Release a Version', desc: 'Click "Create version" and then "Release". This activates your app configuration.' },
                                  { step: 5, title: 'Install on Your Store', desc: 'Go to Distribution, select your store, and install the app. The store and app must be in the same Shopify organization.' },
                                  { step: 6, title: 'Copy Client ID & Client Secret', desc: 'Go to the app\'s Settings page in the Dev Dashboard. Copy the Client ID and Client Secret and paste them below.' },
                                ].map(({ step, title, desc, scopeGroups }) => (
                                  <Box key={step} sx={{ display: 'flex', gap: 1.5, mb: step < 6 ? 2 : 0 }}>
                                    <Avatar
                                      sx={{
                                        width: 28,
                                        height: 28,
                                        fontSize: '0.8rem',
                                        fontWeight: 700,
                                        bgcolor: 'primary.main',
                                        flexShrink: 0,
                                        mt: 0.25,
                                      }}
                                    >
                                      {step}
                                    </Avatar>
                                    <Box sx={{ flex: 1 }}>
                                      <Typography variant="body2" fontWeight={600}>{title}</Typography>
                                      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
                                        {desc}
                                      </Typography>
                                      {scopeGroups && scopeGroups.map(group => (
                                        <Box key={group.label} sx={{ mt: 1.5 }}>
                                          <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>
                                            {group.label}
                                          </Typography>
                                          <Box sx={{ mt: 0.5 }}>
                                            {group.scopes.map(scope => (
                                              <Box key={scope.name} sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                                                <Chip
                                                  label={scope.name}
                                                  size="small"
                                                  variant="outlined"
                                                  sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }}
                                                />
                                                <Typography variant="caption" color="text.secondary">{scope.why}</Typography>
                                              </Box>
                                            ))}
                                          </Box>
                                        </Box>
                                      ))}
                                    </Box>
                                  </Box>
                                ))}
                              </Box>
                            </Collapse>
                          </Paper>
                        </Grid>

                        {/* Client ID Field */}
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label="Client ID"
                            name="clientId"
                            value={connectorForm.clientId}
                            onChange={handleFormChange}
                            required
                            placeholder="e.g., abc123def456..."
                            helperText="Found in your Dev Dashboard app's Settings page"
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                          />
                        </Grid>

                        {/* Client Secret Field */}
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label="Client Secret"
                            name="clientSecret"
                            value={connectorForm.clientSecret}
                            onChange={handleFormChange}
                            type="password"
                            required
                            placeholder="e.g., xyz789..."
                            helperText="Found in your Dev Dashboard app's Settings page (keep this secret)"
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                          />
                        </Grid>
                      </>
                    )}

                    {/* Legacy Custom App Method: Access Token + Guide */}
                    {connectorForm.shopifyConnectMethod === 'manual' && (
                      <>
                        {/* Access-level selector: controls which scopes the guide lists */}
                        <Grid item xs={12}>
                          <Typography variant="caption" color="text.secondary" fontWeight={600} sx={{ display: 'block', mb: 0.5 }}>
                            Access level
                          </Typography>
                          <ToggleButtonGroup
                            exclusive
                            value={shopifyAccessMode}
                            onChange={(e, v) => { if (v) setShopifyAccessMode(v); }}
                            size="small"
                            fullWidth
                            sx={{ '& .MuiToggleButton-root': { textTransform: 'none', borderRadius: 2, py: 1, flexDirection: 'column', alignItems: 'flex-start', gap: 0.25 } }}
                          >
                            <ToggleButton value="read">
                              <Typography variant="body2" fontWeight={600}>Read-only</Typography>
                              <Typography variant="caption" color="text.secondary">Analytics &amp; sync only</Typography>
                            </ToggleButton>
                            <ToggleButton value="full">
                              <Typography variant="body2" fontWeight={600}>Full access</Typography>
                              <Typography variant="caption" color="text.secondary">Also install pixels, edit theme &amp; content</Typography>
                            </ToggleButton>
                          </ToggleButtonGroup>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                            {shopifyAccessMode === 'read'
                              ? 'Read-only requests no write scopes (no pixel install / theme edits). Pixel & event data still sync via read_customer_events.'
                              : 'Full access adds write scopes for pixel/widget install, theme edits, SEO/AEO content, and call-centre draft orders.'}
                          </Typography>
                        </Grid>

                        {/* Step-by-step guide */}
                        <Grid item xs={12}>
                          <Paper
                            elevation={0}
                            sx={{
                              border: '1px solid',
                              borderColor: 'divider',
                              borderRadius: 2,
                              overflow: 'hidden',
                            }}
                          >
                            <Box
                              onClick={() => setShowCustomAppGuide(!showCustomAppGuide)}
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                px: 2.5,
                                py: 1.5,
                                cursor: 'pointer',
                                bgcolor: 'action.hover',
                                '&:hover': { bgcolor: 'action.selected' },
                              }}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <IntegrationInstructionsIcon fontSize="small" color="primary" />
                                <Typography variant="subtitle2" fontWeight={600}>
                                  How to create a Custom App in Shopify
                                </Typography>
                              </Box>
                              {showCustomAppGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </Box>
                            <Collapse in={showCustomAppGuide}>
                              <Box sx={{ px: 2.5, py: 2 }}>
                                {[
                                  { step: 1, title: 'Enable Custom App Development', desc: 'In your Shopify Admin, go to Settings \u2192 Apps and sales channels \u2192 Develop apps. Click "Allow custom app development" if prompted.' },
                                  { step: 2, title: 'Create the App', desc: 'Click "Create an app". Name it something like "SuperChargeMe" and click Create app.' },
                                  { step: 3, title: 'Configure API Scopes', desc: `Click "Configure Admin API scopes" and enable the ${shopifyAccessMode === 'read' ? 'read-only' : 'full-access'} scopes below. You can search for each one in the scope selector.`,
                                    scopeGroups: shopifyScopeGroupsForMode(shopifyAccessMode)
                                  },
                                  { step: 4, title: 'Install the App', desc: 'Click "Install app" in the top right corner and confirm the installation.' },
                                  { step: 5, title: 'Copy the Access Token', desc: 'After installation, you\'ll see the Admin API access token (starts with shpat_). Copy it immediately \u2014 it\'s only shown once.' },
                                ].map(({ step, title, desc, scopeGroups }) => (
                                  <Box key={step} sx={{ display: 'flex', gap: 1.5, mb: step < 5 ? 2 : 0 }}>
                                    <Avatar
                                      sx={{
                                        width: 28,
                                        height: 28,
                                        fontSize: '0.8rem',
                                        fontWeight: 700,
                                        bgcolor: 'primary.main',
                                        flexShrink: 0,
                                        mt: 0.25,
                                      }}
                                    >
                                      {step}
                                    </Avatar>
                                    <Box sx={{ flex: 1 }}>
                                      <Typography variant="body2" fontWeight={600}>{title}</Typography>
                                      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
                                        {desc}
                                      </Typography>
                                      {scopeGroups && scopeGroups.map(group => (
                                        <Box key={group.label} sx={{ mt: 1.5 }}>
                                          <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>
                                            {group.label}
                                          </Typography>
                                          <Box sx={{ mt: 0.5 }}>
                                            {group.scopes.map(scope => (
                                              <Box key={scope.name} sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                                                <Chip
                                                  label={scope.name}
                                                  size="small"
                                                  variant="outlined"
                                                  sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }}
                                                />
                                                <Typography variant="caption" color="text.secondary">{scope.why}</Typography>
                                              </Box>
                                            ))}
                                          </Box>
                                        </Box>
                                      ))}
                                    </Box>
                                  </Box>
                                ))}
                              </Box>
                            </Collapse>
                          </Paper>
                        </Grid>

                        {/* Access Token Field */}
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label="Admin API Access Token"
                            name="accessToken"
                            value={connectorForm.accessToken}
                            onChange={handleFormChange}
                            type="password"
                            required
                            placeholder="shpat_..."
                            helperText="The access token from Step 5 above (starts with 'shpat_')"
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                          />
                        </Grid>
                      </>
                    )}

                    {/* Information Alert */}
                    <Grid item xs={12}>
                      {connectorForm.shopifyConnectMethod === 'oauth' ? (
                        <Alert severity="info" icon={<SecurityIcon />}>
                          <strong>OAuth Connection</strong>
                          <br />
                          After clicking "Confirm & Connect", you'll be redirected to Shopify to authorize the connection securely.
                        </Alert>
                      ) : connectorForm.shopifyConnectMethod === 'client_credentials' ? (
                        <Alert severity="info" icon={<SecurityIcon />}>
                          Your Client ID and Client Secret are used to securely obtain short-lived access tokens (24h) on demand. We never store a permanent token — credentials are exchanged for fresh tokens each time data is fetched.
                        </Alert>
                      ) : (
                        <Alert severity="info" icon={<SecurityIcon />}>
                          Read scopes power analytics and reporting. Write scopes enable pricing updates, blog management, metafields, and real-time webhooks. <strong>Note:</strong> Legacy custom apps cannot be created on Shopify after January 2026. Use "Dev Dashboard App" for new stores.
                        </Alert>
                      )}
                    </Grid>
                  </Grid>
                )}
                
                {/* Facebook Configuration */}
                {connectorType === 'facebook' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Access Token"
                        name="accessToken"
                        value={connectorForm.accessToken}
                        onChange={handleFormChange}
                        required
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 2,
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Ad Account ID"
                        name="accountId"
                        value={connectorForm.accountId}
                        onChange={handleFormChange}
                        required
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 2,
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        OAuth for Meta is fully implemented! Click below to connect securely.
                        <Button 
                          onClick={() => handleOAuthConnect('facebook')}
                          sx={{ ml: 1 }} 
                          size="small" 
                          variant="contained"
                          color="primary"
                        >
                          Connect with OAuth
                        </Button>
                      </Alert>
                    </Grid>
                  </Grid>
                )}
                
                {/* Google Configuration */}
                {(connectorType === 'google' || connectorType === 'google_ads') && (
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Client ID"
                        name="clientId"
                        value={connectorForm.clientId}
                        onChange={handleFormChange}
                        required
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 2,
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Client Secret"
                        name="clientSecret"
                        value={connectorForm.clientSecret}
                        onChange={handleFormChange}
                        required
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 2,
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Refresh Token"
                        name="refreshToken"
                        value={connectorForm.refreshToken}
                        onChange={handleFormChange}
                        required
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 2,
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Developer Token"
                        name="developerToken"
                        value={connectorForm.developerToken}
                        onChange={handleFormChange}
                        required
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 2,
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Customer ID"
                        name="customerId"
                        value={connectorForm.customerId}
                        onChange={handleFormChange}
                        required
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 2,
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        You can get these details from your Google Ads account.
                        <Button 
                          onClick={() => handleOAuthConnect('google')}
                          sx={{ ml: 1 }} 
                          size="small" 
                          variant="outlined"
                        >
                          Connect with OAuth
                        </Button>
                      </Alert>
                    </Grid>
                  </Grid>
                )}
                
                {/* Amazon Vendor Central Configuration: the store whose Vendor Central the vendor signs in to */}
                {connectorType === 'amazon_vendor' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth required>
                        <InputLabel>Country/Region</InputLabel>
                        <Select
                          name="country"
                          value={connectorForm.country}
                          onChange={handleFormChange}
                          label="Country/Region"
                          sx={{ borderRadius: 2 }}
                        >
                          {getAllCountries().map((country) => (
                            <MenuItem key={country.code} value={country.code}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <span>{country.flag}</span>
                                <span>{country.name}</span>
                                <Chip
                                  label={country.region}
                                  size="small"
                                  variant="outlined"
                                  sx={{ ml: 'auto' }}
                                />
                              </Box>
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>The Amazon store your Vendor Central account sells to</FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                        Currency is set automatically from the store you select.
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        You will sign in to Vendor Central and approve access. The first sync reads up to four years of
                        history over several days.
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {/* Amazon Configuration */}
                {connectorType === 'amazon' && (
                  <Grid container spacing={3}>
                    {/* Connection Method Selector */}
                    <Grid item xs={12}>
                      <FormControl fullWidth>
                        <InputLabel>Connection Method</InputLabel>
                        <Select
                          name="amazonConnectMethod"
                          value={connectorForm.amazonConnectMethod}
                          onChange={handleFormChange}
                          label="Connection Method"
                          sx={{ borderRadius: 2 }}
                        >
                          <MenuItem value="manual">Manual Authorization (Recommended for Private Apps)</MenuItem>
                          <MenuItem value="oauth">OAuth (Requires Public App)</MenuItem>
                        </Select>
                        <FormHelperText>
                          {connectorForm.amazonConnectMethod === 'manual'
                            ? 'Self-authorize in Seller Central and enter your refresh token directly'
                            : 'Use OAuth redirect flow — requires a public SP-API application'}
                        </FormHelperText>
                      </FormControl>
                    </Grid>

                    {/* Country/Region — shared by both methods */}
                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth required>
                        <InputLabel>Country/Region</InputLabel>
                        <Select
                          name="country"
                          value={connectorForm.country}
                          onChange={handleFormChange}
                          label="Country/Region"
                          sx={{ borderRadius: 2 }}
                        >
                          {getAllCountries().map((country) => (
                            <MenuItem key={country.code} value={country.code}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <span>{country.flag}</span>
                                <span>{country.name}</span>
                                <Chip
                                  label={country.region}
                                  size="small"
                                  variant="outlined"
                                  sx={{ ml: 'auto' }}
                                />
                              </Box>
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>Select your Amazon marketplace country</FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      {/* No currency picker: the backend sets the connector currency from the
                          marketplace (Canada → CAD, Brazil → BRL …) and ignores a submitted one. */}
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                        Currency is set automatically from the marketplace you select.
                      </Typography>
                    </Grid>

                    {/* Manual Authorization Fields */}
                    {connectorForm.amazonConnectMethod === 'manual' && (
                      <>
                        <Grid item xs={12}>
                          <Alert severity="info" sx={{ mb: 1 }}>
                            <Typography variant="body2">
                              <strong>How to get your credentials:</strong>
                              <br />1. Go to Seller Central → Apps &amp; Services → Develop Apps
                              <br />2. Click "Authorize" on your private app to generate a refresh token
                              <br />3. Copy the refresh token and your Selling Partner ID below
                            </Typography>
                          </Alert>
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label="Selling Partner ID"
                            name="amazonSellingPartnerId"
                            value={connectorForm.amazonSellingPartnerId}
                            onChange={handleFormChange}
                            placeholder="e.g., A1B2C3D4E5F6G7"
                            required
                            helperText="Your Seller ID from Seller Central account settings"
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label="Refresh Token"
                            name="amazonRefreshToken"
                            value={connectorForm.amazonRefreshToken}
                            onChange={handleFormChange}
                            placeholder="Atzr|..."
                            required
                            multiline
                            rows={3}
                            helperText="The refresh token generated when you authorized your app in Seller Central"
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                          />
                        </Grid>
                        {/* Private-app LWA credentials. Optional in the API (blank = fall back to
                            the server-wide SP-API app), but there is no server-wide app configured
                            today, so in practice these are required. */}
                        <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            label="LWA Client ID"
                            name="amazonLwaClientId"
                            value={connectorForm.amazonLwaClientId}
                            onChange={handleFormChange}
                            placeholder="amzn1.application-oa2-client...."
                            helperText="From your private SP-API app (Seller Central → Develop Apps). Required until a server-wide app is configured."
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            label="LWA Client Secret"
                            name="amazonLwaClientSecret"
                            type="password"
                            value={connectorForm.amazonLwaClientSecret}
                            onChange={handleFormChange}
                            placeholder="amzn1.oa2-cs...."
                            helperText="From the same private SP-API app. Required until a server-wide app is configured."
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                          />
                        </Grid>
                      </>
                    )}

                    {/* OAuth Flow */}
                    {connectorForm.amazonConnectMethod === 'oauth' && (
                      <>
                        <Grid item xs={12} md={6}>
                          <Button
                            onClick={() => handleOAuthConnect('amazon-sp')}
                            variant="contained"
                            fullWidth
                            startIcon={<SecurityIcon />}
                            sx={{ height: '56px' }}
                            disabled={!connectorForm.country}
                          >
                            Connect with Amazon SP OAuth
                          </Button>
                        </Grid>
                        <Grid item xs={12}>
                          <Alert severity="warning">
                            <Typography variant="body2">
                              OAuth requires a public SP-API application. If you have a private app, use "Manual Authorization" instead.
                            </Typography>
                          </Alert>
                        </Grid>
                      </>
                    )}
                  </Grid>
                )}

                {/* TikTok Configuration */}
                {connectorType === 'tiktok' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        Connect to TikTok Ads using OAuth to securely access your ad campaigns and analytics data.
                        <Button 
                          onClick={() => handleOAuthConnect('tiktok')}
                          sx={{ ml: 1 }} 
                          size="small" 
                          variant="contained"
                        >
                          Connect with OAuth
                        </Button>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {/* Slack Configuration */}
                {connectorType === 'slack' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        Connect to Slack using OAuth to securely access your workspace communication data and analytics.
                        <Button
                          onClick={() => handleOAuthConnect('slack')}
                          sx={{ ml: 1 }}
                          size="small"
                          variant="contained"
                        >
                          Connect with OAuth
                        </Button>
                      </Alert>
                    </Grid>
                  </Grid>
                )}
                {/* Microsoft Teams Configuration */}
                {connectorType === 'microsoft_teams' && (
                  <TeamsSetupSection
                    onOAuthConnect={() => handleOAuthConnect('microsoft_teams')}
                  />
                )}
                {/* Klaviyo Configuration — API Key only (Klaviyo does not offer OAuth) */}
                {connectorType === 'klaviyo' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 1 }}>
                        Klaviyo doesn't support OAuth. Generate a Public + Private API Key inside your Klaviyo account using the steps below, then paste them in.
                      </Alert>
                    </Grid>

                    {/* Access-level selector: controls which key type the instructions tell you to create */}
                    <Grid item xs={12}>
                      <Typography variant="caption" color="text.secondary" fontWeight={600} sx={{ display: 'block', mb: 0.5 }}>
                        Access level
                      </Typography>
                      <ToggleButtonGroup
                        exclusive
                        value={klaviyoAccessMode}
                        onChange={(e, v) => { if (v) setKlaviyoAccessMode(v); }}
                        size="small"
                        fullWidth
                        sx={{ '& .MuiToggleButton-root': { textTransform: 'none', borderRadius: 2, py: 1, flexDirection: 'column', alignItems: 'flex-start', gap: 0.25 } }}
                      >
                        <ToggleButton value="read">
                          <Typography variant="body2" fontWeight={600}>Read-only</Typography>
                          <Typography variant="caption" color="text.secondary">Analytics &amp; sync only</Typography>
                        </ToggleButton>
                        <ToggleButton value="full">
                          <Typography variant="body2" fontWeight={600}>Full access</Typography>
                          <Typography variant="caption" color="text.secondary">Also write back to Klaviyo</Typography>
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </Grid>

                    {/* Step-by-step instructions with screenshots */}
                    <Grid item xs={12}>
                      <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 2.5 }}>
                        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                          How to generate your Klaviyo API keys
                        </Typography>
                        <Alert severity="warning" sx={{ mt: 1, mb: 2, borderRadius: 1.5 }}>
                          <Typography variant="body2">
                            You need <strong>Owner</strong> or <strong>Admin</strong> access in Klaviyo to create a Private API Key. Members and Managers won't see the "Create Private API Key" button.
                          </Typography>
                        </Alert>

                        {/* Step 1 — click path: Settings → API Keys → Create Private API Key */}
                        <Box sx={{ display: 'flex', gap: 1.5, mt: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>1</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600} gutterBottom>
                              Settings → API Keys → Create Private API Key
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              In your Klaviyo workspace, click your account name in the <strong>bottom-left corner</strong> and choose <strong>Settings</strong> from the popup. Then click <strong>API keys</strong> in the left sidebar, and click <strong>Create Private API Key</strong> on the right.
                            </Typography>
                          </Box>
                        </Box>

                        {/* Step 2 — Configure: name + Full Access + Create */}
                        <Box sx={{ display: 'flex', gap: 1.5, mt: 3 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>2</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600} gutterBottom>
                              Name it "SuperchargeMe", choose {klaviyoAccessMode === 'read' ? 'Read-Only Key' : 'Full Access Key'}, and press Create
                            </Typography>
                            <Typography variant="body2" color="text.secondary" component="div">
                              <ul style={{ margin: '0 0 0 1.2em', padding: 0 }}>
                                <li>Enter <strong>SuperchargeMe</strong> as the Private API Key Name (if that name is already used, append a number, e.g. <em>SuperchargeMe1</em>).</li>
                                {klaviyoAccessMode === 'read' ? (
                                  <li>Under <strong>Select Access Level</strong>, choose <strong>Read-Only Key</strong> — this grants read access to every scope (including Events), which is all we need to sync your data.</li>
                                ) : (
                                  <li>Under <strong>Select Access Level</strong>, choose <strong>Full Access Key</strong> — read + write across every scope. Only needed if you want SuperChargeMe to write back to Klaviyo (e.g. create/update campaigns or flows).</li>
                                )}
                                <li>Click <strong>Create</strong> at the top-right.</li>
                              </ul>
                            </Typography>
                          </Box>
                        </Box>

                        {/* Step 3 — Copy the Private Key (no screenshot — sensitive page) */}
                        <Box sx={{ display: 'flex', gap: 1.5, mt: 3 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>3</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600} gutterBottom>
                              Copy the Private Key and paste it below
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              Klaviyo shows the new key on a confirmation page. It starts with <code>pk_</code>. Click the copy icon and paste it into the <strong>Private API Key</strong> field in the form below.
                            </Typography>
                            <Alert severity="warning" sx={{ mt: 1, borderRadius: 1.5 }}>
                              <Typography variant="body2">
                                This is the <strong>only time Klaviyo will show the key</strong>. If you leave the page without copying it, you'll need to delete the key and create a new one.
                              </Typography>
                            </Alert>
                          </Box>
                        </Box>
                      </Paper>
                    </Grid>

                    {/* Connector form — single field. Public key, currency, company name and
                        timezone are auto-extracted from Klaviyo's /api/accounts/ after we validate
                        the private key. */}
                    <Grid item xs={12}>
                      <Typography variant="subtitle1" fontWeight={600} sx={{ mt: 1 }} gutterBottom>
                        Paste your Private API Key
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Private API Key"
                        value={connectorForm.apiKey}
                        onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                        placeholder="pk_..."
                        helperText="We'll auto-detect your company name, public key, currency and timezone from Klaviyo."
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        onClick={() => handleApiKeyConnect('klaviyo')}
                        variant="contained"
                        fullWidth
                        disabled={!connectorForm.apiKey}
                      >
                        Connect Klaviyo
                      </Button>
                    </Grid>
                  </Grid>
                )}
                {/* Gorgias Configuration — manual API key (HTTP Basic: subdomain + email + key) */}
                {connectorType === 'gorgias' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 1 }}>
                        Gorgias uses an API key (no OAuth). Get your key from Gorgias using the steps below, then enter your subdomain, account email, and key.
                      </Alert>
                    </Grid>

                    {/* Step-by-step instructions */}
                    <Grid item xs={12}>
                      <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 2.5 }}>
                        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                          How to get your Gorgias API key
                        </Typography>
                        <Alert severity="warning" sx={{ mt: 1, mb: 2, borderRadius: 1.5 }}>
                          <Typography variant="body2">
                            You need <strong>Admin</strong> access in Gorgias to view the REST API key.
                          </Typography>
                        </Alert>

                        {/* Step 1 — subdomain */}
                        <Box sx={{ display: 'flex', gap: 1.5, mt: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>1</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600} gutterBottom>
                              Find your subdomain
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              It's the first part of your Gorgias URL — for <code>https://acme.gorgias.com</code> the subdomain is <strong>acme</strong>.
                            </Typography>
                          </Box>
                        </Box>

                        {/* Step 2 — Settings → REST API */}
                        <Box sx={{ display: 'flex', gap: 1.5, mt: 3 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>2</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600} gutterBottom>
                              Open Settings → REST API
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              In Gorgias, go to <strong>Settings → REST API</strong> (or open your user profile). Your <strong>API Key</strong> and the account <strong>email</strong> it belongs to are shown there.
                            </Typography>
                          </Box>
                        </Box>

                        {/* Step 3 — copy the key */}
                        <Box sx={{ display: 'flex', gap: 1.5, mt: 3 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>3</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600} gutterBottom>
                              Copy the key and paste it below
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              Copy the API Key and enter it with the subdomain and account email in the fields below. We only ever read data from Gorgias.
                            </Typography>
                          </Box>
                        </Box>
                      </Paper>
                    </Grid>

                    {/* Connector form — subdomain + email + key */}
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="Gorgias subdomain"
                        value={connectorForm.gorgiasSubdomain}
                        onChange={(e) => setConnectorForm({...connectorForm, gorgiasSubdomain: e.target.value})}
                        placeholder="acme"
                        helperText="from https://<subdomain>.gorgias.com"
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="Account email"
                        value={connectorForm.gorgiasEmail}
                        onChange={(e) => setConnectorForm({...connectorForm, gorgiasEmail: e.target.value})}
                        placeholder="you@company.com"
                        helperText="the Gorgias user that owns the API key"
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="API Key"
                        value={connectorForm.apiKey}
                        onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                        placeholder="Gorgias API key"
                        helperText="Settings → REST API"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        onClick={() => handleApiKeyConnect('gorgias')}
                        variant="contained"
                        fullWidth
                        disabled={!connectorForm.gorgiasSubdomain || !connectorForm.gorgiasEmail || !connectorForm.apiKey}
                      >
                        Connect Gorgias
                      </Button>
                    </Grid>
                  </Grid>
                )}
                {/* SMSBump/Yotpo Configuration */}
                {connectorType === 'smsbump' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        SMSBump is now part of Yotpo. Choose your preferred connection method.
                      </Alert>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <CurrencySelector
                        value={connectorForm.currency || 'USD'}
                        onChange={(currency) => setConnectorForm({...connectorForm, currency})}
                        label="Account Currency"
                        helperText="Select the currency for your SMS campaigns"
                      />
                    </Grid>
                    <Grid item xs={12} />
                    <Grid item xs={12} md={6}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Yotpo OAuth (Recommended)</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          Connect via Yotpo's secure OAuth for access to SMS, reviews, and loyalty data.
                        </Typography>
                        <Button 
                          onClick={() => handleOAuthConnect('yotpo')}
                          variant="contained"
                          fullWidth
                          startIcon={<SecurityIcon />}
                        >
                          Connect with Yotpo OAuth
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Legacy SMSBump API</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          Use your legacy SMSBump API key (may have limited functionality).
                        </Typography>
                        <TextField
                          fullWidth
                          label="SMSBump API Key"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="Enter your SMSBump API key"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <Button 
                          onClick={() => handleApiKeyConnect('smsbump')}
                          variant="outlined"
                          fullWidth
                          disabled={!connectorForm.apiKey}
                        >
                          Connect with API Key
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="warning">
                        <Typography variant="body2">
                          <strong>Setup Instructions:</strong>
                          <br />• <strong>Yotpo OAuth:</strong> Requires a Yotpo partner app registration
                          <br />• <strong>Legacy API:</strong> Log into your SMSBump dashboard → Settings → API
                          <br />• Note: SMSBump was acquired by Yotpo - OAuth provides access to more features
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

{/* Attentive Configuration */}
                {connectorType === 'attentive' && (
                  <Grid container spacing={3}>
                    {error && (
                      <Grid item xs={12}>
                        <Alert severity="error" onClose={() => setError('')}>
                          {error}
                        </Alert>
                      </Grid>
                    )}
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Choose your preferred authentication method for Attentive.
                      </Alert>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <CurrencySelector
                        value={connectorForm.currency || 'USD'}
                        onChange={(currency) => setConnectorForm({...connectorForm, currency})}
                        label="Account Currency"
                        helperText="Select the currency for your Attentive account"
                      />
                    </Grid>
                    <Grid item xs={12} />
                    <Grid item xs={12} md={6}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>OAuth (Recommended)</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          Secure OAuth authentication with automatic token management.
                        </Typography>
                        <Button
                          onClick={() => handleOAuthConnect('attentive')}
                          variant="contained"
                          fullWidth
                          startIcon={<SecurityIcon />}
                        >
                          Connect with OAuth
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>API Key</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          Connect using your Attentive API key for quick setup.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Attentive API Key"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="Enter your Attentive API key"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('attentive')}
                          variant="outlined"
                          fullWidth
                          disabled={!connectorForm.apiKey}
                        >
                          Connect with API Key
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Setup Instructions:</strong>
                          <br />• For OAuth: Click "Connect with OAuth" and authorize in your Attentive account
                          <br />• For API Key: Log into Attentive → Settings → API → Create or copy your API key
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {/* eDesk Configuration */}
                {connectorType === 'edesk' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        eDesk uses API Key authentication for secure access to your customer support data.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>API Key Authentication</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          Connect using your eDesk API token for secure access to your helpdesk data.
                        </Typography>
                        <TextField
                          fullWidth
                          label="eDesk API Token"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="Enter your eDesk API token"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('edesk')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.apiKey}
                        >
                          Connect with API Key
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Setup Instructions:</strong>
                          <br />• Log into your eDesk account (Admin access required)
                          <br />• Navigate to Settings → API Tokens
                          <br />• Click "Add a token" to generate a new API token
                          <br />• Set the access level (Read-only, Full Access, or Custom)
                          <br />• Copy the token and paste it above to connect
                        </Typography>
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="warning">
                        <Typography variant="body2">
                          <strong>What you'll get access to:</strong>
                          <br />• Support tickets and messages
                          <br />• Sales orders and customer data
                          <br />• Contacts and templates
                          <br />• Tag groups and tracking links
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {/* Microsoft Clarity Configuration */}
                {connectorType === 'mirakl' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Mirakl is the platform that many retailers run their marketplace on, so there is
                        no single "Mirakl login". There are <strong>two ways to connect</strong>, and they
                        do not return the same data — pick carefully.
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2, mb: 1 }}>
                        <Typography variant="subtitle2" gutterBottom>How do you want to connect?</Typography>
                        <RadioGroup
                          value={connectorForm.miraklAuthMode}
                          onChange={(e) => { setConnectorForm({...connectorForm, miraklAuthMode: e.target.value}); setError(''); }}
                        >
                          <FormControlLabel
                            value="seller_api"
                            control={<Radio size="small" />}
                            label={
                              <span>
                                <strong>Marketplace API key</strong> (recommended) — one key per retailer.
                                Gets orders, shipments, returns, offers, <strong>and all the money data</strong>:
                                commissions, invoices, billing cycles and payouts.
                              </span>
                            }
                          />
                          <FormControlLabel
                            value="connect"
                            control={<Radio size="small" />}
                            label={
                              <span>
                                <strong>Mirakl Connect</strong> — one login covering every marketplace you sell on.
                                Gets orders, shipments and returns <strong>only</strong>.
                              </span>
                            }
                          />
                        </RadioGroup>
                      </Card>
                    </Grid>

                    {error && (
                      <Grid item xs={12}>
                        <Alert severity="error" onClose={() => setError('')}>{error}</Alert>
                      </Grid>
                    )}

                    {connectorForm.miraklAuthMode === 'connect' && (
                      <Grid item xs={12}>
                        <Alert severity="warning">
                          <Typography variant="body2">
                            <strong>Mirakl Connect does not carry financial data.</strong> Commission, invoice,
                            billing-cycle and payout figures are simply not part of the Connect API, so this
                            connector cannot report marketplace profitability — only order volume. If you need
                            the money side, use a marketplace API key instead (you can add both).
                          </Typography>
                        </Alert>
                      </Grid>
                    )}

                    {connectorForm.miraklAuthMode === 'connect' ? (
                      <Grid item xs={12}>
                        <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                          <Typography variant="h6" gutterBottom>Mirakl Connect Credentials</Typography>
                          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                            We sign in with these before saving, so you will know immediately if they are wrong.
                          </Typography>
                          <TextField
                            fullWidth
                            label="Client ID"
                            value={connectorForm.miraklClientId}
                            onChange={(e) => setConnectorForm({...connectorForm, miraklClientId: e.target.value})}
                            placeholder="Paste your Mirakl Connect Client ID"
                            size="small"
                            sx={{ mb: 2 }}
                          />
                          <TextField
                            fullWidth
                            label="Client Secret"
                            value={connectorForm.miraklClientSecret}
                            onChange={(e) => setConnectorForm({...connectorForm, miraklClientSecret: e.target.value})}
                            placeholder="Paste your Mirakl Connect Client Secret"
                            size="small"
                            type="password"
                            sx={{ mb: 2 }}
                          />
                          <Button
                            onClick={() => handleApiKeyConnect('mirakl')}
                            variant="contained"
                            fullWidth
                            disabled={apiKeyConnecting || !connectorForm.miraklClientId || !connectorForm.miraklClientSecret}
                            startIcon={apiKeyConnecting ? <CircularProgress size={16} color="inherit" /> : null}
                          >
                            {apiKeyConnecting ? 'Connecting...' : 'Connect with Mirakl Connect'}
                          </Button>
                        </Card>
                      </Grid>
                    ) : (
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Marketplace API Key</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the key against that marketplace before saving, and read your shop
                          name, shop ID and currency from it automatically.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Marketplace host"
                          value={connectorForm.miraklHost}
                          onChange={(e) => setConnectorForm({...connectorForm, miraklHost: e.target.value})}
                          placeholder="urbanoutfitters-prod.mirakl.net"
                          helperText="The address of the retailer's marketplace, without https://. Shown in your browser when you are logged into their seller back-office."
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Mirakl API key"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="Paste the API key from that marketplace"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Marketplace display name (optional)"
                          value={connectorForm.miraklMarketplaceName}
                          onChange={(e) => setConnectorForm({...connectorForm, miraklMarketplaceName: e.target.value})}
                          placeholder="Urban Outfitters"
                          helperText="Only affects how this connector is labelled. Defaults to the name taken from the host."
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('mirakl')}
                          variant="contained"
                          fullWidth
                          disabled={apiKeyConnecting || !connectorForm.miraklHost || !connectorForm.apiKey}
                          startIcon={apiKeyConnecting ? <CircularProgress size={16} color="inherit" /> : null}
                        >
                          {apiKeyConnecting ? 'Connecting...' : 'Connect to Marketplace'}
                        </Button>
                      </Card>
                    </Grid>
                    )}

                    <Grid item xs={12}>
                      <Alert severity="info">
                        {connectorForm.miraklAuthMode === 'connect' ? (
                          <Typography variant="body2">
                            <strong>Where to find these:</strong>
                            <br />• Sign in at <strong>miraklconnect.com</strong>
                            <br />• Go to <strong>Settings → Developer / API applications</strong>
                            <br />• Create an application if you don't have one, then copy its <strong>Client ID</strong> and <strong>Client Secret</strong>
                            <br />• Paste both above
                            <br /><br />
                            <strong>Good to know:</strong>
                            <br />• One Connect app covers every Mirakl marketplace you sell on, so you only add this once.
                            <br />• The secret is shown once — if you lose it, generate a new one and use "Update API Token" here.
                            <br />• Orders, shipments and returns only. For commissions and payouts, add a marketplace API key connector as well.
                          </Typography>
                        ) : (
                          <Typography variant="body2">
                            <strong>Where to find these:</strong>
                            <br />• Sign in to the retailer's Mirakl seller back-office (for example Urban Outfitters' seller portal)
                            <br />• Copy the address from your browser's address bar — that is the marketplace host (e.g. <code>urbanoutfitters-prod.mirakl.net</code>)
                            <br />• Go to <strong>My Account → Settings → API Keys</strong>
                            <br />• Copy the existing key, or click <strong>Generate</strong> if there isn't one, and paste it above
                            <br /><br />
                            <strong>Good to know:</strong>
                            <br />• The key is tied to your shop on that one marketplace. Selling on another Mirakl marketplace means adding a second connector.
                            <br />• Read-only access is enough — we never write to the marketplace.
                            <br />• Some retailers switch off returns data for sellers. If yours has, we record that and carry on rather than failing.
                          </Typography>
                        )}
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'target_plus' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Target Plus uses two values from Partners Online: your <strong>Seller ID</strong> and
                        an <strong>API token</strong>. The token is shown only once when you create it, so
                        copy it before closing the dialog.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Seller Credentials</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We verify these against Target before saving, and tell you how many orders we can see.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Seller ID (SMS ID)"
                          value={connectorForm.targetSellerId}
                          onChange={(e) => setConnectorForm({...connectorForm, targetSellerId: e.target.value})}
                          placeholder="69e2adaf9bbf7b35acc99bab"
                          helperText="A long string of letters and numbers, usually starting with 6."
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="API token"
                          value={connectorForm.targetSellerToken}
                          onChange={(e) => setConnectorForm({...connectorForm, targetSellerToken: e.target.value})}
                          placeholder="Paste your Target API token"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Developer app key (optional)"
                          value={connectorForm.targetAppKey}
                          onChange={(e) => setConnectorForm({...connectorForm, targetAppKey: e.target.value})}
                          placeholder="Leave blank unless you have your own"
                          helperText="Only needed if you have registered your own key at developer.target.com. Leave blank otherwise."
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('target_plus')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.targetSellerId || !connectorForm.targetSellerToken}
                        >
                          Connect Target Plus
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find these:</strong>
                          <br />• Sign in to <strong>Partners Online</strong> (plus-portal.partnersonline.com)
                          <br />• <strong>Seller ID:</strong> Business Info → Basic Info → copy the SMS ID
                          <br />• <strong>API token:</strong> Partner Settings → API → Tokens → click the pencil → <strong>Generate</strong>
                          <br />• Copy the token straight away and paste it above
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• The token is displayed once and cannot be retrieved later. If you lose it, generate a new one and use "Update API Token" here.
                          <br />• Read-only access is enough — we never write to your Target listings.
                          <br />• We also pull your settlement report, so payouts and referral fees come through, not just orders.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'impact' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Impact.com uses two read-only API credentials from your account: an
                        <strong> Account SID</strong> and an <strong>Auth Token</strong>.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Advertiser API Credentials</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We verify these against Impact before saving, and tell you how many programs we can see.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Account SID"
                          value={connectorForm.impactAccountSid}
                          onChange={(e) => setConnectorForm({...connectorForm, impactAccountSid: e.target.value})}
                          placeholder="IRxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
                          helperText="Begins with IR — from Impact.com → Settings → API (Technical Settings)."
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Auth Token"
                          value={connectorForm.impactAuthToken}
                          onChange={(e) => setConnectorForm({...connectorForm, impactAuthToken: e.target.value})}
                          placeholder="Paste your Impact Auth Token"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('impact')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.impactAccountSid || !connectorForm.impactAuthToken}
                        >
                          Connect Impact.com
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find these:</strong>
                          <br />• Sign in to <strong>Impact.com</strong> and open <strong>Settings → API</strong> (Technical Settings)
                          <br />• <strong>Account SID:</strong> copy the Account SID (begins with IR)
                          <br />• <strong>Auth Token:</strong> copy the Auth Token shown alongside it
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Read-only access is enough — we never change anything in your Impact account.
                          <br />• We pull programs, media partners, conversions (actions), payouts/invoices, promo codes, deals and product catalogs.
                          <br />• Some resources (contracts, partner contacts, tracking links) may need extra API permissions granted in Impact.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'dor' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Dor counts foot traffic at your physical stores. Connect it with the
                        <strong> API Key</strong> from your Dor dashboard. A Team ID is optional —
                        if your key belongs to just one team we detect it automatically.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Dor API Credentials</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the key against Dor before saving and confirm which team it connects.
                        </Typography>
                        <TextField
                          fullWidth
                          label="API Key"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="Paste your Dor API Key"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Team ID (optional)"
                          value={connectorForm.dorTeamId}
                          onChange={(e) => setConnectorForm({...connectorForm, dorTeamId: e.target.value})}
                          placeholder="tm_… — leave blank to auto-detect"
                          helperText="Only needed if your API key can access more than one Dor team."
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('dor')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.apiKey}
                        >
                          Connect Dor
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find these:</strong>
                          <br />• Sign in to your Dor dashboard at <strong>app.getdor.com</strong>
                          <br />• Go to <strong>Administration</strong> (admin users only)
                          <br />• Copy your <strong>API Key</strong> and, if shown, your <strong>Team ID</strong>
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Read-only access — we never change anything in Dor.
                          <br />• One API key can cover several teams; leave Team ID blank and we pick the single active team, or paste a specific Team ID.
                          <br />• Foot traffic arrives a little behind real time (battery sensors sync periodically), so the newest hour fills in shortly after.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'loop_returns' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Loop Returns holds your <strong>returns and exchanges</strong>. Connect it with an
                        <strong> API key</strong> that has the <strong>Returns</strong> scope.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Loop Returns API Key</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the key against Loop before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="API Key"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="Paste your Loop API key"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('loop_returns')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.apiKey}
                        >
                          Connect Loop Returns
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find this:</strong>
                          <br />• Sign in to Loop Admin at <strong>admin.loopreturns.com</strong>
                          <br />• Go to <strong>Returns Management → Tools &amp; integrations → Developer Tools</strong>
                          <br />• Click <strong>Generate API key</strong>, tick the <strong>Returns</strong> scope, name it and click <strong>Generate</strong>
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• API access depends on your Loop plan. If you cannot see Developer Tools, ask your Loop Merchant Success Manager.
                          <br />• We only read returns; we never process, cancel or change anything in Loop.
                          <br />• We sync returns, line items (reasons, outcomes), exchanges, refunds and store credit daily.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'loop_subscriptions' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Loop runs your <strong>Shopify subscriptions</strong>. Connect it with an
                        <strong> Admin API token</strong> that has at least the <strong>Read subscription contracts</strong> scope.
                        Read-only — we never change anything in Loop.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Loop Subscriptions API Token</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the token against Loop before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="API Token"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="Paste your Loop Admin API token"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('loop_subscriptions')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.apiKey}
                        >
                          Connect Loop Subscriptions
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find this:</strong>
                          <br />• Open the <strong>Loop</strong> app in Shopify (API tokens need Loop's <strong>PRO</strong> plan)
                          <br />• Go to <strong>Settings → API tokens and webhooks</strong> and click <strong>Generate New Token</strong>
                          <br />• Name it (for example "SuperChargeMe"), tick the <strong>read</strong> scopes (subscription contracts, orders, customers and the others you want synced), click <strong>Generate Token</strong>, then <strong>Show Token</strong> and copy it
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• This is Loop <strong>Subscriptions</strong>, not Loop Returns (that one has its own connector).
                          <br />• We only read your data; we never create, cancel or change anything in Loop.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'stayai' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Stay AI runs your <strong>Shopify subscriptions</strong>. Connect it with an
                        <strong> API key</strong> that has at least the <strong>Read Subscriptions</strong> scope.
                        Read-only — we never change anything in Stay.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Stay AI API Key</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the key against Stay before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="API Key"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="Paste your Stay AI API key"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('stayai')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.apiKey}
                        >
                          Connect Stay AI
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find this:</strong>
                          <br />• Sign in to the <strong>Stay Merchant Portal</strong> at <strong>stay.io</strong>
                          <br />• Go to <strong>Settings → API Keys</strong> and click <strong>New API Key</strong>
                          <br />• Fill in Name, Description and Email, tick the <strong>Read Subscriptions</strong> (and Read Orders / Read Selling Plan Groups / Read Webhooks) scopes, and click <strong>Create</strong>
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• We only read your subscription data; we never create, cancel or change anything in Stay.
                          <br />• We sync subscriptions, their line items and full detail, recurring orders, customers, catalog, selling plans and settings daily.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'globale' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Global-e runs your <strong>international checkout</strong>. Connect it with your
                        <strong> Merchant GUID</strong>. Read-only — we never change anything in Global-e.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Global-e Merchant GUID</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the GUID against Global-e before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Merchant GUID"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="Paste your production Merchant GUID"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('globale')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.apiKey}
                        >
                          Connect Global-e
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find this:</strong>
                          <br />• Shopify: open <strong>Apps → Global-e CrossBorder</strong> and look under <strong>Account Settings</strong> for the <strong>Merchant GUID</strong>
                          <br />• Other platforms: the Global-e settings of your store, or ask your Global-e account manager for the production Merchant GUID
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• We sync your countries, currencies and Global-e currency rates, price coefficients, rounding rules, VAT rates and product restrictions daily.
                          <br />• Order lists, duties and settlements are not available from Global-e's API; they arrive as Global-e reports.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'bold_subscriptions' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Bold Subscriptions runs your <strong>subscriptions</strong>. Connect it with an
                        <strong> API access token</strong> from Bold Account Center.
                        Read-only — we never change anything in Bold.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Bold API Access Token</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the token against Bold before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="API Access Token"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="Paste your Bold API access token"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('bold_subscriptions')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.apiKey}
                        >
                          Connect Bold Subscriptions
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find this:</strong>
                          <br />• Sign in to <strong>Bold Account Center</strong> at <strong>account.boldcommerce.com</strong>
                          <br />• Click <strong>API access tokens</strong> in the left menu, then <strong>Create API access token</strong>
                          <br />• Name it, tick the <strong>Shops</strong> and <strong>Subscriptions</strong> read scopes (also Subscription Groups, and Core Customers / Products if you want those), click <strong>Create</strong> and copy the token (it is shown once)
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• We only read your data; we never create, cancel or change anything in Bold.
                          <br />• We sync subscriptions, upcoming orders, order history, customers, subscription groups and your Bold catalog daily.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'woocommerce' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        WooCommerce holds your <strong>orders, products, customers, coupons, taxes and settings</strong>.
                        Connect it with a <strong>read-only REST API key</strong> (your store address, a consumer key and
                        a consumer secret).
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>WooCommerce REST API key</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We read the store once to check the key before saving. We only read data; we never change
                          anything in your store.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Store address"
                          value={connectorForm.wooStoreUrl || ''}
                          onChange={(e) => setConnectorForm({...connectorForm, wooStoreUrl: e.target.value})}
                          placeholder="e.g. https://shop.example.com"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Consumer key"
                          value={connectorForm.wooConsumerKey || ''}
                          onChange={(e) => setConnectorForm({...connectorForm, wooConsumerKey: e.target.value})}
                          placeholder="ck_..."
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Consumer secret"
                          value={connectorForm.wooConsumerSecret || ''}
                          onChange={(e) => setConnectorForm({...connectorForm, wooConsumerSecret: e.target.value})}
                          placeholder="cs_..."
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('woocommerce')}
                          variant="contained"
                          fullWidth
                          disabled={!(connectorForm.wooStoreUrl && connectorForm.wooConsumerKey && connectorForm.wooConsumerSecret)}
                        >
                          Connect WooCommerce
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find this:</strong>
                          <br />• In WordPress admin, go to <strong>WooCommerce → Settings → Advanced → REST API</strong>
                          <br />• Click <strong>Add key</strong>, give it a description, set <strong>Permissions</strong> to <strong>Read</strong>, and click <strong>Generate API key</strong>
                          <br />• Copy the <strong>Consumer key</strong> (starts <code>ck_</code>) and <strong>Consumer secret</strong> (starts <code>cs_</code>) — they are shown only once
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Your store must be reachable over <strong>https</strong> with pretty permalinks enabled (the REST API needs them).
                          <br />• We sync orders, products, customers, refunds, coupons, taxes, shipping, settings and reports daily, plus WooCommerce Subscriptions and Bookings when those plugins are installed.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'powerreviews' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        PowerReviews holds your <strong>ratings, reviews and Q&amp;A</strong>. Connect it with
                        <strong> Enterprise API credentials</strong> (client ID and client secret).
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>PowerReviews API Credentials</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the credentials against PowerReviews before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Client ID"
                          value={connectorForm.powerreviewsClientId}
                          onChange={(e) => setConnectorForm({...connectorForm, powerreviewsClientId: e.target.value})}
                          placeholder="Paste your PowerReviews client ID"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Client secret"
                          value={connectorForm.powerreviewsClientSecret}
                          onChange={(e) => setConnectorForm({...connectorForm, powerreviewsClientSecret: e.target.value})}
                          placeholder="Paste your PowerReviews client secret"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('powerreviews')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.powerreviewsClientId || !connectorForm.powerreviewsClientSecret}
                        >
                          Connect PowerReviews
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find this:</strong>
                          <br />• Sign in to the PowerReviews Portal at <strong>portal.powerreviews.com</strong> as an account administrator
                          <br />• Go to <strong>Account → Manage Users → API</strong> and click <strong>Create New API Credentials</strong>
                          <br />• Add a name and access level, accept the API License Agreement, click <strong>Generate</strong>, then <strong>Download</strong> the file with the client ID and client secret
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• The client secret is only shown in that downloaded file. If it is lost, create new credentials.
                          <br />• If you cannot see the API page, ask your PowerReviews account manager to enable Enterprise API access.
                          <br />• We only read your content; we never submit, moderate or change anything in PowerReviews.
                          <br />• We sync reviews, questions and answers, and products daily.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'adobe_commerce' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Adobe Commerce (Magento) holds your <strong>orders, invoices, refunds, customers, catalog, prices,
                        inventory and promotions</strong>. Connect it with an <strong>integration</strong> (Adobe Commerce on
                        cloud, on-premises or Magento Open Source) or a <strong>Developer Console credential</strong> (Adobe
                        Commerce as a Cloud Service), then pick the store views of this brand.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Adobe Commerce API access</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the credentials against your store before saving.
                        </Typography>
                        <RadioGroup
                          value={connectorForm.acHosting}
                          onChange={(e) => { setConnectorForm({...connectorForm, acHosting: e.target.value, acStores: [], acStoreIds: []}); setError(''); }}
                          sx={{ mb: 2 }}
                        >
                          <FormControlLabel value="paas" control={<Radio size="small" />}
                            label="Adobe Commerce on cloud, on-premises, or Magento Open Source (integration)" />
                          <FormControlLabel value="saas" control={<Radio size="small" />}
                            label="Adobe Commerce as a Cloud Service (Developer Console credential)" />
                        </RadioGroup>
                        <TextField
                          fullWidth
                          label="Store base URL"
                          value={connectorForm.acBaseUrl}
                          onChange={(e) => setConnectorForm({...connectorForm, acBaseUrl: e.target.value})}
                          placeholder={connectorForm.acHosting === 'saas' ? 'https://<server>.api.commerce.adobe.com/<tenant-id>' : 'e.g. https://shop.example.com'}
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        {connectorForm.acHosting === 'saas' ? (
                          <>
                        <TextField
                          fullWidth
                          label="Client ID"
                          value={connectorForm.acClientId}
                          onChange={(e) => setConnectorForm({...connectorForm, acClientId: e.target.value})}
                          placeholder="Paste the client ID"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Client secret"
                          value={connectorForm.acClientSecret}
                          onChange={(e) => setConnectorForm({...connectorForm, acClientSecret: e.target.value})}
                          placeholder="Paste the client secret"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="IMS organization ID"
                          value={connectorForm.acImsOrgId}
                          onChange={(e) => setConnectorForm({...connectorForm, acImsOrgId: e.target.value})}
                          placeholder="e.g. 1234567890ABCDEF12345678@AdobeOrg"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                          </>
                        ) : (
                          <>
                        <TextField
                          fullWidth
                          label="Consumer key"
                          value={connectorForm.acConsumerKey}
                          onChange={(e) => setConnectorForm({...connectorForm, acConsumerKey: e.target.value})}
                          placeholder="Paste the consumer key"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Consumer secret"
                          value={connectorForm.acConsumerSecret}
                          onChange={(e) => setConnectorForm({...connectorForm, acConsumerSecret: e.target.value})}
                          placeholder="Paste the consumer secret"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Access token"
                          value={connectorForm.acAccessToken}
                          onChange={(e) => setConnectorForm({...connectorForm, acAccessToken: e.target.value})}
                          placeholder="Paste the access token"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Access token secret"
                          value={connectorForm.acAccessTokenSecret}
                          onChange={(e) => setConnectorForm({...connectorForm, acAccessTokenSecret: e.target.value})}
                          placeholder="Paste the access token secret"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                          </>
                        )}
                        <Button
                          onClick={loadAdobeCommerceStores}
                          variant="outlined"
                          fullWidth
                          sx={{ mb: 2 }}
                          disabled={!adobeCommerceReady()}
                        >
                          Load store views
                        </Button>
                        {(connectorForm.acStores || []).length > 0 && (
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                              Pick the store view(s) of this brand. Each store view can belong to one brand only.
                            </Typography>
                            {connectorForm.acStores.map(store => (
                              <FormControlLabel
                                key={store.id}
                                sx={{ display: 'block' }}
                                control={
                                  <Checkbox
                                    size="small"
                                    checked={(connectorForm.acStoreIds || []).includes(store.id)}
                                    onChange={(e) => setConnectorForm(f => ({
                                      ...f,
                                      acStoreIds: e.target.checked
                                        ? [...(f.acStoreIds || []), store.id]
                                        : (f.acStoreIds || []).filter(id => id !== store.id)
                                    }))}
                                  />
                                }
                                label={`${store.name} (${store.code}, website ${store.websiteId})`}
                              />
                            ))}
                            <FormControlLabel
                              sx={{ display: 'block', mt: 1 }}
                              control={
                                <Checkbox
                                  size="small"
                                  checked={connectorForm.acWholeInstance === true}
                                  onChange={(e) => setConnectorForm(f => ({ ...f, acWholeInstance: e.target.checked }))}
                                />
                              }
                              label="Also sync instance-wide data (catalog, attributes, inventory sources, tax, CMS, B2B companies). Only if no other company uses this store."
                            />
                          </Box>
                        )}
                        <Button
                          onClick={() => handleApiKeyConnect('adobe_commerce')}
                          variant="contained"
                          fullWidth
                          disabled={!adobeCommerceReady() || !(connectorForm.acStoreIds || []).length}
                        >
                          Connect Adobe Commerce
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find this:</strong>
                          <br />• <strong>On cloud, on-premises or Magento Open Source:</strong> in the Admin go to <strong>System → Extensions → Integrations</strong>, click <strong>Add New Integration</strong>, give it a name, and on the <strong>API</strong> tab choose the resources in our setup guide (at least <strong>Sales</strong> and <strong>Stores</strong>). Save, then <strong>Activate</strong> it and copy the consumer key, consumer secret, access token and access token secret.
                          <br />• <strong>As a Cloud Service:</strong> in the <strong>Adobe Developer Console</strong>, add the Adobe Commerce as a Cloud Service API to a project with <strong>OAuth Server-to-Server</strong>, and copy the client ID, client secret and organization ID. The base URL is in Cloud Manager (instance details).
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• We only read data; we never change orders, customers or your catalog.
                          <br />• Resources you leave out just skip that data; you can add them later and the next sync picks them up.
                          <br />• We sync daily. The first sync of a large store can take several runs; it continues where it stopped.
                          <br />• Several brands can share one store: each connection only reads the store views you pick for it.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'sfcc' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Salesforce Commerce Cloud (B2C Commerce) holds your <strong>orders, customers, catalog, prices and
                        promotions</strong>. Connect it with an <strong>Account Manager API client</strong> and your instance's
                        short code and organization ID. One connection covers every site of the instance.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Salesforce Commerce Cloud API Client</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the API client against your instance before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="API client ID"
                          value={connectorForm.sfccClientId}
                          onChange={(e) => setConnectorForm({...connectorForm, sfccClientId: e.target.value})}
                          placeholder="e.g. 1d763261-6522-4913-9d52-5d947d3b94c4"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="API client password"
                          value={connectorForm.sfccClientSecret}
                          onChange={(e) => setConnectorForm({...connectorForm, sfccClientSecret: e.target.value})}
                          placeholder="Paste the API client password"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Short code"
                          value={connectorForm.sfccShortCode}
                          onChange={(e) => setConnectorForm({...connectorForm, sfccShortCode: e.target.value})}
                          placeholder="8 characters, e.g. kv7kzm78"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Organization ID"
                          value={connectorForm.sfccOrganizationId}
                          onChange={(e) => setConnectorForm({...connectorForm, sfccOrganizationId: e.target.value})}
                          placeholder="e.g. f_ecom_abcd_prd"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Omnichannel Inventory tenant group ID (optional)"
                          value={connectorForm.sfccOciTenantGroupId}
                          onChange={(e) => setConnectorForm({...connectorForm, sfccOciTenantGroupId: e.target.value})}
                          placeholder="Only if you use Omnichannel Inventory"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Custom object type IDs (optional)"
                          value={connectorForm.sfccCustomObjectTypes}
                          onChange={(e) => setConnectorForm({...connectorForm, sfccCustomObjectTypes: e.target.value})}
                          placeholder="e.g. LoyaltyAccount, StoreHours"
                          helperText="Salesforce has no way to list custom object types, so type the IDs you want synced (Business Manager > Administration > Site Development > Custom Object Types). Separate them with commas."
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={loadSfccSites}
                          variant="outlined"
                          fullWidth
                          sx={{ mb: 2 }}
                          disabled={!connectorForm.sfccClientId || !connectorForm.sfccClientSecret || !connectorForm.sfccShortCode || !connectorForm.sfccOrganizationId}
                        >
                          Load sites
                        </Button>
                        {(connectorForm.sfccSites || []).length > 0 && (
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                              Pick the site(s) of this brand. Each site can belong to one brand only.
                            </Typography>
                            {connectorForm.sfccSites.map(site => (
                              <FormControlLabel
                                key={site.id}
                                sx={{ display: 'block' }}
                                control={
                                  <Checkbox
                                    size="small"
                                    checked={(connectorForm.sfccSiteIds || []).includes(site.id)}
                                    onChange={(e) => setConnectorForm(f => ({
                                      ...f,
                                      sfccSiteIds: e.target.checked
                                        ? [...(f.sfccSiteIds || []), site.id]
                                        : (f.sfccSiteIds || []).filter(id => id !== site.id)
                                    }))}
                                  />
                                }
                                label={`${site.name} (${site.id})`}
                              />
                            ))}
                            <FormControlLabel
                              sx={{ display: 'block', mt: 1 }}
                              control={
                                <Checkbox
                                  size="small"
                                  checked={connectorForm.sfccWholeInstance === true}
                                  onChange={(e) => setConnectorForm(f => ({ ...f, sfccWholeInstance: e.target.checked }))}
                                />
                              }
                              label="Also sync instance-wide data (catalogs, price books, inventory, metrics). Only if no other company uses this instance."
                            />
                          </Box>
                        )}
                        <Button
                          onClick={() => handleApiKeyConnect('sfcc')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.sfccClientId || !connectorForm.sfccClientSecret || !connectorForm.sfccShortCode || !connectorForm.sfccOrganizationId || !(connectorForm.sfccSiteIds || []).length}
                        >
                          Connect Salesforce Commerce Cloud
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find this:</strong>
                          <br />• In <strong>Account Manager</strong>, open <strong>API Client</strong> and click <strong>Add API Client</strong>. Give it a name and a password (letters and numbers only).
                          <br />• Add your organization, then the role <strong>Salesforce Commerce API</strong> for the instance you want to connect.
                          <br />• Under OpenID Connect, set the Allowed Scopes to the read scopes in our setup guide (at least <strong>sfcc.sites</strong> and <strong>sfcc.orders</strong>), Token Endpoint Auth Method <strong>client_secret_post</strong> and Access Token Format <strong>JWT</strong>, then save and copy the API client ID.
                          <br />• In <strong>Business Manager</strong>, go to <strong>Administration → Site Development → Salesforce Commerce API Settings</strong> for the short code and the organization ID.
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• We only read data; we never change orders, customers or your catalog.
                          <br />• Each scope you leave out just skips that data; you can add scopes later and the next sync picks them up.
                          <br />• We sync daily. The first sync of a large instance can take several days of runs; it continues where it stopped.
                          <br />• Several brands can share one instance: each connection only reads the sites you pick for it.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'kibo' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Kibo Commerce holds your <strong>orders, returns, fulfillment, customers, catalog, prices and
                        inventory</strong>. Connect it with a Kibo <strong>application</strong> (Application Key and Shared
                        Secret) installed on your tenant, and pick the site(s) of this brand.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Kibo Application</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the application against your tenant before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Tenant URL"
                          value={connectorForm.kiboTenantUrl}
                          onChange={(e) => setConnectorForm({...connectorForm, kiboTenantUrl: e.target.value})}
                          placeholder="e.g. https://t12345.tp0.mozu.com or https://t12345.sb.usc1.gcp.kibocommerce.com"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Application Key"
                          value={connectorForm.kiboApplicationKey}
                          onChange={(e) => setConnectorForm({...connectorForm, kiboApplicationKey: e.target.value})}
                          placeholder="e.g. yourcompany.superchargeme_reader.1.0.0.Release"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Shared Secret"
                          value={connectorForm.kiboSharedSecret}
                          onChange={(e) => setConnectorForm({...connectorForm, kiboSharedSecret: e.target.value})}
                          placeholder="Paste the Shared Secret"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={loadKiboSites}
                          variant="outlined"
                          fullWidth
                          sx={{ mb: 2 }}
                          disabled={!connectorForm.kiboTenantUrl || !connectorForm.kiboApplicationKey || !connectorForm.kiboSharedSecret}
                        >
                          Load sites
                        </Button>
                        {(connectorForm.kiboSites || []).length > 0 && (
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                              Pick the site(s) of this brand. Each site can belong to one brand only.
                            </Typography>
                            {connectorForm.kiboSites.map(site => (
                              <FormControlLabel
                                key={site.id}
                                sx={{ display: 'block' }}
                                control={
                                  <Checkbox
                                    size="small"
                                    checked={(connectorForm.kiboSiteIds || []).includes(site.id)}
                                    onChange={(e) => setConnectorForm(f => ({
                                      ...f,
                                      kiboSiteIds: e.target.checked
                                        ? [...(f.kiboSiteIds || []), site.id]
                                        : (f.kiboSiteIds || []).filter(id => id !== site.id)
                                    }))}
                                  />
                                }
                                label={`${site.name} (${site.id}${site.currencyCode ? ', ' + site.currencyCode : ''})`}
                              />
                            ))}
                            <FormControlLabel
                              sx={{ display: 'block', mt: 1 }}
                              control={
                                <Checkbox
                                  size="small"
                                  checked={connectorForm.kiboWholeTenant === true}
                                  onChange={(e) => setConnectorForm(f => ({ ...f, kiboWholeTenant: e.target.checked }))}
                                />
                              }
                              label="Also sync tenant-wide data (locations, inventory, price lists, store credit, users). Only if no other company uses this tenant."
                            />
                          </Box>
                        )}
                        <Button
                          onClick={() => handleApiKeyConnect('kibo')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.kiboTenantUrl || !connectorForm.kiboApplicationKey || !connectorForm.kiboSharedSecret || !(connectorForm.kiboSiteIds || []).length}
                        >
                          Connect Kibo Commerce
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find this:</strong>
                          <br />• In <strong>Kibo Dev Center</strong>, go to <strong>Develop → Applications</strong>, click <strong>Create Application</strong> and give it a name.
                          <br />• Open the application, go to <strong>Packages → Behaviors</strong> and select the <strong>read</strong> behaviors in our setup guide (at least the order read behavior).
                          <br />• Click <strong>Install</strong> and pick your tenant, then in Kibo Admin go to <strong>System → Customization → Applications</strong>, open the application and click <strong>Enable Application</strong>.
                          <br />• Copy the <strong>Application Key</strong> and <strong>Shared Secret</strong> from the application details, and the tenant URL from your browser bar in Kibo Admin.
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• We only read data; we never change orders, customers or your catalog.
                          <br />• Each behavior you leave out just skips that data; you can add behaviors later and the next sync picks them up.
                          <br />• We sync daily. The first sync of a large tenant can take several runs; it continues where it stopped.
                          <br />• Several brands can share one tenant: each connection only reads the sites you pick for it.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'zendesk' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Zendesk holds your <strong>customer service</strong>: tickets, conversations, CSAT, Help Center,
                        Talk and Chat. Connect it with an <strong>OAuth client</strong> that a Zendesk admin creates in
                        your account. One connection reads the whole Zendesk account, every Zendesk brand included.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Zendesk OAuth Client</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the client against Zendesk before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Zendesk subdomain"
                          value={connectorForm.zendeskSubdomain}
                          onChange={(e) => setConnectorForm({...connectorForm, zendeskSubdomain: e.target.value})}
                          placeholder="acme"
                          helperText="from https://<subdomain>.zendesk.com"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Identifier (client ID)"
                          value={connectorForm.zendeskClientId}
                          onChange={(e) => setConnectorForm({...connectorForm, zendeskClientId: e.target.value})}
                          placeholder="Paste the OAuth client Identifier"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Secret"
                          value={connectorForm.zendeskClientSecret}
                          onChange={(e) => setConnectorForm({...connectorForm, zendeskClientSecret: e.target.value})}
                          placeholder="Paste the OAuth client Secret"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        {(connectorForm.zendeskBrandChoices || []).map(zb => (
                          <TextField
                            key={zb.id}
                            select
                            fullWidth
                            label={`Zendesk brand: ${zb.name || zb.id}`}
                            value={(connectorForm.zendeskBrandMapping || {})[String(zb.id)] || ''}
                            onChange={(e) => setConnectorForm({...connectorForm, zendeskBrandMapping: {...(connectorForm.zendeskBrandMapping || {}), [String(zb.id)]: e.target.value}})}
                            helperText="Which of your brands do this Zendesk brand's tickets belong to?"
                            size="small"
                            sx={{ mb: 2 }}
                          >
                            {brands.map(brand => (
                              <MenuItem key={brand.id} value={brand.id}>{brand.name}</MenuItem>
                            ))}
                          </TextField>
                        ))}
                        <Button
                          onClick={() => handleApiKeyConnect('zendesk')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.zendeskSubdomain || !connectorForm.zendeskClientId || !connectorForm.zendeskClientSecret ||
                            (connectorForm.zendeskBrandChoices || []).some(zb => !(connectorForm.zendeskBrandMapping || {})[String(zb.id)])}
                        >
                          Connect Zendesk
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find this:</strong>
                          <br />• A Zendesk <strong>admin</strong> opens <strong>Admin Center → Apps and integrations → APIs → OAuth clients</strong> and clicks <strong>Add OAuth client</strong>
                          <br />• Name it (e.g. SuperChargeMe), set <strong>Client kind</strong> to <strong>Confidential</strong>, enter any https redirect URL (it is not used) and save
                          <br />• Copy the <strong>Identifier</strong> and the <strong>Secret</strong> (the secret is shown only once) and paste them above with your subdomain
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• The client must be created by an admin: Zendesk only lets admins read the ticket, user and event exports.
                          <br />• Optional: set the client's allowed scopes to <strong>read</strong>. We only read data; we never change tickets or settings.
                          <br />• This replaces API tokens, which Zendesk is retiring (no new tokens from 27 October 2026, all switched off on 30 April 2027).
                          <br />• Help Center, Talk and Chat are read when your plan includes them.
                          <br />• If your Zendesk account has several brands, you choose which of your brands each one belongs to; tickets, CSAT and Help Center content follow that choice.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'gladly' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Gladly holds your <strong>customer service</strong>: customers, conversations across every
                        channel, tasks, answers and reports. Connect it with an <strong>API token</strong> of a Gladly
                        user who has the API User permission. One connection reads the whole Gladly organization,
                        every inbox included.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Gladly API Token</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the token against Gladly before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Gladly address"
                          value={connectorForm.gladlyHost}
                          onChange={(e) => setConnectorForm({...connectorForm, gladlyHost: e.target.value})}
                          placeholder="acme"
                          helperText="from https://<organization>.gladly.com"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="API user email"
                          value={connectorForm.gladlyEmail}
                          onChange={(e) => setConnectorForm({...connectorForm, gladlyEmail: e.target.value})}
                          placeholder="The email of the Gladly user who created the token"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="API token"
                          value={connectorForm.gladlyApiToken}
                          onChange={(e) => setConnectorForm({...connectorForm, gladlyApiToken: e.target.value})}
                          placeholder="Paste the API token"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        {(connectorForm.gladlyInboxChoices || []).map(ib => (
                          <TextField
                            key={ib.id}
                            select
                            fullWidth
                            label={`Gladly inbox: ${ib.name || ib.id}`}
                            value={(connectorForm.gladlyInboxMapping || {})[String(ib.id)] || ''}
                            onChange={(e) => setConnectorForm({...connectorForm, gladlyInboxMapping: {...(connectorForm.gladlyInboxMapping || {}), [String(ib.id)]: e.target.value}})}
                            helperText="Which of your brands do this inbox's conversations belong to?"
                            size="small"
                            sx={{ mb: 2 }}
                          >
                            {brands.map(brand => (
                              <MenuItem key={brand.id} value={brand.id}>{brand.name}</MenuItem>
                            ))}
                          </TextField>
                        ))}
                        <Button
                          onClick={() => handleApiKeyConnect('gladly')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.gladlyHost || !connectorForm.gladlyEmail || !connectorForm.gladlyApiToken ||
                            (connectorForm.gladlyInboxChoices || []).some(ib => !(connectorForm.gladlyInboxMapping || {})[String(ib.id)])}
                        >
                          Connect Gladly
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find this:</strong>
                          <br />• A Gladly admin opens <strong>Settings → Users</strong>, opens the user that will hold the token and ticks <strong>API User</strong> (keep the Agent role), then saves
                          <br />• That user opens <strong>More settings → API Tokens</strong> and clicks <strong>Create Token</strong> (the token is shown only once)
                          <br />• Paste your Gladly address, that user's email and the token above
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Gladly recommends a dedicated user for API access, so API activity is easy to tell apart from agent work.
                          <br />• We only read data; we never change conversations, customers or settings.
                          <br />• If your organization has several inboxes, you choose which of your brands each one belongs to; conversations, tasks and per-inbox reports follow that choice.
                          <br />• The first sync reads your whole history over several runs; Gladly allows 10 report requests a minute.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'kustomer' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Kustomer holds your <strong>customer service</strong>: customers, conversations across every
                        channel with their messages and notes, custom objects and satisfaction. Connect it with an
                        <strong> API key</strong>. One connection reads the whole Kustomer organization.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Kustomer API Key</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the key against Kustomer before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Kustomer organization name"
                          value={connectorForm.kustomerOrgName}
                          onChange={(e) => setConnectorForm({...connectorForm, kustomerOrgName: e.target.value})}
                          placeholder="acme"
                          helperText="from https://<orgname>.kustomerapp.com"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="API key"
                          value={connectorForm.kustomerApiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, kustomerApiKey: e.target.value})}
                          placeholder="Paste the API key"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('kustomer')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.kustomerOrgName || !connectorForm.kustomerApiKey}
                        >
                          Connect Kustomer
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find this:</strong>
                          <br />• A Kustomer admin opens <strong>Settings → Security → API Keys</strong> and adds a key
                          <br />• Give it the read roles listed in our Kustomer guide (customers, conversations, messages, notes, custom objects, search, and so on) and a label such as "SuperChargeMe"
                          <br />• Paste your organization name (the part before .kustomerapp.com) and the key above
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• We only read data; we never change conversations, customers or settings.
                          <br />• Kustomer search reaches the last two years; older conversations and messages are read once from Kustomer's archive.
                          <br />• The first sync reads your whole history over several runs, within your plan's API limit.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'segment' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Segment copies every event your sources collect into an <strong>S3 bucket</strong> you own
                        (the Segment <strong>AWS S3</strong> destination). Connect that bucket with a
                        <strong> read-only access key</strong>; add a Public API token to also read your workspace setup and usage.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Segment S3 Bucket</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check that the key can read the Segment files before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="S3 bucket"
                          value={connectorForm.segmentBucket}
                          onChange={(e) => setConnectorForm({...connectorForm, segmentBucket: e.target.value})}
                          placeholder="my-segment-logs"
                          helperText="Exactly as in the Segment AWS S3 destination settings, including any path prefix (bucket/path/prefix)"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          select
                          fullWidth
                          label="AWS region of the bucket"
                          value={connectorForm.segmentRegion}
                          onChange={(e) => setConnectorForm({...connectorForm, segmentRegion: e.target.value})}
                          size="small"
                          sx={{ mb: 2 }}
                        >
                          {['us-east-1', 'us-east-2', 'us-west-1', 'us-west-2', 'ca-central-1', 'ca-west-1', 'mx-central-1',
                            'sa-east-1', 'eu-west-1', 'eu-west-2', 'eu-west-3', 'eu-central-1', 'eu-central-2', 'eu-north-1',
                            'eu-south-1', 'eu-south-2', 'il-central-1', 'me-central-1', 'me-south-1', 'af-south-1',
                            'ap-south-1', 'ap-south-2', 'ap-east-1', 'ap-east-2', 'ap-northeast-1', 'ap-northeast-2',
                            'ap-northeast-3', 'ap-southeast-1', 'ap-southeast-2', 'ap-southeast-3', 'ap-southeast-4',
                            'ap-southeast-5', 'ap-southeast-6', 'ap-southeast-7'].map(r => (
                            <MenuItem key={r} value={r}>{r}</MenuItem>
                          ))}
                        </TextField>
                        <TextField
                          fullWidth
                          label="Access key ID"
                          value={connectorForm.segmentAccessKeyId}
                          onChange={(e) => setConnectorForm({...connectorForm, segmentAccessKeyId: e.target.value})}
                          placeholder="AKIA..."
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Secret access key"
                          value={connectorForm.segmentSecretAccessKey}
                          onChange={(e) => setConnectorForm({...connectorForm, segmentSecretAccessKey: e.target.value})}
                          placeholder="Paste the secret access key"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Segment Public API token (optional)"
                          value={connectorForm.segmentPublicApiToken}
                          onChange={(e) => setConnectorForm({...connectorForm, segmentPublicApiToken: e.target.value})}
                          placeholder="Paste the token"
                          helperText="Adds your workspace sources, destinations, tracking plans, audiences, audit trail and usage"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        {connectorForm.segmentPublicApiToken && (
                          <TextField
                            select
                            fullWidth
                            label="Segment workspace region"
                            value={connectorForm.segmentPublicApiRegion}
                            onChange={(e) => setConnectorForm({...connectorForm, segmentPublicApiRegion: e.target.value})}
                            size="small"
                            sx={{ mb: 2 }}
                          >
                            <MenuItem value="us">United States</MenuItem>
                            <MenuItem value="eu">Europe</MenuItem>
                          </TextField>
                        )}
                        <Button
                          onClick={() => handleApiKeyConnect('segment')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.segmentBucket || !connectorForm.segmentRegion || !connectorForm.segmentAccessKeyId || !connectorForm.segmentSecretAccessKey}
                        >
                          Connect Segment
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find this:</strong>
                          <br />• In Segment, add the <strong>AWS S3</strong> storage destination to your sources (see Segment's AWS S3 destination guide); note its bucket, region and any path prefix
                          <br />• In AWS IAM, create a user for SuperChargeMe with read-only access to that bucket: s3:ListBucket on the bucket and s3:GetObject on segment-logs/* (plus kms:Decrypt if the bucket uses a KMS key), then create an access key for it
                          <br />• Optional: a Segment Workspace Owner creates a Public API token in <strong>Settings → Workspace settings → Access Management → Tokens</strong> (Team and Business plans)
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• We only read; we never write to your bucket or change your workspace.
                          <br />• Segment copies files to the bucket about once an hour, so new events arrive with that delay. Files already in the bucket are read too, oldest first.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'file_feed' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Load files from an <strong>SFTP folder</strong> on a schedule. For <strong>Bazaarvoice</strong>, connect
                        the SFTP account Bazaarvoice delivers your <strong>export feeds</strong> to; for other systems, any folder
                        of <strong>CSV</strong> or <strong>JSON-lines</strong> files.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>SFTP Folder</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We sign in and list the folder before saving, and remember the server's identity so a changed server is refused.
                        </Typography>
                        <TextField
                          select
                          fullWidth
                          label="Files in the folder"
                          value={connectorForm.fileFeedType}
                          onChange={(e) => setConnectorForm({...connectorForm, fileFeedType: e.target.value,
                            fileFeedPath: e.target.value === 'bazaarvoice' ? '/feeds' : connectorForm.fileFeedPath})}
                          size="small"
                          sx={{ mb: 2 }}
                        >
                          <MenuItem value="bazaarvoice">Bazaarvoice export feeds (XML)</MenuItem>
                          <MenuItem value="csv">CSV files (first row = column names)</MenuItem>
                          <MenuItem value="jsonl">JSON-lines files (one JSON object per line)</MenuItem>
                        </TextField>
                        {connectorForm.fileFeedType === 'bazaarvoice' && (
                          <TextField
                            select
                            fullWidth
                            label="Where Bazaarvoice hosts your data"
                            value={['sftp.bazaarvoice.com', 'sftp7.bazaarvoice.com'].includes(connectorForm.fileFeedHost) ? connectorForm.fileFeedHost : 'other'}
                            onChange={(e) => setConnectorForm({...connectorForm, fileFeedHost: e.target.value === 'other' ? '' : e.target.value, fileFeedPort: '22'})}
                            size="small"
                            sx={{ mb: 2 }}
                          >
                            <MenuItem value="sftp.bazaarvoice.com">United States (sftp.bazaarvoice.com)</MenuItem>
                            <MenuItem value="sftp7.bazaarvoice.com">Europe (sftp7.bazaarvoice.com)</MenuItem>
                            <MenuItem value="other">Another host Bazaarvoice gave you</MenuItem>
                          </TextField>
                        )}
                        <TextField
                          fullWidth
                          label="SFTP host"
                          value={connectorForm.fileFeedHost}
                          onChange={(e) => setConnectorForm({...connectorForm, fileFeedHost: e.target.value})}
                          placeholder="sftp.example.com"
                          helperText="Host name only, without sftp:// or a folder"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Port"
                          value={connectorForm.fileFeedPort}
                          onChange={(e) => setConnectorForm({...connectorForm, fileFeedPort: e.target.value})}
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Username"
                          value={connectorForm.fileFeedUsername}
                          onChange={(e) => setConnectorForm({...connectorForm, fileFeedUsername: e.target.value})}
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          select
                          fullWidth
                          label="Sign in with"
                          value={connectorForm.fileFeedAuth}
                          onChange={(e) => setConnectorForm({...connectorForm, fileFeedAuth: e.target.value})}
                          size="small"
                          sx={{ mb: 2 }}
                        >
                          <MenuItem value="password">Password</MenuItem>
                          <MenuItem value="key">Private key</MenuItem>
                        </TextField>
                        {connectorForm.fileFeedAuth === 'key' ? (
                          <>
                            <TextField
                              fullWidth
                              multiline
                              minRows={4}
                              label="Private key"
                              value={connectorForm.fileFeedPrivateKey}
                              onChange={(e) => setConnectorForm({...connectorForm, fileFeedPrivateKey: e.target.value})}
                              placeholder="Paste the whole key, including the BEGIN and END lines"
                              size="small"
                              sx={{ mb: 2 }}
                            />
                            <TextField
                              fullWidth
                              label="Key passphrase (if any)"
                              value={connectorForm.fileFeedPassphrase}
                              onChange={(e) => setConnectorForm({...connectorForm, fileFeedPassphrase: e.target.value})}
                              size="small"
                              type="password"
                              sx={{ mb: 2 }}
                            />
                          </>
                        ) : (
                          <TextField
                            fullWidth
                            label="Password"
                            value={connectorForm.fileFeedPassword}
                            onChange={(e) => setConnectorForm({...connectorForm, fileFeedPassword: e.target.value})}
                            size="small"
                            type="password"
                            sx={{ mb: 2 }}
                          />
                        )}
                        <TextField
                          fullWidth
                          label="Folder"
                          value={connectorForm.fileFeedPath}
                          onChange={(e) => setConnectorForm({...connectorForm, fileFeedPath: e.target.value})}
                          placeholder="/feeds"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="File names (optional)"
                          value={connectorForm.fileFeedPattern}
                          onChange={(e) => setConnectorForm({...connectorForm, fileFeedPattern: e.target.value})}
                          placeholder={connectorForm.fileFeedType === 'bazaarvoice' ? '*.xml,*.xml.gz' : connectorForm.fileFeedType === 'csv' ? '*.csv,*.csv.gz' : '*.jsonl,*.jsonl.gz'}
                          helperText="Only files matching these names are loaded; leave empty for the usual names"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        {connectorForm.fileFeedType === 'csv' && (
                          <TextField
                            select
                            fullWidth
                            label="Column separator"
                            value={connectorForm.fileFeedCsvDelimiter}
                            onChange={(e) => setConnectorForm({...connectorForm, fileFeedCsvDelimiter: e.target.value})}
                            size="small"
                            sx={{ mb: 2 }}
                          >
                            <MenuItem value=",">Comma</MenuItem>
                            <MenuItem value=";">Semicolon</MenuItem>
                            <MenuItem value={'\t'}>Tab</MenuItem>
                            <MenuItem value="|">Pipe</MenuItem>
                          </TextField>
                        )}
                        <TextField
                          select
                          fullWidth
                          label="Subfolders"
                          value={connectorForm.fileFeedRecursive ? 'yes' : 'no'}
                          onChange={(e) => setConnectorForm({...connectorForm, fileFeedRecursive: e.target.value === 'yes'})}
                          size="small"
                          sx={{ mb: 2 }}
                        >
                          <MenuItem value="no">Only this folder</MenuItem>
                          <MenuItem value="yes">Also subfolders (up to 3 levels)</MenuItem>
                        </TextField>
                        <Button
                          onClick={() => handleApiKeyConnect('file_feed')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.fileFeedHost || !connectorForm.fileFeedUsername ||
                            !(connectorForm.fileFeedAuth === 'key' ? connectorForm.fileFeedPrivateKey : connectorForm.fileFeedPassword)}
                        >
                          Connect SFTP Folder
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find this (Bazaarvoice):</strong>
                          <br />• In the Bazaarvoice Portal, open <strong>Configuration</strong>, edit the Main Implementation, then <strong>Technical Setup → Export Feeds</strong>, and enable the <strong>Full</strong> and <strong>Incremental Standard Content Feed</strong> (and the ratings-only feed if you use it); deploy the change
                          <br />• Ask Bazaarvoice support for your <strong>SFTP username and password</strong> (or give them a public key) and whether your data is hosted in the US or Europe; the feeds land in the <strong>/feeds</strong> folder
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• We only read and download; we never change or delete files on the server.
                          <br />• Every file is loaded once; a file that changes is loaded again. A file that cannot be read is retried on every run and does not block the others.
                          <br />• Bazaarvoice feeds include rejected content and reviewer emails; they are stored with your data like every other source.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'bigquery' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Copy the <strong>tables and views you choose</strong> from your own <strong>Google BigQuery</strong> project.
                        We read with a <strong>service account</strong> you create; queries run in your project, so their cost is
                        billed to your Google Cloud account.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Service Account Key</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          Upload the JSON key file of the service account, or paste its contents. We keep it encrypted and never show it again.
                        </Typography>
                        <Button component="label" variant="outlined" fullWidth startIcon={<UploadIcon />} sx={{ mb: 2 }}>
                          {connectorForm.bqKeyFileName ? `Key file: ${connectorForm.bqKeyFileName}` : 'Upload JSON key file'}
                          <input type="file" accept="application/json,.json" hidden onChange={loadBigQueryKeyFile} />
                        </Button>
                        <TextField
                          fullWidth
                          label="Or paste the JSON key"
                          value={connectorForm.bqKeyText}
                          onChange={(e) => setConnectorForm({...connectorForm, bqKeyText: e.target.value, bqKeyFileName: '', bqDatasets: [], bqPicked: {}, bqColumns: {}})}
                          type="password"
                          size="small"
                          sx={{ mb: 1 }}
                        />
                        {bigQueryKeyInfo() ? (
                          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                            Service account <strong>{bigQueryKeyInfo().email}</strong> (project {bigQueryKeyInfo().project})
                          </Typography>
                        ) : (connectorForm.bqKeyText && (
                          <Typography variant="body2" color="error" sx={{ mb: 2 }}>
                            This is not a service-account JSON key.
                          </Typography>
                        ))}
                        <TextField
                          fullWidth
                          label="Project ID with the data (optional)"
                          value={connectorForm.bqProjectId}
                          onChange={(e) => setConnectorForm({...connectorForm, bqProjectId: e.target.value.trim(), bqDatasets: [], bqPicked: {}, bqColumns: {}})}
                          placeholder={bigQueryKeyInfo()?.project || 'acme-analytics'}
                          helperText="Leave empty to use the key's own project"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Billing project for queries (optional)"
                          value={connectorForm.bqBillingProjectId}
                          onChange={(e) => setConnectorForm({...connectorForm, bqBillingProjectId: e.target.value.trim()})}
                          helperText="The project that runs and pays for our queries; leave empty to use the data project"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Datasets (optional)"
                          value={connectorForm.bqDatasetFilter}
                          onChange={(e) => setConnectorForm({...connectorForm, bqDatasetFilter: e.target.value})}
                          placeholder="sales, marketing"
                          helperText="Only needed when the project has many datasets: comma-separated dataset names"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <Button onClick={loadBigQueryTables} variant="outlined" fullWidth sx={{ mb: 2 }} disabled={!bigQueryKeyInfo()}>
                          Load tables
                        </Button>
                        {(connectorForm.bqDatasets || []).length > 0 && (
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                              Pick the tables and views to copy. Each table can belong to one connection only.
                            </Typography>
                            {connectorForm.bqDatasets.map(ds => (
                              <Box key={ds.dataset} sx={{ mb: 1 }}>
                                <Typography variant="subtitle2">{ds.dataset}{ds.location ? ` (${ds.location})` : ''}</Typography>
                                {(ds.tables || []).length === 0 && (
                                  <Typography variant="body2" color="text.secondary">No tables this key can list.</Typography>
                                )}
                                {(ds.tables || []).map(t => {
                                  const id = `${ds.dataset}.${t.table}`;
                                  const pick = (connectorForm.bqPicked || {})[id];
                                  const cols = (connectorForm.bqColumns || {})[id] || {};
                                  return (
                                    <Box key={id} sx={{ ml: 2 }}>
                                      <FormControlLabel
                                        sx={{ display: 'block' }}
                                        control={
                                          <Checkbox
                                            size="small"
                                            checked={Boolean(pick)}
                                            onChange={(e) => toggleBigQueryTable(ds.dataset, t.table, e.target.checked)}
                                          />
                                        }
                                        label={`${t.table}${t.type && t.type !== 'TABLE' ? ` (${t.type.toLowerCase().replace('_', ' ')})` : ''}`}
                                      />
                                      {pick && (
                                        <Box sx={{ ml: 4, mb: 1 }}>
                                          <TextField
                                            select
                                            fullWidth
                                            label="Changed-since column"
                                            value={pick.cursorColumn || ''}
                                            onChange={(e) => setBigQueryPick(id, { cursorColumn: e.target.value })}
                                            helperText={pick.cursorColumn ? 'Each sync reads rows changed since the last one' : 'None: the whole table is read on every sync, and rows removed from it are marked as removed'}
                                            size="small"
                                            sx={{ mb: 1 }}
                                          >
                                            <MenuItem value="">None (read the whole table)</MenuItem>
                                            {(cols.cursorCandidates || []).map(c => (
                                              <MenuItem key={c} value={c}>{c}</MenuItem>
                                            ))}
                                          </TextField>
                                          <Typography variant="body2" color={pick.cursorColumn && !(pick.primaryKey || []).length ? 'error' : 'text.secondary'}>
                                            Unique key {(pick.primaryKey || []).length ? '' : (pick.cursorColumn
                                              ? '(required with a changed-since column: pick the columns that identify one row)'
                                              : '(none: every row is kept, including identical ones; a changed row is kept as a new row)')}
                                          </Typography>
                                          {(cols.keyCandidates || []).map(c => (
                                            <FormControlLabel
                                              key={c}
                                              control={
                                                <Checkbox
                                                  size="small"
                                                  checked={(pick.primaryKey || []).includes(c)}
                                                  onChange={(e) => setBigQueryPick(id, { primaryKey: e.target.checked
                                                    ? [...(pick.primaryKey || []), c]
                                                    : (pick.primaryKey || []).filter(k => k !== c) })}
                                                />
                                              }
                                              label={c}
                                            />
                                          ))}
                                        </Box>
                                      )}
                                    </Box>
                                  );
                                })}
                              </Box>
                            ))}
                          </Box>
                        )}
                        <TextField
                          fullWidth
                          label="Most data one query may scan (GiB)"
                          value={connectorForm.bqMaxGibPerQuery}
                          onChange={(e) => setConnectorForm({...connectorForm, bqMaxGibPerQuery: e.target.value.replace(/[^0-9]/g, '')})}
                          helperText="Up to 1024. A query estimated above this is not run (BigQuery also refuses to bill above it)"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Most data one sync may scan (GiB)"
                          value={connectorForm.bqMaxGibPerRun}
                          onChange={(e) => setConnectorForm({...connectorForm, bqMaxGibPerRun: e.target.value.replace(/[^0-9]/g, '')})}
                          helperText="Up to 1024 (contact support for more). A sync stops here and continues on the next run"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Most data one sync may store (GiB)"
                          value={connectorForm.bqMaxStoredGibPerRun}
                          onChange={(e) => setConnectorForm({...connectorForm, bqMaxStoredGibPerRun: e.target.value.replace(/[^0-9]/g, '')})}
                          helperText="Up to 50 (contact support for more). A sync stops here and continues on the next run"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('bigquery')}
                          variant="contained"
                          fullWidth
                          disabled={!bigQueryKeyInfo() || Object.keys(connectorForm.bqPicked || {}).length === 0 ||
                            bigQueryMissingKeys().length > 0 || bigQueryLimitTooHigh()}
                        >
                          Connect BigQuery
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find this:</strong>
                          <br />• In the Google Cloud console open <strong>IAM &amp; Admin → Service Accounts</strong> and <strong>create a service account</strong> for SuperChargeMe
                          <br />• In <strong>BigQuery</strong>, share each dataset to read with it as <strong>BigQuery Data Viewer</strong>; in <strong>IAM</strong>, give it <strong>BigQuery Job User</strong> on the project that runs the queries
                          <br />• Open the service account, <strong>Keys → Add key → Create new key → JSON</strong>, and upload the downloaded file here
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Read-only: these roles let us read data and run queries, never change or delete your data.
                          <br />• Query cost is billed to your Google Cloud project at your BigQuery price. We check each query&apos;s size before running it and keep to the limits above; a table with a changed-since column costs least.
                          <br />• Some organisations block key creation (policy <strong>iam.disableServiceAccountKeyCreation</strong>); your Google Cloud administrator can allow it for this project.
                          <br />• We sync daily. A large first copy can take several runs; it continues where it stopped.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}
                {connectorType === 'snowflake' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Copy the <strong>tables and views you choose</strong> from your Snowflake account on a schedule. We
                        sign in as a <strong>read-only service user</strong> with a key pair (no password), and only read what
                        its role is granted.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>1. Create our read-only user</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We create a key pair for this connection. The private key never leaves our servers; you add the public
                          key to a Snowflake service user with the SQL below.
                        </Typography>
                        {!connectorForm.sfPublicKey ? (
                          <Button onClick={generateSnowflakeKey} variant="outlined" fullWidth disabled={connectorForm.sfBusy}>
                            Create key pair
                          </Button>
                        ) : (
                          <>
                            <TextField
                              fullWidth
                              multiline
                              minRows={6}
                              label="Run this in a Snowflake worksheet (edit the names in angle brackets)"
                              value={connectorForm.sfSetupSql}
                              InputProps={{ readOnly: true, sx: { fontFamily: 'monospace', fontSize: 12 } }}
                              size="small"
                              sx={{ mb: 1 }}
                            />
                            <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
                              Public key fingerprint: {connectorForm.sfFingerprint}
                            </Typography>
                            <Button
                              onClick={() => navigator.clipboard.writeText(connectorForm.sfSetupSql)}
                              variant="outlined"
                              size="small"
                              sx={{ mb: 2 }}
                            >
                              Copy SQL
                            </Button>
                          </>
                        )}
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>2. Your Snowflake account</Typography>
                        <TextField
                          fullWidth
                          label="Account identifier"
                          value={connectorForm.sfAccount}
                          onChange={(e) => setConnectorForm({...connectorForm, sfAccount: e.target.value})}
                          placeholder="myorg-myaccount"
                          helperText="Snowsight: open the account selector, then View account details"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="User"
                          value={connectorForm.sfUser}
                          onChange={(e) => setConnectorForm({...connectorForm, sfUser: e.target.value})}
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Role"
                          value={connectorForm.sfRole}
                          onChange={(e) => setConnectorForm({...connectorForm, sfRole: e.target.value})}
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Warehouse"
                          value={connectorForm.sfWarehouse}
                          onChange={(e) => setConnectorForm({...connectorForm, sfWarehouse: e.target.value})}
                          placeholder="SUPERCHARGEME_WH"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={loadSnowflakeObjects}
                          variant="outlined"
                          fullWidth
                          sx={{ mb: 2 }}
                          disabled={!snowflakeReady() || connectorForm.sfBusy}
                        >
                          {connectorForm.sfBusy ? 'Loading tables...' : 'Load tables'}
                        </Button>
                        {(connectorForm.sfObjects || []).length > 0 && (
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                              Pick the tables and views to copy. Choose an <strong>updated-at column</strong> (and the table's
                              <strong> key column(s)</strong>) to read only new and changed rows; without one the whole table is
                              read every run (up to 2 million rows) and a key column is optional.
                              {connectorForm.sfTruncated && ' Your role sees more objects than we list: grant it only what we should read.'}
                            </Typography>
                            <TextField
                              fullWidth
                              label="Filter"
                              value={connectorForm.sfFilter}
                              onChange={(e) => setConnectorForm({...connectorForm, sfFilter: e.target.value})}
                              size="small"
                              sx={{ mb: 1 }}
                            />
                            {connectorForm.sfObjects
                              .filter(o => !connectorForm.sfFilter || `${o.database}.${o.schema}.${o.table}`.toLowerCase().includes(connectorForm.sfFilter.toLowerCase()) || connectorForm.sfSelected[sfKey(o)])
                              .slice(0, 200)
                              .map(o => {
                                const sel = connectorForm.sfSelected[sfKey(o)];
                                return (
                                  <Box key={sfKey(o)} sx={{ mb: 1 }}>
                                    <FormControlLabel
                                      sx={{ display: 'block' }}
                                      control={
                                        <Checkbox
                                          size="small"
                                          checked={Boolean(sel)}
                                          onChange={(e) => setSnowflakeTable(o, e.target.checked ? {} : null)}
                                        />
                                      }
                                      label={`${o.database}.${o.schema}.${o.table} (${o.table_type === 'VIEW' ? 'view' : 'table'}${o.row_count ? `, ${o.row_count} rows` : ''})`}
                                    />
                                    {sel && (
                                      <Box sx={{ pl: 4 }}>
                                        <TextField
                                          select
                                          fullWidth
                                          label="Updated-at column"
                                          value={sel.cursorColumn}
                                          onChange={(e) => setSnowflakeTable(o, { cursorColumn: e.target.value })}
                                          size="small"
                                          sx={{ mb: 1 }}
                                        >
                                          <MenuItem value="">None: read the whole table every run</MenuItem>
                                          {(o.columns || []).filter(c => c.cursor_ok).map(c => (
                                            <MenuItem key={c.name} value={c.name}>{c.name} ({c.data_type})</MenuItem>
                                          ))}
                                        </TextField>
                                        <TextField
                                          select
                                          fullWidth
                                          label={sel.cursorColumn ? 'Key column(s), required with an updated-at column' : 'Key column(s), optional'}
                                          error={Boolean(sel.cursorColumn) && !(sel.primaryKey || []).length}
                                          value={sel.primaryKey}
                                          onChange={(e) => setSnowflakeTable(o, { primaryKey: typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value })}
                                          SelectProps={{ multiple: true }}
                                          size="small"
                                        >
                                          {(o.columns || []).map(c => (
                                            <MenuItem key={c.name} value={c.name}>{c.name}</MenuItem>
                                          ))}
                                        </TextField>
                                      </Box>
                                    )}
                                  </Box>
                                );
                              })}
                          </Box>
                        )}
                        <TextField
                          fullWidth
                          label="Data limit per sync (GiB), optional"
                          value={connectorForm.sfMaxGiB}
                          onChange={(e) => setConnectorForm({...connectorForm, sfMaxGiB: e.target.value.replace(/[^0-9]/g, '')})}
                          placeholder="20"
                          helperText="Up to 50 GiB (default 20). A larger table continues on the next sync; more needs our team."
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('snowflake')}
                          variant="contained"
                          fullWidth
                          disabled={!snowflakeReady() || !Object.keys(connectorForm.sfSelected || {}).length || connectorForm.sfBusy ||
                            Object.values(connectorForm.sfSelected || {}).some(sel => sel.cursorColumn && !(sel.primaryKey || []).length)}
                        >
                          Connect Snowflake
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find this:</strong>
                          <br />• <strong>Account identifier:</strong> in Snowsight, open the <strong>account selector</strong>, then <strong>View account details</strong>; or run <code>SELECT CURRENT_ORGANIZATION_NAME() || '-' || CURRENT_ACCOUNT_NAME();</code>
                          <br />• Run the SQL from step 1 as a role that can create users and roles (for example <strong>SECURITYADMIN</strong>), with grants from the owner of the tables
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• We only read: SELECT on the tables and views you grant. Our queries are tagged <strong>superchargeme-warehouse-reader</strong> in your Query History.
                          <br />• Reads run on the warehouse you name and use your Snowflake credits. A dedicated XSMALL warehouse with auto-suspend and a resource monitor keeps that predictable.
                          <br />• Rows deleted in Snowflake are detected for tables read in full; tables read by an updated-at column keep rows that were deleted.
                          <br />• Private connectivity (PrivateLink) accounts cannot be connected.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'databricks' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Copy the <strong>Unity Catalog tables and views you choose</strong> from your Databricks workspace on a
                        schedule. We sign in as a <strong>service principal</strong> you create, run read-only queries on the SQL
                        warehouse you name, and only read what you grant it.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>1. Your Databricks workspace</Typography>
                        <TextField
                          fullWidth
                          label="Workspace URL"
                          value={connectorForm.dbHost}
                          onChange={(e) => setConnectorForm({...connectorForm, dbHost: e.target.value})}
                          placeholder="dbc-a1b2345c-d6e7.cloud.databricks.com"
                          helperText="The address in your browser when you are signed in to the workspace"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="SQL warehouse ID"
                          value={connectorForm.dbWarehouseId}
                          onChange={(e) => setConnectorForm({...connectorForm, dbWarehouseId: e.target.value})}
                          placeholder="a1b234c567d8e9fa"
                          helperText="SQL Warehouses > your warehouse > Connection details: the end of the HTTP path"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          select
                          fullWidth
                          label="Sign in with"
                          value={connectorForm.dbAuthType}
                          onChange={(e) => setConnectorForm({...connectorForm, dbAuthType: e.target.value})}
                          size="small"
                          sx={{ mb: 2 }}
                        >
                          <MenuItem value="oauth_m2m">Service principal: client ID + OAuth secret (recommended)</MenuItem>
                          <MenuItem value="pat">Access token (legacy)</MenuItem>
                        </TextField>
                        {connectorForm.dbAuthType === 'pat' ? (
                          <TextField
                            fullWidth
                            label="Access token"
                            value={connectorForm.dbToken}
                            onChange={(e) => setConnectorForm({...connectorForm, dbToken: e.target.value})}
                            placeholder="Paste the service principal's access token"
                            size="small"
                            type="password"
                            sx={{ mb: 2 }}
                          />
                        ) : (
                          <>
                            <TextField
                              fullWidth
                              label="Client ID (application ID)"
                              value={connectorForm.dbClientId}
                              onChange={(e) => setConnectorForm({...connectorForm, dbClientId: e.target.value})}
                              placeholder="Paste the service principal's client ID"
                              size="small"
                              sx={{ mb: 2 }}
                            />
                            <TextField
                              fullWidth
                              label="OAuth secret"
                              value={connectorForm.dbClientSecret}
                              onChange={(e) => setConnectorForm({...connectorForm, dbClientSecret: e.target.value})}
                              placeholder="Paste the OAuth secret"
                              size="small"
                              type="password"
                              sx={{ mb: 2 }}
                            />
                          </>
                        )}
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>2. Tables to copy</Typography>
                        <TextField
                          fullWidth
                          label="Catalogs to list, optional"
                          value={connectorForm.dbCatalogs}
                          onChange={(e) => setConnectorForm({...connectorForm, dbCatalogs: e.target.value})}
                          placeholder="main, analytics"
                          helperText="Leave empty to list every catalog the service principal can use"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={loadDatabricksObjects}
                          variant="outlined"
                          fullWidth
                          sx={{ mb: 2 }}
                          disabled={!databricksReady() || connectorForm.dbBusy}
                        >
                          {connectorForm.dbBusy ? 'Loading tables...' : 'Load tables'}
                        </Button>
                        {(connectorForm.dbObjects || []).length > 0 && (
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                              Pick the tables and views to copy. Choose an <strong>updated-at column</strong> (and the table's
                              <strong> key column(s)</strong>) to read only new and changed rows; without one the whole table is
                              read every run (up to 2 million rows) and a key column is optional.
                              {connectorForm.dbTruncated && ' The service principal sees more objects than we list: enter the catalogs to list.'}
                            </Typography>
                            <TextField
                              fullWidth
                              label="Filter"
                              value={connectorForm.dbFilter}
                              onChange={(e) => setConnectorForm({...connectorForm, dbFilter: e.target.value})}
                              size="small"
                              sx={{ mb: 1 }}
                            />
                            {connectorForm.dbObjects
                              .filter(o => !connectorForm.dbFilter || `${o.catalog}.${o.schema}.${o.table}`.toLowerCase().includes(connectorForm.dbFilter.toLowerCase()) || connectorForm.dbSelected[dbKey(o)])
                              .slice(0, 200)
                              .map(o => {
                                const sel = connectorForm.dbSelected[dbKey(o)];
                                return (
                                  <Box key={dbKey(o)} sx={{ mb: 1 }}>
                                    <FormControlLabel
                                      sx={{ display: 'block' }}
                                      control={
                                        <Checkbox
                                          size="small"
                                          checked={Boolean(sel)}
                                          onChange={(e) => setDatabricksTable(o, e.target.checked ? {} : null)}
                                        />
                                      }
                                      label={`${o.catalog}.${o.schema}.${o.table} (${String(o.table_type || '').includes('VIEW') ? 'view' : 'table'})`}
                                    />
                                    {sel && (
                                      <Box sx={{ pl: 4 }}>
                                        <TextField
                                          select
                                          fullWidth
                                          label="Updated-at column"
                                          value={sel.cursorColumn}
                                          onChange={(e) => setDatabricksTable(o, { cursorColumn: e.target.value })}
                                          size="small"
                                          sx={{ mb: 1 }}
                                        >
                                          <MenuItem value="">None: read the whole table every run</MenuItem>
                                          {(o.columns || []).filter(c => c.cursor_ok).map(c => (
                                            <MenuItem key={c.name} value={c.name}>{c.name} ({c.type_text})</MenuItem>
                                          ))}
                                        </TextField>
                                        <TextField
                                          select
                                          fullWidth
                                          label={sel.cursorColumn ? 'Key column(s), required with an updated-at column' : 'Key column(s), optional'}
                                          error={Boolean(sel.cursorColumn) && !(sel.primaryKey || []).length}
                                          value={sel.primaryKey}
                                          onChange={(e) => setDatabricksTable(o, { primaryKey: typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value })}
                                          SelectProps={{ multiple: true }}
                                          size="small"
                                        >
                                          {(o.columns || []).map(c => (
                                            <MenuItem key={c.name} value={c.name}>{c.name}</MenuItem>
                                          ))}
                                        </TextField>
                                      </Box>
                                    )}
                                  </Box>
                                );
                              })}
                          </Box>
                        )}
                        <TextField
                          fullWidth
                          label="Data limit per sync (GiB), optional"
                          value={connectorForm.dbMaxGiB}
                          onChange={(e) => setConnectorForm({...connectorForm, dbMaxGiB: e.target.value.replace(/[^0-9]/g, '')})}
                          placeholder="20"
                          helperText="Up to 50 GiB (default 20). A larger table continues on the next sync; more needs our team."
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('databricks')}
                          variant="contained"
                          fullWidth
                          disabled={!databricksReady() || !Object.keys(connectorForm.dbSelected || {}).length || connectorForm.dbBusy ||
                            Object.values(connectorForm.dbSelected || {}).some(sel => sel.cursorColumn && !(sel.primaryKey || []).length)}
                        >
                          Connect Databricks
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>How to set it up:</strong>
                          <br />• <strong>Service principal:</strong> click your username, then <strong>Settings</strong> &gt; <strong>Identity and access</strong> &gt; <strong>Service principals</strong> &gt; <strong>Manage</strong>. Add one, open its <strong>Secrets</strong> tab and click <strong>Generate secret</strong>; copy the client ID and the secret. Do not make it a workspace admin: we refuse admin service principals (read-only access is all we need). An access token is a legacy option; prefer the service principal.
                          <br />• <strong>Warehouse:</strong> on the SQL warehouse, open <strong>Permissions</strong> and give the service principal <strong>Can use</strong>.
                          <br />• <strong>Data:</strong> grant it read access in Unity Catalog, for example <code>GRANT USE CATALOG ON CATALOG main TO `&lt;client ID&gt;`;</code> <code>GRANT USE SCHEMA ON SCHEMA main.sales TO `&lt;client ID&gt;`;</code> <code>GRANT SELECT ON TABLE main.sales.orders TO `&lt;client ID&gt;`;</code>
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• We only read: SELECT on the tables and views you grant. Our queries carry the query tag <strong>superchargeme_reader</strong> in your Query History.
                          <br />• Reads run on the SQL warehouse you name and use your Databricks compute (DBUs). A small warehouse with auto stop keeps that predictable.
                          <br />• Rows deleted in Databricks are detected for tables read in full; tables read by an updated-at column keep rows that were deleted.
                          <br />• Unity Catalog is required. Private-link workspaces and the account console cannot be connected.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'brightpearl' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Brightpearl holds your <strong>orders, stock and accounting</strong>. Connect it with a
                        <strong> private staff app</strong> created in your Brightpearl account. One connection reads the
                        whole Brightpearl account.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Brightpearl Private App</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the token against Brightpearl before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Private app identifier"
                          value={connectorForm.brightpearlAppRef}
                          onChange={(e) => setConnectorForm({...connectorForm, brightpearlAppRef: e.target.value})}
                          placeholder="youraccount_app-name"
                          helperText="Shown in App Store → Private apps"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Staff token"
                          value={connectorForm.brightpearlAccountToken}
                          onChange={(e) => setConnectorForm({...connectorForm, brightpearlAccountToken: e.target.value})}
                          placeholder="Paste the staff token"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          select
                          fullWidth
                          label="Datacentre (optional)"
                          value={connectorForm.brightpearlDatacentre}
                          onChange={(e) => setConnectorForm({...connectorForm, brightpearlDatacentre: e.target.value})}
                          helperText="Leave on Detect automatically unless your Brightpearl address shows it"
                          size="small"
                          sx={{ mb: 2 }}
                        >
                          <MenuItem value="">Detect automatically</MenuItem>
                          <MenuItem value="euw1">euw1 (Europe)</MenuItem>
                          <MenuItem value="use1">use1 (US East)</MenuItem>
                          <MenuItem value="usw1">usw1 (US West)</MenuItem>
                        </TextField>
                        <Button
                          onClick={() => handleApiKeyConnect('brightpearl')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.brightpearlAppRef || !connectorForm.brightpearlAccountToken}
                        >
                          Connect Brightpearl
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find this:</strong>
                          <br />• In Brightpearl open <strong>App Store → Private apps</strong> and click <strong>Add private app</strong>
                          <br />• Choose <strong>Staff app</strong>, give it a name and an identifier (it starts with your account code, e.g. youraccount_superchargeme), then save
                          <br />• Click <strong>Manage users</strong>, add the staff member whose access the app should use, and copy their token
                          <br />• Paste the app identifier and the token above
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• The app reads with that staff member's permissions; they need access to orders, products, contacts and accounting.
                          <br />• We only read data; we never change orders, stock or accounts.
                          <br />• Brightpearl allows 200 requests a minute per account, shared by all your private apps; we leave room for your other apps, so the first sync reads your history over several runs.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'ordergroove' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Ordergroove holds your <strong>subscriptions and subscription orders</strong>. Connect it with an
                        <strong> Application API key</strong> that has <strong>bulk queries</strong> turned on.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Ordergroove API Key</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the key against Ordergroove before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="API Key"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="Paste your Ordergroove Application API key"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('ordergroove')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.apiKey}
                        >
                          Connect Ordergroove
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find this:</strong>
                          <br />• Sign in to RC3 at <strong>rc3.ordergroove.com</strong>
                          <br />• Go to <strong>Developers → API Keys</strong>, open the <strong>Application</strong> tab and click <strong>Create</strong>
                          <br />• Name it, choose <strong>Read Only</strong>, turn on <strong>Allow bulk queries?</strong>, accept the terms and click <strong>Save</strong>
                          <br />• Copy the key from the <strong>API key</strong> column
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Your RC3 user needs API key access to see or create keys. If the keys are masked, ask your RC3 admin.
                          <br />• We only read data; we never change subscriptions or orders in Ordergroove.
                          <br />• We sync customers, subscriptions, orders, items, addresses, products, offer profiles and one-time incentives daily. Payment methods are not synced.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'stripe' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Stripe holds your <strong>payments, fees, payouts and subscriptions</strong>. Connect it with a
                        <strong> restricted key</strong> that can only <strong>read</strong>.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Stripe Restricted Key</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the key and each permission against Stripe before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Restricted key"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="rk_live_..."
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('stripe')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.apiKey}
                        >
                          Connect Stripe
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to create the key:</strong>
                          <br />• In the Stripe Dashboard go to <strong>Developers → API keys</strong>
                          <br />• Click <strong>Create restricted key</strong> and name it (e.g. SuperChargeMe)
                          <br />• <strong>Required:</strong> set <strong>Read</strong> on: Balance, Charges and Refunds, PaymentIntents, Disputes, Payouts, Customers, Invoices, Subscriptions, Products, Prices / Plans, Coupons, Promotion Codes, Events, and <strong>Connect (Accounts)</strong> so we can see which Stripe account the key belongs to
                          <br />• <strong>Recommended:</strong> also set <strong>Read</strong> on everything you use of: Checkout Sessions, Credit Notes, Transfers, Application Fees, Top-ups, SetupIntents, PaymentMethods, Reviews and Radar (value lists), Files, Reporting, Quotes, Payment Links, Tax Rates, Tax IDs, Tax Settings, Shipping Rates, Billing (meters, alerts, credit grants, customer portal), Payment Method Configurations and Domains, Webhook Endpoints, Entitlements, Invoice Rendering Templates, Terminal, Apps, Climate, Issuing, Identity, Financial Connections and Treasury
                          <br />• Leave every <strong>Write</strong> at <strong>None</strong>
                          <br />• Click <strong>Create key</strong>, copy the <strong>rk_live_...</strong> value and paste it here
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Never paste your secret key (sk_live_...); we refuse it because it can move money.
                          <br />• If a required permission is missing we tell you which one and do not connect. Missing recommended ones do not block the connection; we simply skip that data until you add them.
                          <br />• We only read; we never charge, refund or change anything in Stripe, and we never store card numbers, card fingerprints, signing secrets or the private links of hosted invoices, receipts and files.
                          <br />• If your Stripe account is a <strong>Connect platform</strong>, the Connect (Accounts) permission also lets us read your <strong>connected accounts</strong>: we store their business details, bank accounts, capabilities and the people on them (names, contact details), like your other customer data.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'postscript' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Postscript holds your <strong>SMS subscribers</strong> and their consent. Connect it with your
                        <strong> Private API Key</strong>.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Postscript Private API Key</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the key against Postscript before saving and confirm which shop it connects.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Private API Key"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="sk_..."
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('postscript')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.apiKey}
                        >
                          Connect Postscript
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find the key:</strong>
                          <br />• Sign in to Postscript and open <strong>app.postscript.io/account/api</strong>
                          <br />• Copy the <strong>Private API Key</strong> (not the Public Key) and paste it here
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Postscript allows API access with your own key on <strong>Enterprise</strong> plans. On other plans the key is refused and we tell you so.
                          <br />• Read-only access — we never send messages or change anything in Postscript.
                          <br />• We sync subscribers and keywords daily. Postscript's API does not share campaign, flow or revenue reports.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'okendo' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Okendo holds your <strong>reviews, review photos and videos, Q&amp;A</strong> and your
                        <strong> loyalty</strong> program settings. Connect it with your <strong>User ID</strong> and
                        <strong> Merchant REST API key</strong>.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Okendo API Credentials</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check these against Okendo before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="User ID"
                          value={connectorForm.okendoUserId}
                          onChange={(e) => setConnectorForm({...connectorForm, okendoUserId: e.target.value})}
                          placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Merchant REST API key"
                          value={connectorForm.okendoApiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, okendoApiKey: e.target.value})}
                          placeholder="Paste your Okendo Merchant REST API key"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('okendo')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.okendoUserId || !connectorForm.okendoApiKey}
                        >
                          Connect Okendo
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find these:</strong>
                          <br />• Okendo admin: <strong>Settings → Integrations</strong>, then open the <strong>Okendo</strong> section
                          <br />• Copy your <strong>User ID</strong>. If no Merchant REST API key is shown yet, click <strong>Generate</strong> and copy it
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Read-only use — we never publish, hide or reply to reviews.
                          <br />• The Merchant REST API is not on every Okendo plan. If the key is refused, ask Okendo to enable API access.
                          <br />• Okendo surveys and loyalty points history are not available through this API yet.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'fairing' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Fairing holds your <strong>post-purchase survey answers</strong>, each linked to its order. Connect it with your
                        <strong> Secret Token</strong>.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Fairing Secret Token</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the token against Fairing before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Secret Token"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('fairing')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.apiKey}
                        >
                          Connect Fairing
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find the token:</strong>
                          <br />• Sign in to Fairing and open <strong>Settings</strong>
                          <br />• Under <strong>API Credentials</strong>, copy the <strong>Secret Token</strong> (not the Publishable Key) and paste it here
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• API access is part of Fairing's paid plans. If your plan does not include it, the token is refused and we tell you so.
                          <br />• Read-only access — we never change your questions or answers in Fairing.
                          <br />• We sync questions and answers daily, including answers given or edited after the order.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'knocommerce' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        KnoCommerce holds your <strong>post-purchase survey answers</strong>, each linked to its order. Connect it with an
                        <strong> API client</strong> (Client ID and Client Secret) from your Kno dashboard.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Kno API Client</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the client against KnoCommerce before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Client ID"
                          value={connectorForm.knoClientId || ''}
                          onChange={(e) => setConnectorForm({...connectorForm, knoClientId: e.target.value})}
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Client Secret"
                          value={connectorForm.knoClientSecret || ''}
                          onChange={(e) => setConnectorForm({...connectorForm, knoClientSecret: e.target.value})}
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('knocommerce')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.knoClientId || !connectorForm.knoClientSecret}
                        >
                          Connect KnoCommerce
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find these:</strong>
                          <br />• Sign in to Kno and open <strong>Settings → API Access</strong>
                          <br />• Click <strong>Create Client</strong>, tick the <strong>Responses</strong> and <strong>Surveys</strong> permissions, and save
                          <br />• Copy the <strong>Client ID</strong> and <strong>Client Secret</strong> (the secret is shown only once) and paste them here
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• API access depends on your Kno plan. If your plan does not include it, Kno refuses the client and we tell you so.
                          <br />• Read-only access — we never change your surveys or answers in Kno.
                          <br />• We sync surveys and answers daily, including answers completed after the order.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'braze' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Braze holds your <strong>campaign, Canvas and segment analytics and your user profiles</strong>. Connect it with a
                        <strong> REST API key</strong> and the <strong>REST endpoint</strong> shown next to it in Braze.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Braze REST API Key</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the key against Braze before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="REST endpoint"
                          value={connectorForm.brazeRestEndpoint || ''}
                          onChange={(e) => setConnectorForm({...connectorForm, brazeRestEndpoint: e.target.value})}
                          placeholder="https://rest.iad-01.braze.com"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="REST API Key"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="Paste your Braze REST API key"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('braze')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.apiKey || !connectorForm.brazeRestEndpoint}
                        >
                          Connect Braze
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find these:</strong>
                          <br />• In Braze, open <strong>Settings → APIs and Identifiers → API Keys</strong> and click <strong>Create API Key</strong>
                          <br />• Tick these permissions: <strong>campaigns.list, campaigns.data_series, campaigns.details, canvas.list, canvas.data_series, canvas.details, canvas.data_summary, segments.list, segments.data_series, segments.details, events.list, events.get, events.data_series, custom_attributes.get, sessions.data_series, kpi.dau.data_series, kpi.mau.data_series, kpi.new_users.data_series, kpi.uninstalls.data_series, purchases.product_list, purchases.revenue_series, purchases.quantity_series, users.export.segment, users.export.global_control_group, subscription.groups.get, email.hard_bounces, email.unsubscribe, sms.invalid_phone_numbers, templates.email.list, templates.email.info, content_blocks.list, content_blocks.info, preference_center.list, preference_center.get, messages.schedule_broadcasts, catalogs.get, catalogs.get_items</strong>
                          <br />• If you use them, also tick: <strong>cdi.integration_list, cdi.integration_job_status, data_objects.read, data_objects.user_relationships.read, campaigns.translations.get, canvas.translations.get, content_blocks.translations.get, templates.translations.get, campaigns.url_info.details, canvas.url_info.details</strong>
                          <br />• Copy the key and the <strong>REST endpoint</strong> shown on that page and paste both here
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Braze does not let you change a key's permissions later. If one is missing, we tell you which, and you create a new key.
                          <br />• Read-only access — we never send messages or change anything in Braze. We export your user profiles (segment exports) to sync them; that does not change anything in Braze.
                          <br />• We sync daily and refresh the last 31 days each time, so late conversions are picked up. Braze reports revenue in US dollars.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'sfmc' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Salesforce Marketing Cloud holds your <strong>email sends and their tracking, journeys, lists, subscribers and data extensions</strong>.
                        Connect one <strong>business unit</strong> with an <strong>Installed Package</strong> (Server-to-Server API integration).
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Installed Package API Integration</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the credentials and the business unit against Marketing Cloud before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Authentication Base URI"
                          value={connectorForm.sfmcAuthBaseUri || ''}
                          onChange={(e) => setConnectorForm({...connectorForm, sfmcAuthBaseUri: e.target.value})}
                          placeholder="https://mcxxxxxxxxxxxxxxxxxxxxxxxxxx.auth.marketingcloudapis.com/"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Client ID"
                          value={connectorForm.sfmcClientId || ''}
                          onChange={(e) => setConnectorForm({...connectorForm, sfmcClientId: e.target.value})}
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Client Secret"
                          value={connectorForm.sfmcClientSecret || ''}
                          onChange={(e) => setConnectorForm({...connectorForm, sfmcClientSecret: e.target.value})}
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Business unit MID"
                          value={connectorForm.sfmcAccountId || ''}
                          onChange={(e) => setConnectorForm({...connectorForm, sfmcAccountId: e.target.value})}
                          placeholder="e.g. 510001234"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Data extensions to check now (optional)"
                          value={connectorForm.sfmcDataExtensionKeys || ''}
                          onChange={(e) => setConnectorForm({...connectorForm, sfmcDataExtensionKeys: e.target.value})}
                          placeholder="External keys, separated by commas"
                          helperText="We copy every row of every data extension in this business unit automatically. List external keys here only if you want the connection to confirm now that they exist."
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={connectorForm.sfmcDataViewsOptIn === true}
                              onChange={(e) => setConnectorForm({...connectorForm, sfmcDataViewsOptIn: e.target.checked})}
                            />
                          }
                          label="Also export data views (complaints, jobs, journeys, SMS tracking, automation runs)"
                          sx={{ mb: 1 }}
                        />
                        {connectorForm.sfmcDataViewsOptIn === true && (
                          <Alert severity="warning" sx={{ mb: 2 }}>
                            <Typography variant="body2">
                              Data views can only be read by a query activity in your account. With this option we create, in this business unit,
                              one data extension named <strong>scm_dv_&lt;view&gt;</strong> and one query activity named <strong>scm_q_&lt;view&gt;</strong> for
                              each of 21 data views, and run those queries on every sync. We never change or delete anything else.
                              It needs the extra permissions Data Extensions Write, Automations Write and Automations Execute.
                            </Typography>
                          </Alert>
                        )}
                        <Button
                          onClick={() => handleApiKeyConnect('sfmc')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.sfmcAuthBaseUri || !connectorForm.sfmcClientId || !connectorForm.sfmcClientSecret || !connectorForm.sfmcAccountId}
                        >
                          Connect Salesforce Marketing Cloud
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find these:</strong>
                          <br />• In Marketing Cloud, open <strong>Setup → Apps → Installed Packages</strong> and click <strong>New</strong> (an admin is needed)
                          <br />• Add a component: <strong>API Integration</strong>, type <strong>Server-to-Server</strong>
                          <br />• Tick these read permissions: <strong>Email Read, Tracking Events Read, List and Subscribers Read, Data Extensions Read</strong>
                          <br />• Also tick, to sync everything: <strong>Journeys Read, Documents and Images Read, Saved Content Read, Automations Read, Campaign Read, SMS Read, Push Read, Webhooks Read</strong>
                          <br />• Under <strong>Access</strong>, give the package access to the business unit you connect here
                          <br />• Copy the <strong>Authentication Base URI</strong>, <strong>Client ID</strong> and <strong>Client Secret</strong> from the component, and the business unit's <strong>MID</strong>
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Read-only unless you tick the data view export above. We never send messages or change your data.
                          <br />• One connection per business unit. Marketing Cloud keeps times in US Central time; we store them in UTC.
                          <br />• We sync daily and re-read the last 3 days of tracking each time. The first sync reads a year of tracking and can take a few days.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'salesforce_service_cloud' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Salesforce Service Cloud holds your <strong>cases, customer emails, knowledge articles, chats and surveys</strong>.
                        Connect one <strong>Salesforce org</strong> with an <strong>External Client App</strong> that uses the Client Credentials Flow. Read-only.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>External Client App</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the app and your org against Salesforce before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="My Domain URL"
                          value={connectorForm.sfscMyDomainUrl || ''}
                          onChange={(e) => setConnectorForm({...connectorForm, sfscMyDomainUrl: e.target.value})}
                          placeholder="https://yourcompany.my.salesforce.com"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Consumer key"
                          value={connectorForm.sfscClientId || ''}
                          onChange={(e) => setConnectorForm({...connectorForm, sfscClientId: e.target.value})}
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Consumer secret"
                          value={connectorForm.sfscClientSecret || ''}
                          onChange={(e) => setConnectorForm({...connectorForm, sfscClientSecret: e.target.value})}
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Custom objects to check now (optional)"
                          value={connectorForm.sfscCustomObjects || ''}
                          onChange={(e) => setConnectorForm({...connectorForm, sfscCustomObjects: e.target.value})}
                          placeholder="API names ending in __c, separated by commas"
                          helperText="Service Cloud objects and every custom object the integration user can read are synced automatically. List custom objects here only if you want the connection to confirm now that they are readable."
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('salesforce_service_cloud')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.sfscMyDomainUrl || !connectorForm.sfscClientId || !connectorForm.sfscClientSecret}
                        >
                          Connect Salesforce Service Cloud
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find these (a Salesforce admin is needed):</strong>
                          <br />• Create a user for SuperChargeMe with the <strong>Salesforce Integration</strong> license and the <strong>Minimum Access - API Only Integrations</strong> profile
                          <br />• Give it a permission set (license <strong>Salesforce API Integration</strong>) with <strong>Read</strong> and <strong>View All</strong> on Cases and the other service objects (optional: <strong>View Setup and Configuration</strong>, so we can list fields hidden from it and check its permissions)
                          <br />• Never give it <strong>Modify All Data</strong>, <strong>Customize Application</strong>, <strong>Author Apex</strong>, <strong>Manage Users</strong> or <strong>Modify All</strong> on any object: we refuse a user that can change your org
                          <br />• In Setup, open <strong>External Client App Manager</strong> and create a new app: enable OAuth, scope <strong>Manage user data via APIs (api)</strong>, and tick <strong>Enable Client Credentials Flow</strong>
                          <br />• In the app's <strong>Policies</strong>, set that user as the <strong>Run As</strong> user for the Client Credentials Flow
                          <br />• Copy the <strong>Consumer Key and Secret</strong> from the app's OAuth settings, and your <strong>My Domain URL</strong> from Setup → My Domain
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Read-only. We never create, change or delete anything in Salesforce.
                          <br />• One connection per Salesforce org. We sync every 4 hours and use at most a fifth of your org's daily API allowance per day, spread over the day's syncs.
                          <br />• The first sync reads your full history and can take several days on a large org.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'cj' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        CJ Affiliate holds your <strong>affiliate commissions, publishers and product feeds</strong>. Connect it with a
                        <strong> personal access token</strong> and your <strong>advertiser Company ID</strong>.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>CJ Personal Access Token</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the token against CJ before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Advertiser Company ID (CID)"
                          value={connectorForm.cjAdvertiserCid || ''}
                          onChange={(e) => setConnectorForm({...connectorForm, cjAdvertiserCid: e.target.value})}
                          placeholder="e.g. 1234567"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Personal Access Token"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="Paste your CJ personal access token"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('cj')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.apiKey || !connectorForm.cjAdvertiserCid}
                        >
                          Connect CJ Affiliate
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find these:</strong>
                          <br />• Sign in at <strong>developers.cj.com</strong> with a user of your CJ advertiser account
                          <br />• Open <strong>Authentication → Personal Access Tokens</strong>, create a token and paste it here
                          <br />• Your <strong>Company ID (CID)</strong> is shown in CJ Account Manager next to your company name
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Read-only access — we never change your program, products or commissions in CJ.
                          <br />• We sync daily and refresh the last 180 days of commissions each time, so status changes and corrections are picked up.
                          <br />• The token belongs to the CJ user who created it. If that user leaves your company in CJ, create a new token and reconnect.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'cruva' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Cruva manages your <strong>TikTok Shop affiliate</strong> program. Connect it
                        with the <strong>API Key</strong> from your Cruva dashboard. A Shop ID is
                        optional — if your key reaches just one shop we detect it automatically.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Cruva API Credentials</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the key against Cruva before saving and confirm which shop it connects.
                        </Typography>
                        <TextField
                          fullWidth
                          label="API Key"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="cruva_… — paste your Cruva API Key"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Shop ID (optional)"
                          value={connectorForm.cruvaShopId}
                          onChange={(e) => setConnectorForm({...connectorForm, cruvaShopId: e.target.value})}
                          placeholder="Leave blank to auto-detect"
                          helperText="Only needed if your API key can access more than one Cruva shop."
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('cruva')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.apiKey}
                        >
                          Connect Cruva
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find these:</strong>
                          <br />• Sign in to Cruva at <strong>cruva.com</strong>
                          <br />• Go to <strong>Dashboard → API</strong> and click <strong>Generate API Key</strong>
                          <br />• Your Shop ID is at <strong>Dashboard → My Shops → shop → View Info</strong> (optional)
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Read-only access — we never change anything in Cruva.
                          <br />• One API key can cover several shops; leave Shop ID blank for a single-shop key, or paste a specific Shop ID.
                          <br />• We sync affiliates, videos/lives, samples, spark codes, ads and outreach daily.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'judgeme' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Judge.me holds your <strong>product and store reviews</strong>. Connect it with
                        your <strong>private API token</strong> and your <strong>shop domain</strong>.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Judge.me API Credentials</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the token against Judge.me before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Shop domain"
                          value={connectorForm.judgemeShopDomain}
                          onChange={(e) => setConnectorForm({...connectorForm, judgemeShopDomain: e.target.value})}
                          placeholder="yourstore.myshopify.com"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Private API token"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="Paste your Judge.me private API token"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('judgeme')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.apiKey || !connectorForm.judgemeShopDomain}
                        >
                          Connect Judge.me
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find these:</strong>
                          <br />• In your Judge.me admin, go to <strong>Settings → Integrations</strong>
                          <br />• Click <strong>View API tokens</strong> (top right)
                          <br />• Copy the <strong>Private API Token</strong> (not the public one) and the <strong>Shop domain</strong>
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Read-only use — we never publish, hide or reply to reviews.
                          <br />• We sync all reviews, reviewers, shop info and review counts/ratings daily.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'appstle_subscriptions' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Appstle runs your <strong>Shopify subscriptions</strong>. Connect it with your
                        {' '}<strong>API key</strong> and your <strong>shop domain</strong>. Read-only — we never change anything in Appstle.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Appstle Subscriptions API Credentials</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the key against Appstle before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Shop domain"
                          value={connectorForm.appstleShopDomain}
                          onChange={(e) => setConnectorForm({...connectorForm, appstleShopDomain: e.target.value})}
                          placeholder="yourstore.myshopify.com"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="API key"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="Paste your Appstle API key"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('appstle_subscriptions')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.apiKey || !connectorForm.appstleShopDomain}
                        >
                          Connect Appstle Subscriptions
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find these:</strong>
                          <br />• In your Appstle admin, go to <strong>Settings → API Key Management</strong>
                          <br />• Create or copy your <strong>API key</strong>
                          <br />• Enter your store's <strong>myshopify.com domain</strong>
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Read-only use — we never create, charge, pause or cancel subscriptions.
                          <br />• We sync contracts, billing attempts, cancellation and churn reasons, plans, customers and more, daily.
                          <br />• Your Appstle plan must include API access.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'smile' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Smile.io runs your <strong>loyalty &amp; rewards</strong> program. Connect it with one
                        {' '}<strong>API key</strong> from your Smile admin. Read-only — we never change anything in Smile.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Smile.io API Key</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the key against Smile before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="API key"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="Paste your Smile API key"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('smile')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.apiKey}
                        >
                          Connect Smile.io
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find this:</strong>
                          <br />• In Smile admin, open <strong>Settings → API keys</strong>
                          <br />• Click <strong>Create API key</strong>, give it read access to your loyalty resources, name it (for example "SuperChargeMe") and copy it
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• REST API access needs a Smile <strong>Plus or Enterprise</strong> plan. If you cannot see API keys, check your Smile plan.
                          <br />• Read-only use — we never issue points, change a reward or edit anything in Smile.
                          <br />• We sync your members, points balances and transactions, reward fulfillments, earning rules, points products, VIP tiers and your points and referral settings every day.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'recharge' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Recharge runs your <strong>subscriptions</strong>. Connect it with an <strong>API token</strong>
                        {' '}from your Recharge merchant portal. Read-only — we never change anything in Recharge.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Recharge API Token</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the token against Recharge before saving and confirm which store it connects.
                        </Typography>
                        <TextField
                          fullWidth
                          label="API Token"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="Paste your Recharge API token"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('recharge')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.apiKey}
                        >
                          Connect Recharge
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to create the token:</strong>
                          <br />• Sign in to the Recharge merchant portal (store owner, or a user the owner gave the API tokens permission)
                          <br />• Go to <strong>Tools &amp; apps → API tokens</strong> and click <strong>Create an API token</strong>
                          <br />• Give it a name and contact email, then set <strong>Read access</strong> on: Store, Subscriptions, Customers, Orders, Discounts, Plans, Products, and (Recharge Plus) Events, Credit accounts, Credit adjustments
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Read access is enough; we never write to Recharge.
                          <br />• Recharge only returns successful charges from the last 90 days, so connect soon to keep that history.
                          <br />• We sync subscriptions (incl. cancellation reasons), customers, addresses, charges, orders, discounts and plans daily.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'heartland_retail' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Heartland Retail runs your <strong>stores and POS</strong>. Connect it with your account address and an
                        {' '}<strong>API token</strong>. Read-only — we never change anything in Heartland Retail.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Heartland Retail API Token</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the token against your Heartland Retail account before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Account address"
                          value={connectorForm.heartlandAccountHost}
                          onChange={(e) => setConnectorForm({...connectorForm, heartlandAccountHost: e.target.value})}
                          placeholder="yourstore.retail.heartland.us"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="API Token"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="Paste your Heartland Retail API token"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Box sx={{ mb: 2 }}>
                          <CurrencySelector
                            value={connectorForm.heartlandCurrency}
                            onChange={(currency) => setConnectorForm({...connectorForm, heartlandCurrency: currency})}
                            label="Account Currency"
                            helperText="The currency your Heartland Retail stores sell in. Heartland Retail does not report it, so we need you to pick it."
                            required
                            size="small"
                          />
                        </Box>
                        <Button
                          onClick={() => handleApiKeyConnect('heartland_retail')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.apiKey || !connectorForm.heartlandAccountHost || !connectorForm.heartlandCurrency}
                        >
                          Connect Heartland Retail
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to create the token:</strong>
                          <br />• Sign in to Heartland Retail as a user whose role can view sales, customers, items, inventory, purchasing and reporting (an admin is simplest)
                          <br />• Click your name in the top-right corner → <strong>My account</strong> → <strong>API</strong>
                          <br />• Click <strong>Generate new token</strong>, add a description, then copy the token (it is shown only once)
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• The account address is the one you sign in at, e.g. yourstore.retail.heartland.us.
                          <br />• The token sees what that user's role can see; anything the role cannot view is skipped and listed when you connect.
                          <br />• The first sync reads your full history, so it can take several hours for a busy store; after that we sync daily.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'skio' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Skio runs your <strong>Shopify subscriptions</strong>. Connect it with an
                        <strong> API key</strong> from your Skio dashboard.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Skio API Key</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the key against Skio before saving and confirm which store it connects.
                        </Typography>
                        <TextField
                          fullWidth
                          label="API key"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="Paste your Skio API key"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('skio')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.apiKey}
                        >
                          Connect Skio
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find this:</strong>
                          <br />• In your Skio dashboard, go to <strong>API &amp; Integrations → API</strong>
                          <br />• Enter a name (for example "SuperChargeMe") and click <strong>Generate API key</strong>
                          <br />• Copy the key straight away: Skio shows it only once
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Read-only use — we never skip, pause, cancel or edit a subscription.
                          <br />• We sync subscriptions, orders, customers, products, cancellation reasons and daily subscription revenue every day.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'omnisend' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Omnisend runs your <strong>email &amp; SMS marketing</strong>. Connect it with one
                        <strong> API key</strong> from your Omnisend store settings.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Omnisend API Key</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the key against Omnisend before saving and confirm which brand it connects.
                        </Typography>
                        <TextField
                          fullWidth
                          label="API key"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="Paste your Omnisend API key"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('omnisend')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.apiKey}
                        >
                          Connect Omnisend
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find this:</strong>
                          <br />• In Omnisend, open <strong>Store settings → Integrations &amp; API → API keys</strong>
                          <br />• Click <strong>Create API key</strong>, name it (for example "SuperChargeMe") and copy it
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Read-only use — we never send a campaign, change a contact or edit anything in Omnisend.
                          <br />• We sync your contacts, segments, campaigns, automations, forms, products, orders and reporting every day.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'shipbob' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        ShipBob fulfils your orders. Connect it with a <strong>Personal Access Token</strong> from your ShipBob dashboard.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>ShipBob API Credentials</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the token against ShipBob before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Personal Access Token"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="Paste your ShipBob Personal Access Token"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('shipbob')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.apiKey}
                        >
                          Connect ShipBob
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find it:</strong>
                          <br />• Log in to ShipBob as the <strong>account owner</strong> (ShipBob only accepts tokens from the main user)
                          <br />• Go to <strong>Integrations → API Tokens</strong> and click <strong>Generate New Token</strong>
                          <br />• Copy the token and paste it above
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Read-only use — we never create, change or cancel orders, shipments or receiving orders.
                          <br />• We sync orders, shipments, inventory, receiving orders, returns and billing daily.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'yotpo_reviews' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Yotpo holds your <strong>reviews, star ratings and Q&amp;A</strong>, and your
                        <strong> Loyalty &amp; Referrals</strong> program if you use it. Connect Reviews with your
                        <strong> Store ID</strong> and <strong>API secret</strong>; Loyalty is optional.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Yotpo Reviews Credentials</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check these against Yotpo before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Store ID (App Key)"
                          value={connectorForm.yotpoStoreId}
                          onChange={(e) => setConnectorForm({...connectorForm, yotpoStoreId: e.target.value})}
                          placeholder="Paste your Yotpo Store ID"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="API secret"
                          value={connectorForm.yotpoApiSecret}
                          onChange={(e) => setConnectorForm({...connectorForm, yotpoApiSecret: e.target.value})}
                          placeholder="Paste your Yotpo API secret"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Typography variant="h6" gutterBottom>Loyalty &amp; Referrals (optional)</Typography>
                        <TextField
                          fullWidth
                          label="Loyalty GUID"
                          value={connectorForm.yotpoLoyaltyGuid}
                          onChange={(e) => setConnectorForm({...connectorForm, yotpoLoyaltyGuid: e.target.value})}
                          placeholder="Leave empty if you do not use Yotpo Loyalty"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Loyalty API key"
                          value={connectorForm.yotpoLoyaltyApiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, yotpoLoyaltyApiKey: e.target.value})}
                          placeholder="Leave empty if you do not use Yotpo Loyalty"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('yotpo_reviews')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.yotpoStoreId || !connectorForm.yotpoApiSecret ||
                            Boolean(connectorForm.yotpoLoyaltyGuid) !== Boolean(connectorForm.yotpoLoyaltyApiKey)}
                        >
                          Connect Yotpo
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find these:</strong>
                          <br />• Yotpo admin: profile icon → <strong>Account Settings → General Settings</strong>; the Store ID is at the bottom
                          <br />• On the same page click <strong>Get secret key</strong>. Only an account admin can do this; Yotpo emails them a code
                          <br />• Loyalty: <strong>Loyalty &amp; Referrals → Settings</strong> shows the GUID and API key
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Read-only use — we never publish, hide or answer reviews or questions.
                          <br />• Loyalty customers sync from the day you connect (Yotpo only lists customers updated in the last 7 days).
                          <br />• This is separate from Yotpo SMS, which connects through SMSBump.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'walmart' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Connect your <strong>Walmart Marketplace</strong> seller account with the
                        <strong> Client ID</strong> and <strong>Client Secret</strong> of your personal API key pair.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Walmart API Credentials</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the key pair with Walmart before saving and confirm which seller account it connects.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Client ID"
                          value={connectorForm.walmartClientId}
                          onChange={(e) => setConnectorForm({...connectorForm, walmartClientId: e.target.value})}
                          placeholder="Paste your Walmart Client ID"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Client Secret"
                          value={connectorForm.walmartClientSecret}
                          onChange={(e) => setConnectorForm({...connectorForm, walmartClientSecret: e.target.value})}
                          placeholder="Paste your Walmart Client Secret"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('walmart')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.walmartClientId || !connectorForm.walmartClientSecret}
                        >
                          Connect Walmart
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find these:</strong>
                          <br />• Sign in to Seller Center and open <strong>seller.walmart.com/api-key</strong> (Settings → API Integration)
                          <br />• Click <strong>API Key Management</strong> — this opens the Walmart Developer Portal with your Seller Center login
                          <br />• Find your <strong>personal key pair</strong> (it has a lock icon) and copy the <strong>Client ID</strong> and <strong>Client Secret</strong>
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Read-only use — we never acknowledge, ship, cancel or refund anything.
                          <br />• The key pair needs access to Reports / Payments so we can identify your seller account.
                          <br />• We sync orders (Walmart keeps the last 180 days), returns, items, inventory, reconciliation reports and fees daily.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'applovin' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        AppLovin Ads reports your <strong>web campaign</strong> spend and results. Connect it
                        with your <strong>Report Key</strong> and your <strong>account ID</strong>.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>AppLovin API Credentials</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the Report Key against AppLovin before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Account ID"
                          value={connectorForm.applovinAccountId}
                          onChange={(e) => setConnectorForm({...connectorForm, applovinAccountId: e.target.value})}
                          placeholder="The number after your account name in settings"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Report Key"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="Paste your AppLovin Report Key"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('applovin')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.apiKey || !connectorForm.applovinAccountId}
                        >
                          Connect AppLovin
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find these:</strong>
                          <br />• In AppLovin Ads, click your account name (top right) and select <strong>Keys</strong>
                          <br />• Copy the <strong>Report Key</strong> (not the Event Key)
                          <br />• Your <strong>Account ID</strong> is under account name → <strong>Go to settings</strong>
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Read-only — we never change your campaigns.
                          <br />• AppLovin only lets us read the last 90 days, so history starts there.
                          <br />• We sync daily stats by campaign, creative set and ad, for both click and click-and-view attribution.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'taboola' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Taboola reports your campaign spend and results. Connect it with the
                        <strong> API keys</strong> (client ID and client secret) from Taboola Realize.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Taboola API Keys</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the keys against Taboola and read the account they belong to before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Client ID"
                          value={connectorForm.taboolaClientId}
                          onChange={(e) => setConnectorForm({...connectorForm, taboolaClientId: e.target.value})}
                          placeholder="Paste your Taboola client ID"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Client secret"
                          value={connectorForm.taboolaClientSecret}
                          onChange={(e) => setConnectorForm({...connectorForm, taboolaClientSecret: e.target.value})}
                          placeholder="Paste your Taboola client secret"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        {(connectorForm.taboolaAccountChoices || []).length > 0 && (
                          <TextField
                            select
                            fullWidth
                            label="Advertiser account"
                            value={connectorForm.taboolaAccountId}
                            onChange={(e) => setConnectorForm({...connectorForm, taboolaAccountId: e.target.value})}
                            helperText="These keys reach several Taboola accounts. Pick the one for this brand; connect the others to their own brands with the same keys."
                            size="small"
                            sx={{ mb: 2 }}
                          >
                            {(connectorForm.taboolaAccountChoices || []).map(a => (
                              <MenuItem key={a.account_id} value={a.account_id}>
                                {a.name ? `${a.name} (${a.account_id})` : a.account_id}
                              </MenuItem>
                            ))}
                          </TextField>
                        )}
                        <Button
                          onClick={() => handleApiKeyConnect('taboola')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.taboolaClientId || !connectorForm.taboolaClientSecret ||
                            ((connectorForm.taboolaAccountChoices || []).length > 0 && !connectorForm.taboolaAccountId)}
                        >
                          Connect Taboola
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find it:</strong>
                          <br />• In Taboola Realize, open the <strong>API Keys</strong> page and create a client ID and secret
                          <br />• Each connection syncs one Taboola advertiser account. If your keys reach several, we ask which one belongs to this brand
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Read-only — we never change your campaigns.
                          <br />• History starts up to three years back and fills in over the first days.
                          <br />• Numbers are in each account's own currency and time zone.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'adobe_analytics' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Adobe Analytics reports your site traffic and conversions. Connect it with an
                        <strong> OAuth Server-to-Server credential</strong> from the Adobe Developer Console. Read-only — we never change anything in Adobe.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Adobe credential</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the credential with Adobe and read the Analytics company it belongs to before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Client ID"
                          value={connectorForm.adobeClientId}
                          onChange={(e) => setConnectorForm({...connectorForm, adobeClientId: e.target.value})}
                          placeholder="Paste the Client ID"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Client Secret"
                          value={connectorForm.adobeClientSecret}
                          onChange={(e) => setConnectorForm({...connectorForm, adobeClientSecret: e.target.value})}
                          placeholder="Paste the Client Secret"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Organization ID"
                          value={connectorForm.adobeOrgId}
                          onChange={(e) => setConnectorForm({...connectorForm, adobeOrgId: e.target.value})}
                          placeholder="e.g. 1234ABCD5678EF90@AdobeOrg"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Scopes (optional)"
                          value={connectorForm.adobeScopes}
                          onChange={(e) => setConnectorForm({...connectorForm, adobeScopes: e.target.value})}
                          placeholder="openid,session,AdobeID,read_organizations,additional_info.projectedProductContext"
                          helperText="Copy the Scopes shown on your credential. Leave empty to use the usual Adobe Analytics scopes."
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        {(connectorForm.adobeCompanyChoices || []).length > 0 && (
                          <TextField
                            select
                            fullWidth
                            label="Analytics company"
                            value={connectorForm.adobeCompanyId}
                            onChange={(e) => setConnectorForm({...connectorForm, adobeCompanyId: e.target.value})}
                            helperText="This credential reaches several Adobe Analytics companies. Pick the one for this brand."
                            size="small"
                            sx={{ mb: 2 }}
                          >
                            {(connectorForm.adobeCompanyChoices || []).map(c => (
                              <MenuItem key={c.global_company_id} value={c.global_company_id}>
                                {c.name ? `${c.name} (${c.global_company_id})` : c.global_company_id}
                              </MenuItem>
                            ))}
                          </TextField>
                        )}
                        <Button
                          onClick={() => handleApiKeyConnect('adobe_analytics')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.adobeClientId || !connectorForm.adobeClientSecret || !connectorForm.adobeOrgId ||
                            ((connectorForm.adobeCompanyChoices || []).length > 0 && !connectorForm.adobeCompanyId)}
                        >
                          Connect Adobe Analytics
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Before you connect:</strong>
                          <br />• In the <strong>Adobe Developer Console</strong> (developer.adobe.com/console), create a project, add the <strong>Adobe Analytics</strong> API and choose <strong>OAuth Server-to-Server</strong>
                          <br />• Pick a product profile that includes your <strong>report suites, metrics and dimensions</strong> (a System Admin or Developer of your Adobe organization can do this)
                          <br />• Open the credential and copy the <strong>Client ID</strong>, <strong>Client Secret</strong>, <strong>Organization ID</strong> and <strong>Scopes</strong>
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Each connection syncs one Adobe Analytics company and every report suite its product profile allows.
                          <br />• The last 3 days are refreshed every day, and older history loads over the following days.
                          <br />• Revenue is shown in each report suite's own currency.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'adobe_experience_platform' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Adobe Experience Platform (Real-Time CDP) holds your customer data setup, audiences and activations. Connect it with an
                        <strong> OAuth Server-to-Server credential</strong> from the Adobe Developer Console. Read-only — we never change anything in Adobe.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Adobe credential</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the credential with Adobe and confirm the organization it belongs to before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Client ID"
                          value={connectorForm.aepClientId}
                          onChange={(e) => setConnectorForm({...connectorForm, aepClientId: e.target.value})}
                          placeholder="Paste the Client ID"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Client Secret"
                          value={connectorForm.aepClientSecret}
                          onChange={(e) => setConnectorForm({...connectorForm, aepClientSecret: e.target.value})}
                          placeholder="Paste the Client Secret"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Organization ID"
                          value={connectorForm.aepOrgId}
                          onChange={(e) => setConnectorForm({...connectorForm, aepOrgId: e.target.value})}
                          placeholder="e.g. 1234ABCD5678EF90@AdobeOrg"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Scopes (optional)"
                          value={connectorForm.aepScopes}
                          onChange={(e) => setConnectorForm({...connectorForm, aepScopes: e.target.value})}
                          placeholder="openid,AdobeID,read_organizations,additional_info.projectedProductContext,session"
                          helperText="Copy the Scopes shown on your credential. Leave empty to use the usual Experience Platform scopes."
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Sandboxes (optional)"
                          value={connectorForm.aepSandboxes}
                          onChange={(e) => setConnectorForm({...connectorForm, aepSandboxes: e.target.value})}
                          placeholder="prod"
                          helperText={(connectorForm.aepSandboxChoices || []).length > 0
                            ? `This credential can use: ${(connectorForm.aepSandboxChoices || []).join(', ')}`
                            : 'Sandbox names, separated by commas. Leave empty to sync every sandbox this credential can use.'}
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('adobe_experience_platform')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.aepClientId || !connectorForm.aepClientSecret || !connectorForm.aepOrgId}
                        >
                          Connect Adobe Experience Platform
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Before you connect:</strong>
                          <br />• In the <strong>Adobe Developer Console</strong> (developer.adobe.com/console), create a project, add the <strong>Experience Platform API</strong> and choose <strong>OAuth Server-to-Server</strong>
                          <br />• Pick the <strong>AEP-Default-All-Users</strong> product profile; an Experience Platform system administrator gives the credential's role read access to the sandboxes and features you want synced
                          <br />• Open the credential and copy the <strong>Client ID</strong>, <strong>Client Secret</strong>, <strong>Organization ID</strong> and <strong>Scopes</strong>
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Each connection syncs one Adobe organization. Features your credential cannot read are skipped and listed in the sync log.
                          <br />• Privacy jobs need the Privacy Service API added to the same project.
                          <br />• We read setup, audiences, runs and usage, not the customer records inside your datasets.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'adobe_campaign' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Adobe Campaign sends your emails, SMS and push messages. Connect it with an
                        <strong> OAuth Server-to-Server credential</strong> from the Adobe Developer Console. Read-only — we never change anything in Adobe.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Adobe credential</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the credential with your Campaign instance before saving.
                        </Typography>
                        <TextField
                          select
                          fullWidth
                          label="Adobe Campaign product"
                          value={connectorForm.adobeCampaignProduct}
                          onChange={(e) => setConnectorForm({...connectorForm, adobeCampaignProduct: e.target.value})}
                          size="small"
                          sx={{ mb: 2 }}
                        >
                          <MenuItem value="v8">Adobe Campaign v8</MenuItem>
                          <MenuItem value="standard">Adobe Campaign Standard</MenuItem>
                        </TextField>
                        <TextField
                          fullWidth
                          label={connectorForm.adobeCampaignProduct === 'v8' ? 'Instance address' : 'Organization ID (tenant)'}
                          value={connectorForm.adobeCampaignInstance}
                          onChange={(e) => setConnectorForm({...connectorForm, adobeCampaignInstance: e.target.value})}
                          placeholder={connectorForm.adobeCampaignProduct === 'v8' ? 'e.g. yourbrand-mkt-prod1.campaign.adobe.com' : 'e.g. yourbrand'}
                          helperText={connectorForm.adobeCampaignProduct === 'v8'
                            ? 'The address of your marketing instance (it ends in .campaign.adobe.com).'
                            : 'The ID in your API address https://mc.adobe.io/<ID>/campaign/.'}
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Client ID"
                          value={connectorForm.adobeCampaignClientId}
                          onChange={(e) => setConnectorForm({...connectorForm, adobeCampaignClientId: e.target.value})}
                          placeholder="Paste the Client ID"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Client Secret"
                          value={connectorForm.adobeCampaignClientSecret}
                          onChange={(e) => setConnectorForm({...connectorForm, adobeCampaignClientSecret: e.target.value})}
                          placeholder="Paste the Client Secret"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Scopes"
                          value={connectorForm.adobeCampaignScopes}
                          onChange={(e) => setConnectorForm({...connectorForm, adobeCampaignScopes: e.target.value})}
                          placeholder="openid,AdobeID,additional_info.projectedProductContext"
                          helperText="Copy the Scopes shown on your credential."
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('adobe_campaign')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.adobeCampaignClientId || !connectorForm.adobeCampaignClientSecret || !connectorForm.adobeCampaignInstance}
                        >
                          Connect Adobe Campaign
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Before you connect:</strong>
                          <br />• In the <strong>Adobe Developer Console</strong> (developer.adobe.com/console), create a project, add the <strong>Adobe Campaign</strong> API and choose <strong>OAuth Server-to-Server</strong>
                          <br />• Pick the product profile of your Campaign instance (a System Admin of your Adobe organization can do this); for Campaign v8 also add the <strong>I/O Management API</strong>
                          <br />• Campaign v8 must be on version 8.5 or later
                          <br />• Open the credential and copy the <strong>Client ID</strong>, <strong>Client Secret</strong> and <strong>Scopes</strong>
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Each connection syncs one Campaign instance and everything the credential is allowed to read.
                          <br />• If your instance only accepts listed IP addresses, ask support for ours and add it in the Adobe Campaign Control Panel.
                          <br />• The first sync loads your full history over several runs; after that, changes are read every day.
                          <br />• We read gently (up to one million log rows and two million profile rows per table each day) so your Campaign stays fast. Very large instances (many millions of log rows, or tens of millions of profiles) need a Campaign workflow export for their full history, which we set up with you separately.
                          <br />• Campaign v8 Enterprise (FFDA) instances are not supported yet.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'walmart_connect' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Walmart Connect reports your <strong>Walmart Sponsored Search</strong> advertising (Sponsored
                        Products, Sponsored Brands, Sponsored Videos). You give <strong>SuperChargeMe</strong> access to your
                        advertiser in the Walmart Connect Ad Center, then enter your <strong>advertiser ID</strong> here.
                        Read-only — we never change your campaigns.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Walmart Connect advertiser</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check with Walmart that SuperChargeMe can read this advertiser before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Advertiser ID"
                          value={connectorForm.walmartConnectAdvertiserId}
                          onChange={(e) => setConnectorForm({...connectorForm, walmartConnectAdvertiserId: e.target.value})}
                          placeholder="e.g. 600001"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('walmart_connect')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.walmartConnectAdvertiserId}
                        >
                          Connect Walmart Connect
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Before you connect:</strong>
                          <br />• Sign in to the <strong>Walmart Connect Ad Center</strong> (advertising.walmart.com) as an admin of the advertiser
                          <br />• Open <strong>Admin</strong> and give the API partner <strong>SuperChargeMe</strong> access to this advertiser (we only read)
                          <br />• Copy your <strong>advertiser ID</strong> (the number shown for the advertiser account) and paste it above
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Data starts syncing once we have confirmed the advertiser belongs to your brand. For a Walmart Marketplace seller this is automatic when the same seller account is connected with the Walmart Marketplace connector on this brand; otherwise our team confirms it.
                          <br />• We sync campaigns, ad groups, keywords, items, bids and budgets, every daily performance report, recommendations and change history. The last 35 days are refreshed every day.
                          <br />• Amounts are in US dollars, as Walmart reports them.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'marketo' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Marketo Engage holds your <strong>people, their activities, programs, emails, landing pages and forms</strong>.
                        Connect it with a <strong>LaunchPoint custom service</strong> of an API-only user. Read-only — we never change your instance.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Marketo REST API</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the credentials against your Marketo instance before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="REST API endpoint"
                          value={connectorForm.marketoEndpoint || ''}
                          onChange={(e) => setConnectorForm({...connectorForm, marketoEndpoint: e.target.value})}
                          placeholder="https://123-ABC-456.mktorest.com/rest"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Client ID"
                          value={connectorForm.marketoClientId || ''}
                          onChange={(e) => setConnectorForm({...connectorForm, marketoClientId: e.target.value})}
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Client Secret"
                          value={connectorForm.marketoClientSecret || ''}
                          onChange={(e) => setConnectorForm({...connectorForm, marketoClientSecret: e.target.value})}
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('marketo')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.marketoEndpoint || !connectorForm.marketoClientId || !connectorForm.marketoClientSecret}
                        >
                          Connect Marketo Engage
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Before you connect:</strong>
                          <br />• In Marketo, open <strong>Admin &gt; Users &amp; Roles</strong> and create an API role with the read-only permissions: Read-Only Lead, Read-Only Activity, Read-Only Activity Metadata, Read-Only Assets, Read-Only Campaign and Read-Only Custom Object (optional as well: Read-Only Company, Read-Only Opportunity, Read-Only Named Account, Read-Only Sales Person, Access User Management Api). Never give it a Read-Write permission
                          <br />• Create an <strong>API-only user</strong> with that role
                          <br />• Open <strong>Admin &gt; LaunchPoint</strong>, choose <strong>New &gt; New Service</strong>, pick <strong>Custom</strong> and that API-only user, then <strong>View Details</strong> to copy the Client ID and Client Secret
                          <br />• Open <strong>Admin &gt; Web Services</strong> and copy the <strong>Endpoint</strong> of the REST API section
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• The first sync reads your whole history with Marketo bulk exports, so it takes several days and uses part of your instance's daily API and bulk export allowance, shared with your other integrations.
                          <br />• Permissions you leave out only skip that data; we tell you which.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'criteo_retail_media' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Criteo Retail Media reports your retailer ad spend and results. Connect it with the
                        <strong> client ID and client secret</strong> of an API app you create in the Criteo Partners Portal.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Criteo API Keys</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the keys against Criteo and read the account they belong to before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Client ID"
                          value={connectorForm.criteoClientId}
                          onChange={(e) => setConnectorForm({...connectorForm, criteoClientId: e.target.value})}
                          placeholder="Paste your Criteo client ID"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Client secret"
                          value={connectorForm.criteoClientSecret}
                          onChange={(e) => setConnectorForm({...connectorForm, criteoClientSecret: e.target.value})}
                          placeholder="Paste your Criteo client secret"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        {(connectorForm.criteoAccountChoices || []).length > 0 && (
                          <TextField
                            select
                            fullWidth
                            label="Criteo account"
                            value={connectorForm.criteoAccountId}
                            onChange={(e) => setConnectorForm({...connectorForm, criteoAccountId: e.target.value})}
                            helperText="These keys reach several Criteo accounts. Pick the one for this brand; connect the others to their own brands with the same keys."
                            size="small"
                            sx={{ mb: 2 }}
                          >
                            {(connectorForm.criteoAccountChoices || []).map(a => (
                              <MenuItem key={a.account_id} value={a.account_id}>
                                {a.name ? `${a.name} (${a.account_id})` : a.account_id}
                              </MenuItem>
                            ))}
                          </TextField>
                        )}
                        <Button
                          onClick={() => handleApiKeyConnect('criteo_retail_media')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.criteoClientId || !connectorForm.criteoClientSecret ||
                            ((connectorForm.criteoAccountChoices || []).length > 0 && !connectorForm.criteoAccountId)}
                        >
                          Connect Criteo Retail Media
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find it:</strong>
                          <br />• Sign in to the <strong>Criteo Partners Portal</strong> (partners.criteo.com) with your Criteo login and create an app: authentication <strong>Client Credentials</strong>, service <strong>Retail Media</strong>, read access to Analytics, Campaigns and Accounts
                          <br />• Click <strong>Create new key</strong> (the secret is only in the downloaded file), then <strong>Generate new URL</strong> and approve your account on that consent page
                          <br />• Each connection syncs one Criteo account. If your keys reach several, we ask which one belongs to this brand
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Read-only — we never change your campaigns.
                          <br />• History starts up to three years back and fills in over the first days; the last 14 days are refreshed every day.
                          <br />• Numbers are in each account's own currency and time zone.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'awin' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Awin reports your affiliate programme&apos;s transactions, commissions and publisher performance.
                        Connect it with the <strong>API token</strong> of a user who has access to your advertiser account.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Awin API Token</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the token against Awin and read the advertiser account it belongs to before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="API token"
                          value={connectorForm.awinApiToken}
                          onChange={(e) => setConnectorForm({...connectorForm, awinApiToken: e.target.value})}
                          placeholder="Paste your Awin API token"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        {(connectorForm.awinAccountChoices || []).length > 0 && (
                          <TextField
                            select
                            fullWidth
                            label="Awin advertiser account"
                            value={connectorForm.awinAccountId}
                            onChange={(e) => setConnectorForm({...connectorForm, awinAccountId: e.target.value})}
                            helperText="This token reaches several advertiser accounts. Pick the one for this brand; connect the others to their own brands with the same token."
                            size="small"
                            sx={{ mb: 2 }}
                          >
                            {(connectorForm.awinAccountChoices || []).map(a => (
                              <MenuItem key={a.account_id} value={a.account_id}>
                                {a.name ? `${a.name} (${a.account_id})` : a.account_id}
                              </MenuItem>
                            ))}
                          </TextField>
                        )}
                        <Button
                          onClick={() => handleApiKeyConnect('awin')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.awinApiToken ||
                            ((connectorForm.awinAccountChoices || []).length > 0 && !connectorForm.awinAccountId)}
                        >
                          Connect Awin
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find it:</strong>
                          <br />• Sign in to Awin with a user who has <strong>Admin</strong> access to your advertiser account (Account &gt; Account Permissions)
                          <br />• Open <strong>ui.awin.com/awin-api</strong> (or <strong>API Credentials</strong> in the user menu, top right), enter your password and click <strong>Show my API token</strong>
                          <br />• The token belongs to your user, so it reaches every Awin account you can open. Each connection syncs one advertiser account; if your token reaches several, we ask which one belongs to this brand
                          <br />• Moved from ShareASale? Your programme now lives on Awin: connect it here
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Read-only — we never approve, decline or change transactions.
                          <br />• Full history fills in over the first days; the last 35 days of transactions and every status change are refreshed every day.
                          <br />• Amounts keep the currency Awin gives with each transaction; days are UTC.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'partnerize' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Partnerize reports your partner programme&apos;s conversions, clicks, commissions and partners.
                        Connect it with the <strong>User application key</strong> and <strong>User API key</strong> of a user of your brand account.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Partnerize API Keys</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the keys against Partnerize and read the brand they belong to before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="User application key"
                          value={connectorForm.partnerizeApplicationKey}
                          onChange={(e) => setConnectorForm({...connectorForm, partnerizeApplicationKey: e.target.value})}
                          placeholder="Paste your User application key"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="User API key"
                          value={connectorForm.partnerizeUserApiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, partnerizeUserApiKey: e.target.value})}
                          placeholder="Paste your User API key"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        {(connectorForm.partnerizeBrandChoices || []).length > 0 && (
                          <TextField
                            select
                            fullWidth
                            label="Partnerize brand"
                            value={connectorForm.partnerizeAdvertiserId}
                            onChange={(e) => setConnectorForm({...connectorForm, partnerizeAdvertiserId: e.target.value})}
                            helperText="These keys reach several Partnerize brands. Pick the one for this brand; connect the others to their own brands with the same keys."
                            size="small"
                            sx={{ mb: 2 }}
                          >
                            {(connectorForm.partnerizeBrandChoices || []).map(b => (
                              <MenuItem key={b.advertiser_id} value={b.advertiser_id}>
                                {b.name ? `${b.name} (${b.advertiser_id})` : b.advertiser_id}
                              </MenuItem>
                            ))}
                          </TextField>
                        )}
                        <Button
                          onClick={() => handleApiKeyConnect('partnerize')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.partnerizeApplicationKey || !connectorForm.partnerizeUserApiKey ||
                            ((connectorForm.partnerizeBrandChoices || []).length > 0 && !connectorForm.partnerizeAdvertiserId)}
                        >
                          Connect Partnerize
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find them:</strong>
                          <br />• Sign in to <strong>console.partnerize.com</strong> with a user of your brand account
                          <br />• Open <strong>Settings → Account settings</strong> and copy the <strong>User application key</strong> and the <strong>User API key</strong>
                          <br />• The keys belong to your user, so they reach every Partnerize brand you can open. Each connection syncs one brand; if your keys reach several, we ask which one belongs to this brand
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Read-only — we never approve, reject or change conversions.
                          <br />• Full history fills in over the first days; recent conversions and every status change are refreshed on each sync.
                          <br />• Amounts keep the currency Partnerize gives with each conversion; days are UTC.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'rakuten_advertising' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Rakuten Advertising reports your affiliate programme&apos;s orders, transactions, publishers, sales and commissions.
                        Connect it with the <strong>Get API</strong> URL of one or more of your reports.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Report API URLs</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We run the first report to confirm your advertiser ID (MID) before saving. The URLs carry your account&apos;s API token, so keep them private.
                        </Typography>
                        <TextField
                          fullWidth
                          multiline
                          minRows={3}
                          label="Get API URLs (one per line)"
                          value={connectorForm.rakutenReportApiTokenUrls}
                          onChange={(e) => setConnectorForm({...connectorForm, rakutenReportApiTokenUrls: e.target.value})}
                          placeholder="https://ran-reporting.rakutenmarketing.com/en/reports/.../filters?...&token=..."
                          size="small"
                          inputProps={{ autoComplete: 'off', spellCheck: false }}
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('rakuten_advertising')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.rakutenReportApiTokenUrls.trim()}
                        >
                          Connect Rakuten Advertising
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find them:</strong>
                          <br />• Sign in to the <strong>Rakuten Advertising Advertiser Dashboard</strong>
                          <br />• Open <strong>Reports → Reporting</strong> and choose a report, for example <strong>Signature Orders</strong> or a report you built. The first report must include the <strong>MID</strong> column
                          <br />• Click the arrow next to <strong>View Report</strong>, choose <strong>Get API</strong> and copy the whole URL. Repeat for every report you want
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Read-only — we only run your reports.
                          <br />• We also add the standard reports your account has, and read each report for transaction and process dates, per network, month by month. Full history fills in over the first days; the last four months are refreshed on each sync.
                          <br />• Amounts keep the currency of the report&apos;s network; we never convert them.
                          <br />• If you update your token in Rakuten, connect again with a new URL.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'business_central' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Business Central reports your customers, vendors, items, sales and purchase documents and your
                        general ledger. We read one company of one environment, with read-only permissions you give our app.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>Business Central Company</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          You sign in with Microsoft so we can confirm the company is yours, then we check that our app can read it. Sign in as a Global Administrator or Dynamics 365 Business Central Administrator: our app reads the whole company, so other accounts are refused.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Environment name"
                          value={connectorForm.bcEnvironmentName}
                          onChange={(e) => setConnectorForm({...connectorForm, bcEnvironmentName: e.target.value})}
                          placeholder="production"
                          helperText="As shown in the Business Central admin center (usually production)"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Company name"
                          value={connectorForm.bcCompanyName}
                          onChange={(e) => setConnectorForm({...connectorForm, bcCompanyName: e.target.value})}
                          placeholder="CRONUS USA, Inc."
                          helperText="Exactly as Business Central shows it"
                          size="small"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={handleBusinessCentralConnect}
                          variant="contained"
                          fullWidth
                          disabled={loading || !connectorForm.bcEnvironmentName || !connectorForm.bcCompanyName}
                          sx={{ mb: 1 }}
                        >
                          Sign in with Microsoft and connect
                        </Button>
                        <Button onClick={handleBusinessCentralConsent} variant="outlined" fullWidth disabled={loading}>
                          Grant admin consent (administrator, once)
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Before you connect (once, by an administrator):</strong>
                          <br />• Click <strong>Grant admin consent</strong> and accept for your organization
                          <br />• In Business Central, open <strong>Microsoft Entra applications</strong>, choose <strong>New</strong>, enter our app&apos;s client ID, set <strong>State</strong> to <strong>Enabled</strong> and add the read-only permission set <strong>D365 BASIC</strong>
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Read-only — our app gets only read permission sets, and we never post or change anything.
                          <br />• Full history fills in over the first runs; changes are picked up on every sync.
                          <br />• Amounts keep the currency Business Central gives; an empty currency means your company&apos;s local currency.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'chatgpt_ads' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        ChatGPT Ads reports your campaign spend and results. Connect it with an
                        <strong> Advertiser API key</strong> for the ad account.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>ChatGPT Ads API Key</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We check the key against ChatGPT Ads and read the ad account it belongs to before saving.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Advertiser API key"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="Paste your ChatGPT Ads Advertiser API key"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('chatgpt_ads')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.apiKey}
                        >
                          Connect ChatGPT Ads
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Where to find it:</strong>
                          <br />• In ChatGPT Ads Manager, open <strong>Settings</strong> and create an Advertiser API key
                          <br />• Each key belongs to one ad account; connect each ad account with its own key
                          <br /><br />
                          <strong>Good to know:</strong>
                          <br />• Read-only — we never change your campaigns.
                          <br />• History starts up to one year back (the most ChatGPT Ads keeps).
                          <br />• We sync daily stats by campaign, ad group and ad, in your ad account's currency and time zone.
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'clarity' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info" sx={{ mb: 2 }}>
                        Microsoft Clarity uses a project API token for secure, read-only access to your behavioural analytics.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
                        <Typography variant="h6" gutterBottom>API Token Authentication</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          Connect using your Clarity Data Export API token. One token maps to one Clarity project.
                        </Typography>
                        <TextField
                          fullWidth
                          label="Clarity API Token"
                          value={connectorForm.apiKey}
                          onChange={(e) => setConnectorForm({...connectorForm, apiKey: e.target.value})}
                          placeholder="Paste your Clarity Data Export API token"
                          size="small"
                          type="password"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('clarity')}
                          variant="contained"
                          fullWidth
                          disabled={!connectorForm.apiKey}
                        >
                          Connect with API Token
                        </Button>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Setup Instructions:</strong>
                          <br />• Open your Microsoft Clarity project (project Admin access required)
                          <br />• Go to Settings → Data Export
                          <br />• Click "Generate new API token" and give it a name
                          <br />• Copy the token and paste it above to connect
                        </Typography>
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="warning">
                        <Typography variant="body2">
                          <strong>What you'll get access to:</strong>
                          <br />• Traffic &amp; sessions (sessions, users, bot traffic, pages/session)
                          <br />• Engagement time &amp; scroll depth
                          <br />• Frustration signals (rage clicks, dead clicks, quick backs, script errors)
                          <br />• Breakdowns by page, country, device, OS, browser, and source/medium
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          <strong>Note:</strong> Clarity provides only the last 1–3 days per pull, so data accumulates daily going forward (no historical backfill).
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {/* Pinterest Configuration */}
                {connectorType === 'pinterest' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <CurrencySelector
                        value={connectorForm.currency || 'USD'}
                        onChange={(currency) => setConnectorForm({...connectorForm, currency})}
                        label="Ad Account Currency"
                        helperText="Select the currency for your Pinterest ad account"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        Connect to Pinterest Business using OAuth to securely access your advertising campaigns, boards, and analytics data.
                        <Button 
                          onClick={() => handleOAuthConnect('pinterest')}
                          sx={{ ml: 1 }} 
                          size="small" 
                          variant="contained"
                        >
                          Connect with OAuth
                        </Button>
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="warning">
                        <Typography variant="body2">
                          <strong>What you'll get access to:</strong>
                          <br />• Pinterest Ads campaigns and performance data
                          <br />• Board and pin analytics
                          <br />• Audience insights and demographics  
                          <br />• Conversion tracking data
                          <br />• Shopping catalog performance
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {/* Google Search Console Configuration */}
                {connectorType === 'google_search_console' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        Connect to Google Search Console using OAuth to securely access your website's search performance data.
                        <Button 
                          onClick={() => handleOAuthConnect('google_search_console')}
                          sx={{ ml: 1 }} 
                          size="small" 
                          variant="contained"
                        >
                          Connect with OAuth
                        </Button>
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="warning">
                        <Typography variant="body2">
                          <strong>What you'll get access to:</strong>
                          <br />• Search performance and ranking data
                          <br />• Click-through rates and impressions
                          <br />• Search queries driving traffic
                          <br />• Website indexing status
                          <br />• Core Web Vitals and page experience metrics
                          <br />• URL inspection and crawl data
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {/* Google Analytics Configuration */}
                {connectorType === 'google_analytics' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        Connect to Google Analytics using OAuth to securely access your website analytics and user behavior data.
                        <Button 
                          onClick={() => handleOAuthConnect('google_analytics')}
                          sx={{ ml: 1 }} 
                          size="small" 
                          variant="contained"
                        >
                          Connect with OAuth
                        </Button>
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="warning">
                        <Typography variant="body2">
                          <strong>What you'll get access to:</strong>
                          <br />• Website traffic and user behavior data
                          <br />• Audience demographics and interests
                          <br />• Conversion goals and e-commerce tracking
                          <br />• Page views, sessions, and bounce rates
                          <br />• Traffic sources and campaign performance
                          <br />• Custom events and enhanced measurement
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {/* Google Merchant Center Configuration */}
                {connectorType === 'google_merchant_center' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        Connect to Google Merchant Center using OAuth to securely access your product listings and e-commerce performance data.
                        <Button 
                          onClick={() => handleOAuthConnect('google_merchant_center')}
                          sx={{ ml: 1 }} 
                          size="small" 
                          variant="contained"
                        >
                          Connect with OAuth
                        </Button>
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="warning">
                        <Typography variant="body2">
                          <strong>What you'll get access to:</strong>
                          <br />• Product listings and inventory data
                          <br />• Shopping campaign performance metrics
                          <br />• Product feed management and status
                          <br />• Multi-country and multi-feed support
                          <br />• Item-level issues and feed diagnostics
                          <br />• Account verification and business details
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {/* Amazon Ads Configuration */}
                {connectorType === 'amazon_ads' && (
                  <Grid container spacing={3}>
                    {/* Connection Method Selector */}
                    <Grid item xs={12}>
                      <FormControl fullWidth>
                        <InputLabel>Connection Method</InputLabel>
                        <Select
                          name="amazonAdsConnectMethod"
                          value={connectorForm.amazonAdsConnectMethod}
                          onChange={handleFormChange}
                          label="Connection Method"
                          sx={{ borderRadius: 2 }}
                        >
                          <MenuItem value="oauth">OAuth (Recommended — sign in with Amazon)</MenuItem>
                          <MenuItem value="manual">Manual (enter your own LWA app credentials)</MenuItem>
                        </Select>
                        <FormHelperText>
                          {connectorForm.amazonAdsConnectMethod === 'manual'
                            ? 'Enter the Client ID, Client Secret, and Refresh Token from your own Login-with-Amazon app'
                            : 'Use the OAuth redirect flow — no credentials to copy'}
                        </FormHelperText>
                      </FormControl>
                    </Grid>

                    {/* Country/Region — shared by both methods */}
                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth required>
                        <InputLabel>Select Country/Region</InputLabel>
                        <Select
                          name="country"
                          value={connectorForm.country}
                          onChange={handleFormChange}
                          label="Select Country/Region"
                        >
                          {getAllCountries().map((country) => (
                            <MenuItem key={country.code} value={country.code}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <span>{country.flag}</span>
                                <span>{country.name}</span>
                                <Chip
                                  label={country.region}
                                  size="small"
                                  variant="outlined"
                                  sx={{ ml: 'auto' }}
                                />
                              </Box>
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>Select your Amazon marketplace region</FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      {/* No currency picker: the backend takes the currency Amazon reports for the
                          advertising profile (else the marketplace's) and ignores a submitted one. */}
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                        Currency is set automatically from your Amazon Ads profile.
                      </Typography>
                    </Grid>

                    {/* Manual (bring-your-own LWA app) fields */}
                    {connectorForm.amazonAdsConnectMethod === 'manual' && (
                      <>
                        <Grid item xs={12}>
                          <Alert severity="info" sx={{ mb: 1 }}>
                            <Typography variant="body2">
                              <strong>How to get your credentials:</strong>
                              <br />1. In the Amazon developer console, open your Login-with-Amazon security profile (with the <code>advertising::campaign_management</code> scope)
                              <br />2. Copy the <strong>Client ID</strong> and <strong>Client Secret</strong>
                              <br />3. Authorize your app and copy the resulting <strong>Refresh Token</strong> (starts with <code>Atzr|</code>)
                            </Typography>
                          </Alert>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            label="Client ID"
                            name="amazonAdsClientId"
                            value={connectorForm.amazonAdsClientId}
                            onChange={handleFormChange}
                            placeholder="amzn1.application-oa2-client...."
                            required
                            helperText="LWA Client ID from your Amazon security profile"
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            label="Client Secret"
                            name="amazonAdsClientSecret"
                            type="password"
                            value={connectorForm.amazonAdsClientSecret}
                            onChange={handleFormChange}
                            placeholder="amzn1.oa2-cs...."
                            required
                            helperText="LWA Client Secret from your Amazon security profile"
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label="Refresh Token"
                            name="amazonAdsRefreshToken"
                            value={connectorForm.amazonAdsRefreshToken}
                            onChange={handleFormChange}
                            placeholder="Atzr|...."
                            required
                            multiline
                            rows={3}
                            helperText="Refresh token generated when you authorized your LWA app"
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Alert severity="warning">
                            <Typography variant="body2">
                              The refresh token must be minted against the Client ID / Secret you entered above — a token from a different app will fail verification.
                            </Typography>
                          </Alert>
                        </Grid>
                      </>
                    )}

                    {/* OAuth flow */}
                    {connectorForm.amazonAdsConnectMethod === 'oauth' && (
                      <Grid item xs={12}>
                        <Alert severity="info">
                          Connect to Amazon Advertising using OAuth to securely access your ad campaigns and performance data.
                          <Button
                            onClick={() => handleOAuthConnect('amazon-ads')}
                            sx={{ ml: 1 }}
                            size="small"
                            variant="contained"
                            disabled={!connectorForm.country}
                          >
                            Connect with OAuth
                          </Button>
                        </Alert>
                      </Grid>
                    )}
                  </Grid>
                )}

                {/* QuickBooks Configuration */}
                {connectorType === 'quickbooks' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <CurrencySelector
                        value={connectorForm.currency || 'USD'}
                        onChange={(currency) => setConnectorForm({...connectorForm, currency})}
                        label="Company Currency"
                        helperText="Select the base currency for your QuickBooks company"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        Connect to QuickBooks Online using OAuth to securely access your accounting data including customers, invoices, and financial reports.
                        <Button 
                          onClick={() => handleOAuthConnect('quickbooks')}
                          sx={{ ml: 1 }} 
                          size="small" 
                          variant="contained"
                        >
                          Connect with OAuth
                        </Button>
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="warning">
                        <Typography variant="body2">
                          <strong>What you'll get access to:</strong>
                          <br />• Customer and vendor information
                          <br />• Sales receipts and invoices
                          <br />• Financial reports and profit/loss statements
                          <br />• Chart of accounts and general ledger
                          <br />• Items, products, and services data
                          <br />• Payment and banking transaction data
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {/* Xero Configuration */}
                {connectorType === 'xero' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <CurrencySelector
                        value={connectorForm.currency || 'USD'}
                        onChange={(currency) => setConnectorForm({...connectorForm, currency})}
                        label="Company Currency"
                        helperText="Select the base currency for your Xero organisation"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        Connect to Xero using OAuth to securely access your accounting data including invoices, bank transactions, contacts, and financial reports.
                        <Button
                          onClick={() => handleOAuthConnect('xero')}
                          sx={{ ml: 1 }}
                          size="small"
                          variant="contained"
                        >
                          Connect with OAuth
                        </Button>
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <Alert severity="warning">
                        <Typography variant="body2">
                          <strong>What you'll get access to:</strong>
                          <br />• Chart of accounts and account balances
                          <br />• Sales and purchase invoices
                          <br />• Bank transactions and reconciliation data
                          <br />• Customer and supplier contacts
                          <br />• Payments and credit notes
                          <br />• Manual journals and tracking categories
                          <br />• Profit & Loss, Balance Sheet, and Trial Balance reports
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {/* Microsoft Ads Configuration */}
                {connectorType === 'microsoft_ads' && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Typography variant="h6" gutterBottom>
                        Choose Authentication Method
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        You can connect to Microsoft Advertising using either OAuth (recommended) or a Developer Token.
                      </Typography>
                    </Grid>

                    {/* OAuth Option */}
                    <Grid item xs={12} md={6}>
                      <Card sx={{ p: 2, height: '100%' }}>
                        <Typography variant="subtitle1" gutterBottom color="primary">
                          OAuth (Recommended)
                        </Typography>
                        <Typography variant="body2" sx={{ mb: 2 }}>
                          Secure authentication through Microsoft's OAuth system. Requires work/school account.
                        </Typography>
                        <Alert severity="warning" sx={{ mb: 2 }}>
                          <Typography variant="caption">
                            <strong>Note:</strong> Personal Microsoft accounts are not supported. You need a work/school account.
                          </Typography>
                        </Alert>
                        <Button 
                          onClick={() => handleOAuthConnect('microsoft-ads')}
                          variant="contained" 
                          fullWidth
                          startIcon={<LoginIcon />}
                        >
                          Connect with OAuth
                        </Button>
                      </Card>
                    </Grid>

                    {/* Developer Token Option */}
                    <Grid item xs={12} md={6}>
                      <Card sx={{ p: 2, height: '100%' }}>
                        <Typography variant="subtitle1" gutterBottom color="secondary">
                          Developer Token
                        </Typography>
                        <Typography variant="body2" sx={{ mb: 2 }}>
                          Use a Microsoft Advertising Developer Token for API access. Simpler setup.
                        </Typography>
                        <TextField
                          fullWidth
                          name="developerToken"
                          label="Developer Token"
                          value={connectorForm.developerToken || ''}
                          onChange={handleFormChange}
                          placeholder="e.g., YOUR_DEVELOPER_TOKEN"
                          sx={{ mb: 2 }}
                          helperText="Enter your 12-20 character developer token"
                        />
                        <TextField
                          fullWidth
                          name="customerId"
                          label="Customer ID (Optional)"
                          value={connectorForm.customerId || ''}
                          onChange={handleFormChange}
                          placeholder="e.g., 123456789"
                          sx={{ mb: 2 }}
                          helperText="Your Microsoft Ads customer ID"
                        />
                        <Button
                          onClick={handleMicrosoftAdsTokenConnect}
                          variant="outlined"
                          fullWidth
                          disabled={!connectorForm.developerToken}
                          startIcon={<SecurityIcon />}
                        >
                          Connect with Developer Token
                        </Button>
                      </Card>
                    </Grid>

                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>What you'll get access to:</strong>
                          <br />• Bing search advertising campaigns
                          <br />• Ad groups and keyword performance
                          <br />• Click, impression, and conversion data
                          <br />• Budget and bid management information
                          <br />• Audience insights and demographics
                          <br />• Microsoft Search Network performance metrics
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {/* ShipStation Configuration */}
                {connectorType === 'shipstation' && (
                  <Grid container spacing={3}>
                    {error && (
                      <Grid item xs={12}>
                        <Alert severity="error" onClose={() => setError('')}>
                          {error}
                        </Alert>
                      </Grid>
                    )}
                    
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2" sx={{ mb: 1 }}>
                          <strong>ShipStation requires manual API credentials</strong>
                          <br />Get your API credentials from ShipStation Settings → API Settings
                        </Typography>
                        <Button
                          href="https://ship.shipstation.com/settings/api"
                          target="_blank"
                          rel="noopener noreferrer"
                          size="small"
                          variant="outlined"
                          sx={{ mt: 1 }}
                        >
                          Get API Credentials
                        </Button>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        name="name"
                        label="Connector Name"
                        value={connectorForm.name || ''}
                        onChange={handleFormChange}
                        placeholder="e.g., ShipStation US"
                        helperText="A descriptive name for this connector"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth required>
                        <InputLabel>Region/Geography</InputLabel>
                        <Select
                          name="region"
                          value={connectorForm.region || ''}
                          onChange={handleFormChange}
                          label="Region/Geography"
                        >
                          <MenuItem value="US">
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <span>🇺🇸</span>
                              <span>United States</span>
                            </Box>
                          </MenuItem>
                          <MenuItem value="UK">
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <span>🇬🇧</span>
                              <span>United Kingdom</span>
                            </Box>
                          </MenuItem>
                          <MenuItem value="EU">
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <span>🇪🇺</span>
                              <span>Europe</span>
                            </Box>
                          </MenuItem>
                          <MenuItem value="APAC">
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <span>🌏</span>
                              <span>Asia Pacific</span>
                            </Box>
                          </MenuItem>
                        </Select>
                        <FormHelperText>Select the geographic region for this ShipStation account</FormHelperText>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        name="accountName"
                        label="Connected Account Name (Optional)"
                        value={connectorForm.accountName || ''}
                        onChange={handleFormChange}
                        placeholder="e.g., Excite Foundry US, EF Europe"
                        helperText="Identifier for this ShipStation account"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Alert severity="info" icon={<InfoIcon />}>
                        <Typography variant="body2">
                          <strong>Company-Level Connector</strong>
                          <br />ShipStation connectors are not associated with specific brands. 
                          This allows all brands under your company to utilize shipping data from this account.
                        </Typography>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        name="apiKey"
                        label="API Key"
                        value={connectorForm.apiKey || ''}
                        onChange={handleFormChange}
                        placeholder="Enter your ShipStation API Key"
                        helperText="Found in ShipStation Settings → API Settings"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        name="apiSecret"
                        label="API Secret"
                        type="password"
                        value={connectorForm.apiSecret || ''}
                        onChange={handleFormChange}
                        placeholder="Enter your ShipStation API Secret"
                        helperText="Keep this secret secure - it grants full API access"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Alert severity="warning">
                        <Typography variant="body2">
                          <strong>What data will be synced:</strong>
                          <br />• Orders and order details
                          <br />• Shipments and tracking information
                          <br />• Products and inventory
                          <br />• Warehouses and locations
                          <br />• Connected stores and marketplaces
                          <br />• Carrier information and rates
                        </Typography>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        variant="contained"
                        onClick={handleShipStationConnect}
                        disabled={loading || !connectorForm.apiKey || !connectorForm.apiSecret || !connectorForm.region}
                        startIcon={loading ? <CircularProgress size={20} /> : <SecurityIcon />}
                      >
                        {loading ? 'Connecting...' : 'Connect ShipStation Account'}
                      </Button>
                    </Grid>
                  </Grid>
                )}

                {/* DHL eCommerce Configuration */}
                {/* Shipping Carrier Configuration (UPS, USPS, FedEx) */}
                {['ups', 'usps', 'fedex'].includes(connectorType) && (
                  <Grid container spacing={3}>
                    {error && (
                      <Grid item xs={12}>
                        <Alert severity="error" onClose={() => setError('')}>
                          {error}
                        </Alert>
                      </Grid>
                    )}

                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>{connectorType === 'fedex' ? 'FedEx' : connectorType.toUpperCase()} uses OAuth 2.0 Client Credentials</strong>
                          <br />
                          {connectorType === 'ups' && 'Create an app at the UPS Developer Portal (developer.ups.com), then enter your Client ID and Client Secret below.'}
                          {connectorType === 'usps' && 'Register at the USPS Developer Portal (developer.usps.com), then enter your Consumer Key and Consumer Secret below.'}
                          {connectorType === 'fedex' && 'Create a project at the FedEx Developer Portal (developer.fedex.com), then enter your API Key (Client ID) and Secret Key below.'}
                        </Typography>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        name="name"
                        label="Connector Name (Optional)"
                        value={connectorForm.name || ''}
                        onChange={handleFormChange}
                        placeholder={`e.g., ${connectorType === 'fedex' ? 'FedEx' : connectorType.toUpperCase()} - Main Account`}
                        helperText="A descriptive name for this connector"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        name="carrierClientId"
                        label={connectorType === 'usps' ? 'Consumer Key (Client ID)' : 'Client ID (API Key)'}
                        value={connectorForm.carrierClientId || ''}
                        onChange={handleFormChange}
                        placeholder="Enter your Client ID"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        name="carrierClientSecret"
                        label={connectorType === 'usps' ? 'Consumer Secret (Client Secret)' : 'Client Secret (Secret Key)'}
                        type="password"
                        value={connectorForm.carrierClientSecret || ''}
                        onChange={handleFormChange}
                        placeholder="Enter your Client Secret"
                      />
                    </Grid>

                    {(connectorType === 'ups' || connectorType === 'fedex') && (
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          required
                          name="carrierAccountNumber"
                          label={`${connectorType === 'fedex' ? 'FedEx' : 'UPS'} Account Number`}
                          value={connectorForm.carrierAccountNumber || ''}
                          onChange={handleFormChange}
                          placeholder={connectorType === 'ups' ? 'e.g., A1B2C3' : 'e.g., 123456789'}
                          helperText={connectorType === 'ups' ? 'Your 6-character UPS shipper account number (not a tracking number)' : 'Your 9-digit FedEx account number'}
                        />
                      </Grid>
                    )}

                    <Grid item xs={12}>
                      <Alert severity="warning">
                        <Typography variant="body2">
                          <strong>What data will be synced:</strong>
                          <br />- Shipment tracking &amp; delivery events
                          {(connectorType === 'ups' || connectorType === 'fedex') && <><br />- For the {connectorType === 'fedex' ? 'FedEx' : 'UPS'} tracking numbers on your ShipStation shipments and Shopify fulfillments</>}
                          {connectorType === 'usps' && <><br />- Rate quotes &amp; shipping costs<br />- Address validations<br />- Service delivery standards<br />- Label creation records<br />- Domestic &amp; international rates</>}
                        </Typography>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        variant="contained"
                        onClick={() => handleShippingCarrierConnect(connectorType)}
                        disabled={loading || !connectorForm.carrierClientId || !connectorForm.carrierClientSecret || ((connectorType === 'ups' || connectorType === 'fedex') && !connectorForm.carrierAccountNumber)}
                        startIcon={loading ? <CircularProgress size={20} /> : <SecurityIcon />}
                      >
                        {loading ? 'Connecting...' : `Connect ${connectorType === 'fedex' ? 'FedEx' : connectorType.toUpperCase()} Account`}
                      </Button>
                    </Grid>
                  </Grid>
                )}

                {connectorType === 'dhl_ecommerce' && (
                  <Grid container spacing={3}>
                    {error && (
                      <Grid item xs={12}>
                        <Alert severity="error" onClose={() => setError('')}>
                          {error}
                        </Alert>
                      </Grid>
                    )}

                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>DHL eCommerce connects via SFTP</strong>
                          <br />DHL drops shipping invoices and tracking status files on their SFTP server.
                          Enter your SFTP credentials and DHL account number below.
                        </Typography>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        name="name"
                        label="Connector Name (Optional)"
                        value={connectorForm.name || ''}
                        onChange={handleFormChange}
                        placeholder="e.g., DHL eCommerce - Excite Inc"
                        helperText="A descriptive name for this connector"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        required
                        name="accountNumber"
                        label="DHL Account Number"
                        value={connectorForm.accountNumber || ''}
                        onChange={handleFormChange}
                        placeholder="e.g., 0005122510"
                        helperText="Your DHL eCommerce account number"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        name="accountName"
                        label="Account Name (Optional)"
                        value={connectorForm.accountName || ''}
                        onChange={handleFormChange}
                        placeholder="e.g., Excite Inc"
                        helperText="Identifier for this DHL account"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Alert severity="info" icon={<InfoIcon />}>
                        <Typography variant="body2">
                          <strong>Company-Level Connector</strong>
                          <br />DHL eCommerce connectors are not associated with specific brands.
                          Shipping costs will be matched to orders across all brands via tracking numbers.
                        </Typography>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        name="sftpUsername"
                        label="SFTP Username"
                        value={connectorForm.sftpUsername || ''}
                        onChange={handleFormChange}
                        placeholder="Enter your DHL SFTP username"
                        helperText="Provided by DHL eCommerce"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        name="sftpPassword"
                        label="SFTP Password"
                        type="password"
                        value={connectorForm.sftpPassword || ''}
                        onChange={handleFormChange}
                        placeholder="Enter your DHL SFTP password"
                        helperText="Keep this secure - it grants access to your DHL SFTP account"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Alert severity="warning">
                        <Typography variant="body2">
                          <strong>What data will be synced:</strong>
                          <br />- Shipping invoices (actual costs, surcharges, taxes, weights)
                          <br />- Ship status / tracking events
                          <br />- Delivery confirmations
                        </Typography>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        variant="contained"
                        onClick={handleDHLConnect}
                        disabled={loading || !connectorForm.sftpUsername || !connectorForm.sftpPassword || !connectorForm.accountNumber}
                        startIcon={loading ? <CircularProgress size={20} /> : <SecurityIcon />}
                      >
                        {loading ? 'Creating...' : 'Connect DHL eCommerce Account'}
                      </Button>
                    </Grid>
                  </Grid>
                )}

                {/* Attentive SFTP Configuration */}
                {connectorType === 'attentive_sftp' && (
                  <Grid container spacing={3}>
                    {error && (
                      <Grid item xs={12}>
                        <Alert severity="error" onClose={() => setError('')}>
                          {error}
                        </Alert>
                      </Grid>
                    )}

                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2">
                          <strong>Attentive SFTP delivers daily CSV data feeds</strong>
                          <br />Attentive drops General Events and Conversions files nightly (~10:00 UTC) on its SFTP server.
                          Enter the SFTP credentials from Attentive UI → Settings → SFTP account management.
                          <br />This is a <strong>per-brand</strong> connector — one SFTP account per Attentive account/region.
                        </Typography>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        name="name"
                        label="Connector Name (Optional)"
                        value={connectorForm.name || ''}
                        onChange={handleFormChange}
                        placeholder="e.g., Attentive SFTP - SkinnyMint US"
                        helperText="A descriptive name for this connector"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Market/Region"
                        name="market"
                        value={connectorForm.market || ''}
                        onChange={handleFormChange}
                        placeholder="e.g., US, UK, AU"
                        helperText="Optional: market/region this Attentive account covers"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <CurrencySelector
                        value={connectorForm.currency}
                        onChange={(value) => setConnectorForm({ ...connectorForm, currency: value })}
                        fullWidth
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        name="sftpHost"
                        label="SFTP Host"
                        value={connectorForm.sftpHost || ''}
                        onChange={handleFormChange}
                        placeholder="sftp.client.attentivemobile.com"
                        helperText="Defaults to sftp.client.attentivemobile.com if left blank"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        name="sftpPath"
                        label="SFTP Folder Path"
                        value={connectorForm.sftpPath || ''}
                        onChange={handleFormChange}
                        placeholder="downloads"
                        helperText="Defaults to 'downloads' if left blank"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        name="sftpUsername"
                        label="SFTP Username"
                        value={connectorForm.sftpUsername || ''}
                        onChange={handleFormChange}
                        placeholder="Enter your Attentive SFTP username"
                        helperText="Provided by Attentive (SFTP account management)"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        name="sftpPassword"
                        label="SFTP Password"
                        type="password"
                        value={connectorForm.sftpPassword || ''}
                        onChange={handleFormChange}
                        placeholder="Enter your Attentive SFTP password"
                        helperText="Keep this secure - it grants access to your Attentive SFTP account"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Alert severity="warning">
                        <Typography variant="body2">
                          <strong>What data will be synced:</strong>
                          <br />- General Events (sends, opt-outs, clicks, opt-ins, purchases)
                          <br />- Conversions (SMS/email-attributed revenue with order &amp; product SKUs)
                          <br />Loaded into attentive.events_sftp / attentive.conversions_sftp; daily at 10:30 UTC.
                        </Typography>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        variant="contained"
                        onClick={handleAttentiveSftpConnect}
                        disabled={loading || !connectorForm.sftpUsername || !connectorForm.sftpPassword || !connectorForm.brandId || connectorForm.brandId === 'company'}
                        startIcon={loading ? <CircularProgress size={20} /> : <SecurityIcon />}
                      >
                        {loading ? 'Creating...' : 'Connect Attentive SFTP Account'}
                      </Button>
                    </Grid>
                  </Grid>
                )}

                {/* CIN7 Omni Configuration */}
                {connectorType === 'cin7_omni' && (
                  <Grid container spacing={3}>
                    {error && (
                      <Grid item xs={12}>
                        <Alert severity="error" onClose={() => setError('')}>
                          {error}
                        </Alert>
                      </Grid>
                    )}

                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2" sx={{ mb: 1 }}>
                          <strong>CIN7 Omni requires API credentials</strong>
                          <br />Get your API credentials from CIN7 Omni Settings → Integrations & API → API v1
                        </Typography>
                        <Button
                          href="https://go.cin7.com/Cloud/Settings/API"
                          target="_blank"
                          rel="noopener noreferrer"
                          size="small"
                          variant="outlined"
                          sx={{ mt: 1 }}
                        >
                          Get API Credentials
                        </Button>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        name="name"
                        label="Connector Name"
                        value={connectorForm.name || ''}
                        onChange={handleFormChange}
                        placeholder="e.g., CIN7 Omni - Main Account"
                        helperText="A descriptive name for this connector"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        required
                        name="cin7Username"
                        label="CIN7 Omni Username"
                        value={connectorForm.cin7Username || ''}
                        onChange={handleFormChange}
                        placeholder="Enter your CIN7 Omni API username"
                        helperText="Your CIN7 Omni API connection username"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        required
                        name="apiKey"
                        label="API Key"
                        type="password"
                        value={connectorForm.apiKey || ''}
                        onChange={handleFormChange}
                        placeholder="Enter your CIN7 Omni API key"
                        helperText="Your unique CIN7 Omni API key (keep this secret)"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Alert severity="warning">
                        <Typography variant="body2">
                          <strong>What data will be synced:</strong>
                          <br />• Products and inventory levels
                          <br />• Sales orders and purchase orders
                          <br />• Stock transfers and adjustments
                          <br />• Warehouses and branches
                          <br />• Customer and supplier information
                          <br />• Bill of materials (BOMs)
                        </Typography>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        variant="contained"
                        onClick={handleCin7OmniConnect}
                        disabled={loading || !connectorForm.cin7Username || !connectorForm.apiKey}
                        startIcon={loading ? <CircularProgress size={20} /> : <SecurityIcon />}
                      >
                        {loading ? 'Connecting...' : 'Connect CIN7 Omni Account'}
                      </Button>
                    </Grid>
                  </Grid>
                )}

                {/* THG Procure Configuration */}
                {connectorType === 'thg_procure' && (
                  <Grid container spacing={3}>
                    {error && (
                      <Grid item xs={12}>
                        <Alert severity="error" onClose={() => setError('')}>
                          {error}
                        </Alert>
                      </Grid>
                    )}

                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2" sx={{ mb: 1 }}>
                          <strong>THG Procure uses your supplier-portal login</strong>
                          <br />Enter the same username and password you use at{' '}
                          <a
                            href="https://supplier.thg-procure.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            supplier.thg-procure.com
                          </a>
                          . The OTP step from the browser flow is NOT required for API access —
                          Keycloak's password grant bypasses it.
                        </Typography>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        name="name"
                        label="Connector Name"
                        value={connectorForm.name || ''}
                        onChange={handleFormChange}
                        placeholder="e.g., THG Procure - Wholesale"
                        helperText="A descriptive name for this connector"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        required
                        name="thgUsername"
                        label="THG Procure Username"
                        value={connectorForm.thgUsername || ''}
                        onChange={handleFormChange}
                        placeholder="e.g., wholesale@yourbrand.com"
                        helperText="Your supplier portal login email"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        required
                        name="thgPassword"
                        label="THG Procure Password"
                        type="password"
                        value={connectorForm.thgPassword || ''}
                        onChange={handleFormChange}
                        placeholder="Your supplier portal password"
                        helperText="Stored encrypted (AES-256-GCM)"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        name="thgTenantCode"
                        label="Tenant Code"
                        value={connectorForm.thgTenantCode || 'THG'}
                        onChange={handleFormChange}
                        placeholder="THG"
                        helperText="Almost always 'THG' — change only if instructed"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <CurrencySelector
                        value={connectorForm.currency || 'GBP'}
                        onChange={(currency) => setConnectorForm({ ...connectorForm, currency })}
                        label="Base Currency"
                        helperText="POs are usually in GBP"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Alert severity="warning">
                        <Typography variant="body2">
                          <strong>What data will be synced:</strong>
                          <br />• Purchase orders (Direct + Indirect workflows) with full headers, line items and statuses
                          <br />• Delivery bookings, ASNs, receipts and invoices linked to each PO
                          <br />• EAN barcodes, ERP product IDs, quantities (requested / confirmed / accepted / receipted) and prices
                          <br />• Buyer contact, legal entity, business unit, stock owner and warehouse details
                        </Typography>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        variant="contained"
                        onClick={handleThgProcureConnect}
                        disabled={loading || !connectorForm.thgUsername || !connectorForm.thgPassword}
                        startIcon={loading ? <CircularProgress size={20} /> : <SecurityIcon />}
                      >
                        {loading ? 'Connecting...' : 'Connect THG Procure Account'}
                      </Button>
                    </Grid>
                  </Grid>
                )}

                {/* Procuros Configuration */}
                {connectorType === 'procuros' && (
                  <Grid container spacing={3}>
                    {error && (
                      <Grid item xs={12}>
                        <Alert severity="error" onClose={() => setError('')}>
                          {error}
                        </Alert>
                      </Grid>
                    )}

                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2" sx={{ mb: 1 }}>
                          <strong>Procuros uses your portal login (email + password)</strong>
                          <br />Enter the same email and password you use at{' '}
                          <a
                            href="https://portal.procuros.io/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            portal.procuros.io
                          </a>
                          . Procuros doesn't issue API keys for supplier accounts — the
                          fetcher re-logs in on every sync via session cookies.
                        </Typography>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        name="name"
                        label="Connector Name"
                        value={connectorForm.name || ''}
                        onChange={handleFormChange}
                        placeholder="e.g., Procuros - Flaconi"
                        helperText="A descriptive name for this connector"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        required
                        name="procurosEmail"
                        label="Procuros Email"
                        type="email"
                        value={connectorForm.procurosEmail || ''}
                        onChange={handleFormChange}
                        placeholder="e.g., finance@yourbrand.com"
                        helperText="Your portal.procuros.io login email"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        required
                        name="procurosPassword"
                        label="Procuros Password"
                        type="password"
                        value={connectorForm.procurosPassword || ''}
                        onChange={handleFormChange}
                        placeholder="Your portal password"
                        helperText="Stored encrypted (AES-256-GCM)"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <CurrencySelector
                        value={connectorForm.currency || 'EUR'}
                        onChange={(currency) => setConnectorForm({ ...connectorForm, currency })}
                        label="Base Currency"
                        helperText="Procuros documents are usually in EUR"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Alert severity="warning">
                        <Typography variant="body2">
                          <strong>What data will be synced (all retailer relationships on your Procuros account):</strong>
                          <br />• Orders, Order Confirmations, Partial Order Confirmations and Order Rejections
                          <br />• Shipping Notices (with carton/pallet transport units)
                          <br />• Invoices (with line-level tax, allowances and charges)
                          <br />• Line items with GTIN/EAN, supplier SKU, buyer SKU, quantities (ordered / confirmed / shipped / invoiced), unit prices and VAT
                          <br />• Buyer / supplier / ship-to / bill-to / bill-from party identities (GLN + VAT)
                        </Typography>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        variant="contained"
                        onClick={handleProcurosConnect}
                        disabled={loading || !connectorForm.procurosEmail || !connectorForm.procurosPassword}
                        startIcon={loading ? <CircularProgress size={20} /> : <SecurityIcon />}
                      >
                        {loading ? 'Connecting...' : 'Connect Procuros Account'}
                      </Button>
                    </Grid>
                  </Grid>
                )}

                {/* NetSuite Configuration */}
                {connectorType === 'netsuite' && (
                  <Grid container spacing={3}>
                    {error && (
                      <Grid item xs={12}>
                        <Alert severity="error" onClose={() => setError('')}>
                          {error}
                        </Alert>
                      </Grid>
                    )}

                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2" sx={{ mb: 1 }}>
                          <strong>NetSuite requires Token-Based Authentication (TBA) credentials</strong>
                          <br />To set up TBA in NetSuite:
                          <br />1. Enable TBA: Setup → Company → Enable Features → SuiteCloud → check "Token-Based Authentication"
                          <br />2. Create Integration Record: Setup → Integration → Manage Integrations → New → check "Token-Based Authentication" → Save → copy Consumer Key &amp; Secret
                          <br />3. Create Access Token: Setup → Users/Roles → Access Tokens → New → select Integration, User, Role → Save → copy Token ID &amp; Secret
                          <br />4. Required role permissions: REST Web Services (Full), Log in using Access Tokens (Full), SuiteAnalytics Workbook (Edit)
                        </Typography>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        name="name"
                        label="Connector Name"
                        value={connectorForm.name || ''}
                        onChange={handleFormChange}
                        placeholder="e.g., NetSuite - My Company"
                        helperText="A descriptive name for this connector"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        required
                        name="netsuiteAccountId"
                        label="NetSuite Account ID"
                        value={connectorForm.netsuiteAccountId || ''}
                        onChange={handleFormChange}
                        placeholder="e.g., 1234567 or TSTDRV1234567"
                        helperText="Found at Setup → Company → Company Information"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <CurrencySelector
                        value={connectorForm.currency || 'USD'}
                        onChange={(currency) => setConnectorForm({...connectorForm, currency})}
                        label="Base Currency"
                        helperText="Select the base currency for this NetSuite account"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        required
                        name="netsuiteConsumerKey"
                        label="Consumer Key"
                        type="password"
                        value={connectorForm.netsuiteConsumerKey || ''}
                        onChange={handleFormChange}
                        placeholder="From Integration Record"
                        helperText="Generated when saving the Integration Record"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        required
                        name="netsuiteConsumerSecret"
                        label="Consumer Secret"
                        type="password"
                        value={connectorForm.netsuiteConsumerSecret || ''}
                        onChange={handleFormChange}
                        placeholder="From Integration Record"
                        helperText="Shown only once when Integration Record is created"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        required
                        name="netsuiteTokenId"
                        label="Token ID"
                        type="password"
                        value={connectorForm.netsuiteTokenId || ''}
                        onChange={handleFormChange}
                        placeholder="From Access Token"
                        helperText="Generated when creating the Access Token"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        required
                        name="netsuiteTokenSecret"
                        label="Token Secret"
                        type="password"
                        value={connectorForm.netsuiteTokenSecret || ''}
                        onChange={handleFormChange}
                        placeholder="From Access Token"
                        helperText="Shown only once when Access Token is created"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Alert severity="warning">
                        <Typography variant="body2">
                          <strong>What data will be synced:</strong>
                          <br />• Chart of Accounts (GL accounts)
                          <br />• General Ledger transactions (debits &amp; credits)
                          <br />• Subsidiaries (OneWorld accounts)
                          <br />• Customers and Vendors
                        </Typography>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        variant="contained"
                        onClick={handleNetSuiteConnect}
                        disabled={loading || !connectorForm.netsuiteAccountId || !connectorForm.netsuiteConsumerKey || !connectorForm.netsuiteConsumerSecret || !connectorForm.netsuiteTokenId || !connectorForm.netsuiteTokenSecret}
                        startIcon={loading ? <CircularProgress size={20} /> : <SecurityIcon />}
                      >
                        {loading ? 'Connecting...' : 'Connect NetSuite Account'}
                      </Button>
                    </Grid>
                  </Grid>
                )}

                {/* Revolut Business Configuration */}
                {connectorType === 'revolut' && (
                  <Grid container spacing={3}>
                    {error && (
                      <Grid item xs={12}>
                        <Alert severity="error" onClose={() => setError('')}>
                          {error}
                        </Alert>
                      </Grid>
                    )}

                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2" sx={{ mb: 1 }}>
                          <strong>Revolut Business API requires certificate setup</strong>
                          <br />You need to set up API access in your Revolut Business account first:
                          <br />1. Go to Settings → APIs → Business API in your Revolut Business app
                          <br />2. Generate a certificate pair (public/private key)
                          <br />3. Upload the public certificate and get your Client ID
                          <br />4. Keep your private key safe - you'll need it below
                        </Typography>
                        <Button
                          href="https://developer.revolut.com/docs/guides/manage-accounts/get-started/make-your-first-api-request"
                          target="_blank"
                          rel="noopener noreferrer"
                          size="small"
                          variant="outlined"
                          sx={{ mt: 1 }}
                        >
                          View Setup Guide
                        </Button>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        name="name"
                        label="Connector Name"
                        value={connectorForm.name || ''}
                        onChange={handleFormChange}
                        placeholder="e.g., Revolut Business - Main Account"
                        helperText="A descriptive name for this connector"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        name="revolutClientId"
                        label="Revolut Client ID"
                        value={connectorForm.revolutClientId || ''}
                        onChange={handleFormChange}
                        placeholder="Enter your Revolut Client ID"
                        helperText="Found in your Revolut Business API settings after uploading your certificate"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        multiline
                        rows={6}
                        name="revolutPrivateKey"
                        label="Private Key (PEM format)"
                        value={connectorForm.revolutPrivateKey || ''}
                        onChange={handleFormChange}
                        placeholder="-----BEGIN PRIVATE KEY-----
...your private key content...
-----END PRIVATE KEY-----"
                        helperText="Your private key from the certificate pair. Keep this secret!"
                        sx={{ fontFamily: 'monospace' }}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth>
                        <InputLabel>API Scopes</InputLabel>
                        <Select
                          name="revolutScopes"
                          value={connectorForm.revolutScopes || 'READ'}
                          onChange={handleFormChange}
                          label="API Scopes"
                        >
                          <MenuItem value="READ">READ - View accounts and transactions only</MenuItem>
                          <MenuItem value="READ,WRITE">READ,WRITE - View and manage counterparties</MenuItem>
                          <MenuItem value="READ,WRITE,PAY">READ,WRITE,PAY - Full access including payments</MenuItem>
                        </Select>
                        <FormHelperText>Select the permission level for this connection</FormHelperText>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth>
                        <InputLabel>Environment</InputLabel>
                        <Select
                          name="revolutUseSandbox"
                          value={connectorForm.revolutUseSandbox || false}
                          onChange={handleFormChange}
                          label="Environment"
                        >
                          <MenuItem value={false}>Production</MenuItem>
                          <MenuItem value={true}>Sandbox (Testing)</MenuItem>
                        </Select>
                        <FormHelperText>Use sandbox for testing before connecting production account</FormHelperText>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                      <Alert severity="warning">
                        <Typography variant="body2">
                          <strong>What data will be synced:</strong>
                          <br />• Account balances and details
                          <br />• Transaction history (card payments, transfers, exchanges)
                          <br />• Counterparty information (with WRITE scope)
                          <br />• Payment and exchange data
                        </Typography>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <Alert severity="error" icon={<SecurityIcon />}>
                        <Typography variant="body2">
                          <strong>Security Notice:</strong> Your private key will be stored securely to sign API requests.
                          Never share your private key with anyone. We recommend using READ-only scope unless you need
                          payment capabilities.
                        </Typography>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        variant="contained"
                        onClick={() => handleOAuthConnect('revolut')}
                        disabled={loading || !connectorForm.revolutClientId || !connectorForm.revolutPrivateKey}
                        startIcon={loading ? <CircularProgress size={20} /> : <SecurityIcon />}
                      >
                        {loading ? 'Connecting...' : 'Connect Revolut Business Account'}
                      </Button>
                    </Grid>
                  </Grid>
                )}

                {/* Wise (TransferWise) Configuration */}
                {connectorType === 'wise' && (
                  <Grid container spacing={3}>
                    {error && (
                      <Grid item xs={12}>
                        <Alert severity="error" onClose={() => setError('')}>
                          {error}
                        </Alert>
                      </Grid>
                    )}

                    {/* Currency Selector */}
                    <Grid item xs={12} md={6}>
                      <CurrencySelector
                        value={connectorForm.currency || 'USD'}
                        onChange={(currency) => {
                          console.log('Currency selected:', currency);
                          setConnectorForm(prev => ({...prev, currency}));
                        }}
                        label="Base Currency"
                        helperText="Select your primary currency"
                      />
                    </Grid>

                    {/* Personal API Token Configuration */}
                    <Grid item xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 3 }}>
                        <Typography variant="h6" gutterBottom>
                          Personal API Token Authentication
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                          Connect your Wise Business account using a Personal API Token. Tokens don't expire and provide secure access to your data.
                        </Typography>
                        <TextField
                          fullWidth
                          label="API Token"
                          name="wiseApiToken"
                          value={connectorForm.wiseApiToken || ''}
                          onChange={handleFormChange}
                          placeholder="Enter your Wise API token"
                          type="password"
                          sx={{ mb: 2 }}
                          required
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="wiseSandbox"
                              checked={connectorForm.wiseSandbox || false}
                              onChange={handleFormChange}
                            />
                          }
                          label="Use Sandbox Environment"
                          sx={{ mb: 2 }}
                        />
                        <Button
                          onClick={() => handleApiKeyConnect('wise')}
                          variant="contained"
                          size="large"
                          disabled={!connectorForm.wiseApiToken || loading}
                        >
                          {loading ? 'Connecting...' : 'Connect Wise'}
                        </Button>
                      </Card>
                    </Grid>

                    {/* Instructions */}
                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                          How to get your Personal API Token:
                        </Typography>
                        <Typography variant="body2" component="div">
                          1. Log into your <strong>Wise Business</strong> account<br />
                          2. Go to <strong>Settings → Integrations and Tools → API tokens</strong><br />
                          3. Click <strong>"Add new Token"</strong> (requires 2-step verification)<br />
                          4. Give it a name (e.g., "SuperChargeMe Integration")<br />
                          5. Copy the token and paste it above<br />
                          <br />
                          <em>Note: Personal accounts are not supported. You need a Wise Business account.</em>
                        </Typography>
                      </Alert>
                    </Grid>

                    {/* What will be synced */}
                    <Grid item xs={12}>
                      <Alert severity="success">
                        <Typography variant="body2">
                          <strong>What data will be synced:</strong><br />
                          • Multi-currency account balances<br />
                          • Transaction history (transfers, conversions, payments)<br />
                          • Recipient/payee information<br />
                          • Exchange rates and fees<br />
                          • International transfer details
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {/* PayPal Business Configuration */}
                {connectorType === 'paypal' && (
                  <Grid container spacing={3}>
                    {error && (
                      <Grid item xs={12}>
                        <Alert severity="error" onClose={() => setError('')}>
                          {error}
                        </Alert>
                      </Grid>
                    )}

                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2" sx={{ mb: 1 }}>
                          <strong>Connect your PayPal Business account</strong>
                          <br />Use your PayPal REST API credentials to access transaction history.
                        </Typography>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                          How to get your PayPal API credentials:
                        </Typography>
                        <Typography variant="body2" component="div">
                          1. Log into <strong>PayPal Developer Dashboard</strong> (developer.paypal.com)<br />
                          2. Go to <strong>Apps & Credentials</strong><br />
                          3. Create or select an app (choose <strong>Merchant</strong> integration)<br />
                          4. Enable <strong>Transaction Search</strong> permission (takes up to 9 hours to activate)<br />
                          5. Copy the <strong>Client ID</strong> and <strong>Secret</strong> below<br />
                          <br />
                          <em>Note: Each PayPal Business account needs its own app credentials.</em>
                        </Typography>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Client ID"
                        name="paypalClientId"
                        value={connectorForm.paypalClientId || ''}
                        onChange={handleFormChange}
                        placeholder="ARhS-60gI7wE6mpKbKiaEdEJgA..."
                        required
                        helperText="Your PayPal app Client ID"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Client Secret"
                        name="paypalClientSecret"
                        value={connectorForm.paypalClientSecret || ''}
                        onChange={handleFormChange}
                        placeholder="EJqMcuzipgXYBUwyKrdYMK0..."
                        type="password"
                        required
                        helperText="Your PayPal app Client Secret"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="paypalSandbox"
                            checked={connectorForm.paypalSandbox || false}
                            onChange={handleFormChange}
                          />
                        }
                        label="Use Sandbox Environment (for testing)"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Alert severity="warning">
                        <Typography variant="body2">
                          <strong>Important:</strong> Ensure Transaction Search permission is enabled in your app settings.
                          It can take up to 9 hours to activate after enabling.
                        </Typography>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <Button
                        onClick={() => handleApiKeyConnect('paypal')}
                        variant="contained"
                        fullWidth
                        disabled={!connectorForm.paypalClientId || !connectorForm.paypalClientSecret || loading}
                        startIcon={loading ? <CircularProgress size={20} /> : null}
                      >
                        {loading ? 'Connecting...' : 'Connect PayPal Business'}
                      </Button>
                    </Grid>

                    <Grid item xs={12}>
                      <Alert severity="success">
                        <Typography variant="body2">
                          <strong>What data will be synced:</strong><br />
                          • Transaction history (payments, refunds, fees)<br />
                          • Payer and payee information<br />
                          • Transaction amounts and currencies<br />
                          • Fee details and net amounts<br />
                          • Transaction status and dates<br />
                          • Up to 3 years of historical transactions
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {/* Twilio Configuration */}
                {connectorType === 'twilio' && (
                  <Grid container spacing={3}>
                    {error && (
                      <Grid item xs={12}>
                        <Alert severity="error" onClose={() => setError('')}>
                          {error}
                        </Alert>
                      </Grid>
                    )}

                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2" sx={{ mb: 1 }}>
                          <strong>Connect your Twilio account</strong>
                          <br />Use your Twilio Account SID and Auth Token to access call and SMS data.
                        </Typography>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                          How to get your Twilio credentials:
                        </Typography>
                        <Typography variant="body2" component="div">
                          1. Log into <strong>Twilio Console</strong> (console.twilio.com)<br />
                          2. Your <strong>Account SID</strong> and <strong>Auth Token</strong> are on the dashboard<br />
                          3. Click the eye icon to reveal your Auth Token<br />
                          4. Copy both values below
                        </Typography>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Account SID"
                        name="twilioAccountSid"
                        value={connectorForm.twilioAccountSid || ''}
                        onChange={handleFormChange}
                        placeholder="ACxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
                        required
                        helperText="Your Twilio Account SID (starts with AC)"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Auth Token"
                        name="twilioAuthToken"
                        value={connectorForm.twilioAuthToken || ''}
                        onChange={handleFormChange}
                        placeholder="Your auth token..."
                        type="password"
                        required
                        helperText="Your Twilio Auth Token"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Button
                        onClick={() => handleApiKeyConnect('twilio')}
                        variant="contained"
                        fullWidth
                        disabled={!connectorForm.twilioAccountSid || !connectorForm.twilioAuthToken || loading}
                        startIcon={loading ? <CircularProgress size={20} /> : null}
                      >
                        {loading ? 'Connecting...' : 'Connect Twilio'}
                      </Button>
                    </Grid>

                    <Grid item xs={12}>
                      <Alert severity="success">
                        <Typography variant="body2">
                          <strong>What data will be synced:</strong><br />
                          • Call logs (inbound, outbound, missed)<br />
                          • SMS/MMS messages<br />
                          • Phone numbers and capabilities<br />
                          • Call duration and status<br />
                          • Message delivery status
                        </Typography>
                      </Alert>
                    </Grid>
                  </Grid>
                )}

                {/* ShipHero Configuration */}
                {connectorType === 'shiphero' && (
                  <Grid container spacing={3}>
                    {error && (
                      <Grid item xs={12}>
                        <Alert severity="error" onClose={() => setError('')}>
                          {error}
                        </Alert>
                      </Grid>
                    )}

                    <Grid item xs={12}>
                      <Alert severity="info">
                        <Typography variant="body2" sx={{ mb: 1 }}>
                          <strong>ShipHero API requires developer tokens</strong>
                          <br />Get your tokens from ShipHero dashboard:
                          <br />1. Go to My Account → Developer Users in ShipHero
                          <br />2. Click "Add a 3rd Party Developer"
                          <br />3. Copy the Access Token and Refresh Token
                          <br />4. The Access Token expires after 28 days but auto-refreshes
                        </Typography>
                        <Button
                          href="https://developer.shiphero.com/getting-started/"
                          target="_blank"
                          rel="noopener noreferrer"
                          size="small"
                          variant="outlined"
                          sx={{ mt: 1 }}
                        >
                          View Setup Guide
                        </Button>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        name="name"
                        label="Connector Name"
                        value={connectorForm.name || ''}
                        onChange={handleFormChange}
                        placeholder="e.g., ShipHero - AU Warehouse"
                        helperText="A descriptive name for this connector"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        name="shipheroAccessToken"
                        label="Access Token"
                        value={connectorForm.shipheroAccessToken || ''}
                        onChange={handleFormChange}
                        placeholder="Enter your ShipHero Access Token"
                        helperText="The Bearer token from ShipHero Developer Users page"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        name="shipheroRefreshToken"
                        label="Refresh Token"
                        value={connectorForm.shipheroRefreshToken || ''}
                        onChange={handleFormChange}
                        placeholder="Enter your ShipHero Refresh Token"
                        helperText="Used to automatically refresh the access token when it expires"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        name="shipheroShopName"
                        label="Shop Name (Optional)"
                        value={connectorForm.shipheroShopName || ''}
                        onChange={handleFormChange}
                        placeholder="e.g., au-sandandsky.myshopify.com"
                        helperText="Filter orders to a specific shop (leave empty for all shops)"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Alert severity="warning">
                        <Typography variant="body2">
                          <strong>What data will be synced:</strong>
                          <br />• Products and SKU catalog
                          <br />• Warehouse inventory levels
                          <br />• Orders and line items
                          <br />• Shipments and tracking info
                          <br />• Returns and RMAs
                        </Typography>
                      </Alert>
                    </Grid>

                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        variant="contained"
                        onClick={handleShipHeroConnect}
                        disabled={loading || !connectorForm.shipheroAccessToken || !connectorForm.shipheroRefreshToken}
                        startIcon={loading ? <CircularProgress size={20} /> : <SecurityIcon />}
                      >
                        {loading ? 'Connecting...' : 'Connect ShipHero Account'}
                      </Button>
                    </Grid>
                  </Grid>
                )}
              </Box>
            )}

            {/* Step 3: Confirmation */}
            {activeStep === 2 && (
              <Box>
                <Typography variant="h6" gutterBottom>
                  Confirmation
                </Typography>
                <Typography variant="body2" sx={{ mb: 3 }}>
                  Please review the connector details below before creating it.
                </Typography>
                
                <Paper 
                  elevation={0}
                  sx={{ 
                    p: 3, 
                    borderRadius: 2, 
                    bgcolor: 'background.default',
                    mb: 3
                  }}
                >
                  <Typography variant="subtitle1" gutterBottom>
                    <strong>Connector Name:</strong> {connectorForm.name}
                  </Typography>
                  <Typography variant="subtitle1" gutterBottom>
                    <strong>Brand:</strong> {brands.find(b => b.id === connectorForm.brandId)?.name || 'Unknown'}
                  </Typography>
                  <Typography variant="subtitle1" gutterBottom>
                    <strong>Type:</strong> {getPlatformDisplayName(connectorType || 'unknown')}
                  </Typography>
                  
                  <Divider sx={{ my: 2 }} />
                  
                  {/* Shopify Specific Details */}
                  {connectorType === 'shopify' && (
                    <>
                      <Typography variant="subtitle1" gutterBottom>
                        <strong>Shop Domain:</strong> {connectorForm.shopDomain}
                      </Typography>
                      {connectorForm.market && (
                        <Typography variant="subtitle1" gutterBottom>
                          <strong>Market:</strong> {connectorForm.market}
                        </Typography>
                      )}
                      {connectorForm.currency && (
                        <Typography variant="subtitle1" gutterBottom>
                          <strong>Currency:</strong> {connectorForm.currency}
                        </Typography>
                      )}
                    </>
                  )}

                  {/* TikTok Shop — region picker (US is a separate app/portal). Default Global. */}
                  {connectorType === 'tiktok_shop' && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                      <FormControl sx={{ minWidth: 280 }} size="small">
                        <InputLabel id="tiktok-shop-region-label">TikTok Shop Region</InputLabel>
                        <Select
                          labelId="tiktok-shop-region-label"
                          id="tiktok-shop-region"
                          label="TikTok Shop Region"
                          value={connectorForm.tiktokShopRegion || 'GLOBAL'}
                          onChange={(e) => setConnectorForm(prev => ({ ...prev, tiktokShopRegion: e.target.value }))}
                        >
                          <MenuItem value="GLOBAL">Global (UK / EU / SEA)</MenuItem>
                          {tiktokShopUsAllowed && <MenuItem value="US">United States</MenuItem>}
                          {tiktokShopEuAllowed && <MenuItem value="EU">Europe (own app — e.g. France)</MenuItem>}
                        </Select>
                      </FormControl>
                    </Box>
                  )}

                  {/* Primary action — centered in card, replaces the per-platform Authentication line */}
                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                    <Button
                      variant="contained"
                      size="large"
                      onClick={handleCreateConnector}
                      startIcon={(isOAuthPlatform(connectorType) && !(connectorType === 'shopify' && (connectorForm.shopifyConnectMethod === 'manual' || connectorForm.shopifyConnectMethod === 'client_credentials')) && !(connectorType === 'amazon' && connectorForm.amazonConnectMethod === 'manual') && !(connectorType === 'amazon_ads' && connectorForm.amazonAdsConnectMethod === 'manual')) ? <SecurityIcon /> : <CheckIcon />}
                      sx={{
                        borderRadius: 2,
                        textTransform: 'none',
                        px: 4,
                        py: 1.25,
                        fontSize: '0.95rem',
                        fontWeight: 600,
                        boxShadow: 'none',
                        background: 'linear-gradient(45deg, var(--color-primary) 30%, var(--color-accent) 90%)',
                        '&:hover': { boxShadow: 1 },
                      }}
                    >
                      {(connectorType === 'shopify' && (connectorForm.shopifyConnectMethod === 'manual' || connectorForm.shopifyConnectMethod === 'client_credentials'))
                        ? 'Connect Store'
                        : (connectorType === 'amazon' && connectorForm.amazonConnectMethod === 'manual')
                          ? 'Connect Store'
                          : (connectorType === 'amazon_ads' && connectorForm.amazonAdsConnectMethod === 'manual')
                            ? 'Connect Amazon Ads'
                            : isOAuthPlatform(connectorType)
                              ? 'Connect with OAuth'
                              : 'Create Connector'}
                    </Button>
                  </Box>
                </Paper>

                {/* Facebook — What happens when you connect */}
                {connectorType === 'facebook' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
                    <Box
                      onClick={() => setShowFacebookGuide(!showFacebookGuide)}
                      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, cursor: 'pointer', bgcolor: 'action.hover', '&:hover': { bgcolor: 'action.selected' } }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IntegrationInstructionsIcon fontSize="small" color="primary" />
                        <Typography variant="subtitle2" fontWeight={600}>What happens when you connect</Typography>
                      </Box>
                      {showFacebookGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                    <Collapse in={showFacebookGuide}>
                      <Box sx={{ px: 2.5, py: 2 }}>
                        {/* Prerequisites */}
                        <Alert severity="warning" sx={{ mb: 2.5, borderRadius: 1.5 }}>
                          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>Before you connect</Typography>
                          <Typography variant="body2" color="text.secondary">
                            You need <strong>admin access</strong> to the Meta Ad Account you want to connect. If you manage ads through a Business Manager, make sure your account has the <strong>Ad Account Admin</strong> role.
                          </Typography>
                        </Alert>

                        {/* OAuth Flow Steps */}
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>
                          Connection Flow
                        </Typography>

                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>1</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Sign in with Facebook</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>You'll be redirected to Facebook to log in and authorize the connection.</Typography>
                          </Box>
                        </Box>

                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>2</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Grant permissions</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Meta will ask you to approve the permissions listed below.</Typography>
                          </Box>
                        </Box>

                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>3</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Select your ad account</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>After authorization, you'll choose which ad account to connect from the accounts you have access to.</Typography>
                          </Box>
                        </Box>

                        <Divider sx={{ my: 2 }} />

                        {/* Permissions */}
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>
                          Permissions Requested
                        </Typography>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="ads_read" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read your ad campaigns, ad sets, and ads</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="ads_management" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Manage ads and access performance insights</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="business_management" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Access Business Manager ad accounts and pages</Typography>
                        </Box>

                        <Alert severity="info" sx={{ mt: 2, borderRadius: 1.5 }}>
                          <Typography variant="body2">
                            Your access token is securely stored and auto-refreshes. You won't need to reconnect unless you revoke access from Meta.
                          </Typography>
                        </Alert>
                      </Box>
                    </Collapse>
                  </Paper>
                )}

                {/* Google Ads — What happens when you connect */}
                {connectorType === 'google_ads' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
                    <Box onClick={() => setShowConnectorGuide(!showConnectorGuide)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, cursor: 'pointer', bgcolor: 'action.hover', '&:hover': { bgcolor: 'action.selected' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IntegrationInstructionsIcon fontSize="small" color="primary" />
                        <Typography variant="subtitle2" fontWeight={600}>What happens when you connect</Typography>
                      </Box>
                      {showConnectorGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                    <Collapse in={showConnectorGuide}>
                      <Box sx={{ px: 2.5, py: 2 }}>
                        <Alert severity="warning" sx={{ mb: 2.5, borderRadius: 1.5 }}>
                          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>Before you connect</Typography>
                          <Typography variant="body2" color="text.secondary">
                            You need access to the Google Ads account you want to connect. If you use a <strong>Manager Account (MCC)</strong>, you can connect all client accounts underneath it.
                          </Typography>
                        </Alert>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Connection Flow</Typography>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>1</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Sign in with Google</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>You'll be redirected to Google to log in and authorize access.</Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>2</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Grant permissions</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Google will ask you to approve access to your Google Ads data.</Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>3</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Select your ad account</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Choose which Google Ads account (or MCC sub-account) to connect.</Typography>
                          </Box>
                        </Box>
                        <Divider sx={{ my: 2 }} />
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Permissions Requested</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="adwords" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read and manage your Google Ads campaigns, ad groups, and performance data</Typography>
                        </Box>
                        <Alert severity="info" sx={{ mt: 2, borderRadius: 1.5 }}>
                          <Typography variant="body2">Your tokens are securely stored and auto-refresh. You won't need to reconnect unless you revoke access.</Typography>
                        </Alert>
                      </Box>
                    </Collapse>
                  </Paper>
                )}

                {/* TikTok — What happens when you connect */}
                {connectorType === 'tiktok' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
                    <Box onClick={() => setShowConnectorGuide(!showConnectorGuide)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, cursor: 'pointer', bgcolor: 'action.hover', '&:hover': { bgcolor: 'action.selected' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IntegrationInstructionsIcon fontSize="small" color="primary" />
                        <Typography variant="subtitle2" fontWeight={600}>What happens when you connect</Typography>
                      </Box>
                      {showConnectorGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                    <Collapse in={showConnectorGuide}>
                      <Box sx={{ px: 2.5, py: 2 }}>
                        <Alert severity="warning" sx={{ mb: 2.5, borderRadius: 1.5 }}>
                          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>Before you connect</Typography>
                          <Typography variant="body2" color="text.secondary">
                            You need access to a <strong>TikTok For Business</strong> account with advertiser accounts. On the authorization screen, select <strong>ALL advertiser accounts</strong> AND <strong>ALL TikTok Accounts</strong> to enable both paid and organic data.
                          </Typography>
                        </Alert>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Connection Flow</Typography>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>1</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Sign in with TikTok</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>You'll be redirected to TikTok Business to log in and authorize the connection.</Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>2</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Select accounts & grant permissions</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Select all advertiser accounts and TikTok profiles you want to connect.</Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>3</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Choose your advertiser</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>After authorization, select which advertiser account to connect for ad data import.</Typography>
                          </Box>
                        </Box>
                        <Divider sx={{ my: 2 }} />
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Data We'll Import</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="Campaigns" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Campaign, ad group, and ad performance data</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="Creatives" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Ad creative details and thumbnails</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="Audience" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Audience demographics and targeting data</Typography>
                        </Box>
                        <Alert severity="info" sx={{ mt: 2, borderRadius: 1.5 }}>
                          <Typography variant="body2">Permissions are configured in the TikTok Developer Portal. Your tokens are securely stored and auto-refresh.</Typography>
                        </Alert>
                      </Box>
                    </Collapse>
                  </Paper>
                )}

                {/* Pinterest — What happens when you connect */}
                {connectorType === 'pinterest' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
                    <Box onClick={() => setShowConnectorGuide(!showConnectorGuide)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, cursor: 'pointer', bgcolor: 'action.hover', '&:hover': { bgcolor: 'action.selected' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IntegrationInstructionsIcon fontSize="small" color="primary" />
                        <Typography variant="subtitle2" fontWeight={600}>What happens when you connect</Typography>
                      </Box>
                      {showConnectorGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                    <Collapse in={showConnectorGuide}>
                      <Box sx={{ px: 2.5, py: 2 }}>
                        <Alert severity="warning" sx={{ mb: 2.5, borderRadius: 1.5 }}>
                          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>Before you connect</Typography>
                          <Typography variant="body2" color="text.secondary">
                            You need a <strong>Pinterest Business account</strong> with access to the ad account you want to connect.
                          </Typography>
                        </Alert>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Connection Flow</Typography>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>1</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Sign in with Pinterest</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>You'll be redirected to Pinterest to log in and authorize access.</Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>2</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Grant permissions</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Pinterest will ask you to approve access to your ads, pins, and analytics data.</Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>3</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Select your ad account</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Choose which Pinterest ad account to connect for data import.</Typography>
                          </Box>
                        </Box>
                        <Divider sx={{ my: 2 }} />
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Read Permissions</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="ads:read" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read ad performance data</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="campaigns:read" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read campaign details</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="ad_groups:read" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read ad group configuration</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="analytics:read" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read analytics and reporting data</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="pins:read" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read pins and secret pins</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="boards:read" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read board details</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="user_accounts:read" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read account profile info</Typography>
                        </Box>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mt: 1.5, mb: 1, display: 'block' }}>Write Permissions</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="ads:write" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Manage ads on your behalf</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="campaigns:write" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Manage campaign settings</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="ad_groups:write" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Manage ad group settings</Typography>
                        </Box>
                        <Alert severity="info" sx={{ mt: 2, borderRadius: 1.5 }}>
                          <Typography variant="body2">Your tokens are securely stored with continuous refresh (non-expiring). You won't need to reconnect unless you revoke access.</Typography>
                        </Alert>
                      </Box>
                    </Collapse>
                  </Paper>
                )}

                {/* Square — What happens when you connect */}
                {connectorType === 'square' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
                    <Box onClick={() => setShowConnectorGuide(!showConnectorGuide)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, cursor: 'pointer', bgcolor: 'action.hover', '&:hover': { bgcolor: 'action.selected' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IntegrationInstructionsIcon fontSize="small" color="primary" />
                        <Typography variant="subtitle2" fontWeight={600}>What happens when you connect</Typography>
                      </Box>
                      {showConnectorGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                    <Collapse in={showConnectorGuide}>
                      <Box sx={{ px: 2.5, py: 2 }}>
                        <Alert severity="warning" sx={{ mb: 2.5, borderRadius: 1.5 }}>
                          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>Before you connect</Typography>
                          <Typography variant="body2" color="text.secondary">
                            Sign in as the <strong>Square account owner</strong> (or a team member with permission to manage apps) for the business you want to connect.
                          </Typography>
                        </Alert>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Connection Flow</Typography>
                        {[
                          ['Sign in with Square', "You'll be redirected to Square to log in to the business account."],
                          ['Grant read access', 'Square asks you to approve read-only access to the data listed below.'],
                          ['Data starts syncing', 'All locations of that Square account are imported, full history first, then daily.'],
                        ].map(([title, text], i) => (
                          <Box key={title} sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                            <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>{i + 1}</Avatar>
                            <Box sx={{ flex: 1 }}>
                              <Typography variant="body2" fontWeight={600}>{title}</Typography>
                              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>{text}</Typography>
                            </Box>
                          </Box>
                        ))}
                        <Divider sx={{ my: 2 }} />
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Read Permissions</Typography>
                        {[
                          ['MERCHANT_PROFILE_READ', 'Business profile and locations'],
                          ['ORDERS_READ', 'Orders and line items'],
                          ['PAYMENTS_READ', 'Payments and refunds'],
                          ['PAYOUTS_READ', 'Payouts to your bank account'],
                          ['ITEMS_READ', 'Product catalog'],
                          ['INVENTORY_READ', 'Stock counts and movements'],
                          ['CUSTOMERS_READ', 'Customer directory'],
                          ['DISPUTES_READ', 'Card disputes'],
                          ['INVOICES_READ', 'Invoices'],
                          ['EMPLOYEES_READ', 'Team members'],
                          ['GIFTCARDS_READ', 'Gift cards'],
                          ['LOYALTY_READ', 'Loyalty program, accounts, events and rewards'],
                          ['TIMECARDS_READ', 'Staff timecards and scheduled shifts'],
                          ['TIMECARDS_SETTINGS_READ', 'Break types and workweek settings'],
                          ['BANK_ACCOUNTS_READ', 'Linked bank accounts'],
                          ['APPOINTMENTS_READ', 'Bookings'],
                          ['APPOINTMENTS_BUSINESS_SETTINGS_READ', 'Booking settings'],
                          ['CASH_DRAWER_READ', 'Cash drawer shifts'],
                          ['DEVICES_READ', 'POS devices'],
                          ['ONLINE_STORE_SITE_READ', 'Square Online sites'],
                          ['SUBSCRIPTIONS_READ', 'Subscriptions'],
                          ['VENDOR_READ', 'Vendors'],
                          ['CHANNELS_READ', 'Sales channels'],
                        ].map(([scope, text]) => (
                          <Box key={scope} sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                            <Chip label={scope} size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                            <Typography variant="caption" color="text.secondary">{text}</Typography>
                          </Box>
                        ))}
                        <FormControlLabel
                          sx={{ mt: 1.5 }}
                          control={
                            <Checkbox
                              name="squareSandbox"
                              checked={connectorForm.squareSandbox || false}
                              onChange={(e) => setConnectorForm(prev => ({ ...prev, squareSandbox: e.target.checked }))}
                            />
                          }
                          label="Use Square Sandbox (test accounts only)"
                        />
                        <Alert severity="info" sx={{ mt: 1, borderRadius: 1.5 }}>
                          <Typography variant="body2">Access is read-only: nothing is changed in your Square account. Tokens refresh automatically; you only need to reconnect if you revoke access in Square.</Typography>
                        </Alert>
                      </Box>
                    </Collapse>
                  </Paper>
                )}

                {/* Snapchat Ads — What happens when you connect */}
                {connectorType === 'snapchat_ads' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
                    <Box onClick={() => setShowConnectorGuide(!showConnectorGuide)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, cursor: 'pointer', bgcolor: 'action.hover', '&:hover': { bgcolor: 'action.selected' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IntegrationInstructionsIcon fontSize="small" color="primary" />
                        <Typography variant="subtitle2" fontWeight={600}>What happens when you connect</Typography>
                      </Box>
                      {showConnectorGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                    <Collapse in={showConnectorGuide}>
                      <Box sx={{ px: 2.5, py: 2 }}>
                        <Alert severity="warning" sx={{ mb: 2.5, borderRadius: 1.5 }}>
                          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>Before you connect</Typography>
                          <Typography variant="body2" color="text.secondary">
                            Sign in with a Snapchat account that is a <strong>member of the ad account</strong> in Snap Business Manager with at least the <strong>Reports</strong> (Data Manager) role. Use a login your business keeps: if that person loses access, the connection stops.
                          </Typography>
                        </Alert>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Connection Flow</Typography>
                        {[
                          ['Sign in with Snapchat', "You'll be redirected to Snapchat to log in and approve access to your ad data."],
                          ['Pick ad accounts', 'Choose which ad accounts to connect and the brand each one belongs to.'],
                          ['Data starts syncing', 'Campaigns, ad squads, ads, creatives and daily stats are imported, full history first, then daily.'],
                        ].map(([title, text], i) => (
                          <Box key={title} sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                            <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>{i + 1}</Avatar>
                            <Box sx={{ flex: 1 }}>
                              <Typography variant="body2" fontWeight={600}>{title}</Typography>
                              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>{text}</Typography>
                            </Box>
                          </Box>
                        ))}
                        <Alert severity="info" sx={{ mt: 1, borderRadius: 1.5 }}>
                          <Typography variant="body2">Snapchat's permission covers reading and managing ads; we only read. Nothing is changed in your Snapchat ad accounts. Access renews automatically; you only need to reconnect if access is removed in Snapchat.</Typography>
                        </Alert>
                      </Box>
                    </Collapse>
                  </Paper>
                )}

                {/* Reddit Ads — What happens when you connect */}
                {connectorType === 'reddit_ads' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
                    <Box onClick={() => setShowConnectorGuide(!showConnectorGuide)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, cursor: 'pointer', bgcolor: 'action.hover', '&:hover': { bgcolor: 'action.selected' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IntegrationInstructionsIcon fontSize="small" color="primary" />
                        <Typography variant="subtitle2" fontWeight={600}>What happens when you connect</Typography>
                      </Box>
                      {showConnectorGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                    <Collapse in={showConnectorGuide}>
                      <Box sx={{ px: 2.5, py: 2 }}>
                        <Alert severity="warning" sx={{ mb: 2.5, borderRadius: 1.5 }}>
                          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>Before you connect</Typography>
                          <Typography variant="body2" color="text.secondary">
                            Sign in to Reddit as a member who has access to the <strong>ad accounts</strong> you want to connect (in Reddit Ads Manager under Business &gt; Members).
                          </Typography>
                        </Alert>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Connection Flow</Typography>
                        {[
                          ['Sign in with Reddit', "You'll be redirected to Reddit to approve access for the signed-in account."],
                          ['Grant read access', 'Reddit asks you to approve read-only access to your advertising data (adsread).'],
                          ['Choose ad accounts', 'Pick one or more ad accounts. Each becomes its own connector in its own currency and time zone.'],
                          ['Data starts syncing', 'Up to 24 months of daily history first, then daily, re-reading recent days as Reddit updates conversions.'],
                        ].map(([title, text], i) => (
                          <Box key={title} sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                            <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>{i + 1}</Avatar>
                            <Box sx={{ flex: 1 }}>
                              <Typography variant="body2" fontWeight={600}>{title}</Typography>
                              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>{text}</Typography>
                            </Box>
                          </Box>
                        ))}
                        <Alert severity="info" sx={{ mt: 1, borderRadius: 1.5 }}>
                          <Typography variant="body2">Access is read-only: nothing is changed in your Reddit ad accounts. Tokens refresh automatically; you only need to reconnect if you revoke access in Reddit.</Typography>
                        </Alert>
                      </Box>
                    </Collapse>
                  </Paper>
                )}

                {/* Search Ads 360 — What happens when you connect */}
                {connectorType === 'sa360' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
                    <Box onClick={() => setShowConnectorGuide(!showConnectorGuide)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, cursor: 'pointer', bgcolor: 'action.hover', '&:hover': { bgcolor: 'action.selected' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IntegrationInstructionsIcon fontSize="small" color="primary" />
                        <Typography variant="subtitle2" fontWeight={600}>What happens when you connect</Typography>
                      </Box>
                      {showConnectorGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                    <Collapse in={showConnectorGuide}>
                      <Box sx={{ px: 2.5, py: 2 }}>
                        <Alert severity="warning" sx={{ mb: 2.5, borderRadius: 1.5 }}>
                          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>Before you connect</Typography>
                          <Typography variant="body2" color="text.secondary">
                            Sign in with a Google account that has access to the <strong>Search Ads 360 accounts</strong> you want to connect (directly or through a manager account).
                          </Typography>
                        </Alert>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Connection Flow</Typography>
                        {[
                          ['Sign in with Google', "You'll be redirected to Google to approve access for the signed-in account."],
                          ['Tick the Search Ads 360 box', 'Google shows the Search Ads 360 permission as a checkbox. Tick it, or the connection cannot read your data.'],
                          ['Choose accounts', 'Pick one or more client accounts, including those under your manager accounts. Each becomes its own connector in its own currency and time zone.'],
                          ['Data starts syncing', 'The full history of each account first, then daily, re-reading the last 90 days as conversions update.'],
                        ].map(([title, text], i) => (
                          <Box key={title} sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                            <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>{i + 1}</Avatar>
                            <Box sx={{ flex: 1 }}>
                              <Typography variant="body2" fontWeight={600}>{title}</Typography>
                              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>{text}</Typography>
                            </Box>
                          </Box>
                        ))}
                        <Alert severity="info" sx={{ mt: 1, borderRadius: 1.5 }}>
                          <Typography variant="body2">Access is read-only: the Search Ads 360 reporting API cannot change anything in your accounts. You only need to reconnect if you remove access in your Google account.</Typography>
                        </Alert>
                      </Box>
                    </Collapse>
                  </Paper>
                )}

                {/* Display & Video 360 — What happens when you connect */}
                {connectorType === 'dv360' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
                    <Box onClick={() => setShowConnectorGuide(!showConnectorGuide)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, cursor: 'pointer', bgcolor: 'action.hover', '&:hover': { bgcolor: 'action.selected' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IntegrationInstructionsIcon fontSize="small" color="primary" />
                        <Typography variant="subtitle2" fontWeight={600}>What happens when you connect</Typography>
                      </Box>
                      {showConnectorGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                    <Collapse in={showConnectorGuide}>
                      <Box sx={{ px: 2.5, py: 2 }}>
                        <Alert severity="warning" sx={{ mb: 2.5, borderRadius: 1.5 }}>
                          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>Before you connect</Typography>
                          <Typography variant="body2" color="text.secondary">
                            Sign in with a Google account that is a <strong>Display &amp; Video 360 user</strong> on the advertisers you want to connect (any user role that can view them).
                          </Typography>
                        </Alert>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Connection Flow</Typography>
                        {[
                          ['Sign in with Google', "You'll be redirected to Google to approve access for the signed-in account."],
                          ['Tick both Display & Video 360 boxes', 'Google shows Display & Video 360 and its reporting permission as two checkboxes. Tick both, or the connection cannot read your data.'],
                          ['Choose advertisers', 'Pick one or more advertisers from your partners, or type an advertiser ID you have access to. Each becomes its own connector in its own currency and time zone.'],
                          ['Data starts syncing', 'Your settings and the full report history first, then daily, re-reading the last 90 days as conversions update.'],
                        ].map(([title, text], i) => (
                          <Box key={title} sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                            <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>{i + 1}</Avatar>
                            <Box sx={{ flex: 1 }}>
                              <Typography variant="body2" fontWeight={600}>{title}</Typography>
                              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>{text}</Typography>
                            </Box>
                          </Box>
                        ))}
                        <Alert severity="info" sx={{ mt: 1, borderRadius: 1.5 }}>
                          <Typography variant="body2">We only read your campaigns and settings. To build your reports we save report definitions under your Display &amp; Video 360 login (named SuperChargeMe ...); nothing else in your account is changed.</Typography>
                        </Alert>
                      </Box>
                    </Collapse>
                  </Paper>
                )}

                {/* Campaign Manager 360 — What happens when you connect */}
                {connectorType === 'cm360' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
                    <Box onClick={() => setShowConnectorGuide(!showConnectorGuide)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, cursor: 'pointer', bgcolor: 'action.hover', '&:hover': { bgcolor: 'action.selected' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IntegrationInstructionsIcon fontSize="small" color="primary" />
                        <Typography variant="subtitle2" fontWeight={600}>What happens when you connect</Typography>
                      </Box>
                      {showConnectorGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                    <Collapse in={showConnectorGuide}>
                      <Box sx={{ px: 2.5, py: 2 }}>
                        <Alert severity="warning" sx={{ mb: 2.5, borderRadius: 1.5 }}>
                          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>Before you connect</Typography>
                          <Typography variant="body2" color="text.secondary">
                            Sign in with a Google account that has a <strong>Campaign Manager 360 user profile</strong> in the account you want to connect.
                          </Typography>
                        </Alert>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Connection Flow</Typography>
                        {[
                          ['Sign in with Google', "You'll be redirected to Google to approve access for the signed-in account."],
                          ['Tick both Campaign Manager 360 boxes', 'Google shows Campaign Manager 360 reporting and trafficking as two checkboxes. Tick both, or the connection cannot read your data.'],
                          ['Choose accounts', 'Pick one or more Campaign Manager 360 accounts. Each becomes its own connector in the account currency and report time zone.'],
                          ['Data starts syncing', 'Your setup and the full report history first, then daily, re-reading the last 90 days as conversions update.'],
                        ].map(([title, text], i) => (
                          <Box key={title} sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                            <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>{i + 1}</Avatar>
                            <Box sx={{ flex: 1 }}>
                              <Typography variant="body2" fontWeight={600}>{title}</Typography>
                              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>{text}</Typography>
                            </Box>
                          </Box>
                        ))}
                        <Alert severity="info" sx={{ mt: 1, borderRadius: 1.5 }}>
                          <Typography variant="body2">We only read your account setup. To build some reports we save report definitions under your Campaign Manager 360 profile (named SuperChargeMe ...); nothing else in your account is changed.</Typography>
                        </Alert>
                      </Box>
                    </Collapse>
                  </Paper>
                )}

                {/* Klaviyo — What happens when you connect */}
                {connectorType === 'klaviyo' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
                    <Box onClick={() => setShowConnectorGuide(!showConnectorGuide)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, cursor: 'pointer', bgcolor: 'action.hover', '&:hover': { bgcolor: 'action.selected' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IntegrationInstructionsIcon fontSize="small" color="primary" />
                        <Typography variant="subtitle2" fontWeight={600}>What happens when you connect</Typography>
                      </Box>
                      {showConnectorGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                    <Collapse in={showConnectorGuide}>
                      <Box sx={{ px: 2.5, py: 2 }}>
                        <Alert severity="warning" sx={{ mb: 2.5, borderRadius: 1.5 }}>
                          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>Before you connect</Typography>
                          <Typography variant="body2" color="text.secondary">
                            You need <strong>admin or owner access</strong> to the Klaviyo account to create an API key. Klaviyo does not offer OAuth, so we authenticate using a Private API Key you generate in Klaviyo and paste here.
                          </Typography>
                        </Alert>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Connection Flow</Typography>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>1</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Create an API key in Klaviyo</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Follow the 4 numbered steps on the left to generate a Public + Private API Key inside your Klaviyo account.</Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>2</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Paste keys into SuperChargeMe</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Enter the Public Key, Private Key, market, and currency in the form, then click Connect Klaviyo.</Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>3</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>We validate and store the key</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>We call Klaviyo's <code>/api/accounts/</code> endpoint to verify the Private Key matches the Public Key, then store both encrypted.</Typography>
                          </Box>
                        </Box>
                        <Divider sx={{ my: 2 }} />
                        <Alert severity="info" sx={{ mt: 2, borderRadius: 1.5 }}>
                          {klaviyoAccessMode === 'read' ? (
                            <Typography variant="body2"><strong>Access level:</strong> Read-Only Key. It grants read access to every scope (including Events) — everything SuperChargeMe syncs (campaigns, flows, metrics, events, lists, segments, profiles). No write access is requested.</Typography>
                          ) : (
                            <Typography variant="body2"><strong>Access level:</strong> Full Access Key — read + write across every scope. Choose this only if you want SuperChargeMe to write back to Klaviyo (e.g. create/update campaigns or flows); sync itself only needs read.</Typography>
                          )}
                        </Alert>
                        <Alert severity="success" sx={{ mt: 1.5, borderRadius: 1.5 }}>
                          <Typography variant="body2">Your Private API Key is encrypted at rest. You can revoke it any time from Klaviyo's API Keys page — it'll stop working immediately on our end.</Typography>
                        </Alert>
                      </Box>
                    </Collapse>
                  </Paper>
                )}

                {/* Google Analytics — What happens when you connect */}
                {connectorType === 'google_analytics' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
                    <Box onClick={() => setShowConnectorGuide(!showConnectorGuide)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, cursor: 'pointer', bgcolor: 'action.hover', '&:hover': { bgcolor: 'action.selected' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IntegrationInstructionsIcon fontSize="small" color="primary" />
                        <Typography variant="subtitle2" fontWeight={600}>What happens when you connect</Typography>
                      </Box>
                      {showConnectorGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                    <Collapse in={showConnectorGuide}>
                      <Box sx={{ px: 2.5, py: 2 }}>
                        <Alert severity="warning" sx={{ mb: 2.5, borderRadius: 1.5 }}>
                          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>Before you connect</Typography>
                          <Typography variant="body2" color="text.secondary">
                            You need <strong>Viewer access or higher</strong> to the Google Analytics 4 property you want to connect.
                          </Typography>
                        </Alert>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Connection Flow</Typography>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>1</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Sign in with Google</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>You'll be redirected to Google to log in and authorize read-only access.</Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>2</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Select your GA4 property</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Choose which Analytics property to connect from the accounts you have access to.</Typography>
                          </Box>
                        </Box>
                        <Divider sx={{ my: 2 }} />
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Permissions Requested</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="analytics.readonly" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read-only access to your Google Analytics data</Typography>
                        </Box>
                        <Alert severity="info" sx={{ mt: 2, borderRadius: 1.5 }}>
                          <Typography variant="body2">Read-only access — we never modify your Analytics configuration. Tokens auto-refresh.</Typography>
                        </Alert>
                      </Box>
                    </Collapse>
                  </Paper>
                )}

                {/* Google Search Console — What happens when you connect */}
                {connectorType === 'google_search_console' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
                    <Box onClick={() => setShowConnectorGuide(!showConnectorGuide)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, cursor: 'pointer', bgcolor: 'action.hover', '&:hover': { bgcolor: 'action.selected' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IntegrationInstructionsIcon fontSize="small" color="primary" />
                        <Typography variant="subtitle2" fontWeight={600}>What happens when you connect</Typography>
                      </Box>
                      {showConnectorGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                    <Collapse in={showConnectorGuide}>
                      <Box sx={{ px: 2.5, py: 2 }}>
                        <Alert severity="warning" sx={{ mb: 2.5, borderRadius: 1.5 }}>
                          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>Before you connect</Typography>
                          <Typography variant="body2" color="text.secondary">
                            You need <strong>owner or full user access</strong> to the Search Console property (site) you want to connect.
                          </Typography>
                        </Alert>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Connection Flow</Typography>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>1</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Sign in with Google</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>You'll be redirected to Google to log in and authorize read-only access.</Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>2</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Select your site</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Choose which verified site property to connect for search performance data.</Typography>
                          </Box>
                        </Box>
                        <Divider sx={{ my: 2 }} />
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Permissions Requested</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="webmasters.readonly" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read-only access to Search Console data (search queries, clicks, impressions)</Typography>
                        </Box>
                        <Alert severity="info" sx={{ mt: 2, borderRadius: 1.5 }}>
                          <Typography variant="body2">Read-only access — we never modify your Search Console settings. Tokens auto-refresh.</Typography>
                        </Alert>
                      </Box>
                    </Collapse>
                  </Paper>
                )}

                {/* Google Merchant Center — What happens when you connect */}
                {connectorType === 'google_merchant_center' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
                    <Box onClick={() => setShowConnectorGuide(!showConnectorGuide)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, cursor: 'pointer', bgcolor: 'action.hover', '&:hover': { bgcolor: 'action.selected' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IntegrationInstructionsIcon fontSize="small" color="primary" />
                        <Typography variant="subtitle2" fontWeight={600}>What happens when you connect</Typography>
                      </Box>
                      {showConnectorGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                    <Collapse in={showConnectorGuide}>
                      <Box sx={{ px: 2.5, py: 2 }}>
                        <Alert severity="warning" sx={{ mb: 2.5, borderRadius: 1.5 }}>
                          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>Before you connect</Typography>
                          <Typography variant="body2" color="text.secondary">
                            You need <strong>admin access</strong> to the Google Merchant Center account you want to connect.
                          </Typography>
                        </Alert>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Connection Flow</Typography>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>1</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Sign in with Google</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>You'll be redirected to Google to log in and authorize access.</Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>2</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Select your Merchant account</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Choose which Merchant Center account to connect for product feed and Shopping data.</Typography>
                          </Box>
                        </Box>
                        <Divider sx={{ my: 2 }} />
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Permissions Requested</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="content" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Access to Merchant Center product feeds and data</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="cloud-platform" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Access to Merchant API v1 (product and inventory data)</Typography>
                        </Box>
                        <Alert severity="info" sx={{ mt: 2, borderRadius: 1.5 }}>
                          <Typography variant="body2">Your tokens are securely stored and auto-refresh. You won't need to reconnect unless you revoke access.</Typography>
                        </Alert>
                      </Box>
                    </Collapse>
                  </Paper>
                )}

                {/* Amazon Ads — What happens when you connect */}
                {connectorType === 'amazon_ads' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
                    <Box onClick={() => setShowConnectorGuide(!showConnectorGuide)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, cursor: 'pointer', bgcolor: 'action.hover', '&:hover': { bgcolor: 'action.selected' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IntegrationInstructionsIcon fontSize="small" color="primary" />
                        <Typography variant="subtitle2" fontWeight={600}>What happens when you connect</Typography>
                      </Box>
                      {showConnectorGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                    <Collapse in={showConnectorGuide}>
                      <Box sx={{ px: 2.5, py: 2 }}>
                        <Alert severity="warning" sx={{ mb: 2.5, borderRadius: 1.5 }}>
                          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>Before you connect</Typography>
                          <Typography variant="body2" color="text.secondary">
                            You need an <strong>Amazon Advertising account</strong> with access to the ad profiles you want to connect.
                          </Typography>
                        </Alert>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Connection Flow</Typography>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>1</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Sign in with Amazon</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>You'll be redirected to Amazon to log in and authorize access.</Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>2</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Select your ad profile</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Choose which Amazon Advertising profile to connect for Sponsored Products, Brands, and Display data.</Typography>
                          </Box>
                        </Box>
                        <Divider sx={{ my: 2 }} />
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Permissions Requested</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="campaign_management" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read advertising campaign data and performance reports</Typography>
                        </Box>
                        <Alert severity="info" sx={{ mt: 2, borderRadius: 1.5 }}>
                          <Typography variant="body2">Your tokens are securely stored and auto-refresh. You won't need to reconnect unless you revoke access.</Typography>
                        </Alert>
                      </Box>
                    </Collapse>
                  </Paper>
                )}

                {/* QuickBooks — What happens when you connect */}
                {connectorType === 'quickbooks' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
                    <Box onClick={() => setShowConnectorGuide(!showConnectorGuide)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, cursor: 'pointer', bgcolor: 'action.hover', '&:hover': { bgcolor: 'action.selected' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IntegrationInstructionsIcon fontSize="small" color="primary" />
                        <Typography variant="subtitle2" fontWeight={600}>What happens when you connect</Typography>
                      </Box>
                      {showConnectorGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                    <Collapse in={showConnectorGuide}>
                      <Box sx={{ px: 2.5, py: 2 }}>
                        <Alert severity="warning" sx={{ mb: 2.5, borderRadius: 1.5 }}>
                          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>Before you connect</Typography>
                          <Typography variant="body2" color="text.secondary">
                            You need <strong>admin access</strong> to the QuickBooks Online company you want to connect.
                          </Typography>
                        </Alert>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Connection Flow</Typography>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>1</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Sign in with Intuit</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>You'll be redirected to Intuit to log in and authorize access.</Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>2</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Select your company</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Choose which QuickBooks company to connect for accounting data.</Typography>
                          </Box>
                        </Box>
                        <Divider sx={{ my: 2 }} />
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Permissions Requested</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="accounting" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read accounting data including invoices, expenses, and profit & loss</Typography>
                        </Box>
                        <Alert severity="info" sx={{ mt: 2, borderRadius: 1.5 }}>
                          <Typography variant="body2">Your tokens are securely stored and auto-refresh. You won't need to reconnect unless you revoke access.</Typography>
                        </Alert>
                      </Box>
                    </Collapse>
                  </Paper>
                )}

                {/* Xero — What happens when you connect */}
                {connectorType === 'xero' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
                    <Box onClick={() => setShowConnectorGuide(!showConnectorGuide)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, cursor: 'pointer', bgcolor: 'action.hover', '&:hover': { bgcolor: 'action.selected' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IntegrationInstructionsIcon fontSize="small" color="primary" />
                        <Typography variant="subtitle2" fontWeight={600}>What happens when you connect</Typography>
                      </Box>
                      {showConnectorGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                    <Collapse in={showConnectorGuide}>
                      <Box sx={{ px: 2.5, py: 2 }}>
                        <Alert severity="warning" sx={{ mb: 2.5, borderRadius: 1.5 }}>
                          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>Before you connect</Typography>
                          <Typography variant="body2" color="text.secondary">
                            You need <strong>advisor or standard user access</strong> to the Xero organisation you want to connect.
                          </Typography>
                        </Alert>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Connection Flow</Typography>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>1</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Sign in with Xero</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>You'll be redirected to Xero to log in and authorize read-only access.</Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>2</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Select your organisation</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Choose which Xero organisation to connect for accounting data.</Typography>
                          </Box>
                        </Box>
                        <Divider sx={{ my: 2 }} />
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Permissions Requested (All Read-Only)</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="invoices.read" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read invoices</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="payments.read" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read payments</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="banktransactions.read" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read bank transactions</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="contacts.read" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read contacts and suppliers</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="settings.read" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read organisation settings</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="budgets.read" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read budgets</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="reports P&L / BS / TB" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read P&L, balance sheet, and trial balance reports</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="manualjournals.read" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read manual journal entries</Typography>
                        </Box>
                        <Alert severity="info" sx={{ mt: 2, borderRadius: 1.5 }}>
                          <Typography variant="body2">All 10 permissions are read-only. Your tokens are securely stored and auto-refresh.</Typography>
                        </Alert>
                      </Box>
                    </Collapse>
                  </Paper>
                )}

                {/* Microsoft Ads — What happens when you connect */}
                {connectorType === 'microsoft_ads' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
                    <Box onClick={() => setShowConnectorGuide(!showConnectorGuide)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, cursor: 'pointer', bgcolor: 'action.hover', '&:hover': { bgcolor: 'action.selected' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IntegrationInstructionsIcon fontSize="small" color="primary" />
                        <Typography variant="subtitle2" fontWeight={600}>What happens when you connect</Typography>
                      </Box>
                      {showConnectorGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                    <Collapse in={showConnectorGuide}>
                      <Box sx={{ px: 2.5, py: 2 }}>
                        <Alert severity="warning" sx={{ mb: 2.5, borderRadius: 1.5 }}>
                          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>Before you connect</Typography>
                          <Typography variant="body2" color="text.secondary">
                            You need access to a <strong>Microsoft Advertising account</strong> (Bing Ads). Sign in with the Microsoft account linked to your ad account.
                          </Typography>
                        </Alert>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Connection Flow</Typography>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>1</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Sign in with Microsoft</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>You'll be redirected to Microsoft to log in and authorize access.</Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>2</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Select your ad account</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Choose which Microsoft Advertising account to connect for campaign data.</Typography>
                          </Box>
                        </Box>
                        <Divider sx={{ my: 2 }} />
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Permissions Requested</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="msads.manage" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read and manage your Microsoft Advertising campaigns and data</Typography>
                        </Box>
                        <Alert severity="info" sx={{ mt: 2, borderRadius: 1.5 }}>
                          <Typography variant="body2">Your tokens are securely stored and auto-refresh. You won't need to reconnect unless you revoke access.</Typography>
                        </Alert>
                      </Box>
                    </Collapse>
                  </Paper>
                )}

                {/* Slack — What happens when you connect */}
                {connectorType === 'slack' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
                    <Box onClick={() => setShowConnectorGuide(!showConnectorGuide)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, cursor: 'pointer', bgcolor: 'action.hover', '&:hover': { bgcolor: 'action.selected' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IntegrationInstructionsIcon fontSize="small" color="primary" />
                        <Typography variant="subtitle2" fontWeight={600}>What happens when you connect</Typography>
                      </Box>
                      {showConnectorGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                    <Collapse in={showConnectorGuide}>
                      <Box sx={{ px: 2.5, py: 2 }}>
                        <Alert severity="warning" sx={{ mb: 2.5, borderRadius: 1.5 }}>
                          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>Before you connect</Typography>
                          <Typography variant="body2" color="text.secondary">
                            You need to be an <strong>admin or owner</strong> of the Slack workspace you want to connect, or have permission to install apps.
                          </Typography>
                        </Alert>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Connection Flow</Typography>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>1</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Sign in with Slack</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>You'll be redirected to Slack to log in and authorize the integration.</Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>2</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Allow workspace access</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Approve the app to read channels and send messages on your behalf.</Typography>
                          </Box>
                        </Box>
                        <Divider sx={{ my: 2 }} />
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Messaging</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="chat:write" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Send messages and reports to channels</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="chat:write.public" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Post in channels without being a member</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="im:write" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Send direct messages</Typography>
                        </Box>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mt: 1.5, mb: 1, display: 'block' }}>Reading</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="channels:read" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read channel list and info</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="channels:history" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read channel message history</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="users:read" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read workspace member profiles and emails</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="files:read" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read shared files</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="reactions:read" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read emoji reactions</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="app_mentions:read" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Respond when @mentioned</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="commands" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Register slash commands</Typography>
                        </Box>
                        <Alert severity="info" sx={{ mt: 2, borderRadius: 1.5 }}>
                          <Typography variant="body2">This enables AI-powered analytics directly in your Slack workspace — ask questions, get reports, and receive alerts.</Typography>
                        </Alert>
                      </Box>
                    </Collapse>
                  </Paper>
                )}

                {/* Wise — What happens when you connect */}
                {connectorType === 'wise' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
                    <Box onClick={() => setShowConnectorGuide(!showConnectorGuide)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, cursor: 'pointer', bgcolor: 'action.hover', '&:hover': { bgcolor: 'action.selected' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IntegrationInstructionsIcon fontSize="small" color="primary" />
                        <Typography variant="subtitle2" fontWeight={600}>What happens when you connect</Typography>
                      </Box>
                      {showConnectorGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                    <Collapse in={showConnectorGuide}>
                      <Box sx={{ px: 2.5, py: 2 }}>
                        <Alert severity="warning" sx={{ mb: 2.5, borderRadius: 1.5 }}>
                          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>Before you connect</Typography>
                          <Typography variant="body2" color="text.secondary">
                            You need access to a <strong>Wise Business account</strong> with permission to view transfers and balances.
                          </Typography>
                        </Alert>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Permissions Requested</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="transfers" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read transfer history and details</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="balances" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read account balances across currencies</Typography>
                        </Box>
                        <Alert severity="info" sx={{ mt: 2, borderRadius: 1.5 }}>
                          <Typography variant="body2">Read-only access to your financial data. Tokens auto-refresh.</Typography>
                        </Alert>
                      </Box>
                    </Collapse>
                  </Paper>
                )}

                {/* TikTok Shop — What happens when you connect */}
                {connectorType === 'tiktok_shop' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
                    <Box onClick={() => setShowConnectorGuide(!showConnectorGuide)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, cursor: 'pointer', bgcolor: 'action.hover', '&:hover': { bgcolor: 'action.selected' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IntegrationInstructionsIcon fontSize="small" color="primary" />
                        <Typography variant="subtitle2" fontWeight={600}>What happens when you connect</Typography>
                      </Box>
                      {showConnectorGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                    <Collapse in={showConnectorGuide}>
                      <Box sx={{ px: 2.5, py: 2 }}>
                        <Alert severity="warning" sx={{ mb: 2.5, borderRadius: 1.5 }}>
                          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>Before you connect</Typography>
                          <Typography variant="body2" color="text.secondary">
                            You need access to a <strong>TikTok Shop Seller Center</strong> account.
                          </Typography>
                        </Alert>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Connection Flow</Typography>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>1</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Sign in with TikTok Shop</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>You'll be redirected to TikTok Shop to authorize access to your seller data.</Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>2</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Select your shop</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Choose which TikTok Shop to connect for order and product data.</Typography>
                          </Box>
                        </Box>
                        <Alert severity="info" sx={{ mt: 2, borderRadius: 1.5 }}>
                          <Typography variant="body2">Your tokens are securely stored and auto-refresh.</Typography>
                        </Alert>
                      </Box>
                    </Collapse>
                  </Paper>
                )}

                {/* TikTok Shop — send a link to a client who is not logged in */}
                {connectorType === 'tiktok_shop' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 2.5, mb: 3 }}>
                    <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 0.5 }}>
                      Client not with you? Send them a link
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                      Generate a secure authorization link and send it to the shop owner. When they
                      approve it in their own browser, the connector is created automatically for the
                      selected brand; they do not need a SuperChargeMe login. The link stays valid for 24 hours.
                    </Typography>
                    <Button
                      variant="outlined"
                      startIcon={<CopyIcon />}
                      disabled={!connectorForm.brandId || copyingLink}
                      onClick={handleCopyClientLink}
                    >
                      {copyingLink ? 'Generating link...' : 'Copy client link'}
                    </Button>
                    {!connectorForm.brandId && (
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                        Select a brand above first.
                      </Typography>
                    )}
                  </Paper>
                )}

                {/* TikTok Ads — send a link to a client who is not logged in */}
                {connectorType === 'tiktok' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 2.5, mb: 3 }}>
                    <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 0.5 }}>
                      Client not with you? Send them a link
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                      Generate a secure authorization link and send it to the account owner. When they
                      approve it in their own TikTok For Business account, a connector is created
                      automatically for the selected brand; they do not need a SuperChargeMe login.
                      The link stays valid for 24 hours.
                    </Typography>
                    <Alert severity="info" sx={{ mb: 1.5, borderRadius: 1.5 }}>
                      <Typography variant="body2">
                        <strong>Every advertiser account</strong> the owner authorizes is connected to
                        the brand selected above (one connector each). Make sure this brand is the right
                        home for all of their ad accounts before sending the link.
                      </Typography>
                    </Alert>
                    <Button
                      variant="outlined"
                      startIcon={<CopyIcon />}
                      disabled={!connectorForm.brandId || copyingLink}
                      onClick={handleCopyClientLink}
                    >
                      {copyingLink ? 'Generating link...' : 'Copy client link'}
                    </Button>
                    {!connectorForm.brandId && (
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                        Select a brand above first.
                      </Typography>
                    )}
                  </Paper>
                )}

                {connectorType === 'tiktok_business_account' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 2.5, mb: 3 }}>
                    <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 0.5 }}>
                      Client not with you? Send them a link
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                      Generate a secure authorization link and send it to the account owner. When they
                      approve it in their own TikTok Business account, the connector is created
                      automatically for the selected brand; they do not need a SuperChargeMe login.
                      The link stays valid for 24 hours.
                    </Typography>
                    <Button
                      variant="outlined"
                      startIcon={<CopyIcon />}
                      disabled={!connectorForm.brandId || copyingLink}
                      onClick={handleCopyClientLink}
                    >
                      {copyingLink ? 'Generating link...' : 'Copy client link'}
                    </Button>
                    {!connectorForm.brandId && (
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                        Select a brand above first.
                      </Typography>
                    )}
                  </Paper>
                )}

                {/* Amazon (Seller Partner + Advertising) — send a link to a client who is not
                    logged in. Only for the OAuth connect method: with the manual/private-app
                    method there is nothing for the client to authorize, you paste their keys. */}
                {isAmazonClientLink
                  && ((connectorType === 'amazon' && connectorForm.amazonConnectMethod === 'oauth')
                    || (connectorType === 'amazon_ads' && connectorForm.amazonAdsConnectMethod === 'oauth')) && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 2.5, mb: 3 }}>
                    <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 0.5 }}>
                      Client not with you? Send them a link
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                      Generate a secure authorization link and send it to the account owner. When they
                      approve it in their own {connectorType === 'amazon' ? 'Seller Central' : 'Amazon Advertising'} account,
                      the connector is created automatically for the brand and marketplace selected
                      above; they do not need a SuperChargeMe login. The link expires after a
                      limited window — the exact validity is shown when you copy it, and you can
                      always generate a fresh one. Anyone holding the link can authorize against
                      it, so send it directly to the owner and name the brand in your message.
                    </Typography>
                    {connectorType === 'amazon_ads' && (
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                        If their Amazon login has several advertising profiles, this connects the first
                        one found. Add the others from Connectors afterwards.
                      </Typography>
                    )}
                    {connectorType === 'amazon' && (
                      <Alert severity="warning" sx={{ mb: 1.5, borderRadius: 1.5 }}>
                        <Typography variant="body2">
                          Seller Partner consent still runs against our <strong>draft</strong> app
                          registration, and no client has completed it yet — pilot this with one seller
                          before relying on it. The manual (private app keys) method above is the
                          proven path for Amazon Seller Partner.
                        </Typography>
                      </Alert>
                    )}
                    <Button
                      variant="outlined"
                      startIcon={<CopyIcon />}
                      disabled={!connectorForm.brandId || !connectorForm.country || copyingLink}
                      onClick={handleCopyClientLink}
                    >
                      {copyingLink ? 'Generating link...' : 'Copy client link'}
                    </Button>
                    {(!connectorForm.brandId || !connectorForm.country) && (
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                        Select a brand and a country/region above first.
                      </Typography>
                    )}
                  </Paper>
                )}

                {/* Google Workspace — What happens when you connect */}
                {(connectorType === 'google_workspace' || connectorType === 'google-workspace') && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
                    <Box onClick={() => setShowConnectorGuide(!showConnectorGuide)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, cursor: 'pointer', bgcolor: 'action.hover', '&:hover': { bgcolor: 'action.selected' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IntegrationInstructionsIcon fontSize="small" color="primary" />
                        <Typography variant="subtitle2" fontWeight={600}>What happens when you connect</Typography>
                      </Box>
                      {showConnectorGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                    <Collapse in={showConnectorGuide}>
                      <Box sx={{ px: 2.5, py: 2 }}>
                        <Alert severity="warning" sx={{ mb: 2.5, borderRadius: 1.5 }}>
                          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>Before you connect</Typography>
                          <Typography variant="body2" color="text.secondary">
                            You need a <strong>Google account</strong> with access to the Sheets, Docs, and Drive you want to use for reports and dashboards.
                          </Typography>
                        </Alert>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Permissions Requested</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="spreadsheets" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Create and edit Google Sheets</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="documents" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Create and edit Google Docs</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="presentations" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Create and edit Google Slides</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="drive" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Access and manage files in Google Drive</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="script.projects" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Manage Apps Script projects for automation</Typography>
                        </Box>
                        <Alert severity="info" sx={{ mt: 2, borderRadius: 1.5 }}>
                          <Typography variant="body2">Used for creating live dashboards, automated reports, and data exports to Google Sheets.</Typography>
                        </Alert>
                      </Box>
                    </Collapse>
                  </Paper>
                )}

                {/* Amazon SP — What happens when you connect */}
                {connectorType === 'amazon' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
                    <Box onClick={() => setShowConnectorGuide(!showConnectorGuide)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, cursor: 'pointer', bgcolor: 'action.hover', '&:hover': { bgcolor: 'action.selected' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IntegrationInstructionsIcon fontSize="small" color="primary" />
                        <Typography variant="subtitle2" fontWeight={600}>What happens when you connect</Typography>
                      </Box>
                      {showConnectorGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                    <Collapse in={showConnectorGuide}>
                      <Box sx={{ px: 2.5, py: 2 }}>
                        <Alert severity="warning" sx={{ mb: 2.5, borderRadius: 1.5 }}>
                          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>Before you connect</Typography>
                          <Typography variant="body2" color="text.secondary">
                            You need an <strong>Amazon Seller Central</strong> account. You'll authorize our app to access your seller data via the Selling Partner API.
                          </Typography>
                        </Alert>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Connection Flow</Typography>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>1</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Sign in with Amazon Seller Central</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>You'll be redirected to Amazon to authorize access to your selling account.</Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                          <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.main', flexShrink: 0, mt: 0.25 }}>2</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight={600}>Select your marketplace</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Choose which Amazon marketplace(s) to connect for order and product data.</Typography>
                          </Box>
                        </Box>
                        <Divider sx={{ my: 2 }} />
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Data We'll Import</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="Orders" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Order history, line items, and fulfillment data</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="Products" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Product catalog, listings, and pricing</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="FBA Inventory" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Fulfillment by Amazon inventory levels</Typography>
                        </Box>
                        <Alert severity="info" sx={{ mt: 2, borderRadius: 1.5 }}>
                          <Typography variant="body2">Your tokens are securely stored and auto-refresh. Data is imported via Amazon's Selling Partner API.</Typography>
                        </Alert>
                      </Box>
                    </Collapse>
                  </Paper>
                )}

                {/* Revolut — What happens when you connect */}
                {connectorType === 'revolut' && (
                  <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
                    <Box onClick={() => setShowConnectorGuide(!showConnectorGuide)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, cursor: 'pointer', bgcolor: 'action.hover', '&:hover': { bgcolor: 'action.selected' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IntegrationInstructionsIcon fontSize="small" color="primary" />
                        <Typography variant="subtitle2" fontWeight={600}>What happens when you connect</Typography>
                      </Box>
                      {showConnectorGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                    <Collapse in={showConnectorGuide}>
                      <Box sx={{ px: 2.5, py: 2 }}>
                        <Alert severity="warning" sx={{ mb: 2.5, borderRadius: 1.5 }}>
                          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>Before you connect</Typography>
                          <Typography variant="body2" color="text.secondary">
                            You need a <strong>Revolut Business account</strong> with API access enabled. You'll need your <strong>Client ID</strong> and <strong>Private Key</strong> from the Revolut Business API settings.
                          </Typography>
                        </Alert>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5, display: 'block' }}>Permissions Requested</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                          <Chip label="READ" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem', minWidth: 160 }} />
                          <Typography variant="caption" color="text.secondary">Read-only access to accounts, transactions, and counterparties</Typography>
                        </Box>
                        <Alert severity="info" sx={{ mt: 2, borderRadius: 1.5 }}>
                          <Typography variant="body2">Read-only access to your financial data. Requires API certificate setup in Revolut Business settings.</Typography>
                        </Alert>
                      </Box>
                    </Collapse>
                  </Paper>
                )}

                {error && (
                  <Alert severity="error" onClose={() => setError('')} sx={{ mb: 2 }}>
                    {error}
                  </Alert>
                )}
              </Box>
            )}
          </Box>
            </>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            px: 3,
            py: 2,
            borderTop: '1px solid',
            borderColor: 'divider',
            gap: 1,
          }}
        >
          {connectorType !== 'amex' && (
            <>
              {activeStep > 0 && (
                <Button
                  onClick={handleBackStep}
                  startIcon={<ArrowBackIcon />}
                  sx={{ borderRadius: 2, textTransform: 'none' }}
                >
                  Back
                </Button>
              )}
              <Box sx={{ flex: 1 }} />
              <Button
                onClick={handleCloseDialog}
                sx={{ borderRadius: 2, textTransform: 'none', color: 'text.secondary' }}
              >
                Cancel
              </Button>
              {/* Primary CTA on step 3 lives inside the confirmation card; footer only shows Next on steps 1–2 */}
              {activeStep < 2 && (
                <Button
                  variant="contained"
                  endIcon={<ArrowForwardIcon />}
                  onClick={handleNextStep}
                  disabled={!validateCurrentStep()}
                  sx={{
                    borderRadius: 2,
                    textTransform: 'none',
                    boxShadow: 'none',
                    background: 'linear-gradient(45deg, var(--color-primary) 30%, var(--color-accent) 90%)',
                    '&:hover': { boxShadow: 1 },
                  }}
                >
                  Next
                </Button>
              )}
            </>
          )}
          {(connectorType === 'amex' || connectorType === 'payoneer') && (
            <>
              <Box sx={{ flex: 1 }} />
              <Button
                onClick={handleCloseDialog}
                sx={{ borderRadius: 2, textTransform: 'none', color: 'text.secondary' }}
              >
                Close
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
      
      {/* Enhanced Sync Options Dialog */}
      <SyncOptionsDialog
        open={syncDialogOpen}
        onClose={() => setSyncDialogOpen(false)}
        connector={selectedConnectorForSync}
        onSyncQueued={handleSyncQueued}
        queueStatus={queueStatus}
      />

      {/* Job Details Modal */}
      <JobDetailsModal
        open={jobDetailsOpen}
        onClose={() => setJobDetailsOpen(false)}
        jobId={selectedJobId}
        onActionComplete={handleJobActionComplete}
      />

      {/* CSV Upload Dialog for Amex and other CSV-based connectors */}
      <Dialog
        open={csvUploadDialogOpen}
        onClose={() => setCsvUploadDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Upload Transactions - {selectedConnectorForUpload?.name}
        </DialogTitle>
        <DialogContent>
          {selectedConnectorForUpload && (
            <>
              {selectedConnectorForUpload.platform_name === 'payoneer' ? (
                <PayoneerCSVUpload
                  connectorId={selectedConnectorForUpload.id}
                  onUploadComplete={(result) => {
                    showNotification(`Successfully uploaded ${result.totalTransactions} transactions`, 'success');
                    // Optionally refresh connectors list
                    fetchConnectors();
                  }}
                />
              ) : (
                <AmexCSVUpload
                  connectorId={selectedConnectorForUpload.id}
                  onUploadComplete={(result) => {
                    showNotification(`Successfully uploaded ${result.totalTransactions} transactions`, 'success');
                    // Optionally refresh connectors list
                    fetchConnectors();
                  }}
                />
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCsvUploadDialogOpen(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Connector Delete Confirmation Dialog */}
      <Dialog
        open={confirmDeleteDialog.open}
        onClose={cancelDeleteConnector}
        PaperProps={{
          sx: {
            borderRadius: 3,
            maxWidth: 500
          }
        }}
      >
        <DialogTitle sx={{ pb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box 
              sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                width: 48,
                height: 48,
                borderRadius: '50%',
                backgroundColor: 'error.light',
                color: 'error.contrastText'
              }}
            >
              <DeleteIcon fontSize="large" />
            </Box>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
                Delete Connector?
              </Typography>
              <Typography variant="body2" color="text.secondary">
                This action cannot be undone
              </Typography>
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Alert severity="warning" sx={{ mb: 3 }}>
            <Typography variant="body2">
              <strong>Warning:</strong> Deleting this connector will:
              <br />• Remove all associated data sync schedules
              <br />• Stop any ongoing sync processes
              <br />• Remove the connection to your {confirmDeleteDialog.connectorPlatform} account
              <br />• This action cannot be reversed
            </Typography>
          </Alert>
          
          <Box sx={{ 
            p: 2, 
            borderRadius: 2, 
            backgroundColor: 'background.default',
            border: '1px solid',
            borderColor: 'divider'
          }}>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>Connector:</strong> {confirmDeleteDialog.connectorName}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <strong>Platform:</strong> {confirmDeleteDialog.connectorPlatform}
            </Typography>
          </Box>
          
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2, mb: 2, textAlign: 'center' }}>
            Type the connector name <strong>"{confirmDeleteDialog.connectorName}"</strong> to confirm deletion.
          </Typography>
          
          <TextField
            fullWidth
            label="Confirm connector name"
            value={deleteConfirmationText}
            onChange={(e) => setDeleteConfirmationText(e.target.value)}
            placeholder={confirmDeleteDialog.connectorName}
            variant="outlined"
            size="small"
            sx={{ 
              '& .MuiOutlinedInput-root': {
                borderRadius: 2
              }
            }}
            helperText={deleteConfirmationText === confirmDeleteDialog.connectorName ? 
              "✓ Names match, you can delete" : 
              "Type the exact connector name to enable deletion"
            }
            FormHelperTextProps={{
              sx: {
                color: deleteConfirmationText === confirmDeleteDialog.connectorName ? 
                  'success.main' : 'text.secondary'
              }
            }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, gap: 2 }}>
          <Button
            onClick={cancelDeleteConnector}
            variant="outlined"
            sx={{ borderRadius: 2, minWidth: 100 }}
          >
            Cancel
          </Button>
          <Button
            onClick={confirmDeleteConnector}
            variant="contained"
            color="error"
            startIcon={<DeleteIcon />}
            disabled={deleteConfirmationText !== confirmDeleteDialog.connectorName}
            sx={{ 
              borderRadius: 2,
              minWidth: 120,
              backgroundColor: 'error.main',
              '&:hover': {
                backgroundColor: 'error.dark'
              },
              '&:disabled': {
                backgroundColor: 'action.disabled',
                color: 'action.disabled'
              }
            }}
          >
            Delete Connector
          </Button>
        </DialogActions>
      </Dialog>

      {/* API Key rotation dialog (eDesk and any future API-key connector) */}
      <Dialog
        open={apiKeyDialog.open}
        onClose={apiKeyDialog.submitting ? undefined : handleCloseApiKeyDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Update API Token</DialogTitle>
        <DialogContent>
          {apiKeyDialog.connector && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                <strong>Connector:</strong> {apiKeyDialog.connector.name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Platform:</strong> {(apiKeyDialog.connector.platform_name || apiKeyDialog.connector.type || '').toUpperCase()}
              </Typography>
            </Box>
          )}
          <Alert severity="info" sx={{ mb: 2 }}>
            Paste the new API token below. We will validate it with the provider before saving — if it
            is invalid, your existing token is left in place.
          </Alert>
          <TextField
            fullWidth
            label="New API Token"
            type="password"
            value={apiKeyDialog.newKey}
            onChange={(e) =>
              setApiKeyDialog((prev) => ({ ...prev, newKey: e.target.value, errorText: '' }))
            }
            placeholder="Paste the new token from the provider's admin panel"
            autoFocus
            disabled={apiKeyDialog.submitting}
            sx={{ mb: 1 }}
          />
          {apiKeyDialog.errorText && (
            <Alert severity="error" sx={{ mt: 1 }}>{apiKeyDialog.errorText}</Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseApiKeyDialog}
            disabled={apiKeyDialog.submitting}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmitApiKeyUpdate}
            variant="contained"
            disabled={apiKeyDialog.submitting || !apiKeyDialog.newKey || !apiKeyDialog.newKey.trim()}
          >
            {apiKeyDialog.submitting ? 'Validating…' : 'Update Token'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Notification Snackbar */}
      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={closeNotification}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={closeNotification}
          severity={notification.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
      <ConfirmDialog {...confirmDialogProps} />

      {/* Facebook "move connector to Meta app" dialog (super-admin only) */}
      <Dialog open={fbAppMove.open} onClose={closeFbAppMove} maxWidth="sm" fullWidth>
        <DialogTitle>Re-authenticate Meta</DialogTitle>
        <DialogContent>
          {fbAppMove.connector && (
            <Typography variant="body2" sx={{ mb: 2 }}>
              {fbAppMove.connector.name || 'This connector'} will be re-authenticated in place
              (same connector, no data loss or re-fetch). Choose which Meta app to connect it to.
            </Typography>
          )}
          {fbAppMove.loading ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 2 }}>
              <CircularProgress size={20} /> <Typography variant="body2">Loading apps…</Typography>
            </Box>
          ) : (
            <FormControl fullWidth sx={{ mt: 1 }}>
              <InputLabel id="fb-app-move-label">Meta app</InputLabel>
              <Select
                labelId="fb-app-move-label"
                label="Meta app"
                value={fbAppMove.selected}
                onChange={(e) => setFbAppMove(prev => ({ ...prev, selected: e.target.value }))}
              >
                {fbAppMove.apps.map((a) => (
                  <MenuItem key={a.app_key} value={a.app_key} disabled={!a.usable}>
                    {a.label}
                    {a.app_key === fbAppMove.currentAppKey ? ' (current)' : ''}
                    {a.is_default ? ' — default' : ''}
                    {!a.usable ? ' — unavailable' : ''}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          {fbAppMove.selected && fbAppMove.currentAppKey && fbAppMove.selected !== fbAppMove.currentAppKey && (
            <Alert severity="info" sx={{ mt: 2 }}>
              This will move the connector from <strong>{fbAppMove.currentAppKey}</strong> to{' '}
              <strong>{fbAppMove.selected}</strong>. Grant all pages and ad accounts on Facebook's screen.
            </Alert>
          )}
          {fbAppMove.error && <Alert severity="error" sx={{ mt: 2 }}>{fbAppMove.error}</Alert>}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeFbAppMove} disabled={fbAppMove.submitting}>Cancel</Button>
          <Button
            variant="contained"
            onClick={submitFbAppMove}
            disabled={fbAppMove.loading || fbAppMove.submitting || !fbAppMove.selected}
            startIcon={fbAppMove.submitting ? <CircularProgress size={16} /> : null}
          >
            Re-authenticate
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ConnectorSetup;